// Spanish interface messages. Local catalog; no runtime translation service.
const messages: Record<string, string> = {
  "Modo escuro": "Modo oscuro",
  "Modo claro": "Modo claro",
  "Escuro": "Oscuro",
  "Claro": "Claro",
  "Bem-vindo": "Bienvenido",
  "Dashboard": "Panel",
  "Meus Vídeos": "Mis Videos",
  "Análises": "Análisis",
  "Configurações": "Configuración",
  "Perfil": "Perfil",
  "Sair": "Cerrar Sesión",
  "Feed": "Noticias",
  "Vídeos Recentes": "Videos Recientes",
  "Finanças": "Finanzas",
  "Suporte": "Soporte",
  "Rastreamento": "Seguimiento",
  "Integrações": "Integraciones",
  "Segurança": "Seguridad",
  "Parceiros": "Socios",
  "Ajuda": "Ayuda",
  "Início": "Inicio",
  "Novo Vídeo": "Nuevo Video",
  "Personalização": "Personalización",
  "Funil de Vídeo": "Embudo de Video",
  "VSLeads": "VSLeads",
  "Métricas": "Métricas",
  "Teste A/B": "Test A/B",
  "Teste de hook": "Prueba de ganchos",
  "Proteção Domínios": "Protección de Dominios",
  "Cloaker de VSL": "Cloaker VSL",
  "Membros": "Miembros",
  "Botão de Ação": "Botón de Acción",
  "Master Class": "Clase magistral",
  "Compartilhar": "Compartir",
  "Captura de Leads": "Captura de Leads",
  "Domínios": "Dominios",
  "Chat": "Chat",
  "Central de Ajuda": "Centro de Ayuda",
  "Cloaker": "Cloaker",
  "Personalizar": "Personalizar",
  "Carregando...": "Cargando...",
  "Salvando...": "Guardando...",
  "Excluindo...": "Eliminando...",
  "Processando...": "Procesando...",
  "Erro": "Error",
  "Sucesso": "Éxito",
  "Usuário não autenticado": "Usuario no autenticado",
  "Tente novamente": "Inténtalo de nuevo",
  "Sem dados disponíveis": "Sin datos disponibles",
  "Copiado para a área de transferência": "Copiado al portapapeles",
  "Campo obrigatório": "Campo obligatorio",
  "E-mail inválido": "Correo electrónico inválido",
  "Carregando vídeos...": "Cargando videos...",
  "Nenhum vídeo encontrado": "No se encontraron videos",
  "Erro desconhecido": "Error desconocido",
  "Confirmar exclusão": "Confirmar eliminación",
  "Erro ao salvar": "Error al guardar",
  "Carregando dados...": "Cargando datos...",
  "Acesse a sua conta": "Accede a tu cuenta",
  "Tudo para escalar VSLs com automação, proteção e métricas.": "Todo para escalar VSLs con automatización, protección y métricas.",
  "Login realizado com sucesso!": "¡Inicio de sesión exitoso!",
  "Erro ao fazer login. Verifique suas credenciais.": "Error al iniciar sesión. Verifica tus credenciales.",
  "Erro ao fazer login. Tente novamente.": "Error al iniciar sesión. Inténtalo de nuevo.",
  "Entrar": "Entrar",
  "Entrando...": "Entrando...",
  "Continuar conectado": "Mantenerme conectado",
  "Esqueceu sua senha?": "¿Olvidaste tu contraseña?",
  "Não possui um cadastro?": "¿No tienes una cuenta?",
  "Crie sua conta agora!": "¡Crea tu cuenta ahora!",
  "Crie sua conta": "Crea tu cuenta",
  "E comece a transformar vídeos em conversões reais.": "Y empieza a convertir videos en conversiones reales.",
  "Conta criada com sucesso! Agora escolha seu plano para começar.": "¡Cuenta creada con éxito! Ahora elige tu plan para comenzar.",
  "Erro ao criar conta. Tente novamente.": "Error al crear la cuenta. Inténtalo de nuevo.",
  "Você precisa aceitar os termos de uso para continuar.": "Debes aceptar los términos de uso para continuar.",
  "As senhas precisam ser iguais.": "Las contraseñas deben ser iguales.",
  "Este usuário já está tem contana plataforma.": "Este usuario ya tiene cuenta en la plataforma.",
  "Nome deve ter pelo menos 2 caracteres.": "El nombre debe tener al menos 2 caracteres.",
  "CPF inválido.": "CPF no válido.",
  "WhatsApp inválido.": "WhatsApp no válido.",
  "Senha deve ter pelo menos 8 caracteres.": "La contraseña debe tener al menos 8 caracteres.",
  "Já possui uma conta?": "¿Ya tienes una cuenta?",
  "Faça login aqui": "Inicia sesión aquí",
  "Nome completo": "Nombre completo",
  "hostvsl@email.com": "tuemail@dominio.com",
  "Mín. 8 caracteres": "Mín. 8 caracteres",
  "E-mail": "Correo electrónico",
  "Senha": "Contraseña",
  "Aceito os termos de uso e a política de privacidade": "Acepto los términos de uso y la política de privacidad",
  "Vídeo excluído com sucesso!": "¡Video eliminado con éxito!",
  "Erro ao excluir vídeo": "Error al eliminar video",
  "Vídeo movido para a pasta com sucesso!": "¡Video movido a la carpeta con éxito!",
  "Erro ao mover vídeo para a pasta": "Error al mover video a la carpeta",
  "Vídeo removido da pasta!": "¡Video eliminado de la carpeta!",
  "Buscar vídeos...": "Buscar videos...",
  "Nenhum vídeo nesta pasta": "No hay videos en esta carpeta",
  "Nova pasta": "Nueva carpeta",
  "Visão em grade": "Vista en cuadrícula",
  "Visão em lista": "Vista en lista",
  "Gerencie e visualize seus últimos vídeos": "Administra y visualiza tus últimos videos",
  "Configuração incompleta": "Configuración incompleta",
  "Vídeo principal não selecionado": "Video principal no seleccionado",
  "Seu teste A/B está ativo": "Tu prueba A/B está activa",
  "Seleção de vídeos": "Selección de videos",
  "Distribuição de Tráfego": "Distribución de tráfico",
  "Teste excluído": "Prueba eliminada",
  "Não foi possível excluir o teste": "No se pudo eliminar la prueba",
  "Crie seu primeiro teste A/B": "Crea tu primera prueba A/B",
  "Teste diferentes versões de suas VSLs e descubra o que converte mais": "Prueba diferentes versiones de tus VSLs y descubre qué convierte más",
  "Criar Teste A/B": "Crear Prueba A/B",
  "Como funciona?": "¿Cómo funciona?",
  "Distribuição atualizada": "Distribución actualizada",
  "A distribuição de tráfego foi atualizada com sucesso": "La distribución de tráfico fue actualizada con éxito",
  "Selecione pelo menos 2 vídeos para o teste": "Selecciona al menos 2 videos para la prueba",
  "Selecione no máximo 6 vídeos para o teste": "Selecciona como máximo 6 videos para la prueba",
  "Data não disponível": "Fecha no disponible",
  "Data inválida": "Fecha inválida",
  "Em execução": "En ejecución",
  "Finalizado": "Finalizado",
  "Erro de autenticação": "Error de autenticación",
  "Seu teste de introduções está ativo": "Tu prueba de introducción está activa",
  "Teste diferentes introduções e descubra qual retém mais a atenção": "Prueba diferentes introducciones y descubre cuál retiene más la atención",
  "Crie seu primeiro teste de hook": "Crea tu primera prueba de hook",
  "Erro ao carregar estratégias": "Error al cargar estrategias",
  "Estratégia atualizada": "Estrategia actualizada",
  "A estratégia foi atualizada com sucesso.": "La estrategia fue actualizada con éxito.",
  "Estratégia removida": "Estrategia eliminada",
  "Carregando estratégias...": "Cargando estrategias...",
  "Captura com E-mail": "Captura con Email",
  "Captura com Senha": "Captura con Contraseña",
  "Erro ao carregar estratégia": "Error al cargar estrategia",
  "Estratégia atualizada com sucesso ✅": "Estrategia actualizada con éxito",
  "Erro ao atualizar estratégia": "Error al actualizar estrategia",
  "Conteúdo protegido": "Contenido protegido",
  "Acesse o vídeo": "Accede al video",
  "Estratégia criada com sucesso": "Estrategia creada con éxito",
  "Erro ao salvar estratégia": "Error al guardar estrategia",
  "Erro ao carregar vídeos": "Error al cargar videos",
  "Erro ao carregar regras": "Error al cargar reglas",
  "Selecione o vídeo original": "Selecciona el video original",
  "Regra criada com sucesso": "Regla creada con éxito",
  "A regra foi excluída com sucesso": "Regla eliminada con éxito",
  "Código copiado!": "¡Código copiado!",
  "Nenhuma regra criada": "No hay reglas creadas",
  "Crie regras para filtrar e redirecionar tráfego com base em critérios": "Crea reglas para filtrar y redirigir tráfico según criterios",
  "Formato inválido": "Formato no válido",
  "Selecione apenas arquivos de vídeo": "Selecciona solo archivos de video",
  "Vídeos adicionados": "Videos agregados",
  "Uploads concluídos": "Cargas completadas",
  "O arquivo deve ter no máximo 100MB": "El archivo debe ser de máximo 100MB",
  "Formato não suportado": "Formato no compatible",
  "Nome do vídeo": "Nombre del video",
  "Continue para personalizar seu vídeo": "Continúa para personalizar tu video",
  "Meu Vídeo": "Mi Video",
  "Sem dados de retenção no período": "Sin datos de retención en el período",
  "Sem dados de UTM no período": "Sin datos UTM en el período",
  "Tente ampliar o período": "Intenta ampliar el período",
  "Tempo do Vídeo": "Tiempo del Video",
  "Retenção (%)": "Retención (%)",
  "Playlist excluída": "Playlist eliminada",
  "O link da playlist foi copiado": "Enlace de playlist copiado",
  "Playlist não encontrada": "Playlist no encontrada",
  "Vídeos adicionados!": "¡Videos agregados!",
  "Vídeo removido": "Video eliminado",
  "Os vídeos foram salvos com sucesso.": "Videos guardados con éxito.",
  "O código de incorporação foi copiado para a área de transferência.": "Código de inserción copiado al portapapeles.",
  "Logo otimizado": "Logo optimizado",
  "Erro ao comprimir logo": "Error al comprimir logo",
  "Erro ao comprimir favicon": "Error al comprimir favicon",
  "Adicione vídeos": "Agregar videos",
  "Configurações salvas!": "¡Configuraciones guardadas!",
  "Gerando link público": "Generando enlace público",
  "Ativando métricas": "Activando métricas",
  "Vídeo em preparo": "Video en preparación",
  "cópias": "copias",
  "cópia": "copia",
  "WhatsApp inválido": "WhatsApp no válido",
  "Inscrição realizada!": "¡Inscripción realizada!",
  "Você será redirecionado para a sala...": "Serás redirigido a la sala...",
  "Erro no formulário": "Error en el formulario",
  "Preferências salvas": "Preferencias guardadas",
  "Notificações ativadas!": "¡Notificaciones activadas!",
  "Permissão necessária": "Permiso requerido",
  "Notificação de teste": "Notificación de prueba",
  "O HostVSL está sendo instalado": "HostVSL se está instalando",
  "Você pode acessar o HostVSL pela tela inicial": "Puedes acceder a HostVSL desde tu pantalla de inicio",
  "Instalação não disponível": "Instalación no disponible",
  "URL inválida": "URL no válida",
  "Formato não suportado. Use PNG ou JPG": "Formato no compatible. Usa PNG o JPG",
  "A thumbnail de início foi configurada": "La miniatura de inicio fue configurada",
  "Botão adicionado": "Botón añadido",
  "Botão removido": "Botón eliminado",
  "ID do vídeo não encontrado": "ID de video no encontrado",
  "Envie seu primeiro vídeo para começar": "Sube tu primer video para comenzar",
  "Enviar primeiro vídeo": "Subir primer video",
  "Perfil salvo": "Perfil guardado",
  "Senha alterada com sucesso": "Contraseña cambiada con éxito",
  "Foto alterada": "Foto cambiada",
  "Foto removida": "Foto eliminada",
  "Configuração de Pixel": "Configuración de Pixel",
  "Configure pixels de rastreamento para monitorar conversões": "Configura píxeles de seguimiento para monitorear conversiones",
  "Selecione um vídeo para ver as métricas": "Selecciona un video para ver las métricas",
  "Proteção de Domínios": "Protección de Dominios",
  "Financeiro": "Finanzas",
  "Página não encontrada": "Página no encontrada",
  "Voltar ao início": "Volver al inicio",
  "Seus Testes A/B": "Tus Pruebas A/B",
  "Criar novo teste": "Crear nueva prueba",
  "Nenhum teste A/B encontrado": "No se encontraron pruebas A/B",
  "Crie seu primeiro teste A/B para comparar diferentes versões de vídeos.": "Crea tu primera prueba A/B para comparar diferentes versiones de videos.",
  "Copiar Código": "Copiar Código",
  "Renomear": "Renombrar",
  "Ver Métricas": "Ver Métricas",
  "Excluir teste A/B?": "¿Eliminar prueba A/B?",
  "Esta ação irá excluir permanentemente este teste e todos os seus dados. Esta ação não pode ser desfeita.": "Esta acción eliminará permanentemente esta prueba y todos sus datos. Esta acción no puede deshacerse.",
  "Sim, excluir teste": "Sí, eliminar prueba",
  "O código do teste A/B foi copiado para a área de transferência.": "El código de la prueba A/B ha sido copiado al portapapeles.",
  "O teste A/B foi excluído com sucesso.": "La prueba A/B ha sido eliminada con éxito.",
  "Erro ao excluir": "Error al eliminar",
  "Teste renomeado": "Prueba renombrada",
  "O nome do teste foi atualizado com sucesso.": "El nombre de la prueba ha sido actualizado con éxito.",
  "Erro ao renomear": "Error al renombrar",
  "Não foi possível renomear o teste.": "No se pudo renombrar la prueba.",
  "Erro ao copiar código": "Error al copiar código",
  "Este teste não possui vídeos associados.": "Esta prueba no tiene videos asociados.",
  "Em desenvolvimento": "En desarrollo",
  "Função de ativar/desativar em desenvolvimento.": "La función de activar/desactivar está en desarrollo.",
  "Função de duplicar em desenvolvimento.": "La función de duplicar está en desarrollo.",
  "Seus Testes de Introduções": "Tus Pruebas de Introducción",
  "Criar Teste de Hook": "Crear Prueba de Hook",
  "Você ainda não criou nenhum teste de hook.": "Aún no has creado ninguna prueba de hook.",
  "Criar seu primeiro teste": "Crear tu primera prueba",
  "Excluir teste de hook?": "¿Eliminar prueba de hook?",
  "O teste foi excluído com sucesso.": "La prueba ha sido eliminada con éxito.",
  "Não foi possível atualizar o nome do teste.": "No se pudo actualizar el nombre de la prueba.",
  "Status atualizado": "Estado actualizado",
  "O status do teste foi atualizado.": "El estado de la prueba ha sido actualizado.",
  "Funcionalidade de duplicação em breve.": "Funcionalidad de duplicación próximamente.",
  "Teste sem nome": "Prueba sin nombre",
  "Erro ao remover vídeo da pasta": "Error al eliminar video de la carpeta",
  "Pessoal": "Personal",
  "Idioma": "Idioma",
  "Nome": "Nombre",
  "Sobrenome": "Apellido",
  "Empresa (Opcional)": "Empresa",
  "Senha Atual": "Contraseña actual",
  "Nova Senha": "Nueva contraseña",
  "Confirmar Nova Senha": "Confirmar nueva contraseña",
  "Sua senha deve ter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas e números": "Requisitos de contraseña",
  "Ative o recurso para configurar": "Activa el recurso para configurar",
  "Direcione seus espectadores com um CTA no momento certo.": "Guía a tus espectadores con un CTA en el momento adecuado.",
  "Configuração do Botão": "Configuración del Botón",
  "Defina o texto e link do seu CTA.": "Define el texto y el enlace de tu CTA.",
  "Texto do botão": "Texto del botón",
  "Link do botão": "Enlace del botón",
  "Aparência": "Apariencia",
  "Personalize as cores do botão.": "Personaliza los colores del botón.",
  "Fundo": "Fondo",
  "Texto": "Texto",
  "Cor do Botão": "Color del botón",
  "Cor do Texto": "Color del texto",
  "Tempo de Exibição": "Tiempo de exhibición",
  "Defina quando o botão aparecerá no vídeo.": "Define cuándo aparecerá el botón en el video.",
  "segundos": "segundos",
  "Notificação de Vendas": "Notificación de Ventas",
  "Mostre vendas recentes para criar prova social.": "Muestra ventas recientes para crear prueba social.",
  "Conteúdo": "Contenido",
  "Ativo · 1 notificação a cada {freq}s · {pos}": "Activo · 1 notificación cada {freq}s · {pos}",
  "Velocidade das Notificações": "Velocidad de las Notificaciones",
  "Atraso inicial": "Retraso inicial",
  "Frequência": "Frecuencia",
  "Duração": "Duración",
  "Posição": "Posición",
  "Superior Esquerda": "Superior Izquierda",
  "Superior Direita": "Superior Derecha",
  "Inferior Esquerda": "Inferior Izquierda",
  "Inferior Direita": "Inferior Derecha",
  "Repetir em loop": "Repetir en bucle",
  "Reinicia automaticamente após exibir todas.": "Se reinicia automáticamente al mostrar todas.",
  "Interação": "Interacción",
  "Ao clicar, abrir link": "Al hacer clic, abrir enlace",
  "Abre uma URL ao clicar na notificação.": "Abre una URL al hacer clic en la notificación.",
  "https://exemplo.com/oferta": "https://ejemplo.com/oferta",
  "Ao clicar na notificação, abrir esta URL em nova aba.": "Al hacer clic, abrir esta URL en una pestaña nueva.",
  "URL inválida. Use http:// ou https://. Ex: https://seu-site.com": "URL inválida. Usa http:// o https://. Ej: https://tu-sitio.com",
  "Sem http:// — vamos salvar como https://{url}": "Sin http:// — se guardará como https://{url}",
  "Som": "Sonido",
  "Reproduz um som junto da notificação.": "Reproduce un sonido junto a la notificación.",
  "Volume": "Volumen",
  "Testar som": "Probar sonido",
  "Mensagem": "Mensaje",
  "Nome do produto": "Nombre del producto",
  "Ex: Curso Premium": "Ej: Curso Premium",
  "Mostrar plataforma": "Mostrar plataforma",
  "Selecione uma plataforma": "Selecciona una plataforma",
  "Personalizado": "Personalizado",
  "Logo personalizado": "Logo personalizado",
  "Clique para trocar": "Haz clic para cambiar",
  "Adicionar logo": "Agregar logo",
  "Dados simulados": "Datos simulados",
  "Nomes": "Nombres",
  "Cidades": "Ciudades",
  "Sugestão automática": "Sugerencia automática",
  "(recomendado)": "(recomendado)",
  "Lista personalizada": "Lista personalizada",
  "Não exibir localização": "No mostrar ubicación",
  "Digite e pressione Enter": "Escribe y presiona Enter",
  "Adicionar 10 exemplos": "Agregar 10 ejemplos",
  "Texto do template": "Texto de la plantilla",
  "{nome} de {cidade} acabou de comprar {produto}": "{nome} de {cidade} acaba de comprar {produto}",
  "Inserir:": "Insertar:",
  "Prévia": "Vista previa",
  "Estilo": "Estilo",
  "Cor de fundo": "Color de fondo",
  "Cor da borda": "Color del borde",
  "Cor da letra": "Color del texto",
  "Arredondamento": "Redondeo",
  "Mostrar ícone": "Mostrar ícono",
  "Ajustes rápidos": "Ajustes rápidos",
  "Tamanho": "Tamaño",
  "Pequeno": "Pequeño",
  "Médio": "Mediano",
  "Grande": "Grande",
  "Essas configurações não afetam o funcionamento do vídeo.": "Estas configuraciones no afectan el funcionamiento del video.",
  "Cor personalizada": "Color personalizado",
  "Adicionar...": "Añadir...",
  "Borda do Player": "Borde del Reproductor",
  "Destaque o player com borda e sombra.": "Destaca el reproductor con borde y sombra.",
  "Cor, espessura e arredondamento da borda.": "Color, grosor y redondeo del borde.",
  "Espessura": "Grosor",
  "Clique para alterar": "Haz clic para cambiar",
  "Ativar sombra": "Activar sombra",
  "Adicione profundidade e destaque ao player.": "Añade profundidad y énfasis al reproductor.",
  "Configurações de Sombra": "Configuración de Sombra",
  "Ajuste cor, desfoque e intensidade.": "Ajusta color, desenfoque e intensidad.",
  "Cor da sombra": "Color de la sombra",
  "Desfoque": "Desenfoque",
  "Intensidade": "Intensidad",
  "Controles do Vídeo": "Controles del Video",
  "Permita interação com o vídeo e aumente controle, retenção e experiência do usuário.": "Configura el comportamiento de reproducción del video.",
  "Comportamento de Loop": "Comportamiento de Bucle",
  "Define se o vídeo repete automaticamente.": "Define si el video se repite automáticamente.",
  "Não repetir": "No repetir",
  "Repetir": "Repetir",
  "Pausa Inteligente": "Pausa Inteligente",
  "Pausa o vídeo quando o espectador sai da aba.": "Pausa el video cuando el espectador sale de la pestaña.",
  "Funciona quando o visitante troca de aba ou minimiza o navegador.": "Funciona cuando el visitante cambia de pestaña o minimiza el navegador.",
  "Pausa inteligente ativada": "Pausa inteligente activada",
  "Pausa inteligente desativada": "Pausa inteligente desactivada",
  "Ativo": "Activo",
  "O vídeo pausa ao sair da aba e retoma automaticamente ao retornar.": "El video se pausa al salir de la pestaña y se reanuda automáticamente al volver.",
  "Ative o recurso acima para pausar o vídeo quando o visitante sair da aba.": "Activa el recurso arriba para pausar el video cuando el visitante salga de la pestaña.",
  "Recomeçar o vídeo ao finalizar": "Reiniciar el video al finalizar",
  "Volta o vídeo ao início quando a reprodução termina.": "Reinicia el video cuando termina la reproducción.",
  "Funciona ao final da reprodução do vídeo.": "Funciona al finalizar la reproducción del video.",
  "Reinício automático ativado": "Reinicio automático activado",
  "Reinício automático desativado": "Reinicio automático desactivado",
  "Ao finalizar, o vídeo volta ao início automaticamente, mantendo a reprodução em loop.": "Al finalizar, el video vuelve al inicio automáticamente, manteniendo la reproducción en bucle.",
  "Ative o recurso acima para reiniciar o vídeo automaticamente ao chegar ao fim.": "Activa el recurso arriba para reiniciar el video automáticamente al llegar al final.",
  "Ativar link de afiliado": "Activar enlace de afiliado",
  "Exibe a logo HostVSL e ativa seu link de afiliado.": "Muestra el logo HostVSL y activa tu enlace de afiliado.",
  "Seu link de afiliado": "Tu enlace de afiliado",
  "https://hostvsl.com/?ref=SEU_ID": "https://hostvsl.com/?ref=TU_ID",
  "Parece que este link não é válido. Verifique e tente novamente.": "Este enlace no parece válido. Verifícalo e inténtalo de nuevo.",
  "Insira seu link de afiliado para ganhar comissões. A logo da HostVSL ficará disponível no canto superior direito do player e, ao clicar nela, seu link de afiliado será aberto em uma nova aba.": "Ingresa tu enlace de afiliado para ganar comisiones. El logo de HostVSL aparecerá en la esquina superior derecha del reproductor y al hacer clic abrirá tu enlace en una nueva pestaña.",
  "Logo da HostVSL será exibida no player.": "El logo de HostVSL se mostrará en el reproductor.",
  "Clique do usuário abrirá:": "El clic del usuario abrirá:",
  "Token copiado!": "¡Token copiado!",
  "Facebook": "Facebook",
  "Continuar de onde parou": "Continuar donde lo dejaste",
  "Permite que usuários retomem o vídeo de onde pararam": "Permite que los usuarios reanuden el video donde lo dejaron",
  "Templates": "Plantillas",
  "Selecione um template para a tela de retorno": "Selecciona una plantilla para la pantalla de retorno",
  "Retomar": "Reanudar",
  "Upload Personalizado": "Subida Personalizada",
  "Arraste seu arquivo ou clique para enviar": "Arrastra tu archivo o haz clic para subir",
  "Tamanho máximo: 2MB": "Tamaño máximo: 2MB",
  "Trocar": "Cambiar",
  "Remover": "Quitar",
  "Opções de personalização em breve.": "Opciones de personalización próximamente.",
  "Thumbnails do Vídeo": "Miniaturas del Video",
  "Defina imagens estratégicas para reforçar a atenção.": "Define imágenes estratégicas para reforzar la atención.",
  "Início, pausa e final podem ter imagens diferentes.": "Inicio, pausa y final pueden tener imágenes diferentes.",
  "Pausa": "Pausa",
  "Final": "Final",
  "Thumbnail adicionada com sucesso": "Miniatura añadida con éxito",
  "Configure o botão de ação se desejar": "Configura el botón de acción si lo deseas",
  "A thumbnail de final foi configurada": "La miniatura de final fue configurada",
  "Thumbnail removida com sucesso": "Miniatura eliminada con éxito",
  "A thumbnail foi removida": "La miniatura fue eliminada",
  "Modo atualizado": "Modo actualizado",
  "Thumbnail será exibida sempre que pausar": "La miniatura se mostrará siempre que se pause",
  "Thumbnail será exibida apenas no trecho específico": "La miniatura se mostrará solo en el tramo específico",
  "Configure o botão e visualize no preview": "Configura el botón y visualízalo en la previsualización",
  "O botão foi removido do thumbnail de pausa": "El botón fue eliminado de la miniatura de pausa",
  "Continue Assistindo": "Continuar Viendo",
  "Contagem Final Inteligente": "Cuenta Regresiva Final Inteligente",
  "Exibe uma contagem regressiva ao final do vídeo e redireciona automaticamente.": "Muestra una cuenta regresiva al final del video y redirige automáticamente.",
  "Essencial": "Esencial",
  "Tempo da contagem": "Tiempo de la cuenta",
  "Redirecionamento": "Redirección",
  "Ao finalizar": "Al finalizar",
  "Redirecionar automaticamente ao terminar": "Redirigir automáticamente al terminar",
  "Apenas exibir o aviso": "Solo mostrar el aviso",
  "URL de destino": "URL de destino",
  "https://seu-checkout.com": "https://tu-checkout.com",
  "Informe uma URL para ativar o redirecionamento.": "Ingresa una URL para activar la redirección.",
  "URL inválida. Ex: https://seu-site.com": "URL inválida. Ej: https://tu-sitio.com",
  "Sem uma URL de redirecionamento válida o botão não aparece para o espectador.": "Sin una URL de redirección válida el botón no se muestra al espectador.",
  "Fechar e voltar ao vídeo": "Cerrar y volver al video",
  "Abertura do link": "Apertura del enlace",
  "Abrir na mesma aba": "Abrir en la misma pestaña",
  "Abrir em nova aba": "Abrir en una pestaña nueva",
  "Essas opções são usadas apenas quando o redirecionamento automático estiver ativo.": "Estas opciones se usan solo cuando la redirección automática está activa.",
  "Conteúdo do Card": "Contenido del Card",
  "Título do Card": "Título del Card",
  "Oferta Especial Liberada!": "¡Oferta Especial Liberada!",
  "Descrição": "Descripción",
  "Você será redirecionado em alguns segundos…": "Serás redirigido en unos segundos…",
  "A contagem será exibida automaticamente com base no tempo definido.": "La cuenta se mostrará automáticamente según el tiempo definido.",
  "Botão \"Ir Agora\"": "Botón \"Ir Ahora\"",
  "Exibir botão": "Mostrar botón",
  "Ir Agora": "Ir Ahora",
  "Ação do botão": "Acción del botón",
  "Modo de exibição": "Modo de visualización",
  "Sobrepor no vídeo": "Superponer en el video",
  "Tela cheia": "Pantalla completa",
  "Preset de estilo": "Estilo predefinido",
  "Padrão Host": "Predeterminado Host",
  "Recomendado": "Recomendado",
  "Discreto": "Discreto",
  "Suave e limpo": "Suave y limpio",
  "Opacidade do fundo": "Opacidad del fondo",
  "Raio do card": "Radio del card",
  "Cor principal": "Color principal",
  "Cor Principal": "Color Principal",
  "Aplicada no botão e detalhes": "Aplicado al botón y detalles",
  "Cor do fundo": "Color del fondo",
  "Cor Personalizada": "Color Personalizado",
  "Contagem": "Cuenta",
  "Cor do Círculo": "Color del Círculo",
  "Cor do Número": "Color del Número",
  "P": "P",
  "M": "M",
  "G": "G",
  "Tipografia": "Tipografía",
  "Cor do Título": "Color del Título",
  "Cor da Descrição": "Color de la Descripción",
  "Botão": "Botón",
  "Raio": "Radio",
  "Logo": "Logo",
  "Exiba sua logomarca sobre o vídeo.": "Muestra tu logotipo sobre el video.",
  "Upload da Logo": "Subir Logo",
  "Formato não suportado. Use PNG ou JPG.": "Formato no soportado. Usa PNG o JPG.",
  "Arquivo maior que {n}MB": "Archivo mayor que {n}MB",
  "Erro ao processar arquivo": "Error al procesar el archivo",
  "Link de destino": "Enlace de destino",
  "seusite.com": "tusitio.com",
  "Digite um domínio válido. Ex: seusite.com": "Ingresa un dominio válido. Ej: tusitio.com",
  "→ Será salvo como:": "→ Se guardará como:",
  "Aceita: seusite.com, www.seusite.com ou https://seusite.com": "Acepta: tusitio.com, www.tusitio.com o https://tusitio.com",
  "Adicionar parâmetros UTM": "Añadir parámetros UTM",
  "utm_source (ex: youtube)": "utm_source (ej: youtube)",
  "utm_medium (ex: video)": "utm_medium (ej: video)",
  "utm_campaign (ex: lancamento)": "utm_campaign (ej: lanzamiento)",
  "Posição e Tamanho": "Posición y tamaño",
  "Posição no player": "Posición en el reproductor",
  "Ajustes finos": "Ajustes finos",
  "Deslocamento Horizontal": "Desplazamiento Horizontal",
  "Deslocamento Vertical": "Desplazamiento Vertical",
  "Tamanho e Transparência": "Tamaño y Transparencia",
  "Transparência": "Transparencia",
  "Adicionar borda": "Añadir borde",
  "Adicionar sombra": "Añadir sombra",
  "Superior Centro": "Superior Centro",
  "Centro Esquerda": "Centro Izquierda",
  "Centro": "Centro",
  "Centro Direita": "Centro Derecha",
  "Inferior Centro": "Inferior Centro",
  "Mini-Hook": "Mini-Hook",
  "Exiba imagens ou GIFs em momentos estratégicos.": "Muestra imágenes o GIFs en momentos estratégicos.",
  "Imagem": "Imagen",
  "Excluir": "Eliminar",
  "Comece com seu primeiro Mini-Hook": "Comienza con tu primer Mini-Hook",
  "Use Mini-Hooks para exibir imagens ou GIFs em momentos estratégicos do vídeo. Ideal para reforçar promessas, criar avisos visuais e recuperar atenção.": "Usa Mini-Hooks para mostrar imágenes o GIFs en momentos estratégicos. Ideal para reforzar promesas, crear avisos visuales y recuperar atención.",
  "Criar primeiro Mini-Hook": "Crear primer Mini-Hook",
  "Mini-Hooks": "Mini-Hooks",
  "ativo": "activo",
  "ativos": "activos",
  "Novo Mini-Hook": "Nuevo Mini-Hook",
  "Buscar Mini-Hook": "Buscar Mini-Hook",
  "Voltar": "Volver",
  "Nome interno": "Nombre interno",
  "Ex: Reforço da promessa inicial": "Ej: Refuerzo de la promesa inicial",
  "Imagem ou GIF": "Imagen o GIF",
  "Clique ou arraste o arquivo aqui": "Haz clic o arrastra el archivo aquí",
  "JPG, PNG, WEBP e GIF • até 20 MB": "JPG, PNG, WEBP y GIF • hasta 20 MB",
  "Arquivo": "Archivo",
  "GIF animado": "GIF animado",
  "Imagem estática": "Imagen estática",
  "Analisando…": "Analizando…",
  "Otimizando…": "Optimizando…",
  "Arquivo leve": "Archivo ligero",
  "Pode impactar performance": "Puede impactar el rendimiento",
  "Este GIF é pesado ({size}) e pode impactar a fluidez do preview. Recomendamos usar um GIF mais leve ou reduzir as dimensões.": "Este GIF es pesado ({size}) y puede afectar la fluidez del preview. Recomendamos usar un GIF más ligero o reducir las dimensiones.",
  "Otimizar automaticamente": "Optimizar automáticamente",
  "GIFs otimizados deixam o Mini-Hook mais fluido.": "Los GIFs optimizados hacen el Mini-Hook más fluido.",
  "Temporização": "Temporización",
  "Aparecer em": "Aparecer en",
  "Desaparecer em": "Desaparecer en",
  "Opacidade": "Opacidad",
  "Cancelar": "Cancelar",
  "Salvar alterações": "Guardar cambios",
  "Criar Mini-Hook": "Crear Mini-Hook",
  "Arquivo muito grande. Máximo: 20 MB": "Archivo demasiado grande. Máximo: 20 MB",
  "Formato inválido. Use JPG, PNG, WEBP ou GIF.": "Formato inválido. Usa JPG, PNG, WEBP o GIF.",
  "GIF otimizado • {n}% mais leve": "GIF optimizado • {n}% más ligero",
  "GIF pesado pode impactar a fluidez do preview.": "GIF pesado puede afectar la fluidez del preview.",
  "Mini-Hook atualizado com sucesso": "Mini-Hook actualizado con éxito",
  "Mini-Hook criado com sucesso": "Mini-Hook creado con éxito",
  "Mini-Hook duplicado com sucesso": "Mini-Hook duplicado con éxito",
  "Mini-Hook removido com sucesso": "Mini-Hook eliminado con éxito",
  "Este Mini-Hook se sobrepõe a \"{name}\" no mesmo intervalo.": "Este Mini-Hook se superpone con \"{name}\" en el mismo intervalo.",
  "(cópia)": "(copia)",
  "Envie uma imagem ou GIF para continuar.": "Sube una imagen o GIF para continuar.",
  "Digite um nome para identificar este Mini-Hook.": "Ingresa un nombre para identificar este Mini-Hook.",
  "O tempo de saída precisa ser maior que o tempo de entrada.": "El tiempo de salida debe ser mayor que el de entrada.",
  "Excluir Mini-Hook?": "¿Eliminar Mini-Hook?",
  "Tem certeza que deseja excluir este Mini-Hook? Esta ação não pode ser desfeita.": "¿Seguro que deseas eliminar este Mini-Hook? Esta acción no se puede deshacer.",
  "Legendas": "Subtítulos",
  "Adicione legendas para melhorar a acessibilidade.": "Añade subtítulos para mejorar la accesibilidad.",
  "Configure suas legendas": "Configura tus subtítulos",
  "Com as legendas ativadas, você pode adicionar arquivos .SRT ou .VTT ao seu vídeo. O espectador poderá ativar ou desativar a legenda pelo botão CC nos controles.": "Con los subtítulos activados, puedes añadir archivos .SRT o .VTT a tu video. El espectador podrá activarlos o desactivarlos con el botón CC.",
  "Ative o switch acima para começar a configurar suas legendas.": "Activa el switch arriba para empezar a configurar tus subtítulos.",
  "Aprenda sobre legendas": "Aprende sobre subtítulos",
  "Envie um arquivo .VTT ou .SRT com as legendas sincronizadas. Ambos os formatos são suportados.": "Sube un archivo .VTT o .SRT con los subtítulos sincronizados. Ambos formatos son compatibles.",
  "Arquivo da legenda": "Archivo de subtítulos",
  "Envie o arquivo .VTT ou .SRT com as legendas sincronizadas.": "Sube el archivo .VTT o .SRT con los subtítulos sincronizados.",
  "Clique ou arraste o arquivo .VTT ou .SRT": "Haz clic o arrastra el archivo .VTT o .SRT",
  "Formatos aceitos: .VTT, .SRT": "Formatos aceptados: .VTT, .SRT",
  "Arquivo inválido ou corrompido. Nenhuma legenda encontrada.": "Archivo inválido o corrupto. No se encontraron subtítulos.",
  "Baixe o arquivo modelo para ver o formato correto": "Descarga el archivo modelo para ver el formato correcto",
  "Precisa de ajuda para criar sua legenda?": "¿Necesitas ayuda para crear tus subtítulos?",
  "Baixar modelo (.TXT)": "Descargar modelo (.TXT)",
  "Baixe um exemplo simples para preencher suas legendas.": "Descarga un ejemplo simple para rellenar tus subtítulos.",
  "Converter para VTT": "Convertir a VTT",
  "Converta seu texto para o formato aceito.": "Convierte tu texto al formato aceptado.",
  "Carregado": "Cargado",
  "legenda": "subtítulo",
  "legendas": "subtítulos",
  "Editar legenda": "Editar subtítulo",
  "Substituir arquivo": "Reemplazar archivo",
  "Remover legenda": "Quitar subtítulo",
  "Pré-visualização": "Vista previa",
  "Buscar legenda...": "Buscar subtítulo...",
  "Nenhuma legenda encontrada para \"{q}\"": "No se encontraron subtítulos para \"{q}\"",
  "Mostrar menos": "Mostrar menos",
  "Ver todas ({n})": "Ver todos ({n})",
  "Editar texto": "Editar texto",
  "Excluir legenda": "Eliminar subtítulo",
  "Clique para editar tempo": "Haz clic para editar tiempo",
  "Editar conteúdo VTT": "Editar contenido VTT",
  "Salvar": "Guardar",
  "Tempo inválido. Use o formato m:ss.s e garanta que início < fim.": "Tiempo inválido. Usa el formato m:ss.s y asegura que inicio < fin.",
  "Tempo atualizado!": "¡Tiempo actualizado!",
  "O texto da legenda não pode estar vazio.": "El texto del subtítulo no puede estar vacío.",
  "Texto atualizado!": "¡Texto actualizado!",
  "Tem certeza que deseja excluir esta legenda?": "¿Seguro que deseas eliminar este subtítulo?",
  "Última legenda removida. Arquivo excluído.": "Último subtítulo eliminado. Archivo borrado.",
  "Legenda excluída!": "¡Subtítulo eliminado!",
  "Ordem atualizada!": "¡Orden actualizado!",
  "Configurações da legenda": "Configuración de subtítulos",
  "Personalize a exibição das legendas no player.": "Personaliza cómo se muestran los subtítulos en el reproductor.",
  "Exibir legenda por padrão": "Mostrar subtítulos por defecto",
  "A legenda já começa ativa quando o vídeo carregar": "Los subtítulos comienzan activos al cargar el video",
  "Mostrar botão de legenda": "Mostrar botón de subtítulos",
  "Permite que o espectador ative ou desative": "Permite que el espectador los active o desactive",
  "A legenda ficará desativada para o espectador.": "Los subtítulos quedarán desactivados para el espectador.",
  "Tamanho da fonte": "Tamaño de fuente",
  "Alinhamento": "Alineación",
  "Cor do texto": "Color del texto",
  "Estilo da legenda": "Estilo del subtítulo",
  "Escolha como a legenda aparece no player.": "Elige cómo aparece el subtítulo en el reproductor.",
  "Tipo de animação": "Tipo de animación",
  "Padrão": "Estándar",
  "Sem animação": "Sin animación",
  "Fade suave": "Fundido suave",
  "Transição suave": "Transición suave",
  "Pop / Destaque": "Aparición / Destacado",
  "Escala com impacto": "Escala con impacto",
  "Palavra por palavra": "Palabra por palabra",
  "Estilo TikTok": "Estilo TikTok",
  "Estilo do destaque": "Estilo del destaque",
  "Fundo colorido": "Fondo coloreado",
  "Escala leve": "Escala ligera",
  "Cor do destaque": "Color del destaque",
  "📋 O que são Headlines/Subheadlines?": "📋 ¿Qué son los Titulares/Subtítulos?",
  "Deseja realmente excluir esta ação?": "¿Realmente quieres eliminar esta acción?",
  "\"Assista esse vídeo\"": "\"Mira este video\"",
  "\"Ganhe R$ 1.000/mês\" vs \"Ganhe dinheiro\"": "\"Gana R$ 1.000/mes\" vs \"Gana dinero\"",
  "\"Últimas 24h\", \"Vagas Limitadas\"": "\"Últimas 24h\", \"Cupos Limitados\"",
  "<div>Seu HTML aqui</div>": "<div>Tu HTML aquí</div>",
  "<h1>Meu título personalizado</h1>&#10;Cole seu código HTML aqui...": "<h1>Mi título personalizado</h1>&#10;Pega tu código HTML aquí...",
  "A distribuição precisa somar 100%": "La distribución debe sumar 100%",
  "A reprodução automática cria a sensação de início imediato, aumentando o engajamento dos usuários. O vídeo começa sem som para cumprir as políticas dos navegadores, e o overlay incentiva a ativação do áudio.": "La reproducción automática crea la sensación de inicio inmediato, aumentando el engagement. El video comienza sin sonido para cumplir las políticas de los navegadores, y el overlay incentiva la activación del audio.",
  "A soma da distribuição de tráfego deve ser 100%": "La distribución de tráfico debe sumar 100%",
  "Adicionar classe": "Añadir clase",
  "Aguarde pelo menos 7 dias para que o teste colete dados suficientes": "Espera al menos 7 días para que la prueba recopile datos suficientes",
  "Ajustamos o intervalo para manter a ordem correta.": "Ajustamos el intervalo para mantener el orden correcto.",
  "Ajuste a aparência do overlay de autoplay": "Ajusta la apariencia del overlay de autoplay",
  "Ajuste velocidade e visibilidade dos controles.": "Ajusta velocidad y visibilidad de los controles.",
  "Alterar estilo": "Cambiar estilo",
  "Alterar texto": "Cambiar texto",
  "Animação Pulsar": "Animación de pulso",
  "Animação de entrada": "Animación de entrada",
  "Exibe a headline diretamente sobre o vídeo.": "Muestra el titular directamente sobre el video.",
  "Ao finalizar, a velocidade com melhor engajamento será definida como principal.": "Al finalizar, la velocidad con mejor engagement se definirá como principal.",
  "Aparência do Player": "Apariencia del Player",
  "Aparência dos Controles": "Apariencia de los Controles",
  "Aplicada em barra de controle, play, volume e botões principais": "Aplicada en barra de control, play, volumen y botones principales",
  "Aplicada em ícones secundários e textos do player": "Aplicada en iconos secundarios y textos del player",
  "Arraste ou clique para enviar": "Arrastra o haz clic para subir",
  "Arraste sua imagem de fundo": "Arrastra tu imagen de fondo",
  "Assistir do início": "Ver desde el inicio",
  "Ativar Autoplay": "Activar Autoplay",
  "Ativar Ações Sincronizadas": "Activar Acciones Sincronizadas",
  "Ativar Continuar Assistindo": "Activar Continuar Viendo",
  "Headline": "Titular",
  "Ativar Velocidade": "Activar Velocidad",
  "Ativar botão": "Activar botón",
  "Ativar tema do player": "Activar tema del player",
  "Ativar teste automático": "Activar prueba automática",
  "Ative o autoplay na aba Configuração para configurar testes A/B": "Activa el autoplay en la pestaña Configuración para configurar pruebas A/B",
  "Ative o autoplay para ver o preview": "Activa el autoplay para ver la vista previa",
  "Ative o som": "Activa el sonido",
  "Até": "Hasta",
  "Aumente a retenção com um vídeo gancho no autoplay": "Aumenta la retención con un video gancho en el autoplay",
  "Avalie o contexto do seu conteúdo - vídeos técnicos podem funcionar melhor em velocidades mais baixas": "Evalúa el contexto de tu contenido — los videos técnicos pueden funcionar mejor a velocidades más bajas",
  "Avançado": "Avanzado",
  "Avançar 10s": "Avanzar 10s",
  "Ação": "Acción",
  "Ação atualizada com sucesso!": "¡Acción actualizada con éxito!",
  "Ação criada com sucesso!": "¡Acción creada con éxito!",
  "Ação excluída com sucesso!": "¡Acción eliminada con éxito!",
  "Ações": "Acciones",
  "Baixo Direita": "Inferior Derecha",
  "Baixo Esquerda": "Inferior Izquierda",
  "Barra Inferior": "Barra Inferior",
  "Barra de Controles": "Barra de Controles",
  "Barra de Progresso": "Barra de Progreso",
  "Botão continuar": "Botón continuar",
  "Botão discreto sobre o vídeo": "Botón discreto sobre el video",
  "Botão play pequeno": "Botón play pequeño",
  "Botão reiniciar": "Botón reiniciar",
  "C. no Botão": "Color del Botón",
  "C. no botão": "Color del botón",
  "Click": "Click",
  "Click Here": "Click Aquí",
  "Cole seu código HTML aqui...&#10;Aceita HTML, CSS inline e scripts leves.": "Pega tu código HTML aquí...&#10;Acepta HTML, CSS inline y scripts ligeros.",
  "Como ficará no vídeo": "Cómo se verá en el video",
  "Compare no mínimo 3 velocidades diferentes para melhores resultados": "Compara al menos 3 velocidades diferentes para mejores resultados",
  "Comportamento": "Comportamiento",
  "Comportamento do Vídeo de Fundo": "Comportamiento del Video de Fondo",
  "Configuração Personalizada": "Configuración Personalizada",
  "Configurações Técnicas": "Configuración Técnica",
  "Configure como o autoplay se comporta": "Configura cómo se comporta el autoplay",
  "Configure os botões de reprodução e volume.": "Configura los botones de reproducción y volumen.",
  "Configure quando a headline aparece e desaparece": "Configura cuándo aparece y desaparece el titular",
  "Configure tamanho e posição por dispositivo.": "Configura tamaño y posición por dispositivo.",
  "Considere o público-alvo: usuários mais técnicos geralmente são mais receptivos a velocidades mais rápidas.": "Considera al público: los usuarios más técnicos suelen ser más receptivos a velocidades más rápidas.",
  "Conteúdo HTML": "Contenido HTML",
  "Conteúdo de Continuar de onde parou": "Contenido de Continuar Viendo",
  "Continuar Assistindo": "Continuar Viendo",
  "Continuar agora": "Continuar ahora",
  "Continuar assistindo?": "¿Continuar viendo?",
  "Contraste adequado com o fundo": "Contraste adecuado con el fondo",
  "Controle de volume": "Control de volumen",
  "Controles": "Controles",
  "Controles Principais": "Controles Principales",
  "Controles de Reprodução": "Controles de Reproducción",
  "Controles do Player": "Controles del Player",
  "Controles foram desabilitados automaticamente ao ativar autoplay": "Los controles fueron desactivados automáticamente al activar el autoplay",
  "Conversão:": "Conversión:",
  "Conversões": "Conversiones",
  "Conversões dividido por visualizações": "Conversiones divididas por visualizaciones",
  "Cor": "Color",
  "Cor Primária": "Color primario",
  "Cor Secundária": "Color secundario",
  "Cor Sólida": "Color sólido",
  "Cor da Borda": "Color del borde",
  "Cor da Subheadline": "Color del subtítulo",
  "Cor de Fundo": "Color de fondo",
  "Cor de fundo dos controles": "Color de fondo de los controles",
  "Cor de fundo e opacidade da barra inferior.": "Color de fondo y opacidad de la barra inferior.",
  "Cor do Fundo": "Color de fondo",
  "Cor do Ícone": "Color del icono",
  "Cores do Autoplay": "Colores del Autoplay",
  "Cores do Botão": "Colores del botón",
  "Cores do Overlay": "Colores del overlay",
  "Cores do Player": "Colores del Player",
  "Cores do overlay": "Colores del overlay",
  "Crie sua primeira variação": "Crea tu primera variación",
  "Curva de Retenção": "Curva de Retención",
  "Custom": "Personalizado",
  "Custom icon": "Icono personalizado",
  "Custom overlay": "Overlay personalizado",
  "Código HTML": "Código HTML",
  "Código HTML personalizado": "Código HTML personalizado",
  "Código copiado para a área de transferência": "Código copiado al portapapeles",
  "Código copiado para a área de transferência!": "¡Código copiado al portapapeles!",
  "Dados resetados com sucesso!": "¡Datos restablecidos con éxito!",
  "De": "De",
  "Defina uma velocidade fixa ou rode um teste automático.": "Define una velocidad fija o ejecuta una prueba.",
  "Desabilitar controles": "Desactivar controles",
  "Destaca o botão central de play": "Destaca el botón central de play",
  "Dica: clique na caixa no player para mover e redimensionar.": "Consejo: haz clic en la caja del player para mover y redimensionar.",
  "Digite o novo texto": "Escribe el nuevo texto",
  "Digite o texto da subheadline (opcional)": "Escribe el texto del subtítulo (opcional)",
  "Digite o texto principal...": "Escribe el texto principal...",
  "Digite o texto secundário...": "Escribe el texto secundario...",
  "Digite um nome para a variação": "Escribe un nombre para la variación",
  "Direita": "Derecha",
  "Distribuição de tráfego atualizada com sucesso!": "¡Distribución de tráfico actualizada con éxito!",
  "Duração da exibição (segundos)": "Duración de la exhibición (segundos)",
  "Duração do Teste": "Duración de la prueba",
  "Editar": "Editar",
  "Encerra o teste e mantém a variação vencedora ativa.": "Finaliza la prueba y mantiene la variación ganadora activa.",
  "Engajamento": "Engagement",
  "Enviar Imagem": "Subir imagen",
  "Enviar Ícone (SVG recomendado)": "Subir icono (SVG recomendado)",
  "Envie uma imagem para o template personalizado": "Sube una imagen para la plantilla personalizada",
  "Escolha o estilo visual do botão de play do seu player.": "Elige el estilo visual del botón de play de tu player.",
  "Escolha o ícone": "Elige el icono",
  "Escolha um modelo visual para o overlay": "Elige una plantilla visual para el overlay",
  "Escolha um vídeo da biblioteca": "Elige un video de la biblioteca",
  "Esconder Início": "Ocultar inicio",
  "Esquerda": "Izquierda",
  "Estilo Avançado": "Estilo avanzado",
  "Estilo da Barra": "Estilo de la barra",
  "Estilo da Headline": "Estilo del titular",
  "Estilo da Subheadline": "Estilo del subtítulo",
  "Estilo do Autoplay": "Estilo del Autoplay",
  "Estilo do Ícone": "Estilo del icono",
  "Estilo e Comportamento": "Estilo y comportamiento",
  "Evite conclusões precipitadas com poucos dados - espere atingir os valores mínimos recomendados.": "Evita conclusiones precipitadas con pocos datos — espera alcanzar los valores mínimos recomendados.",
  "Ex.: Ative o som para melhor experiência": "Ej.: Activa el sonido para mejor experiencia",
  "Ex.: Seu vídeo já começou": "Ej.: Tu video ya comenzó",
  "Ex: Assista até o final para descobrir o método que está gerando vendas todos os dias": "Ej.: Mira hasta el final para descubrir el método que está generando ventas todos los días",
  "Ex: Autoplay Moderno, Conversão Limpa...": "Ej.: Autoplay Moderno, Conversión Limpia...",
  "Ex: Botão de Checkout": "Ej.: Botón de Checkout",
  "Ex: Headline Moderna, Conversão Limpa...": "Ej.: Titular Moderno, Conversión Limpia...",
  "Ex: Mostrar botão de compra": "Ej.: Mostrar botón de compra",
  "Ex: Seu vídeo já começou": "Ej.: Tu video ya comenzó",
  "Ex: Toque para ativar o som": "Ej.: Toca para activar el sonido",
  "Ex: ativo, visivel, destaque": "Ej.: activo, visible, destacado",
  "Ex: color, background, display": "Ej.: color, background, display",
  "Excluir variação?": "¿Eliminar variación?",
  "Retoma o vídeo de onde o usuário parou.": "Retoma el video donde el usuario se detuvo.",
  "Exibe uma imagem estática no lugar do player": "Muestra una imagen estática en lugar del player",
  "Avisa que o vídeo iniciou automaticamente.": "Avisa que el video inició automáticamente.",
  "Exibir Vídeo Original": "Mostrar video original",
  "Exibir barra de controles": "Mostrar barra de controles",
  "Exibição por Dispositivo": "Visualización por dispositivo",
  "Experiência imersiva": "Experiencia inmersiva",
  "Facilite o controle de tempo durante a reprodução.": "Facilita el control de tiempo durante la reproducción.",
  "Família da Fonte": "Familia de la fuente",
  "Finalizar teste A/B?": "¿Finalizar prueba A/B?",
  "Forma do Botão": "Forma del botón",
  "Formato da Imagem": "Formato de la imagen",
  "Fundo Botão": "Fondo del botón",
  "Fundo da Headline": "Fondo del titular",
  "Futuras Integrações": "Integraciones futuras",
  "Grátis, Segredo, Exclusivo, Novo": "Gratis, Secreto, Exclusivo, Nuevo",
  "HTML Personalizado": "HTML personalizado",
  "Habilita a sincronização inteligente de ações com o vídeo": "Activa la sincronización inteligente de acciones con el video",
  "Habilita o botão de ação no vídeo selecionado": "Activa el botón de acción en el video seleccionado",
  "Headline Principal": "Titular principal",
  "Headline não ativada": "Titular no activado",
  "Headline por Dispositivo": "Titular por dispositivo",
  "Herdando valores do Desktop. Altere para personalizar.": "Heredando valores del Desktop. Cambia para personalizar.",
  "Hover Fundo": "Hover fondo",
  "Hover Texto": "Hover texto",
  "Ideal para vídeos corporativos e educacionais": "Ideal para videos corporativos y educativos",
  "Imagem Desktop": "Imagen Desktop",
  "Imagem Mobile": "Imagen Mobile",
  "Imagem carregada com sucesso!": "¡Imagen cargada con éxito!",
  "Imagem de Fundo": "Imagen de fondo",
  "Imagem do Autoplay": "Imagen del Autoplay",
  "Imagem do Continuar de onde parou": "Imagen de Continuar Viendo",
  "Imagem removida": "Imagen eliminada",
  "Inferior Direito": "Inferior Derecho",
  "Inferior Esquerdo": "Inferior Izquierdo",
  "Inicia o vídeo automaticamente ao entrar na página.": "Inicia el video automáticamente al entrar en la página.",
  "Iniciar sem som": "Iniciar sin sonido",
  "Interação com Vídeo": "Interacción con el video",
  "Início (mm:ss)": "Inicio (mm:ss)",
  "Link do Botão": "Enlace del botón",
  "Loop contínuo": "Loop continuo",
  "Mantém o vídeo padrão neste dispositivo": "Mantiene el video predeterminado en este dispositivo",
  "Melhor para captar atenção e criar urgência": "Mejor para captar atención y crear urgencia",
  "Melhor plataforma": "Mejor plataforma",
  "Mensagem personalizada": "Mensaje personalizado",
  "Meu título personalizado": "Mi título personalizado",
  "Modo HTML": "Modo HTML",
  "Modo HTML (Avançado)": "Modo HTML (Avanzado)",
  "Modo Imagem": "Modo imagen",
  "Modo Texto": "Modo texto",
  "Modo de Exibição": "Modo de visualización",
  "Mostra o progresso do vídeo": "Muestra el progreso del video",
  "Mostra o progresso visual": "Muestra el progreso visual",
  "Mostra os controles na parte inferior do player": "Muestra los controles en la parte inferior del player",
  "Mostra um vídeo diferente apenas neste dispositivo": "Muestra un video diferente solo en este dispositivo",
  "Mostrar Imagem": "Mostrar imagen",
  "Mostrar barra de progresso": "Mostrar barra de progreso",
  "Mostrar contagem regressiva": "Mostrar cuenta regresiva",
  "Mostrar controles": "Mostrar controles",
  "Mostrar controles do vídeo durante o autoplay": "Mostrar controles del video durante el autoplay",
  "Mostrar elemento": "Mostrar elemento",
  "Mostre o avanço do vídeo e aumente a retenção.": "Muestra el avance del video y aumenta la retención.",
  "Muito rápido ou muito lento": "Muy rápido o muy lento",
  "Máximo 8-10 palavras": "Máximo 8-10 palabras",
  "Máximo de 5 modelos simultâneos permitidos": "Máximo 5 plantillas simultáneas permitidas",
  "Métricas Rastreadas:": "Métricas rastreadas:",
  "Métricas atualizadas para novo formato!": "¡Métricas actualizadas al nuevo formato!",
  "Mínimo: 2 variações": "Mínimo: 2 variaciones",
  "Navegação do Vídeo": "Navegación del video",
  "Nenhum teste ativo": "Ninguna prueba activa",
  "Nenhuma variação configurada": "Ninguna variación configurada",
  "Nome da Ação *": "Nombre de la acción *",
  "Nome da Classe": "Nombre de la clase",
  "Nome da Variação": "Nombre de la variación",
  "Novo Texto": "Nuevo texto",
  "O tempo de Pitch é:": "El tiempo de Pitch es:",
  "Oculta os controles até a primeira interação": "Oculta los controles hasta la primera interacción",
  "Ocultar Pause": "Ocultar pausa",
  "Ocultar Vídeo": "Ocultar video",
  "Ocultar elemento": "Ocultar elemento",
  "Open Sans": "Open Sans",
  "Open Sans (Classic)": "Open Sans (clásica)",
  "Ordem atualizada": "Orden actualizado",
  "Overlay personalizado": "Overlay personalizado",
  "Para conteúdos educativos, priorize o engajamento; para vendas, priorize a taxa de conversão": "Para contenidos educativos, prioriza el engagement; para ventas, prioriza la tasa de conversión",
  "Para usar a Barra de Progresso personalizada, desative os controles do player.": "Para usar la barra de progreso personalizada, desactiva los controles del player.",
  "Percentual de visitantes que iniciaram o vídeo": "Porcentaje de visitantes que iniciaron el video",
  "Percentual médio de retenção do vídeo assistido": "Porcentaje promedio de retención del video visto",
  "Perfeito para vendas e call-to-actions": "Perfecto para ventas y call-to-actions",
  "Ative os controles do player para o espectador.": "Activa los controles del reproductor.",
  "Permite ajustar o áudio": "Permite ajustar el audio",
  "Permite que o espectador retome o vídeo de onde parou.": "Permite al espectador retomar el video donde lo dejó.",
  "Personalização Visual": "Personalización visual",
  "Personalize a aparência do Autoplay": "Personaliza la apariencia del Autoplay",
  "Personalize cores dos controles e da barra inferior.": "Personaliza colores de los controles y la barra inferior.",
  "Personalize cores, animações e efeitos visuais": "Personaliza colores, animaciones y efectos visuales",
  "Ajuste o player para cada tipo de dispositivo.": "Ajusta el reproductor para cada dispositivo.",
  "Player Simulado": "Player simulado",
  "Plays Únicos": "Reproducciones únicas",
  "Plays únicos por usuário": "Reproducciones únicas por usuario",
  "Posição H (%)": "Posición H (%)",
  "Posição V (%)": "Posición V (%)",
  "Posição do botão no vídeo": "Posición del botón en el video",
  "Preencha Headline ou Subheadline.": "Completa el titular o subtítulo.",
  "Preencha todos os campos obrigatórios": "Completa todos los campos obligatorios",
  "Preview": "Vista previa",
  "Preview configurado:": "Vista previa configurada:",
  "Preview de frames na timeline": "Vista previa de cuadros en la línea de tiempo",
  "Preview disponível no player real": "Vista previa disponible en el player real",
  "Preview do Botão": "Vista previa del botón",
  "Preview do Player": "Vista previa del player",
  "Progresso do Teste": "Progreso de la prueba",
  "Pré-Visualizações de Estilos": "Vistas previas de estilos",
  "Pré-visualização ilustrativa": "Vista previa ilustrativa",
  "Pré-visualização ilustrativa da barra de progresso": "Vista previa ilustrativa de la barra de progreso",
  "Pré-visualização ilustrativa do HTML personalizado": "Vista previa ilustrativa del HTML personalizado",
  "Pré-visualização ilustrativa do botão no vídeo": "Vista previa ilustrativa del botón en el video",
  "Prévia do Botão": "Vista previa del botón",
  "Pulsar": "Pulso",
  "Quando a headline aparece": "Cuando el titular aparece",
  "Quando a headline desaparece": "Cuando el titular desaparece",
  "Quando ativado, o vídeo reinicia do início ao clicar": "Cuando está activado, el video reinicia desde el inicio al hacer clic",
  "Realize testes com pelo menos 100 visualizações por velocidade": "Realiza pruebas con al menos 100 visualizaciones por velocidad",
  "Recomenda-se um mínimo de 800 plays únicos por variação para resultados estatisticamente significativos": "Se recomienda un mínimo de 800 reproducciones únicas por variación para resultados estadísticamente significativos",
  "Recomeçar vídeo após o fim": "Reiniciar video después del final",
  "Reiniciar vídeo": "Reiniciar video",
  "Remove completamente o player neste dispositivo": "Elimina completamente el player en este dispositivo",
  "Remove distração visual": "Elimina la distracción visual",
  "Remover imagem": "Eliminar imagen",
  "Repetir vídeo (loop)": "Repetir video (loop)",
  "Reprodução automática": "Reproducción automática",
  "Retenção no Pitch": "Retención en el Pitch",
  "Retenção no pitch": "Retención en el pitch",
  "Retomada automática": "Reanudación automática",
  "Retomar reprodução": "Reanudar reproducción",
  "Retângulo": "Rectángulo",
  "Selecione a posição": "Selecciona la posición",
  "Selecione a velocidade desejada": "Selecciona la velocidad deseada",
  "Selecione o tamanho": "Selecciona el tamaño",
  "Selecione pelo menos 2 modelos para iniciar o teste": "Selecciona al menos 2 plantillas para iniciar la prueba",
  "Selecione uma animação": "Selecciona una animación",
  "Seu HTML aparecerá aqui": "Tu HTML aparecerá aquí",
  "Seu HTML aqui": "Tu HTML aquí",
  "Seu vídeo já começou": "Tu video ya comenzó",
  "Slide de baixo": "Deslizar desde abajo",
  "Sobre a reprodução automática:": "Acerca de la reproducción automática:",
  "Som de alerta": "Sonido de alerta",
  "Status do Teste": "Estado de la prueba",
  "Substituir por Outro Vídeo": "Sustituir por otro video",
  "Sólido": "Sólido",
  "Tamanho da Fonte": "Tamaño de la fuente",
  "Tamanho do Ícone": "Tamaño del icono",
  "Tamanho e Posição": "Tamaño y posición",
  "Tamanho recomendado: 1920x1080px • Formatos: JPG, PNG, GIF • Máximo: 10MB": "Tamaño recomendado: 1920x1080px • Formatos: JPG, PNG, GIF • Máximo: 10MB",
  "Taxa de Conversão": "Tasa de conversión",
  "Tempo": "Tiempo",
  "Tempo Atual": "Tiempo actual",
  "Tempo atual": "Tiempo actual",
  "Tempo até retomar": "Tiempo hasta reanudar",
  "Tempo do Vídeo (mm:ss) *": "Tiempo del video (mm:ss) *",
  "Tempo para exibição (segundos)": "Tiempo para exhibición (segundos)",
  "Teste A/B ativado!": "¡Prueba A/B activada!",
  "Teste aplicado com sucesso!": "¡Prueba aplicada con éxito!",
  "Teste finalizado": "Prueba finalizada",
  "Teste finalizado com sucesso!": "¡Prueba finalizada con éxito!",
  "Texto Botão": "Texto del botón",
  "Texto Inferior": "Texto inferior",
  "Texto Superior": "Texto superior",
  "Texto branco em fundo claro": "Texto blanco sobre fondo claro",
  "Texto da Headline": "Texto del titular",
  "Texto da Subheadline": "Texto del subtítulo",
  "Texto do Botão": "Texto del botón",
  "Texto do botão principal": "Texto del botón principal",
  "Texto do link secundário": "Texto del enlace secundario",
  "Texto exibido no overlay para orientar o usuário": "Texto mostrado en el overlay para orientar al usuario",
  "Textos do overlay": "Textos del overlay",
  "Ticket médio": "Ticket promedio",
  "Tipo": "Tipo",
  "Tipo de Animação": "Tipo de animación",
  "Tipo de Ação *": "Tipo de acción *",
  "Tipo de Fundo": "Tipo de fondo",
  "Tipo de som": "Tipo de sonido",
  "Tipo:": "Tipo:",
  "Todos os vídeos": "Todos los videos",
  "Topo Direita": "Superior Derecha",
  "Topo Esquerda": "Superior Izquierda",
  "Topo pode funcionar melhor que rodapé": "Arriba puede funcionar mejor que abajo",
  "Total de visualizações do vídeo": "Total de visualizaciones del video",
  "Tráfego": "Tráfico",
  "Tráfego dividido igualmente": "Tráfico dividido equitativamente",
  "Término": "Fin",
  "Término previsto:": "Fin previsto:",
  "Título": "Título",
  "Título (opcional)": "Título (opcional)",
  "Título do overlay": "Título del overlay",
  "Uma mensagem principal por vez": "Un mensaje principal a la vez",
  "Upload do Ícone Personalizado": "Subida del icono personalizado",
  "Usar cor do Play": "Usar color del Play",
  "Usar velocidade fixa": "Usar velocidad fija",
  "Use #id para IDs ou .classe para classes CSS. Exemplo: #meuBotao ou .minha-secao": "Usa #id para IDs o .clase para clases CSS. Ejemplo: #miBoton o .mi-seccion",
  "Use o calendário para comparar períodos semelhantes": "Usa el calendario para comparar periodos similares",
  "Variação": "Variación",
  "Variação adicionada!": "¡Variación añadida!",
  "Variação atualizada!": "¡Variación actualizada!",
  "Variação excluída": "Variación eliminada",
  "Variação removida!": "¡Variación eliminada!",
  "Variação salva!": "¡Variación guardada!",
  "Variações": "Variaciones",
  "Velocidade": "Velocidad",
  "Velocidade Fixa": "Velocidad fija",
  "Velocidade atual": "Velocidad actual",
  "Velocidade final": "Velocidad final",
  "Velocidade inicial": "Velocidad inicial",
  "Vis. Únicas": "Vis. únicas",
  "Visualizações": "Visualizaciones",
  "Visualizações Únicas": "Visualizaciones únicas",
  "Visualizações únicas (por usuário)": "Visualizaciones únicas (por usuario)",
  "Você parou em um ponto importante do vídeo.": "Te detuviste en un punto importante del video.",
  "Volte para revisar momentos": "Vuelve para revisar momentos",
  "Vídeo de Fundo Inteligente": "Video de fondo inteligente",
  "até": "hasta",
  "https://exemplo.com": "https://ejemplo.com",
  "https://exemplo.com.br": "https://ejemplo.com",
  "Ícone": "Icono",
  "Ícone Personalizado": "Icono personalizado",
  "Ícone do Play": "Icono del Play",
  "• Analytics avançados": "• Analíticas avanzadas",
  "• Animações CSS": "• Animaciones CSS",
  "• Até 3 variações simultâneas": "• Hasta 3 variaciones simultáneas",
  "• CTR (Click-through Rate)": "• CTR (Click-through Rate)",
  "• Compressão automática": "• Compresión automática",
  "• Configurações de qualidade": "• Configuración de calidad",
  "• Controle total com código": "• Control total con código",
  "• Cores personalizáveis": "• Colores personalizables",
  "• Cores que não contrastam:": "• Colores que no contrastan:",
  "• Crie urgência:": "• Crea urgencia:",
  "• Código de embed": "• Código embed",
  "• Divisão automática de tráfego": "• División automática de tráfico",
  "• Editor visual intuitivo": "• Editor visual intuitivo",
  "• Engajamento": "• Engagement",
  "• Headlines genéricas:": "• Titulares genéricos:",
  "• Integração com CDN": "• Integración con CDN",
  "• Integração com JS": "• Integración con JS",
  "• Mantenha legível:": "• Mantén legible:",
  "• Métricas em tempo real": "• Métricas en tiempo real",
  "• Múltiplos focos:": "• Múltiples focos:",
  "• Otimização de performance": "• Optimización de rendimiento",
  "• Para desenvolvedores": "• Para desarrolladores",
  "• Posição que cobre conteúdo:": "• Posición que cubre contenido:",
  "• Preview em tempo real": "• Vista previa en tiempo real",
  "• Seja específico:": "• Sé específico:",
  "• Tamanho máximo: 2MB": "• Tamaño máximo: 2MB",
  "• Taxa de conversão": "• Tasa de conversión",
  "• Tempo médio de exibição": "• Tiempo promedio de exhibición",
  "• Teste posições:": "• Prueba posiciones:",
  "• Texto muito longo:": "• Texto demasiado largo:",
  "• Upload de imagens/GIFs": "• Subir imágenes/GIFs",
  "• Use números:": "• Usa números:",
  "• Versões desktop/mobile": "• Versiones desktop/mobile",
  "⚠️ Alguns navegadores podem restringir o áudio automático mesmo após interação do visitante.": "⚠️ Algunos navegadores pueden restringir el audio automático incluso después de la interacción del visitante.",
  "⚠️ Velocidades muito altas (acima de 1.5x) podem prejudicar a compreensão e confiança no conteúdo.": "⚠️ Velocidades muy altas (por encima de 1.5x) pueden perjudicar la comprensión y confianza en el contenido.",
  "⚡ Requisito: Autoplay Ativo": "⚡ Requisito: Autoplay activo",
  "✅ Faça": "✅ Haz",
  "🎨 Modos de Criação": "🎨 Modos de creación",
  "🎯 Melhores Práticas": "🎯 Mejores prácticas",
  "💡 Dicas de Templates": "💡 Consejos de plantillas",
  "Peso da Fonte": "Peso de la Fuente",
  "Todas": "Todas",
  "Nenhuma": "Ninguna",
  "Fade In": "Aparición gradual",
  "Fade-in": "Fade-in",
  "Carregar bloco": "Cargar bloque",
  "Status": "Estado",
  "Status:": "Estado:",
  "Upload": "Subir",
  "Mensagens do Autoplay": "Mensajes del Autoplay",
  "Exibir borda": "Mostrar borde",
  "Salva o progresso do espectador automaticamente": "Guarda automáticamente el progreso del espectador",
  "Picture-in-Picture": "Picture-in-Picture",
  "Valor inicial do contador": "Valor inicial del contador",
  "Plays": "Reproducciones",
  "Play Rate": "Tasa de reproducción",
  "Receita": "Ingresos",
  "Copiar código": "Copiar código",
  "Fechar": "Cerrar",
  "Vídeo": "Video",
  "de": "de",
  "Retenção": "Retención",
  "HostVSL": "HostVSL",
  "visualizações": "visualizaciones",
  "Cliques": "Clics",
  "Tentar novamente": "Intentar de nuevo",
  "Ticket Médio": "Importe medio",
  "Vídeos": "Videos",
  "Plataforma": "Plataforma",
  "Selecione um vídeo": "Selecciona un video",
  "Todos": "Todos",
  "Nenhum vídeo selecionado": "Ningún video seleccionado",
  "Desktop": "Escritorio",
  "Vencendo": "Ganando",
  "Desativar": "Desactivar",
  "Etapa": "Etapa",
  "Exportar CSV": "Exportar CSV",
  "Mobile": "Móvil",
  "Normal": "Normal",
  "Receita Total": "Ingresos totales",
  "Adicionar": "Añadir",
  "Clique Aqui": "Haz clic aquí",
  "Criado em": "Creado el",
  "Enviando...": "Enviando...",
  "Erro ao copiar": "Error al copiar",
  "Principal": "Principal",
  "Selecionar Vídeo": "Seleccionar video",
  "Subpastas": "Subcarpetas",
  "Tablet": "Tableta",
  "Tempo:": "Tiempo:",
  "Adicionar Vídeos": "Añadir videos",
  "Aplicar": "Aplicar",
  "Continuar": "Continuar",
  "Copiado!": "¡Copiado!",
  "Finalizar Teste": "Finalizar prueba",
  "Processando": "Procesando",
  "Token": "Token",
  "Total:": "Total:",
  "Ver detalhes": "Ver detalles",
  "% concluído": "% completado",
  "Anterior": "Anterior",
  "Borda": "Borde",
  "Configurar": "Configurar",
  "Criado em:": "Creado el:",
  "Desativado": "Desactivado",
  "Descrição (opcional)": "Descripción (opcional)",
  "Download": "Descargar",
  "Enviar": "Enviar",
  "Episódio": "Episodio",
  "Host VSL": "Host VSL",
  "Novidades": "Novedades",
  "Pendente": "Pendiente",
  "Pitch": "Pitch",
  "Plano": "Plan",
  "Selecionar": "Seleccionar",
  "Sem dados": "Sin datos",
  "Taxa Média": "Tasa media",
  "Total": "Total",
  "vídeos": "videos",
  "Análise de Retenção": "Análisis de retención",
  "Ativa": "Activa",
  "Ativar": "Activar",
  "Bloqueado": "Bloqueado",
  "Bom": "Bueno",
  "Buscar vídeo...": "Buscar video...",
  "Conversão": "Conversión",
  "Conversões:": "Conversiones:",
  "Criando...": "Creando...",
  "Deletar": "Eliminar",
  "dias": "días",
  "Erro ao criar teste": "Error al crear la prueba",
  "Horários de Pico": "Horas punta",
  "Hover": "Al pasar el cursor",
  "País": "País",
  "Pixel": "Píxel",
  "Play": "Reproducir",
  "plays": "reproducciones",
  "Plays únicos": "Reproducciones únicas",
  "Receita:": "Ingresos:",
  "Seu navegador não suporta vídeos.": "Tu navegador no admite videos.",
  "Taxa de Play": "Tasa de reproducción",
  "Termos de Uso": "Términos de uso",
  "Ticket:": "Importe:",
  "Upload Novo Vídeo": "Subir nuevo video",
  "Usuário": "Usuario",
  "Valor": "Valor",
  "vídeo": "video",
  "Vídeo Alternativo": "Video alternativo",
  "{value0} ficou no topo": "{value0} quedó en primer lugar",
  "Ainda não há dados suficientes": "Aún no hay suficientes datos",
  "Alterar": "Cambiar",
  "As configurações foram aplicadas com sucesso.": "La configuración se ha aplicado correctamente.",
  "aula": "lección",
  "aulas": "lecciones",
  "Bloquear": "Bloquear",
  "Cliques:": "Clics:",
  "Configuração": "Configuración",
  "Copiar código de incorporação do vídeo": "Copiar código de inserción del video",
  "Criar Teste": "Crear prueba",
  "CVC": "CVC",
  "Dispositivos": "Dispositivos",
  "Em teste": "En prueba",
  "Escolha um vídeo": "Elige un video",
  "Expira em": "Caduca el",
  "Falhou": "Falló",
  "Favicon": "Favicon",
  "Fonte": "Fuente",
  "Inter": "Inter",
  "leads": "leads",
  "Link copiado!": "¡Enlace copiado!",
  "Lista": "Lista",
  "Melhor": "Mejor",
  "min": "min",
  "Negrito": "Negrita",
  "Nova Pasta": "Nueva carpeta",
  "Página": "Página",
  "Pago": "Pagado",
  "Pastas": "Carpetas",
  "Reproduzir agora": "Reproducir ahora",
  "Salvar Alterações": "Guardar cambios",
  "Selecionado": "Seleccionado",
  "Selecione o Vídeo": "Selecciona el video",
  "Taxa:": "Tasa:",
  "Trocar vídeo": "Cambiar video",
  "URL": "URL",
  "Validade": "Validez",
  "Variação {value0}": "Variación {value0}",
  "Vídeo Original": "Video original",
  "VSL Dinâmica": "VSL dinámica",
  "Webhook URL": "URL del webhook",
  "? Esta ação não pode ser desfeita.": "? Esta acción no se puede deshacer.",
  "(não usado neste template)": "(no utilizado en esta plantilla)",
  "% das visualizações": "% de las visualizaciones",
  "% vs período anterior": "% frente al período anterior",
  "A distribuição de tráfego foi atualizada com sucesso.": "La distribución del tráfico se ha actualizado correctamente.",
  "Academy": "Academia",
  "Adicionar Cartão": "Añadir tarjeta",
  "Agora não": "Ahora no",
  "Análise de Performance": "Análisis de rendimiento",
  "Área restrita a administradores.": "Área restringida a administradores.",
  "Atenção": "Atención",
  "Atualizado:": "Actualizado:",
  "Autoplay desativado": "Reproducción automática desactivada",
  "Baixa amostra": "Muestra pequeña",
  "Barra de progresso": "Barra de progreso",
  "Bold": "Negrita",
  "Campo de Senha": "Campo de contraseña",
  "Campo não usado neste template": "Campo no utilizado en esta plantilla",
  "Cancelado": "Cancelado",
  "Carregando métricas...": "Cargando métricas...",
  "Cliques no CTA": "Clics en el CTA",
  "Comparar VSL": "Comparar VSL",
  "Configurar integração com": "Configurar integración con",
  "Copiar token": "Copiar token",
  "Desktop:": "Escritorio:",
  "dia": "día",
  "Dica:": "Consejo:",
  "Duplicar": "Duplicar",
  "Entendi": "Entendido",
  "Enviando vídeo...": "Enviando video...",
  "Esta pasta não possui vídeos": "Esta carpeta no contiene videos",
  "Estratégia de Captura": "Estrategia de captura",
  "Excelente": "Excelente",
  "Excluir vídeo": "Eliminar video",
  "Expirado": "Caducado",
  "Faça upload do primeiro vídeo para começar": "Sube el primer video para empezar",
  "Forma de Pagamento": "Método de pago",
  "Fuso Horário": "Zona horaria",
  "Horários de pico por tipo de acesso": "Horas punta por tipo de acceso",
  "Ignorar": "Omitir",
  "Impostos": "Impuestos",
  "Manual": "Manual",
  "Melhor Janela por Dispositivo": "Mejor franja por dispositivo",
  "Menor desvio padrão no período": "Menor desviación estándar del período",
  "Mini Hooks": "Mini Hooks",
  "Minutos": "Minutos",
  "mm:ss": "mm:ss",
  "Mobile:": "Móvil:",
  "Não foi possível copiar o código. Tente novamente.": "No se pudo copiar el código. Inténtalo de nuevo.",
  "Nenhum cartão cadastrado": "No hay tarjetas registradas",
  "Nenhum registro encontrado": "No se encontraron registros",
  "Nenhum vídeo disponível": "No hay videos disponibles",
  "Nome Completo": "Nombre completo",
  "Nome da pasta": "Nombre de la carpeta",
  "Origem": "Origen",
  "Países": "Países",
  "Período": "Período",
  "Permissão": "Permiso",
  "Plataforma de origem das conversões registradas. Clique para ver detalhes de cada plataforma.": "Plataforma de origen de las conversiones registradas. Haz clic para ver los detalles de cada plataforma.",
  "Política de Privacidade": "Política de privacidad",
  "Pontos de Queda": "Puntos de abandono",
  "Preview em Tempo Real": "Vista previa en tiempo real",
  "Processando…": "Procesando…",
  "Próxima": "Siguiente",
  "Rascunho": "Borrador",
  "Receita total": "Ingresos totales",
  "registro(s)": "registro(s)",
  "Rodapé": "Pie de página",
  "Ruim": "Malo",
  "Segundos": "Segundos",
  "Selecionar vídeo": "Seleccionar video",
  "Sem término (manual)": "Sin fecha de fin (manual)",
  "Semi Bold": "Seminegrita",
  "Solicitado": "Solicitado",
  "Teste:": "Prueba:",
  "Todas as Plataformas": "Todas las plataformas",
  "Todos os status": "Todos los estados",
  "Token da plataforma": "Token de la plataforma",
  "Últimos 30 dias": "Últimos 30 días",
  "Únicas": "Únicas",
  "Upload concluído": "Subida completada",
  "Uso do Plano": "Uso del plan",
  "Valor do parâmetro": "Valor del parámetro",
  "Verifique se o link está correto.": "Comprueba que el enlace sea correcto.",
  "Vídeo carregado": "Video cargado",
  "Vídeo de entrada": "Video de entrada",
  "Vídeos em Teste": "Videos en prueba",
  "views": "visualizaciones",
  "Visão Geral": "Vista general",
  "Visualizações únicas": "Visualizaciones únicas",
  " · vencedora": " · ganadora",
  "\"{value0}\" está pronto para personalização": "\"{value0}\" está listo para personalizar",
  "{value0} logo": "Logotipo de {value0}",
  "% do total": "% del total",
  "A data de término foi atingida e o teste foi encerrado.": "Se ha alcanzado la fecha de fin y la prueba ha finalizado.",
  "Abaixo do vídeo": "Debajo del video",
  "Abrir em nova guia": "Abrir en una nueva pestaña",
  "Abrir link": "Abrir enlace",
  "Abrir URL": "Abrir URL",
  "Ações do vídeo": "Acciones del video",
  "Adicionar País": "Añadir país",
  "Adicionar Região": "Añadir región",
  "Adicionar vídeos": "Añadir videos",
  "Administrador": "Administrador",
  "Alterações não salvas": "Cambios sin guardar",
  "Assistiram até o fim": "Vieron hasta el final",
  "Ativar Captura por Tempo": "Activar captura por tiempo",
  "Ative ou desative o formulário de captura neste vídeo. Quando ativo, o formulário será exibido no momento configurado.": "Activa o desactiva el formulario de captura en este video. Cuando está activo, el formulario aparece en el momento configurado.",
  "Ativos": "Activos",
  "Audiência em Tempo Real": "Audiencia en tiempo real",
  "Baixo": "Bajo",
  "Barra fake foi desativada automaticamente. Barra fake e controles não podem estar ativos ao mesmo tempo.": "La barra simulada se ha desactivado automáticamente. La barra simulada y los controles no pueden estar activos al mismo tiempo.",
  "Brasil": "Brasil",
  "Buscar integração...": "Buscar integración...",
  "Campos": "Campos",
  "Captura de Dados": "Captura de datos",
  "Carregando recursos...": "Cargando funciones...",
  "Carregando vídeo...": "Cargando video...",
  "Cartão": "Tarjeta",
  "Cartão adicionado com sucesso!": "¡Tarjeta añadida correctamente!",
  "Centralizado": "Centrado",
  "Chave de integração Payt (integration_key)": "Clave de integración de Payt (integration_key)",
  "Cidade": "Ciudad",
  "Clique para fazer upload": "Haz clic para subir",
  "Close": "Cerrar",
  "Como usar:": "Cómo usar:",
  "Compacto": "Compacto",
  "Concluído": "Completado",
  "Conectar rastreamento": "Conectar seguimiento",
  "Confirmar Seleção": "Confirmar selección",
  "conversões": "conversiones",
  "Copiado": "Copiado",
  "Copiar link": "Copiar enlace",
  "Copie o código do teste e atualize o embed no seu site para que ele comece a rodar.": "Copia el código de la prueba y actualiza el código insertado en tu sitio para que empiece a funcionar.",
  "Cores": "Colores",
  "Criar Captura de Dados": "Crear captura de datos",
  "Criar fluxo": "Crear flujo",
  "Cupom de desconto": "Cupón de descuento",
  "Data": "Fecha",
  "Erro ao deletar teste": "Error al eliminar la prueba",
  "Escolha seu plano": "Elige tu plan",
  "EUA": "EE. UU.",
  "Excluir vídeo?": "¿Eliminar video?",
  "Exportar": "Exportar",
  "Exportar Dados": "Exportar datos",
  "Feedback do Vídeo": "Comentarios del video",
  "Filtrar": "Filtrar",
  "Finalizar automaticamente": "Finalizar automáticamente",
  "Finalizar teste": "Finalizar prueba",
  "Grade": "Cuadrícula",
  "HTML personalizado": "HTML personalizado",
  "Importar vídeos": "Importar videos",
  "Inativa": "Inactiva",
  "Inativo": "Inactivo",
  "Informações Básicas": "Información básica",
  "Ir para Meus Vídeos": "Ir a Mis videos",
  "Jornada de Conversão": "Recorrido de conversión",
  "Largura": "Ancho",
  "Lateral": "Lateral",
  "Layout": "Diseño",
  "Liberado": "Permitido",
  "Light": "Claro",
  "Link não encontrado": "Enlace no encontrado",
  "Métricas do Teste A/B": "Métricas de la prueba A/B",
  "minutos": "minutos",
  "Momento de Exibição": "Momento de aparición",
  "Montserrat": "Montserrat",
  "Não foi possível copiar o token.": "No se pudo copiar el token.",
  "Não informado": "No indicado",
  "Nenhum": "Ninguno",
  "Nenhum vídeo encontrado para \"{value0}\"": "No se encontraron videos para \"{value0}\"",
  "Nome do Vídeo": "Nombre del video",
  "Nome impresso no cartão": "Nombre impreso en la tarjeta",
  "Nova aba": "Nueva pestaña",
  "Novo": "Nuevo",
  "Número do cartão": "Número de tarjeta",
  "O fluxo pode ter no máximo {value0} etapas.": "El flujo puede tener un máximo de {value0} etapas.",
  "O teste A/B foi finalizado com sucesso.": "La prueba A/B ha finalizado correctamente.",
  "O total deve ser 100%. Atualmente: {value0}%": "El total debe ser del 100 %. Actualmente: {value0}%",
  "Opacidade:": "Opacidad:",
  "Original": "Original",
  "Pagamento 100% seguro": "Pago 100 % seguro",
  "Parâmetro da UTM": "Parámetro UTM",
  "Pausado": "Pausado",
  "Percentual de espectadores que ainda assistia no momento do pitch": "Porcentaje de espectadores que seguían viendo en el momento de la oferta",
  "PlayRate": "Tasa de reproducción",
  "Por Dispositivo": "Por dispositivo",
  "Portugal": "Portugal",
  "Preencha seus dados": "Completa tus datos",
  "Privacidade": "Privacidad",
  "problema": "problema",
  "Provedor": "Proveedor",
  "Próximo episódio em": "Próximo episodio en",
  "Queda": "Caída",
  "Receita & Conversões (Tracking)": "Ingresos y conversiones (Tracking)",
  "Recusar": "Rechazar",
  "Reenviar Convite": "Reenviar invitación",
  "Região": "Región",
  "registros": "registros",
  "Remover Membro": "Eliminar miembro",
  "Resumo": "Resumen",
  "Retenção Média": "Retención media",
  "Retenção:": "Retención:",
  "Saiba mais": "Más información",
  "Saída": "Salida",
  "Salvar Tracking": "Guardar seguimiento",
  "Salvo": "Guardado",
  "Selecionar data": "Seleccionar fecha",
  "Selecionar Imagem": "Seleccionar imagen",
  "Selecione um país": "Selecciona un país",
  "Selecione um vídeo para visualizar o preview": "Selecciona un video para ver la vista previa",
  "Selecione uma região": "Selecciona una región",
  "Sem dados de retenção": "Sin datos de retención",
  "Sem nome": "Sin nombre",
  "Sem permissão para criar testes A/B": "Sin permiso para crear pruebas A/B",
  "Sobre o vídeo": "Encima del video",
  "Storyboard": "Storyboard",
  "Sublinhado": "Subrayado",
  "Substituir": "Sustituir",
  "Taxa": "Tasa",
  "Taxa Conv.": "Tasa de conv.",
  "Taxa de conversão": "Tasa de conversión",
  "Taxa de play": "Tasa de reproducción",
  "Tecnologia de": "Tecnología de",
  "Tela flutuante": "Pantalla flotante",
  "Tempo personalizado": "Tiempo personalizado",
  "Tempo Real": "Tiempo real",
  "TEMPO:": "TIEMPO:",
  "Temporizador": "Temporizador",
  "Tentar de novo": "Intentar de nuevo",
  "Tente ampliar o período ou visualizar outro vídeo.": "Prueba a ampliar el período o ver otro video.",
  "Tente buscar por outro termo": "Prueba a buscar otro término",
  "Testar Regra": "Probar regla",
  "Teste criado com sucesso!": "¡Prueba creada correctamente!",
  "Teste finalizado automaticamente": "Prueba finalizada automáticamente",
  "Todos Status": "Todos los estados",
  "Toggle Sidebar": "Mostrar u ocultar barra lateral",
  "Token copiado para a área de transferência.": "Token copiado al portapapeles.",
  "Top 3 Janelas": "Las 3 mejores franjas",
  "Top 3 Receita": "Los 3 mayores ingresos",
  "Top 3 Taxa Conv%": "Las 3 mejores tasas de conv. %",
  "Total: R$": "Total: R$",
  "Transparente": "Transparente",
  "únicas": "únicas",
  "únicos": "únicos",
  "Upgrade": "Mejorar plan",
  "URL Webhook": "URL del webhook",
  "Vencedora": "Ganadora",
  "Vídeo {value0}": "Video {value0}",
  "Vídeo atual": "Video actual",
  "Vídeo disponível na biblioteca": "Video disponible en la biblioteca",
  "Video thumbnail": "Miniatura del video",
  "Vídeo:": "Video:",
  "Vídeos Compartilhados": "Videos compartidos",
  "Visualizações Totais": "Visualizaciones totales",
  "Você ainda não tem vídeos": "Aún no tienes videos",
  "Voltar para HostVSL": "Volver a HostVSL",
  "VSL": "VSL",
  "VSL Original": "VSL original",
  "WhatsApp": "WhatsApp",
  "(deve ser 100%)": "(debe ser del 100 %)",
  "(opcional)": "(opcional)",
  "{value0} únicos": "{value0} únicos",
  "{value0} vídeo{value1} importado{value2} com sucesso": "{value0} video{value1} importado{value2} correctamente",
  "% da audiência ainda está assistindo.": "% de la audiencia sigue viendo.",
  "% das views": "% de las visualizaciones",
  "% de participação": "% de participación",
  "✅ Thumbnail adicionada com sucesso": "✅ Miniatura añadida correctamente",
  "🌍 Proteção por Localização": "🌍 Protección por ubicación",
  "🎥 Taxa de Reprodução": "🎥 Tasa de reproducción",
  "📋 Sugestões Avançadas": "📋 Sugerencias avanzadas",
  "📋 Ver Análise Educacional": "📋 Ver análisis educativo",
  "📌 Sugestões": "📌 Sugerencias",
  "001 - Banco do Brasil S.A.": "001 - Banco do Brasil S.A.",
  "033 - Banco Santander (Brasil) S.A.": "033 - Banco Santander (Brasil) S.A.",
  "077 - Banco Inter S.A.": "077 - Banco Inter S.A.",
  "1 Play = R$ 0,02": "1 reproducción = R$ 0,02",
  "1. Crie um teste": "1. Crea una prueba",
  "10 p/ pág": "10 por pág.",
  "100 p/ pág": "100 por pág.",
  "104 - Caixa Econômica Federal": "104 - Caixa Econômica Federal",
  "15 dias grátis": "15 días gratis",
  "212 - Banco Original S.A.": "212 - Banco Original S.A.",
  "237 - Banco Bradesco S.A.": "237 - Banco Bradesco S.A.",
  "260 - Nu Pagamentos S.A. (Nubank)": "260 - Nu Pagamentos S.A. (Nubank)",
  "3. Análise de métricas": "3. Análisis de métricas",
  "341 - Itaú Unibanco S.A.": "341 - Itaú Unibanco S.A.",
  "4. Identifique o vencedor": "4. Identifica al ganador",
  "50 p/ pág": "50 por pág.",
  "A Academy chegou para acelerar seu domínio da plataforma. Trilha organizada por módulos, com aulas curtas e objetivas sobre cada recurso, do básico ao avançado, com progresso salvo automaticamente.": "Academy ha llegado para ayudarte a dominar la plataforma. Un recorrido organizado por módulos, con lecciones breves y prácticas sobre cada función, desde lo básico hasta lo avanzado, y con el progreso guardado automáticamente.",
  "A configuração de Teste A/B foi movida para a aba \"Teste A/B\" no menu de configurações do Autoplay.": "La configuración de la prueba A/B se ha movido a la pestaña \"Prueba A/B\" del menú de configuración de la reproducción automática.",
  "A FunnelX é a nossa ferramenta para criar quizzes interativos de alta performance. Engaje sua audiência, qualifique leads e direcione cada pessoa para a oferta certa, com lógica condicional e visual premium.": "FunnelX es nuestra herramienta para crear cuestionarios interactivos de alto rendimiento. Conecta con tu audiencia, cualifica leads y dirige a cada persona a la oferta adecuada, con lógica condicional y un diseño prémium.",
  "A imagem foi enviada e salva com sucesso": "La imagen se ha enviado y guardado correctamente",
  "A pasta \"{value0}\" foi criada com sucesso.": "La carpeta \"{value0}\" se ha creado correctamente.",
  "Abaixo de 45%:": "Por debajo del 45 %:",
  "Abaixo de 50%:": "Por debajo del 50 %:",
  "Abaixo do Vídeo": "Debajo del video",
  "Abrir em": "Abrir en",
  "Abrir menu": "Abrir menú",
  "Academy com tutoriais": "Academy con tutoriales",
  "Acesso Facilitado": "Acceso simplificado",
  "Acesso Rápido": "Acceso rápido",
  "Acesso total, incluindo gestão de usuários": "Acceso completo, incluida la gestión de usuarios",
  "Acima de 65%:": "Por encima del 65 %:",
  "Acima de 70%:": "Por encima del 70 %:",
  "Acompanhe as métricas individuais de cada vídeo deste teste.": "Consulta las métricas individuales de cada video de esta prueba.",
  "Acompanhe de forma visual e intuitiva cada etapa da jornada do espectador. O funil mostra desde os carregamentos da página até as conversões finais, com percentuais e valores absolutos para cada etapa.": "Sigue de forma visual e intuitiva cada etapa del recorrido del espectador. El embudo muestra desde las cargas de la página hasta las conversiones finales, con porcentajes y valores absolutos para cada etapa.",
  "Adiciona uma camada colorida sobre o vídeo quando o formulário aparece. A cor é definida em \"Background do Vídeo\" acima": "Añade una capa de color sobre el video cuando aparece el formulario. El color se define arriba en \"Fondo del video\"",
  "Adicionar Aula": "Añadir lección",
  "Adicionar imagem": "Añadir imagen",
  "Adicionar Membro": "Añadir miembro",
  "Adicionar novo cartão": "Añadir nueva tarjeta",
  "Adicionar Pixel": "Añadir píxel",
  "Adicionar Plataforma": "Añadir plataforma",
  "Adicionar regra UTM": "Añadir regla UTM",
  "Adicionar Variação": "Añadir variación",
  "Adicione domínios para proteger sua VSL": "Añade dominios para proteger tu VSL",
  "Adicione legendas aos seus vídeos com suporte a arquivos .VTT e .SRT. Edite textos e tempos diretamente no painel, reordene blocos e escolha entre 4 animações de exibição.": "Añade subtítulos a tus videos con archivos .VTT y .SRT. Edita textos y tiempos directamente en el panel, reordena bloques y elige entre 4 animaciones de aparición.",
  "Adicione pelo menos 1 vídeo para ativar": "Añade al menos 1 video para activar",
  "Agência": "Agencia",
  "Agendada": "Programada",
  "Agora seus vídeos pausam automaticamente quando o espectador sai da aba do navegador. Ao retornar, a reprodução continua exatamente de onde parou, sem perder nenhum segundo de conteúdo.": "Ahora tus videos se pausan automáticamente cuando el espectador sale de la pestaña del navegador. Al volver, la reproducción continúa exactamente donde se detuvo, sin perder un segundo de contenido.",
  "Agora você pode compartilhar seus vídeos com afiliados por link. O afiliado copia o vídeo direto no painel com um clique, sem precisar baixar no Drive ou fazer upload demorado. Você acompanha quem copiou e toda a atividade do compartilhamento.": "Ahora puedes compartir tus videos con afiliados mediante un enlace. El afiliado copia el video directamente en el panel con un clic, sin descargarlo de Drive ni realizar subidas lentas. Puedes consultar quién lo ha copiado y toda la actividad del enlace compartido.",
  "Agora você pode personalizar a caixa de autoplay de forma visual e intuitiva. Arraste para mover, use os handles para redimensionar e veja as alterações em tempo real no preview do player.": "Ahora puedes personalizar el cuadro de reproducción automática de forma visual e intuitiva. Arrástralo para moverlo, usa los tiradores para cambiar su tamaño y observa los cambios en tiempo real en la vista previa del reproductor.",
  "Aguardando dados": "Esperando datos",
  "Ainda não temos tráfego suficiente neste período.": "Todavía no tenemos suficiente tráfico en este período.",
  "Ainda tem dúvidas": "¿Aún tienes dudas?",
  "Ajuste o tamanho e espaçamento do formulário": "Ajusta el tamaño y el espaciado del formulario",
  "Algo deu errado": "Algo ha salido mal",
  "Alterações salvas com sucesso": "Cambios guardados correctamente",
  "Alterar foto": "Cambiar foto",
  "Alterar vídeo": "Cambiar video",
  "Alto Engajamento": "Alta interacción",
  "Análise de Custos por Usuário": "Análisis de costes por usuario",
  "Antecipe o Pitch": "Adelanta la oferta",
  "Ao clicar nesse botão você aceita e concorda com nossos termos de uso": "Al hacer clic en este botón, aceptas nuestros términos de uso",
  "ao vivo": "en directo",
  "Aparência geral do formulário": "Aspecto general del formulario",
  "Aplicando...": "Aplicando...",
  "Aplicar Configurações": "Aplicar configuración",
  "Aprendizado": "Aprendizaje",
  "Área restrita a parceiros e gestores.": "Área restringida a socios y gestores.",
  "Área restrita exclusivamente para administradores.": "Área restringida exclusivamente a administradores.",
  "Arial": "Arial",
  "Arquitetura Zustand": "Arquitectura Zustand",
  "Arquivo muito grande": "Archivo demasiado grande",
  "Arraste uma imagem ou clique para selecionar": "Arrastra una imagen o haz clic para seleccionar",
  "Arraste vídeos aqui": "Arrastra videos aquí",
  "Arredondado": "Redondeado",
  "Arredondamento dos Cards": "Redondeado de las tarjetas",
  "As alterações aparecerão aqui em tempo real": "Los cambios aparecerán aquí en tiempo real",
  "As alterações foram salvas com sucesso.": "Los cambios se han guardado correctamente.",
  "As configurações de velocidade foram salvas com sucesso": "La configuración de velocidad se ha guardado correctamente",
  "As curvas de retenção aparecerão assim que houver visualizações no teste.": "Las curvas de retención aparecerán cuando haya visualizaciones en la prueba.",
  "As linhas mostram a porcentagem de espectadores que continuam assistindo em cada momento do vídeo": "Las líneas muestran el porcentaje de espectadores que siguen viendo en cada momento del video",
  "As senhas não conferem": "Las contraseñas no coinciden",
  "Assistir de novo": "Ver de nuevo",
  "Atenção:": "Atención:",
  "Ativar agora": "Activar ahora",
  "Ativar notificações": "Activar notificaciones",
  "Ativar o plano": "Activar el plan",
  "Ativar VSLeads": "Activar VSLeads",
  "Atualizando...": "Actualizando...",
  "Atualizar": "Actualizar",
  "Atualizar dados": "Actualizar datos",
  "Aula": "Lección",
  "Aula {value0}": "Lección {value0}",
  "Aula concluída! 🎉": "¡Lección completada! 🎉",
  "Aulas (": "Lecciones (",
  "Autoplay": "Reproducción automática",
  "Autoplay foi desativado automaticamente. Autoplay e controles não podem estar ativos ao mesmo tempo.": "La reproducción automática se ha desactivado automáticamente. La reproducción automática y los controles no pueden estar activos al mismo tiempo.",
  "Avatar": "Avatar",
  "Background": "Fondo",
  "Background Botão": "Fondo del botón",
  "Background do Vídeo": "Fondo del video",
  "Barra Fake": "Barra simulada",
  "Barras": "Barras",
  "Baseado no desempenho do período": "Según el rendimiento del período",
  "Biblioteca Host VSL": "Biblioteca Host VSL",
  "Bloqueada": "Bloqueada",
  "Bloqueados": "Bloqueados",
  "Bloquear pause": "Bloquear pausa",
  "Bloquear selecionados": "Bloquear seleccionados",
  "Blur de Fundo (Glass Effect)": "Desenfoque del fondo (efecto cristal)",
  "Bom Desempenho": "Buen rendimiento",
  "Bônus": "Bonificación",
  "Bônus por tempo limitado": "Bonificación por tiempo limitado",
  "Borda customizada": "Borde personalizado",
  "Borda do player": "Borde del reproductor",
  "Botão CTA": "Botón CTA",
  "Botão desativado": "Botón desactivado",
  "BRL": "BRL",
  "broip": "broip",
  "Bunny": "Bunny",
  "Buscando...": "Buscando...",
  "Buscar": "Buscar",
  "Buscar por nome, e-mail ou telefone": "Buscar por nombre, correo electrónico o teléfono",
  "Buscar por URL, Token ou Vídeo": "Buscar por URL, token o video",
  "Buscar...": "Buscar...",
  "Cadastro": "Registro",
  "Campeão da Semana": "Campeón de la semana",
  "Campo obrigatório para proteção por senha": "Campo obligatorio para la protección con contraseña",
  "Campos de Entrada": "Campos de entrada",
  "Campos do Formulário": "Campos del formulario",
  "Chamar no chat": "Contactar por chat",
  "Chaves de API": "Claves de API",
  "Checkout": "Página de pago",
  "Chegou a Audiência em Tempo Real: um mapa-múndi que mostra, ao vivo, quem está assistindo às suas VSLs neste exato momento e de onde no mundo. Acompanhe quantas pessoas estão na sua oferta agora, quais vídeos estão bombando e de quais fontes de tráfego elas vieram — tudo atualizando sozinho.": "Llega la audiencia en tiempo real: un mapamundi que muestra en directo quién está viendo tus VSL en este momento y desde dónde. Consulta cuántas personas están viendo tu oferta ahora, qué videos destacan y de qué fuentes de tráfico proceden, todo con actualización automática.",
  "Chegou o Storyboard, um novo recurso dos controles do player. Ao passar o mouse pela barra de progresso, o espectador vê uma miniatura do frame correspondente àquele instante do vídeo. Ajuda a encontrar rapidamente um trecho específico ou voltar pra um ponto de interesse.": "Llega Storyboard, una nueva función de los controles del reproductor. Al pasar el cursor por la barra de progreso, el espectador ve una miniatura del fotograma correspondiente a ese instante del video. Ayuda a encontrar rápidamente un fragmento concreto o volver a un punto de interés.",
  "Clicks": "Clics",
  "Clicks atualizados com sucesso!": "¡Clics actualizados correctamente!",
  "Cliente Stripe não encontrado": "Cliente de Stripe no encontrado",
  "Cliques Únicos": "Clics únicos",
  "Cloudflare": "Cloudflare",
  "Cole a integration_key configurada na Payt": "Pega la integration_key configurada en Payt",
  "Colunas (": "Columnas (",
  "Com a AdSniper você espiona em tempo real as ofertas que estão escalando na Meta Ads e descobre rapidamente quais criativos, ângulos e funis estão convertendo. Use o cupom 50%OFF e garanta 50% de desconto em qualquer plano.": "Con AdSniper puedes explorar en tiempo real las ofertas que están creciendo en Meta Ads y descubrir rápidamente qué creatividades, enfoques y embudos están generando conversiones. Usa el cupón 50%OFF y consigue un 50 % de descuento en cualquier plan.",
  "Começa em": "Empieza en",
  "Começar pela etapa": "Empezar por la etapa",
  "Comece fazendo upload do seu primeiro vídeo.": "Empieza subiendo tu primer video.",
  "Comissão Recorrente": "Comisión recurrente",
  "Como interpretar o gráfico de retenção": "Cómo interpretar el gráfico de retención",
  "Como interpretar?": "¿Cómo interpretarlo?",
  "Comparativo por Variação": "Comparación por variación",
  "Compare como cada variação influencia a permanência da audiência ao longo do vídeo.": "Compara cómo influye cada variación en la permanencia de la audiencia a lo largo del video.",
  "Compartilhado por": "Compartido por",
  "Compartilhamento desativado": "Enlace compartido desactivado",
  "Compartilhamento não encontrado": "Enlace compartido no encontrado",
  "compartilhamentos": "enlaces compartidos",
  "Compartilhar Vídeo com Afiliados": "Compartir video con afiliados",
  "Componentes Principais": "Componentes principales",
  "Comportamento do Vídeo": "Comportamiento del video",
  "Comprovante": "Justificante",
  "Comprovante de Transferência": "Justificante de transferencia",
  "Compute": "Cómputo",
  "Concluir": "Completar",
  "Conectado": "Conectado",
  "Conectar": "Conectar",
  "Conectar Google Drive": "Conectar Google Drive",
  "Configuração salva!": "¡Configuración guardada!",
  "Configurações de Recebimento": "Configuración de cobro",
  "Configurações importadas!": "¡Configuración importada!",
  "Configure comportamentos específicos do player dependendo do dispositivo do espectador. Ofereça a melhor experiência em desktop, tablet e mobile de forma automática.": "Configura comportamientos específicos del reproductor según el dispositivo del espectador. Ofrece automáticamente la mejor experiencia en equipos de escritorio, tabletas y móviles.",
  "Configure o vídeo para retornar automaticamente ao início quando terminar. Com Autoplay ativo, entra em loop contínuo. Caso contrário, fica pausado no início pronto para ser assistido novamente.": "Configura el video para que vuelva automáticamente al inicio cuando termine. Con la reproducción automática activada, se repite en bucle continuo. En caso contrario, queda pausado al inicio, listo para volver a verlo.",
  "Configure opções visuais e de comportamento do formulário": "Configura las opciones visuales y de comportamiento del formulario",
  "Configure os textos do botão de ação": "Configura los textos del botón de acción",
  "Confirmar": "Confirmar",
  "Conheça a Replic, a nossa ferramenta para criar e clonar sites de alta conversão em poucos minutos. Comece gratuitamente em apenas um clique, sem precisar cadastrar cartão de crédito, e ganhe velocidade para validar suas ofertas.": "Descubre Replic, nuestra herramienta para crear y clonar sitios con alta conversión en pocos minutos. Empieza gratis con un solo clic, sin registrar una tarjeta de crédito, y valida tus ofertas más rápido.",
  "Conta": "Cuenta",
  "Container do Formulário": "Contenedor del formulario",
  "Contornado": "Con contorno",
  "Controles foram desativados automaticamente. Autoplay e controles não podem estar ativos ao mesmo tempo.": "Los controles se han desactivado automáticamente. La reproducción automática y los controles no pueden estar activos al mismo tiempo.",
  "Conversões ÷ Plays únicos no período": "Conversiones ÷ reproducciones únicas del período",
  "Conversões Totais": "Conversiones totales",
  "Copiado com sucesso!": "¡Copiado correctamente!",
  "Copiar": "Copiar",
  "Copiar Embed": "Copiar código de inserción",
  "Copiar URL": "Copiar URL",
  "Cor da barra": "Color de la barra",
  "Cor do Corpo": "Color del cuerpo",
  "Cores do Texto": "Colores del texto",
  "Cores e Estilos": "Colores y estilos",
  "Criando teste...": "Creando prueba...",
  "Criar": "Crear",
  "Criar Captura com Senha": "Crear captura con contraseña",
  "Criar minha Playlist": "Crear mi lista de reproducción",
  "Criar pasta": "Crear carpeta",
  "Criar Playlist": "Crear lista de reproducción",
  "Criar Registro": "Crear registro",
  "Criar Sites com a Replic": "Crear sitios con Replic",
  "Criar Variação": "Crear variación",
  "Criar Webinário": "Crear seminario web",
  "CSV": "CSV",
  "CSV exportado!": "¡CSV exportado!",
  "CTR": "CTR",
  "Custos por Usuário": "Costes por usuario",
  "Dados": "Datos",
  "Dados coletados de 01/05/2024 a 15/05/2024 · Total de 1.262 visitantes": "Datos recopilados del 01/05/2024 al 15/05/2024 · Total de 1.262 visitantes",
  "Das {value0} pessoas que deram play, {value1} converteram.": "De las {value0} personas que reprodujeron el video, {value1} se convirtieron.",
  "Das {value0} pessoas que viram seu vídeo, {value1} deram play.": "De las {value0} personas que vieron tu video, {value1} lo reprodujeron.",
  "Data do Convite": "Fecha de invitación",
  "Data/Hora": "Fecha/hora",
  "de variação": "de variación",
  "Defina a senha que o usuário precisará digitar para acessar o vídeo": "Define la contraseña que deberá introducir el usuario para acceder al video",
  "Defina se o vídeo deve voltar ao início automaticamente quando a reprodução terminar.": "Define si el video debe volver automáticamente al inicio cuando termine la reproducción.",
  "Definir": "Definir",
  "Deixe vazio para ilimitado": "Déjalo vacío para no establecer un límite",
  "Deletando...": "Eliminando...",
  "Desativados": "Desactivados",
  "Desativar compartilhamento": "Desactivar enlace compartido",
  "Descreva o conteúdo da sua playlist...": "Describe el contenido de tu lista de reproducción...",
  "Descrição da Aula": "Descripción de la lección",
  "Desempenho Baixo": "Rendimiento bajo",
  "Desempenho diário": "Rendimiento diario",
  "Desempenho Médio": "Rendimiento medio",
  "Desempenho por vídeo": "Rendimiento por video",
  "Design System": "Sistema de diseño",
  "Detalhar por dispositivo →": "Desglosar por dispositivo →",
  "Detalhes": "Detalles",
  "Deve conter letra maiúscula": "Debe contener una mayúscula",
  "Deve conter letra minúscula": "Debe contener una minúscula",
  "Deve conter número": "Debe contener un número",
  "Digite a descrição da aula...": "Introduce la descripción de la lección...",
  "Digite a senha": "Introduce la contraseña",
  "Digite a senha de acesso": "Introduce la contraseña de acceso",
  "Digite o nome impresso no cartão": "Introduce el nombre impreso en la tarjeta",
  "Digite o novo nome": "Introduce el nuevo nombre",
  "Digite seu cupom": "Introduce tu cupón",
  "Digite um e-mail válido": "Introduce un correo electrónico válido",
  "Dimensões": "Dimensiones",
  "Dispositivo mais usado": "Dispositivo más utilizado",
  "Distância do formulário em relação às bordas do vídeo": "Distancia del formulario respecto a los bordes del video",
  "Distribuição de tráfego": "Distribución del tráfico",
  "Dividir igualmente": "Repartir por igual",
  "Duração: {value0}": "Duración: {value0}",
  "É o checkout": "Es la página de pago",
  "E-mail do Usuário": "Correo electrónico del usuario",
  "Editar Captura com Senha": "Editar captura con contraseña",
  "Editar Captura de Dados": "Editar captura de datos",
  "Editar intro": "Editar introducción",
  "Editar Permissões": "Editar permisos",
  "Editor": "Editor",
  "Efeitos": "Efectos",
  "Ei, novidade boa por aqui! A gente trabalhou nos bastidores e entregou uma melhoria de performance completa na abertura dos vídeos. Resultado: carregamento mais rápido, menos travamentos e uma experiência muito melhor pra quem assiste o seu conteúdo.": "¡Tenemos buenas noticias! Hemos trabajado para mejorar por completo el rendimiento al abrir los videos. El resultado: cargas más rápidas, menos bloqueos y una experiencia mucho mejor para quienes ven tu contenido.",
  "Em desenvolvimento...": "En desarrollo...",
  "Email do usuário": "Correo electrónico del usuario",
  "Email:": "Correo electrónico:",
  "encontrado": "encontrado",
  "Endereço da página": "Dirección de la página",
  "English": "English",
  "Entendendo os padrões de engajamento do seu vídeo": "Comprende los patrones de interacción de tu video",
  "Entrar na Sala": "Entrar en la sala",
  "Entre 45% e 65%:": "Entre el 45 % y el 65 %:",
  "Entre 50% e 70%:": "Entre el 50 % y el 70 %:",
  "Envie seu vídeo": "Envía tu video",
  "Episódios": "Episodios",
  "Erro ao aplicar configurações": "Error al aplicar la configuración",
  "Erro ao atualizar": "Error al actualizar",
  "Erro ao atualizar clicks.": "Error al actualizar los clics.",
  "Erro ao carregar detalhes": "Error al cargar los detalles",
  "Erro ao carregar métricas do vídeo": "Error al cargar las métricas del video",
  "Erro ao compartilhar": "Error al compartir",
  "Erro ao criar pasta": "Error al crear la carpeta",
  "Erro ao definir cartão padrão": "Error al definir la tarjeta predeterminada",
  "Erro ao fazer login de suporte": "Error al iniciar sesión de soporte",
  "Erro ao processar cartão": "Error al procesar la tarjeta",
  "Erro ao remover cartão": "Error al eliminar la tarjeta",
  "Erro ao renomear pasta": "Error al cambiar el nombre de la carpeta",
  "Erro ao renomear vídeo": "Error al cambiar el nombre del video",
  "Erro inesperado. Tente novamente.": "Error inesperado. Inténtalo de nuevo.",
  "Escolha como os campos serão organizados": "Elige cómo se organizarán los campos",
  "Escolha do Template": "Selección de plantilla",
  "Escolha o tema": "Elige el tema",
  "Escolha o vídeo a integrar": "Elige el video que quieres integrar",
  "Escurecimento": "Oscurecimiento",
  "Espaçamento Externo (Offset)": "Espaciado exterior (desplazamiento)",
  "Espaçamento Interno": "Espaciado interior",
  "Español": "Español",
  "Espectadores": "Espectadores",
  "Espessura da Borda": "Grosor del borde",
  "Espionar Ofertas com a AdSniper": "Explorar ofertas con AdSniper",
  "Esta será a senha que os usuários precisarão digitar para desbloquear o vídeo": "Esta será la contraseña que deberán introducir los usuarios para desbloquear el video",
  "Estado Normal": "Estado normal",
  "Estados": "Estados",
  "Este link atingiu o limite máximo de cópias permitido. Entre em contato com o produtor.": "Este enlace ha alcanzado el número máximo de copias permitidas. Contacta con el productor.",
  "Este link de compartilhamento não existe ou foi removido.": "Este enlace compartido no existe o se ha eliminado.",
  "Este link expirou e não está mais disponível. Solicite um novo link ao produtor.": "Este enlace ha caducado y ya no está disponible. Solicita un nuevo enlace al productor.",
  "Este painel mostra quando seu público mais assiste ou carrega seu vídeo. Plays Únicos representam sessões deduplicadas; Visualizações Únicas, impressões deduplicadas. Use os horários mais fortes para agendar campanhas e posts.": "Este panel muestra cuándo tu público reproduce o carga más tu video. Las reproducciones únicas representan sesiones sin duplicados; las visualizaciones únicas, impresiones sin duplicados. Usa las horas de mayor actividad para programar campañas y publicaciones.",
  "Estilo dos inputs do formulário": "Estilo de los campos del formulario",
  "Estimativa:": "Estimación:",
  "Eventos": "Eventos",
  "Eventos de Interação": "Eventos de interacción",
  "Ex: Continuar Assistindo": "Ej.: Seguir viendo",
  "Ex: Curso Completo de Marketing Digital": "Ej.: Curso completo de marketing digital",
  "Ex: facebook": "Ej.: facebook",
  "Ex: Libere o acesso ao vídeo": "Ej.: Desbloquea el acceso al video",
  "Excluir etapa": "Eliminar etapa",
  "exemplo.com": "ejemplo.com",
  "Exibição": "Visualización",
  "Exportando dados": "Exportando datos",
  "Extra grande": "Extragrande",
  "Falar com especialista": "Hablar con un especialista",
  "Falha ao carregar {value0}": "Error al cargar {value0}",
  "Faturamento": "Facturación",
  "Ferramentas": "Herramientas",
  "Filtros de Período": "Filtros de período",
  "Fonte (Source)": "Fuente (Source)",
  "Fontes de Tráfego (UTMs)": "Fuentes de tráfico (UTM)",
  "Forma": "Forma",
  "Formato": "Formato",
  "Formulário": "Formulario",
  "Fundo (Hover)": "Fondo al pasar el cursor",
  "Fundo botão play": "Fondo del botón de reproducción",
  "Fundo botão restart": "Fondo del botón de reinicio",
  "Funil de Conversão": "Embudo de conversión",
  "Funil de Conversão nas Métricas": "Embudo de conversión en las métricas",
  "Gerar novo token": "Generar nuevo token",
  "Gerencie suas plataformas de venda integradas": "Gestiona tus plataformas de venta integradas",
  "Gradiente": "Degradado",
  "Guia de Desenvolvimento": "Guía de desarrollo",
  "Hero Banner": "Banner principal",
  "Home": "Inicio",
  "Horário campeão do período": "Hora con mejor rendimiento del período",
  "Horários ideais por tipo de acesso": "Horarios ideales por tipo de acceso",
  "Horizontal (campos lado a lado)": "Horizontal (campos uno al lado del otro)",
  "ℹ️ Formulário configurado para aparecer em:": "ℹ️ Formulario configurado para aparecer en:",
  "ID do vídeo não encontrado.": "ID del video no encontrado.",
  "ID:": "ID:",
  "Identidade Visual": "Identidad visual",
  "Imagem (favicon/logo)": "Imagen (favicon/logotipo)",
  "Imagem carregada": "Imagen cargada",
  "Imagem de Capa (1920×700px recomendado)": "Imagen de portada (recomendado: 1920×700 px)",
  "Impede o espectador de pausar o vídeo": "Impide que el espectador pause el video",
  "Importar": "Importar",
  "Incorpore seu vídeo no site!": "¡Inserta tu video en el sitio!",
  "Increment Clicks": "Aumentar clics",
  "Informe um nome para a proteção.": "Indica un nombre para la protección.",
  "Informe um nome para o teste.": "Indica un nombre para la prueba.",
  "Iniciando...": "Iniciando...",
  "Iniciar Teste": "Iniciar prueba",
  "INÍCIO": "INICIO",
  "Instalando...": "Instalando...",
  "Inter (Modern)": "Inter (moderna)",
  "Intro adicionada": "Introducción añadida",
  "Invalid color code": "Código de color no válido",
  "Itálico": "Cursiva",
  "Just-in-Time": "Justo a tiempo",
  "Lato (Professional)": "Lato (profesional)",
  "Leads Capturados": "Leads captados",
  "Liberar": "Permitir",
  "Limite de {value0} vídeos por envio": "Límite de {value0} videos por envío",
  "Limite de cópias atingido": "Límite de copias alcanzado",
  "Linhas": "Líneas",
  "Linhas por página:": "Filas por página:",
  "Link de compartilhamento criado e copiado!": "¡Enlace compartido creado y copiado!",
  "Link expirado": "Enlace caducado",
  "Maior": "Mayor",
  "Maior Ponto de Queda": "Mayor punto de abandono",
  "Maior valor registrado em 30d": "Mayor valor registrado en 30 días",
  "Maior valor registrado no período": "Mayor valor registrado en el período",
  "Mapa de Calor Premium": "Mapa de calor prémium",
  "Marcar como Concluído": "Marcar como completado",
  "Máximo de": "Máximo de",
  "Mede os acessos ao checkout. Não confirma uma compra; vendas dependem do rastreamento conectado.": "Mide los accesos a la página de pago. No confirma una compra; las ventas dependen del seguimiento conectado.",
  "Média": "Media",
  "Meio (Medium)": "Medio (Medium)",
  "Melhor dia": "Mejor día",
  "Melhor Momento de Engajamento": "Mejor momento de interacción",
  "Menor": "Menor",
  "Mensagem Principal": "Mensaje principal",
  "Mensagem Secundária": "Mensaje secundario",
  "Mesma aba": "Misma pestaña",
  "Métrica base:": "Métrica base:",
  "Métricas de Teste": "Métricas de la prueba",
  "Métricas do Webinário": "Métricas del seminario web",
  "Meu Dispositivo": "Mi dispositivo",
  "Minas Gerais": "Minas Gerais",
  "Minha Rede": "Mi red",
  "Mini Hook": "Mini Hook",
  "Mini Hooks são pequenos blocos de texto que aparecem em momentos estratégicos do vídeo para reativar a atenção do espectador. Configure quantos quiser, defina o tempo de exibição e veja o impacto direto na retenção.": "Los Mini Hooks son pequeños bloques de texto que aparecen en momentos estratégicos del video para recuperar la atención del espectador. Configura tantos como quieras, define el tiempo de aparición y observa el impacto directo en la retención.",
  "Mínimo 6 caracteres": "Mínimo 6 caracteres",
  "Módulo não encontrado": "Módulo no encontrado",
  "Módulos": "Módulos",
  "Montserrat (Impact)": "Montserrat (impacto)",
  "Mostrando": "Mostrando",
  "Mostrar no quadro": "Mostrar en el panel",
  "Mover para": "Mover a",
  "MP4, MOV, WEBM • Máximo 2GB": "MP4, MOV, WEBM • Máximo 2 GB",
  "Não conectado": "Sin conectar",
  "Não foi possível carregar as plataformas. Tente novamente.": "No se pudieron cargar las plataformas. Inténtalo de nuevo.",
  "Não foi possível criar a pasta": "No se pudo crear la carpeta",
  "Não foi possível processar este link. Tente novamente ou entre em contato com o produtor.": "No se pudo procesar este enlace. Inténtalo de nuevo o contacta con el productor.",
  "Não foi possível salvar as configurações.": "No se pudo guardar la configuración.",
  "Não há dados para exportar.": "No hay datos para exportar.",
  "Não há métricas para o período selecionado. Aguarde a coleta de dados ou ajuste o período.": "No hay métricas para el período seleccionado. Espera a que se recopilen datos o ajusta el período.",
  "Não salvo": "Sin guardar",
  "Navegador": "Navegador",
  "Navegadores": "Navegadores",
  "Nenhum dado disponível ainda": "Aún no hay datos disponibles",
  "Nenhum domínio cadastrado": "No hay dominios registrados",
  "Nenhum evento de clique foi registrado ainda.": "Todavía no se ha registrado ningún evento de clic.",
  "Nenhum feedback recebido ainda": "Aún no se han recibido comentarios",
  "Nenhum link encontrado para este vídeo": "No se encontró ningún enlace para este video",
  "Nenhum parâmetro UTM foi registrado ainda.": "Todavía no se ha registrado ningún parámetro UTM.",
  "Nenhum resultado encontrado": "No se encontraron resultados",
  "Nenhum vídeo adicionado": "Ningún video añadido",
  "Nenhum vídeo alternativo selecionado": "Ningún video alternativo seleccionado",
  "Nenhum vídeo encontrado.": "No se encontraron videos.",
  "Nenhum vídeo selecionado para salvar": "Ningún video seleccionado para guardar",
  "Nenhuma aula adicionada ainda": "Aún no se han añadido lecciones",
  "Nenhuma integração encontrada.": "No se encontraron integraciones.",
  "Nenhuma intro encontrada": "No se encontraron introducciones",
  "Nenhuma métrica disponível": "No hay métricas disponibles",
  "Nenhuma métrica disponível para o período selecionado.": "No hay métricas disponibles para el período seleccionado.",
  "Networking": "Contactos profesionales",
  "New feature": "Nueva función",
  "Nome da Playlist *": "Nombre de la lista de reproducción *",
  "Nome do Evento": "Nombre del evento",
  "Nome do fluxo": "Nombre del flujo",
  "Nome do teste": "Nombre de la prueba",
  "Nome do Teste": "Nombre de la prueba",
  "Nome muito longo": "Nombre demasiado largo",
  "Nome não pode estar vazio": "El nombre no puede estar vacío",
  "Nome usado apenas para organização interna.": "Nombre utilizado solo para la organización interna.",
  "Nome:": "Nombre:",
  "Normalizar por dia": "Normalizar por día",
  "Nova Captura": "Nueva captura",
  "Nova Despesa": "Nuevo gasto",
  "Nova senha deve ser diferente da atual": "La nueva contraseña debe ser distinta de la actual",
  "Novo Front Host VSL 2.0": "Nueva interfaz Host VSL 2.0",
  "Novo Player de vídeo da HostVSL": "Nuevo reproductor de video de HostVSL",
  "Novo Teste": "Nueva prueba",
  "Número total de cliques no botão de call-to-action (CTA) do vídeo.": "Número total de clics en el botón de llamada a la acción (CTA) del video.",
  "Número total de vezes que o play foi dado no vídeo.": "Número total de veces que se ha reproducido el video.",
  "Número total de vezes que o vídeo foi carregado, independente se foi assistido ou não.": "Número total de veces que se ha cargado el video, independientemente de si se ha visto o no.",
  "Nunito (Rounded)": "Nunito (redondeada)",
  "O arquivo foi baixado com sucesso.": "El archivo se ha descargado correctamente.",
  "O HostVSL está sendo instalado no seu dispositivo.": "HostVSL se está instalando en tu dispositivo.",
  "O nome da pasta não pode estar vazio": "El nombre de la carpeta no puede estar vacío",
  "O produtor desativou este compartilhamento. Entre em contato com ele para solicitar um novo link.": "El productor ha desactivado este enlace compartido. Contacta con él para solicitar un nuevo enlace.",
  "O teste será encerrado e a variação principal será aplicada. Esta ação não pode ser desfeita.": "La prueba finalizará y se aplicará la variación principal. Esta acción no se puede deshacer.",
  "Obrigatório": "Obligatorio",
  "Ocorreu um erro ao criar o teste. Tente novamente.": "Se ha producido un error al crear la prueba. Inténtalo de nuevo.",
  "Ocorreu um erro. Tente novamente.": "Se ha producido un error. Inténtalo de nuevo.",
  "Ocultar Feedback": "Ocultar comentarios",
  "offline": "sin conexión",
  "Onde o formulário será exibido sobre o vídeo": "Dónde aparecerá el formulario sobre el video",
  "Ordenar por": "Ordenar por",
  "Orientação do Formulário": "Orientación del formulario",
  "Os dados estão sendo atualizados para o novo período": "Los datos se están actualizando para el nuevo período",
  "Os primeiros 15 segundos são críticos. Considere testar diferentes abordagens com Teste de hook.": "Los primeros 15 segundos son cruciales. Prueba distintos enfoques con la prueba de ganchos.",
  "Oswald": "Oswald",
  "Oswald (Bold)": "Oswald (negrita)",
  "Other": "Otro",
  "Otimização": "Optimización",
  "Otimize o Início": "Optimiza el inicio",
  "ou": "o",
  "Overlay de Vídeo": "Capa sobre el video",
  "Padrão global": "Predeterminado global",
  "Parado": "Detenido",
  "Parâmetro": "Parámetro",
  "Parâmetros": "Parámetros",
  "Pasta excluída.": "Carpeta eliminada.",
  "Pausa o vídeo automaticamente quando o espectador sai da aba do navegador.": "Pausa automáticamente el video cuando el espectador sale de la pestaña del navegador.",
  "Percentual médio do vídeo que foi assistido pelos espectadores.": "Porcentaje medio del video que han visto los espectadores.",
  "Perfil Comercial": "Perfil comercial",
  "Período atualizado": "Período actualizado",
  "Período campeão": "Período con mejor rendimiento",
  "Permitir selecionados": "Permitir seleccionados",
  "Personalizar Caixa do Autoplay": "Personalizar cuadro de reproducción automática",
  "Personalize as cores dos elementos do formulário": "Personaliza los colores de los elementos del formulario",
  "Pesquisar vídeos": "Buscar videos",
  "Picos de Horário nas Métricas do Vídeo": "Horas punta en las métricas del video",
  "Pixels & Integrações": "Píxeles e integraciones",
  "Placeholder": "Texto de ejemplo",
  "Plano Atual": "Plan actual",
  "Plano inativo": "Plan inactivo",
  "Plano Selecionado": "Plan seleccionado",
  "Plataforma de vendas": "Plataforma de ventas",
  "Plataformas conectadas": "Plataformas conectadas",
  "Play Rate:": "Tasa de reproducción:",
  "Playfair Display (Elegant)": "Playfair Display (elegante)",
  "Plays restantes": "Reproducciones restantes",
  "PNG, JPG até 4MB": "PNG, JPG hasta 4 MB",
  "PNG, JPG ou SVG · até 2 MB": "PNG, JPG o SVG · hasta 2 MB",
  "Pode editar e adicionar vídeos": "Puede editar y añadir videos",
  "Pode ver vídeos e métricas": "Puede ver videos y métricas",
  "Ponto de Entrada": "Punto de entrada",
  "Poppins": "Poppins",
  "Poppins (Friendly)": "Poppins (amigable)",
  "por dia e horário": "por día y hora",
  "Por favor, digite um e-mail.": "Introduce un correo electrónico.",
  "Por favor, informe o {value0}": "Indica el {value0}",
  "Por favor, selecione um vídeo original": "Selecciona un video original",
  "Posição no Vídeo": "Posición en el video",
  "Posição:": "Posición:",
  "Posicionamento": "Posicionamiento",
  "Pré-visualizar": "Vista previa",
  "Preenchimento": "Relleno",
  "Pressionado": "Pulsado",
  "Preview Dinâmico": "Vista previa dinámica",
  "Primeiros passos": "Primeros pasos",
  "problemas": "problemas",
  "Proteção": "Protección",
  "Próxima Aula": "Siguiente lección",
  "Próxima aula em": "Siguiente lección en",
  "Próximas 24h": "Próximas 24 h",
  "Próximo": "Siguiente",
  "Próximo Pico": "Próxima hora punta",
  "Publicar": "Publicar",
  "QUA • 18h-20h": "MIÉ • 18:00-20:00",
  "Quando exibir o CTA": "Cuándo mostrar el CTA",
  "Quantidade de conversões registradas a partir deste vídeo.": "Número de conversiones registradas a partir de este video.",
  "Quantidade de pessoas diferentes que deram play no vídeo.": "Número de personas distintas que reprodujeron el video.",
  "Quantidade de pessoas diferentes que visualizaram o vídeo.": "Número de personas distintas que visualizaron el video.",
  "Quero aproveitar": "Quiero aprovecharlo",
  "Quero Ser Parceiro Host VSL": "Quiero ser socio de Host VSL",
  "Quiz Interativo com FunnelX": "Cuestionario interactivo con FunnelX",
  "Raio de Borda (Arredondamento)": "Radio del borde (redondeado)",
  "Rápida": "Rápida",
  "Rascunho salvo": "Borrador guardado",
  "Recarga Automática": "Recarga automática",
  "Recarregar Página": "Recargar página",
  "Receita atribuída": "Ingresos atribuidos",
  "Receita total gerada a partir de conversões deste vídeo.": "Ingresos totales generados a partir de las conversiones de este video.",
  "Recomeçar após finalizar": "Reiniciar al finalizar",
  "Recomeçar Vídeo Após o Fim": "Reiniciar video al terminar",
  "Recursos de Interação": "Funciones de interacción",
  "Redirecionamentos": "Redirecciones",
  "Reduzido de {value0} para {value1}": "Reducido de {value0} a {value1}",
  "Reenviar convite": "Reenviar invitación",
  "Reexibir no final do vídeo": "Volver a mostrar al final del video",
  "Região:": "Región:",
  "Regiões": "Regiones",
  "registro": "registro",
  "Regular": "Normal",
  "Reinicia em": "Se reinicia en",
  "Relatórios": "Informes",
  "Remover da pasta": "Quitar de la carpeta",
  "Remover do teste": "Quitar de la prueba",
  "Remover membro": "Eliminar miembro",
  "Remover plataforma": "Eliminar plataforma",
  "Reportar problema": "Informar de un problema",
  "Reproduza o vídeo para ver o formulário aparecendo no tempo configurado.": "Reproduce el video para ver cómo aparece el formulario en el momento configurado.",
  "Reset": "Restablecer",
  "Retangular": "Rectangular",
  "Retenção ao longo do tempo": "Retención a lo largo del tiempo",
  "Retroceder 10s": "Retroceder 10 s",
  "Revogar a chave {value0}": "Revocar la clave {value0}",
  "Rio de Janeiro": "Rio de Janeiro",
  "Roboto": "Roboto",
  "Roboto (Clean)": "Roboto (limpia)",
  "Rotas e Navegação": "Rutas y navegación",
  "Saiba Mais": "Más información",
  "Saiba mais:": "Más información:",
  "Saída de checkout": "Salida de la página de pago",
  "Salvar Configuração": "Guardar configuración",
  "Salvar todas as configurações no banco de dados": "Guardar toda la configuración en la base de datos",
  "Salve o tracking para liberar a URL": "Guarda el seguimiento para habilitar la URL",
  "Sans-serif": "Sin serifa",
  "São Paulo": "São Paulo",
  "seg": "s",
  "Selecionar plano": "Seleccionar plan",
  "Selecionar vídeo *": "Seleccionar video *",
  "Selecionar vídeos": "Seleccionar videos",
  "Selecione": "Selecciona",
  "Selecione a VSL que será protegida.": "Selecciona la VSL que quieres proteger.",
  "Selecione o país": "Selecciona el país",
  "Selecione o seu banco": "Selecciona tu banco",
  "Selecione o vídeo alternativo para acessos bloqueados.": "Selecciona el video alternativo para los accesos bloqueados.",
  "Selecione o vídeo e informe a chave da plataforma para receber conversões.": "Selecciona el video e indica la clave de la plataforma para recibir conversiones.",
  "Selecione um vídeo da biblioteca": "Selecciona un video de la biblioteca",
  "Selecione uma aula para começar": "Selecciona una lección para empezar",
  "Selecione uma pasta": "Selecciona una carpeta",
  "Selecione uma permissão": "Selecciona un permiso",
  "Sem nome da proteção": "Sin nombre de protección",
  "Sem permissão para editar testes A/B": "Sin permiso para editar pruebas A/B",
  "Sem permissão para excluir vídeos": "Sin permiso para eliminar videos",
  "Sem plano ativo": "Sin plan activo",
  "Sem vídeo alternativo": "Sin video alternativo",
  "Sem VSL protegida": "Sin VSL protegida",
  "Senha *": "Contraseña *",
  "Senha atual é obrigatória": "La contraseña actual es obligatoria",
  "Senha de Acesso": "Contraseña de acceso",
  "Senha deve ter pelo menos 8 caracteres": "La contraseña debe tener al menos 8 caracteres",
  "Serviço": "Servicio",
  "Sessão Agendada": "Sesión programada",
  "Seu pitch ocorre quando apenas": "Tu oferta aparece cuando solo",
  "Seu teste \"{value0}\" foi criado e está pronto para uso.": "Tu prueba \"{value0}\" se ha creado y está lista para usar.",
  "Seu vídeo está sendo processado…": "Tu video se está procesando…",
  "SEX • 14h-16h": "VIE • 14:00-16:00",
  "Sim, finalizar teste": "Sí, finalizar prueba",
  "Simulação do card no final do vídeo": "Simulación de la tarjeta al final del video",
  "Simular 10s": "Simular 10 s",
  "Simular 3s": "Simular 3 s",
  "Smart Autoplay": "Reproducción automática inteligente",
  "Só você vê esse nome.": "Solo tú ves este nombre.",
  "Sobre o Vídeo": "Encima del video",
  "Solte para enviar": "Suelta para enviar",
  "Sombra": "Sombra",
  "Somente hoje": "Solo hoy",
  "Source Sans Pro (Technical)": "Source Sans Pro (técnica)",
  "Storage": "Almacenamiento",
  "Sua headline aqui": "Tu titular aquí",
  "Suave": "Suave",
  "Sugestões de Melhoria": "Sugerencias de mejora",
  "Tamanho (px)": "Tamaño (px)",
  "Tamanho da Fonte (px)": "Tamaño de fuente (px)",
  "Taxa de Reprodução": "Tasa de reproducción",
  "Telefone:": "Teléfono:",
  "Tem certeza que deseja excluir esta variação? Esta ação não pode ser desfeita.": "¿Seguro que quieres eliminar esta variación? Esta acción no se puede deshacer.",
  "Tem certeza que deseja excluir permanentemente o vídeo": "¿Seguro que quieres eliminar permanentemente el video",
  "Tem certeza? Esta ação não pode ser desfeita.": "¿Seguro? Esta acción no se puede deshacer.",
  "Tente novamente.": "Inténtalo de nuevo.",
  "Tente selecionar um intervalo de datas diferente.": "Prueba a seleccionar otro intervalo de fechas.",
  "TER • 12h-14h": "MAR • 12:00-14:00",
  "Testar": "Probar",
  "Teste de velocidade deletado com sucesso.": "Prueba de velocidad eliminada correctamente.",
  "Testes A/B": "Pruebas A/B",
  "Testes em andamento": "Pruebas en curso",
  "Texto (Hover)": "Texto al pasar el cursor",
  "Texto principal do formulário": "Texto principal del formulario",
  "Textos": "Textos",
  "Thumbnail": "Miniatura",
  "Título da Seção": "Título de la sección",
  "Título do formulário": "Título del formulario",
  "Todas as configurações do seu vídeo foram salvas": "Se ha guardado toda la configuración de tu video",
  "Todos os planos incluem 15 dias grátis": "Todos los planes incluyen 15 días gratis",
  "Token de Suporte": "Token de soporte",
  "Top 3 horários com maior": "Los 3 horarios con mayor",
  "Topo": "Parte superior",
  "Total BRL": "Total BRL",
  "Total c/ Impostos": "Total con impuestos",
  "Total de": "Total de",
  "Total de Leads": "Total de leads",
  "Total geral": "Total general",
  "Total USD": "Total USD",
  "Total: 100%": "Total: 100 %",
  "Última Interação": "Última interacción",
  "Últimas Atualizações": "Últimas actualizaciones",
  "Últimos 7 dias": "Últimos 7 días",
  "Um vídeo foi compartilhado com você": "Se ha compartido un video contigo",
  "Upload concluído!": "¡Subida completada!",
  "URL copiada": "URL copiada",
  "URL do site": "URL del sitio",
  "URL do vídeo não disponível": "URL del video no disponible",
  "URL MP4 direta": "URL directa del MP4",
  "Use um nome que ajude você a identificar facilmente este experimento no futuro.": "Usa un nombre que te ayude a identificar fácilmente este experimento en el futuro.",
  "Usuário não encontrado": "Usuario no encontrado",
  "UTMs": "UTM",
  "Vagas limitadas": "Plazas limitadas",
  "Valor numérico": "Valor numérico",
  "Variações em teste": "Variaciones en prueba",
  "Velocidade atualizada": "Velocidad actualizada",
  "Vencedor": "Ganador",
  "Vendas aprovadas": "Ventas aprobadas",
  "Ver Detalhes": "Ver detalles",
  "Ver documentação": "Ver documentación",
  "Ver Feedback": "Ver comentarios",
  "Ver integrações": "Ver integraciones",
  "Ver no gráfico": "Ver en el gráfico",
  "Ver Sugestões": "Ver sugerencias",
  "Ver UTMs": "Ver UTM",
  "Vertical (campos empilhados)": "Vertical (campos apilados)",
  "Vídeo \"{value0}\" pronto para personalização!": "¡Video \"{value0}\" listo para personalizar!",
  "VÍDEO ALTERNATIVO": "VIDEO ALTERNATIVO",
  "Vídeo Base": "Video base",
  "Vídeo com Maior Captura": "Video con mayor captura",
  "Vídeo da Captura": "Video de la captura",
  "Vídeo da etapa": "Video de la etapa",
  "Vídeo de Fundo": "Video de fondo",
  "Vídeo de saída": "Video de salida",
  "Vídeo não encontrado": "Video no encontrado",
  "Vídeo não encontrado para salvar o pitch.": "Video no encontrado para guardar la oferta.",
  "Vídeo Principal": "Video principal",
  "Vídeo renomeado com sucesso": "Nombre del video cambiado correctamente",
  "Vídeo renomeado com sucesso!": "¡Nombre del video cambiado correctamente!",
  "vídeo selecionado": "video seleccionado",
  "Vídeos do fluxo": "Videos del flujo",
  "vídeos selecionados": "videos seleccionados",
  "Views": "Visualizaciones",
  "Vimeo": "Vimeo",
  "Vincular": "Vincular",
  "Visitas": "Visitas",
  "Visualizador": "Visor",
  "Visualizar": "Ver",
  "Você encerra quando quiser.": "Puedes finalizarlo cuando quieras.",
  "Você já começou a assistir esse vídeo": "Ya has empezado a ver este video",
  "Você pode acessar o HostVSL pela tela inicial do seu dispositivo.": "Puedes acceder a HostVSL desde la pantalla de inicio de tu dispositivo.",
  "Você precisa de um plano ativo para enviar vídeos. Ative um plano para continuar.": "Necesitas un plan activo para subir videos. Activa un plan para continuar.",
  "Você recebe": "Recibes",
  "Voltar para a lista": "Volver a la lista",
  "Voltar para Lista": "Volver a la lista",
  "VSL Alternativa": "VSL alternativa",
  "VSL PROTEGIDA": "VSL PROTEGIDA",
  "Webinários": "Seminarios web",
  "Your browser does not support the video tag.": "Tu navegador no admite la etiqueta de video.",
  " · o player mostra \"Conteúdo indisponível\" enquanto pausado": " · el reproductor muestra \"Contenido no disponible\" mientras está pausado",
  " (as de maior volume)": " (las de mayor volumen)",
  " (inativa)": " (inactiva)",
  " (seleção manual)": " (selección manual)",
  " • {value0} de conteúdo": " • {value0} de contenido",
  " de ": " de ",
  " em {value0}": " en {value0}",
  " Esta ação não afeta o vídeo já enviado.": " Esta acción no afecta al video ya enviado.",
  " Último: {value0}.": " Último: {value0}.",
  "— Escolha um vídeo —": "— Elige un video —",
  "— Sem destino —": "— Sin destino —",
  ", todas ligadas": ", todas conectadas",
  ": a pré-visualização pode ter etapas sem vídeo ou opções sem destino.": ": la vista previa puede contener etapas sin video u opciones sin destino.",
  ":1). Recomendado: mínimo 4.5:1 para acessibilidade (WCAG AA).": ":1). Recomendado: mínimo 4,5:1 para accesibilidad (WCAG AA).",
  ". Ao confirmar, você reconhece que recebeu acesso autorizado para usar este vídeo na sua conta HostVSL e concorda em não redistribuir este conteúdo para outras pessoas fora do fluxo oficial de compartilhamento.": ". Al confirmar, reconoces que has recibido acceso autorizado para usar este video en tu cuenta de HostVSL y aceptas no redistribuir este contenido a otras personas fuera del flujo oficial para compartirlo.",
  ". Cancele quando quiser.": ". Cancela cuando quieras.",
  ". Clique em uma célula para ver detalhes e abrir no Tracking.": ". Haz clic en una celda para ver los detalles y abrirlos en Tracking.",
  ". Cole apenas o valor, sem escrever nada antes dele.": ". Pega solo el valor, sin escribir nada delante.",
  ". Deseja continuar?": ". ¿Quieres continuar?",
  ". Ele será usado para todas as intros do teste.": ". Se utilizará para todas las introducciones de la prueba.",
  ". Use esses dados para planejar estratégias de tráfego.": ". Usa estos datos para planificar estrategias de tráfico.",
  ".SRT": ".SRT",
  ".VTT": ".VTT",
  "· assistido em média": "· visto de media",
  "· Página": "· Página",
  "' da lista?": "' de la lista?",
  "\" aparece.": "\" aparece.",
  "\" será removida deste teste.": "\" se eliminará de esta prueba.",
  "\" será removido da fila de upload.": "\" se eliminará de la cola de subida.",
  "\" será removido da lista.": "\" se eliminará de la lista.",
  "\" será removido permanentemente.": "\" se eliminará permanentemente.",
  "\"? Ela deixará de funcionar imediatamente.": "\"? Dejará de funcionar inmediatamente.",
  "\"? Esta ação não pode ser desfeita.": "\"? Esta acción no se puede deshacer.",
  "\"{value0}\" enviado. O processamento começou.": "\"{value0}\" enviado. El procesamiento ha comenzado.",
  "\"{value0}\" está completamente pronto e disponível para visualização!": "¡\"{value0}\" está completamente listo y disponible para verlo!",
  "\"{value0}\" está pronto para personalização (configurações padrão)": "\"{value0}\" está listo para personalizar (configuración predeterminada)",
  "\"{value0}\" já pode ser personalizado! O MP4 ainda está sendo gerado.": "¡Ya puedes personalizar \"{value0}\"! El MP4 todavía se está generando.",
  "\"5 Dicas Secretas\" vs \"Dicas Secretas\"": "\"5 consejos secretos\" frente a \"Consejos secretos\"",
  "(fim)": "(fin)",
  "(Mais alta)": "(Más alta)",
  "(Mais baixa)": "(Más baja)",
  "(mínimo 4.5:1)": "(mínimo 4,5:1)",
  "(Recomendado:": "(Recomendado:",
  "(Visível só para você)": "(Solo visible para ti)",
  "(XX) XXXXX-XXXX": "(XX) XXXXX-XXXX",
  "). Ou o VSL não foi aberto nas últimas 24h, ou o envio server-side falhou (credencial/endpoint) — ou a URL vinculada não é a página do vídeo.": "). La VSL no se ha abierto en las últimas 24 h, el envío desde el servidor ha fallado (credenciales/endpoint) o la URL vinculada no es la página del video.",
  "[AO VIVO] Crie seu webinário do zero em 60 minutos": "[EN DIRECTO] Crea tu seminario web desde cero en 60 minutos",
  "{value0} (clique duas vezes para renomear)": "{value0} (haz doble clic para cambiar el nombre)",
  "{value0} (seletor)": "{value0} (selector)",
  "{value0} (valor)": "{value0} (valor)",
  "{value0} • Atualizado: {value1}": "{value0} • Actualizado: {value1}",
  "{value0} arquivo(s) acima do limite de 2GB. Baixe pro PC primeiro.": "{value0} archivo(s) superan el límite de 2 GB. Descárgalos primero al PC.",
  "{value0} de {value1} integrações criadas. Você pode configurar as demais em Rastreamento.": "{value0} de {value1} integraciones creadas. Puedes configurar las demás en Seguimiento.",
  "{value0} indisponível neste ambiente. Tente novamente mais tarde.": "{value0} no está disponible en este entorno. Inténtalo más tarde.",
  "{value0} notificações não lidas": "{value0} notificaciones sin leer",
  "{value0} plays adicionados com sucesso!": "¡{value0} reproducciones añadidas correctamente!",
  "{value0} registro(s) exportado(s).": "{value0} registro(s) exportado(s).",
  "{value0} removido da seleção": "{value0} eliminado de la selección",
  "{value0} thumbnail": "Miniatura de {value0}",
  "{value0} tracking(s) excluído(s) com sucesso!": "¡{value0} seguimiento(s) eliminado(s) correctamente!",
  "{value0} vídeo(s) adicionado(s) à fila": "{value0} video(s) añadido(s) a la cola",
  "{value0} vídeo(s) adicionado(s) à pasta": "{value0} video(s) añadido(s) a la carpeta",
  "{value0} vídeo(s) adicionado(s) à playlist.": "{value0} video(s) añadido(s) a la lista de reproducción.",
  "{value0} vídeo(s) em processamento": "{value0} video(s) en procesamiento",
  "{value0} vídeo(s) excluído(s) com sucesso": "{value0} video(s) eliminado(s) correctamente",
  "{value0} vídeo{value1} importado{value2}": "{value0} video{value1} importado{value2}",
  "{value0} vídeo{value1} na fila de envio.": "{value0} video{value1} en la cola de envío.",
  "{value0} vídeos": "{value0} videos",
  "{value0} vídeos enviando": "{value0} videos en envío",
  "{value0}, {value1}, {value2} {value3} ({value4}% do pico)": "{value0}, {value1}, {value2} {value3} ({value4}% del pico)",
  "{value0}% (individual)": "{value0}% (individual)",
  "{value0}% taxa de clique": "{value0}% de tasa de clics",
  "{value0}º pitch": "Oferta n.º {value0}",
  "@empresa.com, @outra.com": "@empresa.com, @otra.com",
  "#meuElemento ou .minha-classe": "#miElemento o .mi-clase",
  "% (ajuste para 100%)": "% (ajustar al 100 %)",
  "% abaixo do desktop. Otimize sua experiência mobile.": "% por debajo del escritorio. Optimiza tu experiencia móvil.",
  "% ainda assistindo": "% siguen viendo",
  "% convertem": "% se convierten",
  "% de engajamento neste ponto": "% de interacción en este punto",
  "% de retenção": "% de retención",
  "% de visitantes que deram play no vídeo. Avalia título + thumbnail.": "% de visitantes que reprodujeron el video. Evalúa título y miniatura.",
  "% do horário de pico": "% de la hora punta",
  "% do limite": "% del límite",
  "% do pico": "% del pico",
  "% do pico do período": "% del pico del período",
  "% do tráfego": "% del tráfico",
  "% do vídeo": "% del video",
  "% dos espectadores saem aqui": "% de los espectadores abandonan aquí",
  "% dos espectadores saíram aqui": "% de los espectadores abandonaron aquí",
  "% dos plays do período.": "% de las reproducciones del período.",
  "% engajamento": "% de interacción",
  "% Engajamento": "% de interacción",
  "% médio de tempo assistido. Indica profundidade da retenção.": "% medio del tiempo visto. Indica la profundidad de la retención.",
  "% OFF ativo": "% de descuento activo",
  "% PlayRate": "% de tasa de reproducción",
  "% retenção": "% de retención",
  "% variação": "% de variación",
  "% vs 4 sem": "% frente a 4 semanas",
  "% vs. período anterior": "% frente al período anterior",
  "• 3 fontes profissionais": "• 3 fuentes profesionales",
  "• As notificações funcionam mesmo com o navegador fechado (em segundo plano)": "• Las notificaciones funcionan incluso con el navegador cerrado (en segundo plano)",
  "• As preferências são salvas automaticamente ao alterar qualquer configuração": "• Las preferencias se guardan automáticamente al cambiar cualquier ajuste",
  "• Dispositivo principal: Mobile (65% das capturas)": "• Dispositivo principal: móvil (65 % de las capturas)",
  "• Escalar campanhas entre 22h-24h": "• Aumentar las campañas entre las 22:00 y las 24:00",
  "• Formatos PNG, JPEG, GIF": "• Formatos PNG, JPEG, GIF",
  "• Horário campeão: 22h-24h com 238 conversões": "• Mejor horario: 22:00-24:00 con 238 conversiones",
  "• IMPORTANTE: Após a confirmação, os fundos podem levar até 3 dias úteis para constar em sua conta bancária.": "• IMPORTANTE: Tras la confirmación, los fondos pueden tardar hasta 3 días laborables en aparecer en tu cuenta bancaria.",
  "• Investir mais em tráfego móvel (maior conversão)": "• Invertir más en tráfico móvil (mayor conversión)",
  "• Layouts complexos": "• Diseños complejos",
  "• O repasse será depositado na conta bancária padrão vinculada ao seu cadastro.": "• El pago se ingresará en la cuenta bancaria predeterminada vinculada a tu registro.",
  "• O valor mínimo regulamentado para saques manuais é de": "• El importe mínimo establecido para retiradas manuales es de",
  "• Tamanhos responsivos": "• Tamaños adaptables",
  "• Taxa de completude de dados: 92% (excelente)": "• Tasa de integridad de los datos: 92 % (excelente)",
  "• Taxas operacionais de saque serão debitadas de acordo com as regras internas do split.": "• Las comisiones operativas de retirada se deducirán según las reglas internas del reparto.",
  "• Testar captura com senha neste horário": "• Probar la captura con contraseña en este horario",
  "• Timing inadequado:": "• Momento inadecuado:",
  "• Use o botão \"Enviar Notificação Teste\" para verificar se está tudo funcionando": "• Usa el botón \"Enviar notificación de prueba\" para comprobar que todo funciona",
  "• Use power words:": "• Usa palabras persuasivas:",
  "• Você pode desativar notificações específicas sem perder as outras": "• Puedes desactivar notificaciones concretas sin perder las demás",
  "© 2025 Host VSL": "© 2025 Host VSL",
  "© HostVSL. 2025. Todos os direitos reservados.": "© HostVSL. 2025. Todos los derechos reservados.",
  "← Voltar para Métricas": "← Volver a las métricas",
  "→ Será salvo como: https://": "→ Se guardará como: https://",
  "+ Adicionar": "+ Añadir",
  "+ Adicionar ao Plano": "+ Añadir al plan",
  "+ Adicionar mais": "+ Añadir más",
  "+ Adicionar parâmetro": "+ Añadir parámetro",
  "+ Adicionar Plays Extras": "+ Añadir reproducciones extra",
  "+ Adicionar vídeos": "+ Añadir videos",
  "+ Conectar Novo Pixel": "+ Conectar nuevo píxel",
  "+ Conectar Plataforma": "+ Conectar plataforma",
  "+ Etapa": "+ Etapa",
  "+ Novo Vídeo": "+ Nuevo video",
  "± 8% variação": "± 8 % de variación",
  "| Conta: ****": "| Cuenta: ****",
  "⏰ Horário de pico": "⏰ Hora punta",
  "⚛️ Componentes React": "⚛️ Componentes React",
  "⚠️ Aviso: Dados grandes": "⚠️ Aviso: datos voluminosos",
  "⚠️ Este domínio já está cadastrado": "⚠️ Este dominio ya está registrado",
  "⚠️ O usuário ainda não configurou uma conta padrão!": "⚠️ ¡El usuario aún no ha configurado una cuenta predeterminada!",
  "✅ \"{value0}\" foi movido com sucesso!": "✅ ¡\"{value0}\" se ha movido correctamente!",
  "✅ Status: OK": "✅ Estado: correcto",
  "✖ O domínio inserido não é válido": "✖ El dominio introducido no es válido",
  "✨ 15 dias grátis": "✨ 15 días gratis",
  "✨ Proteção geográfica configurada com sucesso!": "✨ ¡Protección geográfica configurada correctamente!",
  "✨ Proteção por região configurada com sucesso!": "✨ ¡Protección por región configurada correctamente!",
  "❌ Erro ao importar": "❌ Error al importar",
  "❌ Evite": "❌ Evita",
  "❓ Como funciona": "❓ Cómo funciona",
  "⭐ Diferenciais Premium": "⭐ Ventajas prémium",
  "🌐 Environment:": "🌐 Entorno:",
  "🎁 Bônus": "🎁 Bonificación",
  "🎉 Notificações ativadas!": "🎉 ¡Notificaciones activadas!",
  "🎉 Nova conversão!": "🎉 ¡Nueva conversión!",
  "🎥 Vídeo:": "🎥 Video:",
  "🎨 Cores do Tema": "🎨 Colores del tema",
  "🎯 Configurações Netflix": "🎯 Configuración de Netflix",
  "🎯 O ideal": "🎯 Lo ideal",
  "🎯 O ideal: curva estável com retenção >50% até metade da VSL.": "🎯 Lo ideal: una curva estable con retención >50 % hasta la mitad de la VSL.",
  "🏆 Estratégias Avançadas": "🏆 Estrategias avanzadas",
  "🏆 Horário Campeão": "🏆 Horario ganador",
  "👑 Principal": "👑 Principal",
  "👤 Ações do Usuário": "👤 Acciones del usuario",
  "👤 Criador": "👤 Creador",
  "💡 Barra verde indica o \"Dia Campeão\"": "💡 La barra verde indica el \"Día ganador\"",
  "💡 Clique no vídeo para reproduzir/pausar e testar o formulário": "💡 Haz clic en el video para reproducirlo o pausarlo y probar el formulario",
  "💡 Dica": "💡 Consejo",
  "💡 Dica de Ouro": "💡 Consejo de oro",
  "💡 Dica Inteligente": "💡 Consejo inteligente",
  "💡 Dica: Configure um teste na aba 'Teste A/B' para visualizar métricas comparativas por variação.": "💡 Consejo: configura una prueba en la pestaña 'Prueba A/B' para ver métricas comparativas por variación.",
  "💡 Dica: Configure um teste na aba \"Teste A/B\" para visualizar métricas comparativas por variação.": "💡 Consejo: configura una prueba en la pestaña \"Prueba A/B\" para ver métricas comparativas por variación.",
  "💡 Insight Automático": "💡 Análisis automático",
  "💡 Insight do Dia": "💡 Dato destacado del día",
  "💡 Os vídeos são opcionais e serão aplicados conforme a ação escolhida.": "💡 Los videos son opcionales y se aplicarán según la acción elegida.",
  "💡 Recomendações": "💡 Recomendaciones",
  "💡 Sobre as notificações": "💡 Acerca de las notificaciones",
  "💾 localStorage (persist)": "💾 localStorage (persistencia)",
  "📈 Engajamento": "📈 Interacción",
  "📊 Análise de Introduções": "📊 Análisis de introducciones",
  "📊 Análise de Retenção – VSLs Testadas": "📊 Análisis de retención – VSL probadas",
  "📊 Interpretação das Métricas": "📊 Interpretación de las métricas",
  "📊 Interpretando os Resultados": "📊 Interpretación de los resultados",
  "📊 Meta alcançada!": "📊 ¡Objetivo alcanzado!",
  "📊 Métricas —": "📊 Métricas —",
  "📊 O teste está ativo, mas ainda não há métricas disponíveis. As métricas aparecerão assim que houver visualizações.": "📊 La prueba está activa, pero todavía no hay métricas disponibles. Aparecerán cuando haya visualizaciones.",
  "📊 Principais Insights": "📊 Conclusiones principales",
  "📋 Como melhorar?": "📋 ¿Cómo mejorar?",
  "📘 Como interpretar os dados do Teste A/B?": "📘 ¿Cómo interpretar los datos de la prueba A/B?",
  "📘 Como interpretar?": "📘 ¿Cómo interpretarlo?",
  "📝 Rodapé": "📝 Pie de página",
  "📤 Upload iniciado": "📤 Subida iniciada",
  "📦 Código de Incorporação": "📦 Código de inserción",
  "📱 Mobile": "📱 Móvil",
  "📷 Personalização do Header": "📷 Personalización de la cabecera",
  "🔁 Visualizações x Plays": "🔁 Visualizaciones frente a reproducciones",
  "🔒 Conexão segura • Dados criptografados • Suporte 24/7": "🔒 Conexión segura • Datos cifrados • Soporte 24/7",
  "🔒 Site seguro": "🔒 Sitio seguro",
  "🔗 Botão Externo": "🔗 Botón externo",
  "🔥 Alto engajamento!": "🔥 ¡Alta interacción!",
  "🔥 Engajamento": "🔥 Interacción",
  "🔧 Otimizações Comuns": "🔧 Optimizaciones habituales",
  "🕐 Timestamp:": "🕐 Marca de tiempo:",
  "🖥️ Desktop": "🖥️ Escritorio",
  "🖼️ Favicon e Título": "🖼️ Favicon y título",
  "🖼️ Logo da Playlist": "🖼️ Logotipo de la lista de reproducción",
  "🗄️ Supabase (API)": "🗄️ Supabase (API)",
  "🧪 Notificação de teste": "🧪 Notificación de prueba",
  "🚀 Para continuar assistindo, preencha seus dados rápidos abaixo!": "🚀 ¡Para seguir viendo, completa tus datos a continuación!",
  "🛡️ Código de Incorporação com Proteção": "🛡️ Código de inserción con protección",
  "🛡️ Proteção por Domínio": "🛡️ Protección por dominio",
  "0 = exibir até o final do vídeo": "0 = mostrar hasta el final del video",
  "0 participantes": "0 participantes",
  "004 - Banco do Nordeste do Brasil S.A.": "004 - Banco do Nordeste do Brasil S.A.",
  "02 JAN 2026": "02 ENE 2026",
  "021 - BANESTES S.A. Banco do Estado do Espírito Santo": "021 - BANESTES S.A. Banco do Estado do Espírito Santo",
  "041 - Banco do Estado do Rio Grande do Sul S.A. (Banrisul)": "041 - Banco do Estado do Rio Grande do Sul S.A. (Banrisul)",
  "070 - Banco de Brasília S.A. (BRB)": "070 - Banco de Brasília S.A. (BRB)",
  "085 - Cooperativa Central de Crédito Ailos": "085 - Cooperativa Central de Crédito Ailos",
  "09 JAN 2026": "09 ENE 2026",
  "1 = maior prioridade. Regras com maior prioridade são avaliadas primeiro.": "1 = máxima prioridad. Las reglas con mayor prioridad se evalúan primero.",
  "1 linha": "1 línea",
  "1 Play = R$": "1 reproducción = R$",
  "1 USD = BRL": "1 USD = BRL",
  "1. Crie o fluxo": "1. Crea el flujo",
  "1. Para PlayRate Baixo (abaixo de 45%):": "1. Para una tasa de reproducción baja (inferior al 45 %):",
  "1. Pegue o seu link": "1. Obtén tu enlace",
  "1. Selecione duas VSLs": "1. Selecciona dos VSL",
  "1.0x (Normal)": "1.0x (normal)",
  "1.8 GB": "1.8 GB",
  "10 minutos": "10 minutos",
  "10% das comissões deles": "10 % de sus comisiones",
  "12% menos": "12 % menos",
  "136 - Confederação Nacional das Cooperativas Unicred": "136 - Confederação Nacional das Cooperativas Unicred",
  "15 dias grátis — você só paga após o período de teste": "15 días gratis: solo pagas después del período de prueba",
  "15 minutos": "15 minutos",
  "16 JAN 2026": "16 ENE 2026",
  "197 - Stone Co. (Stone Pagamentos)": "197 - Stone Co. (Stone Pagamentos)",
  "2 dias atrás": "Hace 2 días",
  "2 linhas": "2 líneas",
  "2 segundos": "2 segundos",
  "2. Acompanhe os cliques": "2. Sigue los clics",
  "2. Analise os dados reais": "2. Analiza los datos reales",
  "2. Distribução automática": "2. Distribución automática",
  "2. Distribuição automática": "2. Distribución automática",
  "2. Envie os vídeos": "2. Envía los videos",
  "2. Para Engajamento Baixo (abaixo de 50%):": "2. Para una interacción baja (inferior al 50 %):",
  "20 p/ pág": "20 por pág.",
  "20% de comissão recorrente": "20 % de comisión recurrente",
  "208 - Banco BTG Pactual S.A.": "208 - Banco BTG Pactual S.A.",
  "23 JAN 2026": "23 ENE 2026",
  "25 p/ pág": "25 por pág.",
  "25% recorrente": "25 % recurrente",
  "26 DEZ 2025": "26 DIC 2025",
  "290 - Pagseguro Internet S.A. (PagBank)": "290 - Pagseguro Internet S.A. (PagBank)",
  "3 dias úteis": "3 días laborables",
  "3 linhas": "3 líneas",
  "3 segundos": "3 segundos",
  "3. Identifique a vencedora": "3. Identifica a la ganadora",
  "3. Monte as etapas": "3. Monta las etapas",
  "3. Para Cliques Baixos no CTA:": "3. Para pocos clics en el CTA:",
  "3. Receba os pagamentos": "3. Recibe los pagos",
  "30 minutos": "30 minutos",
  "323 - Mercado Pago Caixa Eletrônica do MP Ltda.": "323 - Mercado Pago Caixa Eletrônica do MP Ltda.",
  "336 - Banco C6 S.A. (C6 Bank)": "336 - Banco C6 S.A. (C6 Bank)",
  "389 - Banco Mercantil do Brasil S.A.": "389 - Banco Mercantil do Brasil S.A.",
  "390 × 844 · iPhone": "390 × 844 · iPhone",
  "399 - Kirton Bank S.A. (Banco Múltiplo)": "399 - Kirton Bank S.A. (Banco Múltiplo)",
  "4. Otimize suas decisões": "4. Optimiza tus decisiones",
  "4. Personalize o player": "4. Personaliza el reproductor",
  "403 - Cora Sociedade de Crédito Direto S.A.": "403 - Cora Sociedade de Crédito Direto S.A.",
  "422 - Banco Safra S.A.": "422 - Banco Safra S.A.",
  "5 minutos": "5 minutos",
  "5 segundos": "5 segundos",
  "5. Publique e cole o código": "5. Publica y pega el código",
  "50% OFF": "50 % de descuento",
  "536 - Neon Pagamentos S.A. (Banco Neon)": "536 - Neon Pagamentos S.A. (Banco Neon)",
  "6. Acompanhe as métricas": "6. Sigue las métricas",
  "623 - Banco Pan S.A.": "623 - Banco Pan S.A.",
  "637 - Banco Sofisa S.A.": "637 - Banco Sofisa S.A.",
  "65% = VSL magnética.": "65 % = VSL magnética.",
  "655 - Banco Votorantim S.A. (Banco BV)": "655 - Banco Votorantim S.A. (Banco BV)",
  "67% dos visitantes entram neste ponto": "67 % de los visitantes entran en este punto",
  "745 - Banco Citibank S.A.": "745 - Banco Citibank S.A.",
  "748 - Banco Cooperativo Sicredi S.A.": "748 - Banco Cooperativo Sicredi S.A.",
  "756 - Banco Cooperativo do Brasil S.A. (Sicoob)": "756 - Banco Cooperativo do Brasil S.A. (Sicoob)",
  "756 - Banco Ourinvest S.A. (Nomad)": "756 - Banco Ourinvest S.A. (Nomad)",
  "80% das vagas preenchidas": "80 % de las plazas cubiertas",
  "820 × 1180 · iPad": "820 × 1180 · iPad",
  "A = Ativo": "A = Activo",
  "A agência deve conter exatamente 4 dígitos.": "La sucursal debe contener exactamente 4 dígitos.",
  "A aplicação utiliza uma arquitetura de componentes modular, com componentes reutilizáveis organizados por domínio.": "La aplicación utiliza una arquitectura modular, con componentes reutilizables organizados por dominio.",
  "A cada visitante, uma nova intro é exibida aleatoriamente para coleta de dados.": "Cada visitante ve una nueva introducción elegida al azar para recopilar datos.",
  "A captura foi desativada com sucesso.": "La captura se ha desactivado correctamente.",
  "A captura por senha foi configurada com sucesso.": "La captura con contraseña se ha configurado correctamente.",
  "A captura por senha foi desativada com sucesso.": "La captura con contraseña se ha desactivado correctamente.",
  "A conta informada deve pertencer ao mesmo titular do CPF cadastrado.": "La cuenta indicada debe pertenecer al mismo titular del CPF registrado.",
  "A conta precisa de atenção ou envio de novos documentos.": "La cuenta requiere atención o el envío de nuevos documentos.",
  "A data não pode ser no passado.": "La fecha no puede estar en el pasado.",
  "A estratégia foi {value0}.": "La estrategia se ha {value0}.",
  "A exclusão de registros estará disponível em breve.": "La eliminación de registros estará disponible pronto.",
  "A Host VSL entrou em uma nova fase. O Front 2.0 foi criado para quem quer operar com mais clareza, mais velocidade e mais controle.": "Host VSL ha entrado en una nueva etapa. Front 2.0 se ha creado para quienes quieren trabajar con más claridad, velocidad y control.",
  "A Host VSL entrou em uma nova fase. O Front 2.0 foi criado para quem quer operar com mais clareza, mais velocidade e mais controle. Tudo ficou mais consistente, mais fluido e pronto para acompanhar o crescimento de quem escala vendas todos os dias.": "Host VSL ha entrado en una nueva etapa. Front 2.0 se ha creado para quienes quieren trabajar con más claridad, velocidad y control. Todo es más coherente, fluido y preparado para acompañar el crecimiento de quienes aumentan sus ventas cada día.",
  "A Host VSL Transforma Recursos em Resultados": "Host VSL transforma funciones en resultados",
  "A HostVSL funciona em sistema pré-pago. Você paga antecipadamente pelo seu plano e pelos plays inclusos. Se precisar de mais plays, pode comprá-los avulsos ou configurar a recarga automática.": "HostVSL funciona con un sistema de prepago. Pagas por adelantado tu plan y las reproducciones incluidas. Si necesitas más reproducciones, puedes comprarlas por separado o configurar la recarga automática.",
  "A HostVSL segue um design system premium inspirado na Apple, com foco em minimalismo, elegância e consistência visual.": "HostVSL sigue un sistema de diseño prémium inspirado en Apple, centrado en el minimalismo, la elegancia y la coherencia visual.",
  "A HostVSL utiliza Zustand para gerenciamento de estado global. Cada store é responsável por um domínio específico da aplicação, com persistência automática via localStorage quando necessário.": "HostVSL utiliza Zustand para gestionar el estado global. Cada almacén se encarga de un dominio concreto de la aplicación, con persistencia automática mediante localStorage cuando es necesario.",
  "A imagem deve ter no máximo 2MB": "La imagen debe ocupar como máximo 2 MB",
  "A integração com {value0} foi configurada.": "La integración con {value0} se ha configurado.",
  "A linha vertical amarela indica o ponto do pitch de vendas": "La línea vertical amarilla indica el momento de la oferta de ventas",
  "A logo foi enviada e salva com sucesso": "El logotipo se ha enviado y guardado correctamente",
  "A logo foi removida com sucesso": "El logotipo se ha eliminado correctamente",
  "A maioria dos espectadores inicia o vídeo do começo. Otimize seus primeiros 10 segundos para maximizar a retenção.": "La mayoría de los espectadores empieza el video desde el principio. Optimiza los primeros 10 segundos para maximizar la retención.",
  "A nova thumbnail foi aplicada à sua playlist.": "La nueva miniatura se ha aplicado a tu lista de reproducción.",
  "A pausa também foi removida: ela depende de quando as opções aparecem.": "La pausa también se ha eliminado: depende de cuándo aparecen las opciones.",
  "A plataforma integra com Supabase para backend (autenticação, banco de dados, storage) e utiliza React Query para cache e sincronização de dados.": "La plataforma se integra con Supabase como backend (autenticación, base de datos y almacenamiento) y utiliza React Query para la caché y la sincronización de datos.",
  "A playlist foi removida com sucesso.": "La lista de reproducción se ha eliminado correctamente.",
  "A playlist precisa ter pelo menos 1 vídeo para gerar a thumbnail.": "La lista de reproducción debe contener al menos 1 video para generar la miniatura.",
  "A playlist precisa ter pelo menos 1 vídeo.": "La lista de reproducción debe contener al menos 1 video.",
  "A playlist que você está procurando não existe ou foi removida.": "La lista de reproducción que buscas no existe o se ha eliminado.",
  "A prévia para marcar os tempos aparece assim que o vídeo começar a ficar pronto. Enquanto isso, você pode digitar os tempos.": "La vista previa para marcar los tiempos aparecerá cuando el video empiece a estar listo. Mientras tanto, puedes introducir los tiempos.",
  "A prioridade dos testes foi alterada": "Se ha cambiado la prioridad de las pruebas",
  "A processar...": "Procesando...",
  "a qualquer momento.": "en cualquier momento.",
  "A queda acentuada no início sugere que seu gancho não está forte o suficiente. Teste um problema mais urgente ou curiosidade mais intensa.": "La caída pronunciada al inicio sugiere que el gancho no es lo bastante fuerte. Prueba un problema más urgente o despierta más curiosidad.",
  "A regra do cloaker foi atualizada.": "La regla del cloaker se ha actualizado.",
  "A senha deve ter pelo menos 6 caracteres": "La contraseña debe tener al menos 6 caracteres",
  "A senha deve ter pelo menos 6 caracteres.": "La contraseña debe tener al menos 6 caracteres.",
  "A thumbnail foi removida com sucesso": "La miniatura se ha eliminado correctamente",
  "A thumbnail inicial só funciona se os Controles de Vídeo estiverem ativados. Ative os Controles nas configurações.": "La miniatura inicial solo funciona si los controles de video están activados. Activa los controles en la configuración.",
  "A URL deve começar com http:// ou https://": "La URL debe empezar por http:// o https://",
  "A URL não pode estar vazia": "La URL no puede estar vacía",
  "A venda será contabilizada para o afiliado detentor do último link acessado pelo cliente antes do registo.": "La venta se atribuirá al afiliado propietario del último enlace al que haya accedido el cliente antes de registrarse.",
  "A verificar conta...": "Verificando cuenta...",
  "A versão no ar já é igual ao rascunho.": "La versión publicada ya coincide con el borrador.",
  "A versão publicada continua no ar como está.": "La versión publicada sigue disponible sin cambios.",
  "A VSL protegida não foi encontrada.": "No se ha encontrado la VSL protegida.",
  "Abaixo": "Debajo",
  "Abra no computador para editar": "Ábrelo en un ordenador para editarlo",
  "Abra o app direto da tela inicial, sem precisar abrir o navegador": "Abre la aplicación directamente desde la pantalla de inicio, sin abrir el navegador",
  "Abra o seletor do Google e marque os vídeos. Eles entram direto na fila de envio.": "Abre el selector de Google y marca los videos. Se añadirán directamente a la cola de envío.",
  "Abre o vídeo em tela cheia ao clicar no overlay": "Abre el video a pantalla completa al hacer clic en la capa superpuesta",
  "Abrindo preview do vídeo {value0}": "Abriendo la vista previa del video {value0}",
  "Abrir": "Abrir",
  "Abrir link do botão em nova aba": "Abrir el enlace del botón en una nueva pestaña",
  "Abrir menu de ações": "Abrir menú de acciones",
  "Abrir menu de conta": "Abrir menú de cuenta",
  "Abrir Modal de Incorporação": "Abrir diálogo de inserción",
  "Abrir nova aba": "Abrir nueva pestaña",
  "Abrir Original": "Abrir original",
  "Abrir página": "Abrir página",
  "Abrir pasta": "Abrir carpeta",
  "Abrir playlist {value0}": "Abrir lista de reproducción {value0}",
  "Abrir URL em nova aba": "Abrir URL en una nueva pestaña",
  "Abrir vídeo agora": "Abrir video ahora",
  "Abrir Vídeos Compartilhados": "Abrir videos compartidos",
  "Ação & Destino": "Acción y destino",
  "Ação aplicada:": "Acción aplicada:",
  "Ação Ativada": "Acción activada",
  "Ação quando zerar": "Acción al llegar a cero",
  "Ação:": "Acción:",
  "Aceita HTML e CSS inline. Scripts não são permitidos.": "Admite HTML y CSS en línea. No se permiten scripts.",
  "Aceita Vimeo, Bunny, Cloudflare ou MP4 direto": "Admite Vimeo, Bunny, Cloudflare o MP4 directo",
  "Aceitar e adicionar": "Aceptar y añadir",
  "Aceite de uso": "Aceptación de uso",
  "Acelere levemente o meio do vídeo": "Acelera ligeramente la parte central del video",
  "Acelere momentos menos importantes e destaque momentos chave com ritmo mais lento e foco.": "Acelera los momentos menos importantes y destaca los momentos clave con un ritmo más lento y enfoque.",
  "Acessando...": "Accediendo...",
  "Acessar": "Acceder",
  "Acessar central de ajuda": "Acceder al centro de ayuda",
  "Acessar vídeo": "Acceder al video",
  "Acesse o conteúdo e receba o link no seu e-mail": "Accede al contenido y recibe el enlace por correo electrónico",
  "Acesse suas métricas e vídeos diretamente da tela inicial do seu dispositivo. Funciona offline e carrega instantaneamente!": "Accede a tus métricas y videos directamente desde la pantalla de inicio de tu dispositivo. ¡Funciona sin conexión y carga al instante!",
  "Acesse suas métricas mesmo sem conexão com a internet": "Accede a tus métricas incluso sin conexión a internet",
  "Acesso bloqueado": "Acceso bloqueado",
  "Acesso de Suporte": "Acceso de soporte",
  "Acesso permitido": "Acceso permitido",
  "Acessos ao checkout": "Accesos a la página de pago",
  "acessos protegidos": "accesos protegidos",
  "Acessos sem UTM aparecem como “Direto” na tabela, mas não têm curva de retenção no gráfico.": "Los accesos sin UTM aparecen como «Directo» en la tabla, pero no tienen curva de retención en el gráfico.",
  "Acessos únicos": "Accesos únicos",
  "Acessos únicos ao checkout": "Accesos únicos a la página de pago",
  "Acessou a Sala": "Accedió a la sala",
  "Acima": "Encima",
  "Acionar vendas simuladas": "Activar ventas simuladas",
  "ações configuradas": "acciones configuradas",
  "Ações Configuradas (": "Acciones configuradas (",
  "Ações do vídeo {value0}": "Acciones del video {value0}",
  "Ações Necessárias": "Acciones necesarias",
  "Acompanhe a performance detalhada do seu webinário.": "Sigue el rendimiento detallado de tu seminario web.",
  "Acompanhe a performance dos seus vídeos.": "Sigue el rendimiento de tus videos.",
  "Acompanhe cada lead em um pipeline visual com histórico completo.": "Sigue cada lead en un canal visual con un historial completo.",
  "Acompanhe o desempenho das suas VSL's em tempo real": "Sigue el rendimiento de tus VSL en tiempo real",
  "Acompanhe os padrões que mais convertem": "Sigue los patrones que más convierten",
  "Acompanhe qual variação converte mais.": "Comprueba qué variación genera más conversiones.",
  "Acompanhe seu consumo de plays mensais": "Controla tu consumo mensual de reproducciones",
  "Acompanhe todas as atualizações e novos recursos da Host VSL": "Consulta todas las actualizaciones y nuevas funciones de Host VSL",
  "Acompanhe todas as conversões em um só painel.": "Consulta todas las conversiones en un solo panel.",
  "Acompanhe todas as vendas em tempo real": "Sigue todas las ventas en tiempo real",
  "Acompanhe visualizações, engajamento, cliques e outras métricas importantes para cada variante.": "Consulta las visualizaciones, la interacción, los clics y otras métricas importantes de cada variante.",
  "Acompanhe visualizações, engajamento, retenção e outras métricas importantes para cada introdução.": "Consulta las visualizaciones, la interacción, la retención y otras métricas importantes de cada introducción.",
  "Acumulado": "Acumulado",
  "Acumulado por todos os afiliados.": "Acumulado por todos los afiliados.",
  "Adapte o formato Atenção, Interesse, Desejo e Ação para sua narrativa em vídeo.": "Adapta el modelo de atención, interés, deseo y acción a tu narrativa en video.",
  "Add to favorites": "Añadir a favoritos",
  "Adiciona botão para avançar 10 segundos no vídeo": "Añade un botón para avanzar 10 segundos en el video",
  "Adiciona botão para retroceder 10 segundos no vídeo": "Añade un botón para retroceder 10 segundos en el video",
  "Adiciona efeito pulsante para chamar atenção": "Añade un efecto de pulsación para llamar la atención",
  "Adiciona sombras nos cards para maior profundidade": "Añade sombras a las tarjetas para dar más profundidad",
  "Adicionamos um novo botão de transmissão para Smart TV nos controles do player. Com ele ativo, seu espectador clica e escolhe transmitir o vídeo pra uma Chromecast (no Chrome) ou Apple TV/AirPlay (no Safari) que esteja na mesma rede Wi-Fi. Ótimo pra ofertas high-ticket onde o cliente quer assistir junto com cônjuge ou sócio antes de fechar.": "Hemos añadido un botón para transmitir a Smart TV en los controles del reproductor. Cuando está activo, el espectador puede enviar el video a un Chromecast (en Chrome) o Apple TV/AirPlay (en Safari) de la misma red wifi. Ideal para ofertas de alto valor que el cliente quiere ver con su pareja o socio antes de comprar.",
  "Adicionando...": "Añadiendo...",
  "Adicionar aos favoritos": "Añadir a favoritos",
  "Adicionar Bônus": "Añadir bonificación",
  "Adicionar Campo Extra": "Añadir campo extra",
  "Adicionar cartão": "Añadir tarjeta",
  "Adicionar Intros": "Añadir introducciones",
  "Adicionar legenda": "Añadir subtítulos",
  "Adicionar Link": "Añadir enlace",
  "Adicionar Mini Hook": "Añadir Mini Hook",
  "Adicionar Módulo": "Añadir módulo",
  "Adicionar novos campos": "Añadir nuevos campos",
  "Adicionar opção": "Añadir opción",
  "Adicionar pagamento": "Añadir pago",
  "Adicionar pitch": "Añadir oferta",
  "Adicionar Plays ao Plano": "Añadir reproducciones al plan",
  "Adicionar primeiro domínio": "Añadir primer dominio",
  "Adicionar Primeiro Membro": "Añadir primer miembro",
  "Adicionar Primeiro Vídeo": "Añadir primer video",
  "Adicionar Regra UTM": "Añadir regla UTM",
  "Adicionar texto personalizado": "Añadir texto personalizado",
  "Adicionar um botão abaixo do vídeo da playlist para enviar o usuário a um link externo.": "Añadir un botón debajo del video de la lista de reproducción para enviar al usuario a un enlace externo.",
  "Adicionar vídeo": "Añadir video",
  "Adicione as introduções que você deseja testar com o vídeo principal. Você pode adicionar quantas introduções desejar.": "Añade las introducciones que quieras probar con el video principal. Puedes añadir tantas introducciones como quieras.",
  "Adicione até": "Añade hasta",
  "Adicione aulas a este módulo no painel de edição": "Añade lecciones a este módulo en el panel de edición",
  "Adicione Botões": "Añade botones",
  "Adicione código HTML para visualizar": "Añade código HTML para ver la vista previa",
  "Adicione e organize os vídeos da sua playlist": "Añade y organiza los videos de tu lista de reproducción",
  "Adicione elementos de \"open loops\" para manter curiosidade": "Añade elementos de curiosidad pendiente para mantener el interés",
  "Adicione elementos de escassez": "Añade elementos de escasez",
  "Adicione elementos de urgência ou escassez antes do botão": "Añade elementos de urgencia o escasez antes del botón",
  "Adicione elementos gráficos ou pausas dramáticas nos momentos pré-CTA para aumentar conversões.": "Añade elementos gráficos o pausas dramáticas antes del CTA para aumentar las conversiones.",
  "Adicione elementos visuais": "Añade elementos visuales",
  "Adicione este cupom no checkout do plano que você gostar.": "Introduce este cupón en la página de pago del plan que prefieras.",
  "Adicione headlines persuasivas ao player.": "Añade titulares persuasivos al reproductor.",
  "Adicione imagens específicas para desktop e mobile": "Añade imágenes específicas para escritorio y móvil",
  "Adicione introduções ao seu teste para visualizar métricas.": "Añade introducciones a tu prueba para ver las métricas.",
  "Adicione legendas .VTT ou .SRT ao seu vídeo.": "Añade subtítulos .VTT o .SRT a tu video.",
  "Adicione legendas sincronizadas ao seu vídeo. Suporta .SRT e .VTT.": "Añade subtítulos sincronizados a tu video. Admite .SRT y .VTT.",
  "Adicione links de termos, privacidade, etc.": "Añade enlaces a los términos, la política de privacidad, etc.",
  "Adicione observações internas sobre este pagamento.": "Añade notas internas sobre este pago.",
  "Adicione observações sobre esta regra...": "Añade notas sobre esta regla...",
  "Adicione padrões de interrupção": "Añade cambios de patrón",
  "Adicione sua logo marca no vídeo": "Añade el logotipo de tu marca al video",
  "Adicione títulos chamativos com upload de imagem e A/B test integrado": "Añade títulos llamativos con subida de imágenes y prueba A/B integrada",
  "Adicione um botão de compra ou call-to-action": "Añade un botón de compra o de llamada a la acción",
  "Adicione um botão secundário, como WhatsApp": "Añade un botón secundario, como WhatsApp",
  "Adicione um pixel para começar a rastrear conversões nos seus vídeos.": "Añade un píxel para empezar a seguir las conversiones de tus videos.",
  "Adicione uma borda animada e personalizada": "Añade un borde animado y personalizado",
  "Adicione uma borda colorida em volta do thumbnail para destacar": "Añade un borde de color alrededor de la miniatura para destacarla",
  "Adicione uma conta para receber seus saques.": "Añade una cuenta para recibir tus retiradas.",
  "Adicione uma descrição para ajudar a lembrar do objetivo deste teste...": "Añade una descripción que te ayude a recordar el objetivo de esta prueba...",
  "Adicione uma mensagem extra no rodapé (opcional)": "Añade un mensaje extra en el pie de página (opcional)",
  "Adicione uma saída de checkout no editor para conectar o rastreamento.": "Añade una salida a la página de pago en el editor para conectar el seguimiento.",
  "Adicione vídeos a esta pasta para começar a organizar seu conteúdo.": "Añade videos a esta carpeta para empezar a organizar tu contenido.",
  "Adicione vídeos antes e depois do conteúdo principal para aquecer, conduzir e converter espectadores.": "Añade videos antes y después del contenido principal para preparar, guiar y convertir a los espectadores.",
  "Adicione vídeos da sua biblioteca para criar a sequência da playlist.": "Añade videos de tu biblioteca para crear la secuencia de la lista de reproducción.",
  "Adicione vídeos para começar a criar sua playlist": "Añade videos para empezar a crear tu lista de reproducción",
  "Adicione vídeos para usar este recurso.": "Añade videos para utilizar esta función.",
  "Adicione vídeos primeiro": "Añade videos primero",
  "Adicione VITE_GOOGLE_CLIENT_ID e VITE_GOOGLE_DEVELOPER_KEY no .env e reinicie o servidor.": "Añade VITE_GOOGLE_CLIENT_ID y VITE_GOOGLE_DEVELOPER_KEY al archivo .env y reinicia el servidor.",
  "Ag:": "Sucursal:",
  "Agência/Conta": "Sucursal/cuenta",
  "Agências de Marketing": "Agencias de marketing",
  "Agendado": "Programado",
  "Agendamento": "Programación",
  "Agendamento de recarga cancelado.": "Programación de recarga cancelada.",
  "Agendando...": "Programando...",
  "Agendar Oferta": "Programar oferta",
  "Agende ofertas e eventos nesses períodos para maximizar resultados.": "Programa ofertas y eventos en estos períodos para maximizar los resultados.",
  "Agora a HostVSL também fala com o Google Ads. Você cadastra o ID de conversão da sua conta (AW-) e o rótulo de cada ação que quer medir — o play do vídeo, o momento em que a oferta aparece e o clique no botão de compra. A partir daí, você enxerga dentro do próprio Google Ads quais campanhas levam as pessoas a assistir e a clicar na sua oferta.": "Ahora HostVSL también se conecta con Google Ads. Registra el ID de conversión de tu cuenta (AW-) y la etiqueta de cada acción que quieras medir: la reproducción del video, el momento en que aparece la oferta y el clic en el botón de compra. A partir de ahí, podrás ver en Google Ads qué campañas llevan a las personas a ver y hacer clic en tu oferta.",
  "Agora adicione vídeos à sua playlist.": "Ahora añade videos a tu lista de reproducción.",
  "Agora escolha o fim do intervalo": "Ahora elige el final del intervalo",
  "Agora você pode compartilhar seus vídeos diretamente com membros da sua equipe ou afiliados. Ideal para co-produtores que precisam distribuir conteúdo sem perder o controle.": "Ahora puedes compartir tus videos directamente con miembros de tu equipo o afiliados. Ideal para coproductores que necesitan distribuir contenido sin perder el control.",
  "Agora você pode exibir avisos de compra por cima da sua VSL, no estilo prova social ao vivo. Você escreve o texto do aviso com nome, cidade e produto, escolhe a plataforma de venda que aparece ao lado e deixa as notificações rodando enquanto o vídeo toca. Dá pra segurar os avisos nos primeiros minutos e só então começar o rodízio, ajustando o intervalo entre eles e quanto tempo cada um fica na tela. E, se quiser, a notificação vira um link clicável que abre a sua oferta em uma nova aba.": "Ahora puedes mostrar avisos de compra sobre tu VSL, como prueba social en directo. Escribe el texto del aviso con nombre, ciudad y producto, elige la plataforma de ventas que aparecerá al lado y deja que las notificaciones se alternen mientras se reproduce el video. Puedes retrasar los avisos durante los primeros minutos y ajustar su intervalo y duración. Si quieres, la notificación puede ser un enlace que abra tu oferta en una nueva pestaña.",
  "Agora você pode importar vídeos diretamente da sua conta do Google Drive, sem precisar baixar primeiro pro computador. No modal de envio, escolha \"Google Drive\" como origem, conecte sua conta com segurança e selecione os vídeos que quiser mandar pra plataforma.": "Ahora puedes importar videos directamente desde tu cuenta de Google Drive, sin descargarlos primero al ordenador. En el diálogo de envío, elige \"Google Drive\" como origen, conecta tu cuenta de forma segura y selecciona los videos que quieras enviar a la plataforma.",
  "Agora você pode personalizar seu vídeo com as opções do editor": "Ahora puedes personalizar tu video con las opciones del editor",
  "agregado": "agregado",
  "Aguardando 1ª venda": "Esperando la primera venta",
  "Aguardando 1º disparo": "Esperando el primer envío",
  "Aguardando dados de visualização para determinar o desempenho dos vídeos.": "Esperando datos de visualización para determinar el rendimiento de los videos.",
  "Aguardando dados de visualização para gerar análise de performance.": "Esperando datos de visualización para generar el análisis de rendimiento.",
  "Aguardando dados de visualização para gerar o gráfico de retenção.": "Esperando datos de visualización para generar el gráfico de retención.",
  "Aguardando pagamento.": "Esperando el pago.",
  "Aguardando primeiro evento": "Esperando el primer evento",
  "Aguardando seleção": "Esperando selección",
  "Aguardando seleção...": "Esperando selección...",
  "Aguardando visualizações": "Esperando visualizaciones",
  "Aguardar clique do espectador": "Esperar el clic del espectador",
  "Aguarde enquanto buscamos os dados do teste": "Espera mientras buscamos los datos de la prueba",
  "Aguarde enquanto buscamos seus vídeos": "Espera mientras buscamos tus videos",
  "Aguarde enquanto preparamos seu vídeo": "Espera mientras preparamos tu video",
  "Aguarde os envios atuais terminarem ou cancele alguns para enviar novos vídeos.": "Espera a que finalicen los envíos actuales o cancela algunos para enviar nuevos videos.",
  "Aguarde os envios atuais terminarem ou cancele alguns.": "Espera a que finalicen los envíos actuales o cancela algunos.",
  "Aguarde pelo menos 300 visualizações por intro para dados confiáveis": "Espera al menos 300 visualizaciones por introducción para obtener datos fiables",
  "Aguarde um momento": "Espera un momento",
  "Ainda não há dados de retenção": "Todavía no hay datos de retención",
  "Ainda não há dados de retenção para as variações deste teste. Assim que forem coletados, a curva comparativa aparecerá aqui.": "Todavía no hay datos de retención para las variaciones de esta prueba. Cuando se recopilen, aparecerá aquí la curva comparativa.",
  "Ainda não há plays deste vídeo no período.": "Todavía no hay reproducciones de este video en el período.",
  "Ainda não há visitas neste período. As métricas aparecem quando o fluxo publicado recebe visitas.": "Todavía no hay visitas en este período. Las métricas aparecen cuando el flujo publicado recibe visitas.",
  "Ainda não identificamos sites ou páginas enviando tráfego para este vídeo. Quando houver acessos externos, as referências aparecerão aqui.": "Todavía no hemos identificado sitios o páginas que envíen tráfico a este video. Cuando haya accesos externos, las referencias aparecerán aquí.",
  "Ainda não temos dados de conversão suficientes neste período.": "Todavía no tenemos suficientes datos de conversión en este período.",
  "Ainda não temos dados suficientes para gerar métricas avançadas.": "Todavía no tenemos suficientes datos para generar métricas avanzadas.",
  "Ainda sem dados aqui": "Todavía sin datos aquí",
  "Ajuda sobre autoplay": "Ayuda sobre la reproducción automática",
  "Ajuda: {value0}": "Ayuda: {value0}",
  "Ajustar automaticamente o último valor para fechar 100%": "Ajustar automáticamente el último valor para completar el 100 %",
  "Ajustar valor": "Ajustar valor",
  "Ajuste a configuração para gerar horários": "Ajusta la configuración para generar horarios",
  "Ajuste a copy de abertura (gancho, avatar ou história)": "Ajusta el texto de apertura (gancho, avatar o historia)",
  "Ajuste a distribuição para 100% para continuar.": "Ajusta la distribución al 100 % para continuar.",
  "Ajuste a visibilidade dos controles do player.": "Ajusta la visibilidad de los controles del reproductor.",
  "Ajuste o período e tente novamente.": "Ajusta el período e inténtalo de nuevo.",
  "Ajuste os filtros ou cadastre uma despesa manual.": "Ajusta los filtros o registra un gasto manual.",
  "Ajuste os percentuais de tráfego para cada vídeo": "Ajusta los porcentajes de tráfico de cada video",
  "Alertas quando seus vídeos tiverem picos de engajamento": "Alertas cuando tus videos tengan picos de interacción",
  "Algo deu errado. Recuperando...": "Algo ha salido mal. Recuperando...",
  "Alguns arquivos não são vídeos e foram ignorados.": "Se han omitido algunos archivos que no son videos.",
  "Alinhamento do Logo": "Alineación del logotipo",
  "Alinhar à direita": "Alinear a la derecha",
  "Alinhar à esquerda": "Alinear a la izquierda",
  "Alta Reprodução + Alto Engajamento = Copy matadora": "Muchas reproducciones + alta interacción = texto persuasivo eficaz",
  "Alta Taxa de Reprodução + Engajamento": "Alta tasa de reproducción e interacción",
  "Alterações futuras no vídeo": "Cambios futuros en el video",
  "Alterações não publicadas": "Cambios sin publicar",
  "Alterações pendentes": "Cambios pendientes",
  "Alterações salvas": "Cambios guardados",
  "Alterar número": "Cambiar número",
  "Alterar plano": "Cambiar plan",
  "Altere a data e horário de encerramento automático do teste.": "Cambia la fecha y la hora de finalización automática de la prueba.",
  "Altere a quantidade de clicks de incremento para este usuário.": "Cambia la cantidad de clics que se añadirán a este usuario.",
  "Altere seu plano atual": "Cambia tu plan actual",
  "Alternar modo teatro": "Alternar modo cine",
  "Alternativo:": "Alternativo:",
  "Alto engajamento": "Alta interacción",
  "Alto volume": "Gran volumen",
  "Altura visual da barra durante a reprodução": "Altura visual de la barra durante la reproducción",
  "America/New York": "America/New York",
  "America/São Paulo": "America/São Paulo",
  "amostra baixa": "muestra pequeña",
  "Análise competitiva": "Análisis competitivo",
  "Analise conversões": "Analiza las conversiones",
  "Análise de comportamento de usuários com mapas de calor e gravações de sessões.": "Análisis del comportamiento de los usuarios con mapas de calor y grabaciones de sesiones.",
  "Análise de Desempenho": "Análisis de rendimiento",
  "Análise de Locais": "Análisis de ubicaciones",
  "Analise de onde vem sua audiência e como ela se comporta": "Analiza de dónde viene tu audiencia y cómo se comporta",
  "Análise Detalhada": "Análisis detallado",
  "Análise detalhada do desempenho desta introdução": "Análisis detallado del rendimiento de esta introducción",
  "Análise Inteligente": "Análisis inteligente",
  "Analise os elementos que estão gerando mais engajamento": "Analiza los elementos que generan más interacción",
  "Analise os pontos de queda": "Analiza los puntos de abandono",
  "Analise retenção, plays, conversão e desempenho em uma visão comparativa completa com dados reais": "Analiza la retención, las reproducciones, la conversión y el rendimiento en una vista comparativa completa con datos reales",
  "Análises inteligentes baseadas nos seus dados": "Análisis inteligentes basados en tus datos",
  "Anima o botão em um pulso contínuo para chamar atenção": "Anima el botón con una pulsación continua para llamar la atención",
  "Animação": "Animación",
  "Animação e Timing": "Animación y tiempos",
  "ANO": "AÑO",
  "Anônimo": "Anónimo",
  "Antes de copiar para sua conta, confirme os termos de uso.": "Antes de copiarlo a tu cuenta, confirma los términos de uso.",
  "Antes do principal": "Antes del principal",
  "Antes e depois": "Antes y después",
  "Anti-Plágio": "Antiplagio",
  "Ao adicionar o connector da HostVSL, cole a chave no campo de header": "Al añadir el conector de HostVSL, pega la clave en el campo de cabecera",
  "Ao ativar a sua conta, ganhará acesso imediato ao seu painel administrativo para obter o seu link e começar a indicar.": "Al activar tu cuenta, tendrás acceso inmediato a tu panel de administración para obtener tu enlace y empezar a recomendar.",
  "Ao ativar, a headline será exibida diretamente sobre o vídeo conforme suas configurações.": "Al activarlo, el titular aparecerá directamente sobre el video según tu configuración.",
  "Ao cancelar sua assinatura:": "Al cancelar tu suscripción:",
  "Ao confirmar, sua assinatura será cancelada imediatamente e o acesso será encerrado.": "Al confirmar, tu suscripción se cancelará inmediatamente y perderás el acceso.",
  "Ao continuar, você concorda com os": "Al continuar, aceptas los",
  "Ao editar, o último vídeo será compensado automaticamente": "Al editar, el último video se compensará automáticamente",
  "Ao me inscrever, concordo em receber comunicações e aceito a política de privacidade.": "Al registrarme, acepto recibir comunicaciones y la política de privacidad.",
  "Ao pausar o vídeo": "Al pausar el video",
  "ao seu vídeo. O espectador poderá ativar ou desativar a legenda pelo botão": "a tu video. El espectador podrá activar o desactivar los subtítulos con el botón",
  "Ao terminar o vídeo, mostre uma contagem regressiva e leve o espectador ao checkout": "Al terminar el video, muestra una cuenta atrás y dirige al espectador a la página de pago",
  "Ao vivo — {count} pessoas assistindo agora": "En directo: {count} personas viendo ahora",
  "Aparece na sidebar do player público": "Aparece en la barra lateral del reproductor público",
  "Aparece no header e sidebar do player público": "Aparece en la cabecera y la barra lateral del reproductor público",
  "Aparência do link de recusa exibido abaixo do botão.": "Aspecto del enlace para rechazar mostrado debajo del botón.",
  "Aparência dos Cards": "Aspecto de las tarjetas",
  "Apenas 3 passos simples para começar a ganhar": "Solo 3 sencillos pasos para empezar a ganar",
  "Apenas em um trecho específico": "Solo en un fragmento concreto",
  "Aplica uma sombra sob o botão para destacá-lo do fundo": "Aplica una sombra bajo el botón para destacarlo del fondo",
  "Aplicação": "Aplicación",
  "Aplicação & Metadados": "Aplicación y metadatos",
  "Aplicado": "Aplicado",
  "Aplicar como padrão": "Aplicar como predeterminado",
  "Aplicar desfoque na imagem de fundo (blur 8px)": "Aplicar desenfoque a la imagen de fondo (8 px)",
  "Aplicar em {value0} {value1}": "Aplicar a {value0} {value1}",
  "Aplicar leve desfoque": "Aplicar desenfoque suave",
  "Aplicar Template": "Aplicar plantilla",
  "Aplique as estratégias vencedoras nos outros vídeos": "Aplica las estrategias ganadoras a los demás videos",
  "Aplique configurações padrão em vários vídeos de uma só vez para acelerar seu fluxo.": "Aplica una configuración predeterminada a varios videos a la vez para agilizar tu trabajo.",
  "Após 15 dias": "Después de 15 días",
  "Após a ativação, terá acesso instantâneo a um link parametrizado exclusivo para divulgar nas suas redes ou site.": "Tras la activación, tendrás acceso inmediato a un enlace exclusivo con parámetros para compartirlo en tus redes o sitio web.",
  "Após identificar um vencedor, crie um novo teste usando aquele como controle vs novas variações.": "Tras identificar un ganador, crea una nueva prueba usándolo como control frente a nuevas variaciones.",
  "Após o envio": "Después del envío",
  "Após o vídeo de entrada": "Después del video de entrada",
  "App instalado com sucesso!": "¡Aplicación instalada correctamente!",
  "App já instalado!": "¡Aplicación ya instalada!",
  "Aprenda as melhores estratégias de marketing digital": "Aprende las mejores estrategias de marketing digital",
  "Aprimoradores de Conversão": "Mejoras de conversión",
  "Aprofunde no storytelling": "Profundiza en la narración",
  "Aqui você define as introduções.": "Aquí defines las introducciones.",
  "Área de membros não encontrada": "Área de miembros no encontrada",
  "Área de upload de vídeo. Pressione Enter para selecionar um arquivo": "Área de subida de videos. Pulsa Intro para seleccionar un archivo",
  "Área segura": "Área segura",
  "Argentina": "Argentina",
  "Armazenamento cheio. Reduza o tamanho das imagens (logo, favicon, thumbnails) ou remova playlists antigas.": "Almacenamiento lleno. Reduce el tamaño de las imágenes (logotipo, favicon y miniaturas) o elimina listas de reproducción antiguas.",
  "Armazenamento:": "Almacenamiento:",
  "Arquitetura de gerenciamento de estado da HostVSL": "Arquitectura de gestión del estado de HostVSL",
  "Arquivado": "Archivado",
  "Arquivo excede o limite de {value0}MB": "El archivo supera el límite de {value0} MB",
  "Arquivo exportado com sucesso": "Archivo exportado correctamente",
  "Arquivo grande demais": "Archivo demasiado grande",
  "Arquivo muito grande. Tamanho máximo: 5GB.": "Archivo demasiado grande. Tamaño máximo: 5 GB.",
  "Arrastando...": "Arrastrando...",
  "Arraste arquivos aqui ou clique": "Arrastra archivos aquí o haz clic",
  "Arraste e solte o vídeo aqui": "Arrastra y suelta el video aquí",
  "Arraste e solte ou escolha arquivos do seu computador.": "Arrastra y suelta o elige archivos de tu ordenador.",
  "Arraste e solte seu vídeo aqui": "Arrastra y suelta tu video aquí",
  "Arraste e solte vídeos para carregar": "Arrastra y suelta videos para subirlos",
  "Arraste o vídeo aqui ou clique no botão abaixo para selecionar": "Arrastra el video aquí o haz clic en el botón de abajo para seleccionarlo",
  "Arraste os sliders ou digite valores. A soma sempre será ajustada para 100%.": "Arrastra los controles deslizantes o introduce valores. La suma siempre se ajustará al 100 %.",
  "Arraste para reordenar, configure obrigatoriedade e placeholders": "Arrastra para reordenar y configura los campos obligatorios y los textos de ejemplo",
  "Arraste seu vídeo aqui ou clique no botão abaixo para selecionar": "Arrastra tu video aquí o haz clic en el botón de abajo para seleccionarlo",
  "Arraste um vídeo da lista para cá ou use": "Arrastra un video de la lista aquí o usa",
  "Arraste um vídeo para o quadro para criar uma etapa com ele.": "Arrastra un video al panel para crear una etapa con él.",
  "Arraste vídeos da biblioteca para organizá-los aqui.": "Arrastra videos de la biblioteca para organizarlos aquí.",
  "Arredondado (16px)": "Redondeado (16 px)",
  "As alterações não foram salvas.": "Los cambios no se han guardado.",
  "As alterações não salvas serão perdidas.": "Los cambios sin guardar se perderán.",
  "As configurações ainda não foram salvas. Clique no botão \"Aplicar\" no canto superior direito para iniciar o teste.": "La configuración todavía no se ha guardado. Haz clic en \"Aplicar\" en la esquina superior derecha para iniciar la prueba.",
  "As configurações da logo foram salvas com sucesso": "La configuración del logotipo se ha guardado correctamente",
  "As configurações da thumbnail de pausa foram salvas com sucesso": "La configuración de la miniatura de pausa se ha guardado correctamente",
  "As configurações de legenda foram aplicadas com sucesso.": "La configuración de subtítulos se ha aplicado correctamente.",
  "As configurações do botão de ação foram salvas com sucesso": "La configuración del botón de acción se ha guardado correctamente",
  "As configurações foram salvas com sucesso": "La configuración se ha guardado correctamente",
  "As configurações são salvas individualmente por dispositivo.": "La configuración se guarda individualmente por dispositivo.",
  "As cores indicam horários com": "Los colores indican horarios con",
  "As cores mais intensas indicam horários com maior": "Los colores más intensos indican horarios con mayor",
  "As cores mais intensas indicam horários com maior volume de": "Los colores más intensos indican horarios con mayor volumen de",
  "As cores mais intensas indicam horários com maior volume de plays.": "Los colores más intensos indican horarios con más reproducciones.",
  "as demais estão na tabela abaixo": "las demás están en la tabla de abajo",
  "As imagens foram enviadas e salvas com sucesso": "Las imágenes se han enviado y guardado correctamente",
  "As informações aparecerão quando houver cópias do vídeo": "La información aparecerá cuando se hagan copias del video",
  "As métricas aparecerão quando houver visualizações nos vídeos do teste": "Las métricas aparecerán cuando haya visualizaciones de los videos de la prueba",
  "As métricas começam quando o fluxo é publicado.": "Las métricas empiezan cuando se publica el flujo.",
  "As métricas da Jornada aparecem aqui assim que os espectadores começarem a assistir aos vídeos de entrada e saída.": "Las métricas del recorrido aparecen aquí cuando los espectadores empiezan a ver los videos de entrada y salida.",
  "As mudanças já estão visíveis na URL pública.": "Los cambios ya son visibles en la URL pública.",
  "As opções que levam a ela ficam sem destino. O vídeo continua na lista do fluxo.": "Las opciones que llevan a ella se quedan sin destino. El video permanece en la lista del flujo.",
  "As personalizações serão aplicadas ao abrir o vídeo.": "Las personalizaciones se aplicarán al abrir el video.",
  "As senhas não coincidem": "Las contraseñas no coinciden",
  "As solicitações de saque dos afiliados aparecerão aqui.": "Las solicitudes de retirada de los afiliados aparecerán aquí.",
  "Asia/Tokyo": "Asia/Tokyo",
  "Assim que alguém der play numa VSL (com som), o ponto aparece aqui no mapa.": "Cuando alguien reproduzca una VSL (con sonido), el punto aparecerá aquí en el mapa.",
  "Assim que o teste começar a receber visualizações, você verá a comparação de retenção entre as introduções aqui.": "Cuando la prueba empiece a recibir visualizaciones, verás aquí la comparación de retención de las introducciones.",
  "Assim que suas visualizações começarem, mostraremos os dispositivos e origens.": "Cuando empiecen tus visualizaciones, mostraremos los dispositivos y los orígenes.",
  "Assim que um evento for detectado, ele aparece aqui.": "Cuando se detecte un evento, aparecerá aquí.",
  "Assinatura": "Suscripción",
  "Assinatura atualizada com sucesso.": "Suscripción actualizada correctamente.",
  "Assinatura cancelada com sucesso": "Suscripción cancelada correctamente",
  "Assinatura criada com sucesso": "Suscripción creada correctamente",
  "Assistido": "Visto",
  "Assistido em média": "Visto de media",
  "assistindo agora": "viendo ahora",
  "Assistir na Smart TV": "Ver en Smart TV",
  "Assistir Novamente": "Ver de nuevo",
  "Assistir tutorial": "Ver tutorial",
  "At least one thumbnail URL is required": "Se requiere al menos una URL de miniatura",
  "Atalhos": "Atajos",
  "Até 23:59": "Hasta las 23:59",
  "Atenção antes de criar o teste": "Atención antes de crear la prueba",
  "Atendimento": "Atención al cliente",
  "Ativa o som ao detectar ação do visitante (clique, scroll ou toque)": "Activa el sonido al detectar una acción del visitante (clic, desplazamiento o toque)",
  "Ativa tanto as áreas de linguagem quanto as de processamento sensorial": "Activa tanto las áreas del lenguaje como las del procesamiento sensorial",
  "Ativada": "Activada",
  "Ativadas": "Activadas",
  "Ativar acesso grátis": "Activar acceso gratis",
  "ATIVAR AUTOPLAY": "ACTIVAR REPRODUCCIÓN AUTOMÁTICA",
  "Ativar botão de ação": "Activar botón de acción",
  "Ativar com teste grátis": "Activar con prueba gratis",
  "Ativar compartilhamento": "Activar enlace compartido",
  "Ativar Exibição por Dispositivo": "Activar visualización por dispositivo",
  "Ativar horários de silêncio": "Activar horario de silencio",
  "Ativar Minha Conta de Afiliado": "Activar mi cuenta de afiliado",
  "Ativar Notificações Push": "Activar notificaciones push",
  "Ativar Perfil Gratuitamente": "Activar perfil gratis",
  "Ativar segundo botão": "Activar segundo botón",
  "Ativar som": "Activar sonido",
  "Ativar Spark Points": "Activar Spark Points",
  "Ativar temporizador": "Activar temporizador",
  "Ative a estratégia para copiar o código": "Activa la estrategia para copiar el código",
  "Ative a exibição por dispositivo para personalizar Desktop, Tablet e Mobile.": "Activa la visualización por dispositivo para personalizar escritorio, tableta y móvil.",
  "Ative a recarga para nunca ficar sem plays": "Activa la recarga para no quedarte sin reproducciones",
  "Ative a sua conta gratuitamente, partilhe o seu link exclusivo e construa uma nova fonte de rendimento acompanhando tudo em tempo real através de um painel analítico completo.": "Activa tu cuenta gratis, comparte tu enlace exclusivo y crea una nueva fuente de ingresos con seguimiento en tiempo real desde un panel analítico completo.",
  "Ative as notificações para receber alertas em tempo real sobre conversões, métricas e atualizações importantes.": "Activa las notificaciones para recibir alertas en tiempo real sobre conversiones, métricas y actualizaciones importantes.",
  "Ative as notificações primeiro para enviar testes.": "Activa primero las notificaciones para enviar pruebas.",
  "Ative comportamentos extras do Autoplay": "Activa comportamientos adicionales de la reproducción automática",
  "Ative comportamentos extras do botão": "Activa comportamientos adicionales del botón",
  "Ative o bloco de saída para visualizar suas métricas aqui.": "Activa el bloque de salida para ver sus métricas aquí.",
  "Ative o botão de ação na aba Configuração para configurar a exibição": "Activa el botón de acción en la pestaña Configuración para configurar su aparición",
  "Ative o botão de ação na aba Configuração para personalizar o estilo": "Activa el botón de acción en la pestaña Configuración para personalizar su estilo",
  "Ative o botão para ver o preview": "Activa el botón para ver la vista previa",
  "Ative o formulário VSLeads para capturar emails e informações dos seus visitantes.": "Activa el formulario de VSLeads para captar correos electrónicos y datos de tus visitantes.",
  "Ative o recurso acima para pausar o vídeo quando o visitante sair da aba do navegador.": "Activa la función de arriba para pausar el video cuando el visitante salga de la pestaña del navegador.",
  "Ative o recurso de headline para visualizar as métricas": "Activa la función de titulares para ver las métricas",
  "Ative o recurso para ver o preview": "Activa la función para ver la vista previa",
  "Ative o Smart Autoplay na aba \"Configuração\" para personalizar o estilo visual.": "Activa la reproducción automática inteligente en la pestaña \"Configuración\" para personalizar el estilo visual.",
  "Ative o Smart Autoplay para personalizar o estilo visual.": "Activa la reproducción automática inteligente para personalizar el estilo visual.",
  "Ative ou desative os campos que deseja coletar no formulário": "Activa o desactiva los campos que quieras recopilar en el formulario",
  "Ative para exibir a barra de progresso no vídeo.": "Actívalo para mostrar la barra de progreso en el video.",
  "Ative para exibir o formulário de captura de dados neste vídeo no momento configurado. Quando ativo, o formulário será exibido automaticamente.": "Actívalo para mostrar el formulario de captura de datos en este video en el momento configurado. El formulario aparecerá automáticamente.",
  "Atividade Recente": "Actividad reciente",
  "ATIVO": "ACTIVO",
  "Atraia atenção com um título impactante": "Capta la atención con un título impactante",
  "Atribuição por Último Clique": "Atribución al último clic",
  "Atualização de Pagamento": "Actualización de pago",
  "Atualização do Pagamento": "Actualización del pago",
  "Atualização do sistema": "Actualización del sistema",
  "Atualização em tempo real dos resultados do teste": "Actualización en tiempo real de los resultados de la prueba",
  "atualizações registradas": "actualizaciones registradas",
  "Atualizado": "Actualizado",
  "Atualizado em": "Actualizado el",
  "Atualizar Clicks": "Actualizar clics",
  "Atualizar Documentação": "Actualizar documentación",
  "Atualizar Pagamento": "Actualizar pago",
  "Atualizar Permissões": "Actualizar permisos",
  "Atualize as informações do cartão.": "Actualiza los datos de la tarjeta.",
  "Audiência Predominantemente Mobile": "Audiencia principalmente móvil",
  "Auditoria": "Auditoría",
  "Auditoria Anti-Fraude": "Auditoría antifraude",
  "Auditoria de Membros": "Auditoría de miembros",
  "Aula Concluída": "Lección completada",
  "aula disponível": "lección disponible",
  "Aula Gratuita - Marketing": "Lección gratuita - Marketing",
  "Aula não encontrada": "Lección no encontrada",
  "Aulas": "Lecciones",
  "aulas concluídas": "lecciones completadas",
  "aulas disponíveis": "lecciones disponibles",
  "Aulas do Curso": "Lecciones del curso",
  "Aulas exclusivas para aumente suas conversões imediatamente.": "Lecciones exclusivas para aumentar tus conversiones de inmediato.",
  "Aumentar valor": "Aumentar valor",
  "Aumento de 35% na retenção da VSL": "Aumento del 35 % en la retención de la VSL",
  "Autenticado com sucesso!": "¡Autenticación correcta!",
  "Auto": "Automático",
  "Auto usa o formato do vídeo da etapa inicial.": "Automático utiliza el formato del video de la etapa inicial.",
  "Auto-ajustado": "Ajustado automáticamente",
  "Auto-balancear": "Equilibrar automáticamente",
  "Auto-fechar ao enviar": "Cerrar automáticamente al enviar",
  "Auto-gerado": "Generado automáticamente",
  "Auto-indicação ou práticas abusivas de SPAM resultarão no cancelamento imediato das comissões e da conta.": "Las autorreferencias o las prácticas abusivas de spam provocarán la cancelación inmediata de las comisiones y de la cuenta.",
  "Auto-play Próxima Aula": "Reproducir automáticamente la siguiente lección",
  "Automação de emails e fluxos de trabalho para marketing e vendas.": "Automatización de correos electrónicos y flujos de trabajo para marketing y ventas.",
  "Automático": "Automático",
  "Automatize tarefas integrando mais de 5.000 aplicativos diferentes.": "Automatiza tareas integrando más de 5.000 aplicaciones distintas.",
  "Autoplay ativado": "Reproducción automática activada",
  "Autoplay e controles não podem estar ativos ao mesmo tempo.": "La reproducción automática y los controles no pueden estar activos al mismo tiempo.",
  "Autoplay e Teste A/B": "Reproducción automática y prueba A/B",
  "Avançar": "Avanzar",
  "Avançar 10 segundos": "Avanzar 10 segundos",
  "Avisos": "Avisos",
  "AWS": "AWS",
  "Badge \"Sessão atualizada hoje\"": "Insignia \"Sesión actualizada hoy\"",
  "Badge personalizado": "Insignia personalizada",
  "Badges de urgência": "Insignias de urgencia",
  "Baixando {value0} vídeo{value1}...": "Descargando {value0} video{value1}...",
  "Baixando seus vídeos do Google Drive...": "Descargando tus videos de Google Drive...",
  "Baixar": "Descargar",
  "Baixar comprovante": "Descargar justificante",
  "Baixar fatura": "Descargar factura",
  "Baixar QR Code": "Descargar código QR",
  "Banco": "Banco",
  "Bancos Vinculados": "Bancos vinculados",
  "Banner": "Banner",
  "Base (opcional)": "Base (opcional)",
  "Base: últimos 7 dias": "Base: últimos 7 días",
  "Bem-vindo ao HostVSL": "Bienvenido a HostVSL",
  "Bem-vindo de volta,": "Bienvenido de nuevo,",
  "Benefícios do Programa": "Ventajas del programa",
  "Biblioteca": "Biblioteca",
  "Bloco de oferta": "Bloque de oferta",
  "blog.exemplo.com": "blog.ejemplo.com",
  "Bloq.": "Bloq.",
  "Bloqueadas": "Bloqueadas",
  "Bloquear acesso": "Bloquear acceso",
  "Bloquear fechamento (segundos)": "Bloquear cierre (segundos)",
  "Bloquear fechar até enviar": "Bloquear cierre hasta enviar",
  "Bloquear número": "Bloquear número",
  "Bloquear por Domínio": "Bloquear por dominio",
  "Bloquear Proxy/VPN": "Bloquear proxy/VPN",
  "Bloquear visualização": "Bloquear visualización",
  "Bloqueia acessos suspeitos usando proxy, VPN ou mascaramento de localização.": "Bloquea los accesos sospechosos que utilizan proxy, VPN o enmascaramiento de ubicación.",
  "Bloqueie a exibição dos vídeos fora do seu site.": "Bloquea la visualización de videos fuera de tu sitio.",
  "Bloqueios detectados": "Bloqueos detectados",
  "Boa Performance": "Buen rendimiento",
  "Bônus (até 6)": "Bonificaciones (hasta 6)",
  "Borda branca": "Borde blanco",
  "Bordas arredondadas": "Bordes redondeados",
  "Bordas Arredondadas:": "Bordes redondeados:",
  "Border Radius": "Radio del borde",
  "Botão \"Pular\"": "Botón \"Omitir\"",
  "Botão ativo": "Botón activo",
  "Botão de ação": "Botón de acción",
  "Botão de Ação (CTA)": "Botón de acción (CTA)",
  "Botão de ação atualizado": "Botón de acción actualizado",
  "Botão de pular": "Botón de omisión",
  "Botão de Thumb": "Botón de miniatura",
  "Botão não visível neste momento": "Botón no visible en este momento",
  "Botão para transmitir o vídeo": "Botón para transmitir el video",
  "Botão Principal": "Botón principal",
  "Botão Principal (CTA)": "Botón principal (CTA)",
  "Botão WhatsApp": "Botón de WhatsApp",
  "Botões das opções": "Botones de las opciones",
  "Branco": "Blanco",
  "breadcrumb": "ruta de navegación",
  "Breadcrumb": "Ruta de navegación",
  "BRL + Taxas estimadas": "BRL + comisiones estimadas",
  "Buscar aula...": "Buscar lección...",
  "Buscar comentário": "Buscar comentario",
  "Buscar domínio...": "Buscar dominio...",
  "Buscar e selecionar idiomas": "Buscar y seleccionar idiomas",
  "Buscar e selecionar países": "Buscar y seleccionar países",
  "Buscar e selecionar regiões": "Buscar y seleccionar regiones",
  "Buscar e-mail...": "Buscar correo electrónico...",
  "Buscar em {value0}": "Buscar en {value0}",
  "Buscar fluxo": "Buscar flujo",
  "Buscar fluxo pelo nome": "Buscar flujo por nombre",
  "Buscar intro...": "Buscar introducción...",
  "Buscar origem...": "Buscar origen...",
  "Buscar por e-mail": "Buscar por correo electrónico",
  "Buscar por E-mail": "Buscar por correo electrónico",
  "Buscar por email...": "Buscar por correo electrónico...",
  "Buscar por nome ou email...": "Buscar por nombre o correo electrónico...",
  "Buscar por título, pasta ou tag...": "Buscar por título, carpeta o etiqueta...",
  "Buscar recurso...": "Buscar función...",
  "Buscar Registro por E-mail": "Buscar registro por correo electrónico",
  "Buscar URL, domínio ou página": "Buscar URL, dominio o página",
  "Buscar Usuário": "Buscar usuario",
  "Buscar Usuário por E-mail": "Buscar usuario por correo electrónico",
  "Buscar vídeo…": "Buscar video…",
  "Buscar vídeos": "Buscar videos",
  "Buscar vídeos ou pastas…": "Buscar videos o carpetas…",
  "Busque um usuário para gerenciar nível, status, plano e cliques operacionais.": "Busca un usuario para gestionar el nivel, el estado, el plan y los clics operativos.",
  "Busque, crie, edite ou exclua registros de incremento condicional de clicks por usuário.": "Busca, crea, edita o elimina registros de incremento condicional de clics por usuario.",
  "Button text is required": "El texto del botón es obligatorio",
  "Button text too long": "El texto del botón es demasiado largo",
  "Cache limpo! Recarregando...": "¡Caché borrada! Recargando...",
  "Cada linha mostra a % de pessoas que continuam assistindo ao longo do tempo.": "Cada línea muestra el porcentaje de personas que siguen viendo a lo largo del tiempo.",
  "Cada linha representa um tipo de introdução testada.": "Cada línea representa un tipo de introducción probado.",
  "Cada visitante vê um começo diferente e, ao final, a VSL principal continua automaticamente, como se fosse um único vídeo.": "Cada visitante ve un comienzo distinto y, al terminar, la VSL principal continúa automáticamente, como si fuera un único video.",
  "cadastrado ainda.": "registrado todavía.",
  "Cadastrar": "Registrar",
  "Cadastre este webhook na plataforma, para as compras deste checkout:": "Registra este webhook en la plataforma para las compras de esta página de pago:",
  "Cadastre um cartão antes de comprar": "Registra una tarjeta antes de comprar",
  "Cadastre-se": "Regístrate",
  "Calendário de Disponibilidade": "Calendario de disponibilidad",
  "Câmbio": "Tipo de cambio",
  "Campo de cupom": "Campo de cupón",
  "Campo Extra": "Campo extra",
  "Campos ativos:": "Campos activos:",
  "Campos inválidos": "Campos no válidos",
  "Campos obrigatórios": "Campos obligatorios",
  "Campos para Captura": "Campos de captura",
  "Campos Preenchidos": "Campos completados",
  "Campos Selecionados": "Campos seleccionados",
  "Campos um abaixo do outro, com o botão em largura total": "Campos uno debajo del otro, con el botón a todo el ancho",
  "Cancelamento confirmado": "Cancelación confirmada",
  "Cancelando...": "Cancelando...",
  "Cancelar Agendamento": "Cancelar programación",
  "Cancelar Assinatura": "Cancelar suscripción",
  "Cancelar edição": "Cancelar edición",
  "Cancelar envio": "Cancelar envío",
  "Cancelar o envio de": "Cancelar el envío de",
  "Cancelar uploads": "Cancelar subidas",
  "Cantos Arredondados": "Esquinas redondeadas",
  "Capa Principal (Hero)": "Portada principal (Hero)",
  "Capacidade e Acesso": "Capacidad y acceso",
  "Capacidade por slot (opcional)": "Capacidad por franja (opcional)",
  "Caps Lock está ativado": "Bloq Mayús está activado",
  "Captura de leads": "Captura de leads",
  "Captura desativada": "Captura desactivada",
  "Capturar E-mail": "Captar correo electrónico",
  "Capturar Nome": "Captar nombre",
  "Capturar WhatsApp": "Captar WhatsApp",
  "Capturas nos Últimos 7 Dias": "Capturas de los últimos 7 días",
  "caracteres": "caracteres",
  "Carregando análise de custos...": "Cargando análisis de costes...",
  "Carregando custos...": "Cargando costes...",
  "Carregando dados da estratégia...": "Cargando datos de la estrategia...",
  "Carregando dados de retenção...": "Cargando datos de retención...",
  "Carregando dados do pagamento...": "Cargando datos del pago...",
  "Carregando detalhes do compartilhamento…": "Cargando detalles del enlace compartido…",
  "Carregando detalhes...": "Cargando detalles...",
  "Carregando integrações...": "Cargando integraciones...",
  "Carregando logs...": "Cargando registros...",
  "Carregando mais vídeos...": "Cargando más videos...",
  "Carregando membros...": "Cargando miembros...",
  "Carregando o fluxo": "Cargando el flujo",
  "Carregando o mapa…": "Cargando el mapa…",
  "Carregando pastas...": "Cargando carpetas...",
  "Carregando plataformas": "Cargando plataformas",
  "Carregando plataformas...": "Cargando plataformas...",
  "Carregando proteções...": "Cargando protecciones...",
  "Carregando rastreamentos...": "Cargando seguimientos...",
  "Carregando registros da rede...": "Cargando registros de la red...",
  "Carregando registros...": "Cargando registros...",
  "Carregando solicitações...": "Cargando solicitudes...",
  "Carregando vídeos…": "Cargando videos…",
  "Carregar do celular": "Subir desde el móvil",
  "Carregar um novo vídeo": "Subir un nuevo video",
  "Cartão adicionado, mas não foi possível defini-lo como padrão.": "Tarjeta añadida, pero no se pudo definir como predeterminada.",
  "Cartão atualizado com sucesso!": "¡Tarjeta actualizada correctamente!",
  "Cartão padrão atualizado!": "¡Tarjeta predeterminada actualizada!",
  "Cartão removido com sucesso!": "¡Tarjeta eliminada correctamente!",
  "Cartão selecionado!": "¡Tarjeta seleccionada!",
  "Catálogo moderno com fundo escuro e carrossel horizontal. Ideal para playlists longas.": "Catálogo moderno con fondo oscuro y carrusel horizontal. Ideal para listas de reproducción largas.",
  "CC": "CC",
  "Celular": "Móvil",
  "Central": "Central",
  "Central de ajuda": "Centro de ayuda",
  "Centralizar": "Centrar",
  "CEP (00000-000)": "Código postal (00000-000)",
  "Certifique-se de que seu vídeo carrega rapidamente em todos os dispositivos e conexões.": "Asegúrate de que tu video carga rápidamente en todos los dispositivos y conexiones.",
  "Chama atenção sem poluir": "Llama la atención sin recargar",
  "Chamada Principal (CTA)": "Llamada principal (CTA)",
  "Chat com suporte": "Chat con soporte",
  "Chat com Suporte": "Chat con soporte",
  "Chave": "Clave",
  "Chave / Identificador": "Clave / Identificador",
  "Chave copiada": "Clave copiada",
  "Chave criada": "Clave creada",
  "Chave PIX": "Clave PIX",
  "Chave PIX (CPF, E-mail, Celular ou Aleatória)": "Clave PIX (CPF, correo electrónico, móvil o aleatoria)",
  "Chave PIX cadastrada": "Clave PIX registrada",
  "Chave revogada": "Clave revocada",
  "Checkout de alta conversão para negócios digitais.": "Página de pago de alta conversión para negocios digitales.",
  "Checkout do plano": "Página de pago del plan",
  "Chegaram ao principal": "Llegaron al principal",
  "Chegou a Contagem Final Inteligente: assim que o vídeo acaba, um card com contagem regressiva aparece e leva o espectador ao próximo passo, sem aquele silêncio depois do último argumento. Você define o tempo da contagem, escreve o título e a descrição do card e decide o desfecho — redirecionar automaticamente para o seu link ou apenas exibir o aviso, deixando a pessoa fechar e voltar ao vídeo. O card ainda combina com a sua marca: cores, tamanho, arredondamento e animação de entrada são todos ajustáveis.": "Llega la cuenta atrás final inteligente: al terminar el video, aparece una tarjeta con cuenta atrás que lleva al espectador al siguiente paso. Define su duración, el título y la descripción, y elige entre redirigir automáticamente a tu enlace o mostrar un aviso que la persona pueda cerrar para volver al video. Personaliza los colores, el tamaño, las esquinas y la animación de entrada para que encajen con tu marca.",
  "Chegou a integração com o TikTok Ads. Cadastre o ID do pixel e o token de acesso do seu Events Manager e a HostVSL passa a enviar ao TikTok os eventos de quem assiste às suas VSLs: visualização da página, play, retenção e tempo assistido. O envio é feito direto do nosso servidor pela API de eventos do TikTok, então você não precisa colar nenhum código extra na sua página e o seu token fica guardado com segurança.": "Llega la integración con TikTok Ads. Registra el ID del píxel y el token de acceso de tu Events Manager para que HostVSL envíe a TikTok los eventos de tus espectadores: visualización de página, reproducción, retención y tiempo visto. El envío se realiza desde nuestro servidor mediante la API de eventos de TikTok, sin añadir código a tu página, y tu token se guarda de forma segura.",
  "Chegou a Jornada de Conversão: agora você encaixa um vídeo de entrada antes da sua VSL principal e, se quiser, um vídeo de saída logo depois — tudo no estilo anúncio do YouTube. Use a entrada pra criar contexto, qualificar ou aquecer o lead antes do conteúdo principal, e a saída pra reforçar a oferta e chamar pra ação assim que o vídeo termina. Os vídeos saem da sua própria biblioteca, com botão de pular, card de CTA clicável e métricas de cada etapa.": "Llega el recorrido de conversión: coloca un video de entrada antes de tu VSL principal y, si quieres, uno de salida después, como los anuncios de YouTube. Usa la entrada para crear contexto, cualificar o preparar al lead, y la salida para reforzar la oferta y llamar a la acción. Los videos proceden de tu biblioteca y cuentan con botón para omitir, tarjeta CTA y métricas de cada etapa.",
  "Chegou no Pitch": "Llegó a la oferta",
  "Chegou o recurso Picos de Horário. Agora você identifica com clareza quando seu público mais assiste, em quais dias e em quais faixas de horário.": "Llega la función de horas punta. Ahora puedes identificar claramente cuándo ve más tu público, en qué días y en qué franjas horarias.",
  "Chegou o recurso Picos de Horário. Agora você identifica com clareza quando seu público mais assiste, em quais dias e em quais faixas de horário. Isso permite publicar com mais precisão, otimizar suas campanhas e aumentar o desempenho do vídeo com base em dados reais.": "Llega la función de horas punta. Ahora puedes identificar claramente cuándo ve más tu público, en qué días y en qué franjas horarias. Así podrás publicar con más precisión, optimizar tus campañas y mejorar el rendimiento del video basándote en datos reales.",
  "Chrome": "Chrome",
  "Cidade/UF": "Ciudad/estado",
  "Cinza claro": "Gris claro",
  "Circular": "Circular",
  "Claro premium": "Claro prémium",
  "Claude no notebook": "Claude en el portátil",
  "Clean:": "Limpio:",
  "Clicar para iniciar": "Haz clic para iniciar",
  "Click Rate": "Tasa de clics",
  "Click to activate sound": "Haz clic para activar el sonido",
  "Clicks a Incrementar": "Clics que se añadirán",
  "Clicks Configurados:": "Clics configurados:",
  "Clicks Restantes:": "Clics restantes:",
  "Clicou na Oferta": "Hizo clic en la oferta",
  "Cliente assinou um plano de R$ 100/mês": "El cliente contrató un plan de R$ 100/mes",
  "Clientes Ativos": "Clientes activos",
  "Clientes que assinaram através do seu link.": "Clientes que se suscribieron a través de tu enlace.",
  "Clique aqui e ative agora!": "¡Haz clic aquí y actívalo ahora!",
  "Clique Automático": "Clic automático",
  "Clique em \"Buscar por E-mail\" para localizar um registro existente, ou \"Novo Registro\" para criar um novo incremento.": "Haz clic en \"Buscar por correo electrónico\" para localizar un registro existente o en \"Nuevo registro\" para crear un nuevo incremento.",
  "Clique em \"Usar Esta Thumbnail\" para aplicar.": "Haz clic en \"Usar esta miniatura\" para aplicarla.",
  "Clique no botão \"Buscar Usuário\" localizado no topo para pesquisar e gerenciar uma conta por e-mail.": "Haz clic en el botón \"Buscar usuario\" de la parte superior para buscar y gestionar una cuenta por correo electrónico.",
  "Clique no botão abaixo para visualizar o modal premium de incorporação de vídeo HostVSL.": "Haz clic en el botón de abajo para ver el diálogo prémium de inserción de videos de HostVSL.",
  "Clique no botão acima para instalar o app no seu dispositivo": "Haz clic en el botón de arriba para instalar la aplicación en tu dispositivo",
  "Clique para ajustar o pitch": "Haz clic para ajustar la oferta",
  "Clique para escolher. Máximo: 5MB": "Haz clic para elegir. Máximo: 5 MB",
  "Clique para fazer upload (1920×700px)": "Haz clic para subir (1920×700 px)",
  "Clique para ouvir": "Haz clic para escuchar",
  "Clique para selecionar .SRT ou .VTT": "Haz clic para seleccionar .SRT o .VTT",
  "Clique para ver os uploads": "Haz clic para ver las subidas",
  "cliques": "clics",
  "Cliques CTA": "Clics en el CTA",
  "cliques na oferta": "clics en la oferta",
  "Cliques no Botão": "Clics en el botón",
  "Cliques no CTA de entrada": "Clics en el CTA de entrada",
  "Cliques no CTA final": "Clics en el CTA final",
  "Cliques Totais": "Clics totales",
  "Cloaker de VSL reformulado": "Cloaker de VSL renovado",
  "Cobrança automática após 15 dias. Cancele a qualquer momento.": "Cobro automático después de 15 días. Cancela en cualquier momento.",
  "Cód. Banco": "Código del banco",
  "Código": "Código",
  "Código copiado com sucesso!": "¡Código copiado correctamente!",
  "Código Copiado!": "¡Código copiado!",
  "Código copiado.": "Código copiado.",
  "Código copiado. Cole na página onde o vídeo deve aparecer.": "Código copiado. Pégalo en la página donde debe aparecer el video.",
  "Código copiado. Ele só mostra o vídeo depois que o fluxo for publicado.": "Código copiado. Solo mostrará el video cuando el flujo esté publicado.",
  "Código copiado. O fluxo está pausado: o vídeo só aparece quando ele for retomado.": "Código copiado. El flujo está pausado: el video solo aparecerá cuando se reanude.",
  "Código da Máquina": "Código de la máquina",
  "Código de acesso": "Código de acceso",
  "Código de acesso é obrigatório": "El código de acceso es obligatorio",
  "Código de E-mail": "Código de correo electrónico",
  "Código de incorporação do fluxo para colar no site.": "Código de inserción del flujo para pegarlo en el sitio.",
  "Código do fluxo": "Código del flujo",
  "Código do Funil": "Código del embudo",
  "Código do idioma (ex: pt, en, es)": "Código del idioma (ej.: pt, en, es)",
  "Código enviado para seu e-mail!": "¡Código enviado a tu correo electrónico!",
  "Código inválido.": "Código no válido.",
  "Código JavaScript:": "Código JavaScript:",
  "Código reenviado!": "¡Código reenviado!",
  "cole": "pega",
  "Cole a URL completa, incluindo https://.": "Pega la URL completa, incluido https://.",
  "Cole a URL de webhook abaixo no painel": "Pega la URL del webhook de abajo en el panel",
  "Cole aqui o token gerado pela plataforma": "Pega aquí el token generado por la plataforma",
  "Cole este código onde deseja exibir o vídeo. A proteção será aplicada automaticamente conforme a regra configurada.": "Pega este código donde quieras mostrar el video. La protección se aplicará automáticamente según la regla configurada.",
  "Cole na página onde o vídeo deve aparecer. O código não muda quando você publica de novo.": "Pégalo en la página donde deba aparecer el video. El código no cambia cuando vuelves a publicar.",
  "Cole o código abaixo na tag": "Pega el código de abajo en la etiqueta",
  "Cole o código de acesso aqui": "Pega el código de acceso aquí",
  "Cole o código na sua landing page para ativar a proteção.": "Pega el código en tu página de destino para activar la protección.",
  "Cole o token do pixel": "Pega el token del píxel",
  "Cole seu código HTML aqui...\nAceita HTML, CSS inline e scripts leves.": "Pega tu código HTML aquí...\nAdmite HTML, CSS en línea y scripts ligeros.",
  "Coleta Nome, E-mail, WhatsApp e ativa formulário no player.": "Recopila nombre, correo electrónico y WhatsApp, y activa el formulario en el reproductor.",
  "Coletando dados em tempo real": "Recopilando datos en tiempo real",
  "Colete avaliações dos espectadores diretamente no player": "Recoge las valoraciones de los espectadores directamente en el reproductor",
  "Colunas": "Columnas",
  "Colunas visíveis": "Columnas visibles",
  "com": "con",
  "Com 100 indicações no plano Premium, você ganha": "Con 100 recomendaciones en el plan Premium, ganas",
  "Com as legendas ativadas, você pode adicionar arquivos": "Con los subtítulos activados, puedes añadir archivos",
  "Com base nos dados coletados,": "Según los datos recopilados,",
  "Com base nos dados reais, descubra qual introdução tem melhor performance e finalize o teste.": "Descubre qué introducción rinde mejor con datos reales y finaliza la prueba.",
  "Com base nos dados reais, descubra qual variante tem melhor performance e finalize o teste quando tiver confiança.": "Descubre qué variante rinde mejor con datos reales y finaliza la prueba cuando tengas confianza en los resultados.",
  "Com o Teste de hook, nossos usuários relatam em média:": "Con la prueba de ganchos, nuestros usuarios informan de media:",
  "Comandos Úteis": "Comandos útiles",
  "começa com": "empieza por",
  "Começa com": "Empieza por",
  "Comece com uma pergunta intrigante ou uma afirmação surpreendente que gere interesse imediato.": "Empieza con una pregunta intrigante o una afirmación sorprendente que despierte interés inmediato.",
  "Comece conectando suas plataformas 🎯": "Empieza conectando tus plataformas 🎯",
  "Comece criando sua primeira pasta para organizar seus vídeos": "Empieza creando tu primera carpeta para organizar tus videos",
  "Comece enviando seu primeiro vídeo para acompanhar métricas e performance.": "Empieza enviando tu primer video para seguir las métricas y el rendimiento.",
  "Comentários recentes": "Comentarios recientes",
  "Comissão": "Comisión",
  "Comissão do seller atualizada com sucesso!": "¡Comisión del vendedor actualizada correctamente!",
  "Comissão do Seller:": "Comisión del vendedor:",
  "Comissão Individual": "Comisión individual",
  "Comissão Recorrente Mensal (20%)": "Comisión mensual recurrente (20 %)",
  "Comissões Recebidas": "Comisiones recibidas",
  "comissões recorrentes": "comisiones recurrentes",
  "Como Funciona": "Cómo funciona",
  "Como funciona a comparação de VSLs": "Cómo funciona la comparación de VSL",
  "Como funciona a Proteção Anti-Plágio?": "¿Cómo funciona la protección antiplagio?",
  "Como funciona a VSL Dinâmica": "Cómo funciona la VSL dinámica",
  "Como funciona o programa?": "¿Cómo funciona el programa?",
  "Como funciona o recurso de legendas": "Cómo funciona la función de subtítulos",
  "Como funciona o Teste de hook": "Cómo funciona la prueba de ganchos",
  "Como funciona o teste?": "¿Cómo funciona la prueba?",
  "Como funciona os plays extras": "Cómo funcionan las reproducciones extra",
  "Como funcionam os testes A/B": "Cómo funcionan las pruebas A/B",
  "Como funcionam os testes de introduções": "Cómo funcionan las pruebas de introducciones",
  "Como Ganhar Com Sua Rede": "Cómo ganar con tu red",
  "Como o vídeo começa": "Cómo empieza el video",
  "Como o vídeo deve se comportar quando o formulário aparece": "Cómo debe comportarse el video cuando aparece el formulario",
  "Como podemos te ajudar?": "¿Cómo podemos ayudarte?",
  "Como seu público está acessando": "Cómo accede tu público",
  "Como seu público interagiu": "Cómo interactuó tu público",
  "Como subir seu primeiro vídeo": "Cómo subir tu primer video",
  "Como usar": "Cómo usar",
  "Como Usar Headlines/Subheadlines": "Cómo usar titulares y subtítulos",
  "Como você avalia este conteúdo?": "¿Cómo valoras este contenido?",
  "Como você deseja proteger seus vídeos?": "¿Cómo quieres proteger tus videos?",
  "Comp. Média da Conta": "Comparación con la media de la cuenta",
  "Comp. Vídeo Anterior": "Comparación con el video anterior",
  "Comparação da retenção de audiência entre diferentes introduções": "Comparación de la retención de audiencia entre distintas introducciones",
  "Comparação da retenção de audiência entre diferentes vídeos": "Comparación de la retención de audiencia entre distintos videos",
  "Comparação de Plataformas": "Comparación de plataformas",
  "Comparação Visual": "Comparación visual",
  "Comparado aos 30d anteriores": "Comparado con los 30 días anteriores",
  "Comparar agora": "Comparar ahora",
  "Comparativo das Introduções": "Comparación de introducciones",
  "Comparativo de Performance": "Comparación de rendimiento",
  "Comparativo dos Vídeos": "Comparación de videos",
  "Comparativo por Velocidade": "Comparación por velocidad",
  "Compare como cada velocidade influencia a permanência da audiência ao longo do vídeo.": "Compara cómo influye cada velocidad en la permanencia de la audiencia a lo largo del video.",
  "Compare diferentes aberturas do seu vídeo e descubra qual gera mais engajamento.": "Compara distintos comienzos de tu video y descubre cuál genera más interacción.",
  "Compare diferentes variações do seu vídeo e descubra qual converte melhor.": "Compara distintas variaciones de tu video y descubre cuál convierte mejor.",
  "Compare introduções, distribua o tráfego automaticamente e otimize sua conversão com dados reais": "Compara introducciones, distribuye el tráfico automáticamente y optimiza tu conversión con datos reales",
  "Compare métricas de retenção nos primeiros 30 segundos": "Compara las métricas de retención de los primeros 30 segundos",
  "Compare o desempenho das introduções ao longo do vídeo principal.": "Compara el rendimiento de las introducciones a lo largo del video principal.",
  "Compare plataformas": "Compara plataformas",
  "Compare plays, impressões e usuários únicos por fonte de tráfego.": "Compara reproducciones, impresiones y usuarios únicos por fuente de tráfico.",
  "Compare resultados baseados na origem do tráfego (Facebook vs Instagram vs Email).": "Compara resultados según el origen del tráfico (Facebook frente a Instagram frente a correo electrónico).",
  "Compare suas VSLs lado a lado e descubra qual performa melhor": "Compara tus VSL en paralelo y descubre cuál rinde mejor",
  "Compare versões e descubra o que mais converte.": "Compara versiones y descubre cuál convierte más.",
  "Compare VSLs, distribua o tráfego automaticamente e otimize sua conversão com dados reais": "Compara VSL, distribuye el tráfico automáticamente y optimiza tu conversión con datos reales",
  "Compartilhamento de Vídeos com Equipe e Afiliados": "Compartir videos con el equipo y los afiliados",
  "Compartilhamento excluído com sucesso!": "¡Enlace compartido eliminado correctamente!",
  "Compartilhando vídeo": "Compartiendo video",
  "Compartilhe o vídeo para começar a coletar avaliações dos espectadores.": "Comparte el video para empezar a recoger las valoraciones de los espectadores.",
  "Compartilhe seu link": "Comparte tu enlace",
  "Compartilhe vídeos com seus afiliados para que eles possam divulgar suas ofertas. Acesse seus vídeos e clique em \"Compartilhar\" para começar.": "Comparte videos con tus afiliados para que puedan difundir tus ofertas. Accede a tus videos y haz clic en \"Compartir\" para empezar.",
  "Completude dos dados": "Integridad de los datos",
  "Completude:": "Integridad:",
  "Component Stack:": "Pila de componentes:",
  "Componente": "Componente",
  "Components": "Componentes",
  "Comportamento de Envio": "Comportamiento del envío",
  "Comportamento de visualização dos leads": "Comportamiento de visualización de los leads",
  "Comportamento do Modal": "Comportamiento del diálogo",
  "Comportamento do Player": "Comportamiento del reproductor",
  "Comprados separadamente": "Comprados por separado",
  "Comprar": "Comprar",
  "Comprar agora": "Comprar ahora",
  "Compre plays extras para continuar exibindo seus vídeos": "Compra reproducciones extra para seguir mostrando tus videos",
  "Comprovante ampliado": "Justificante ampliado",
  "Comprovante atual": "Justificante actual",
  "Comprovante de pagamento": "Justificante de pago",
  "Comprovante de Pagamento": "Justificante de pago",
  "computados.": "calculados.",
  "concluído": "completado",
  "Conclusão da entrada": "Finalización de la entrada",
  "Conclusão da saída": "Finalización de la salida",
  "Condição": "Condición",
  "Condição liberada apenas nesta janela.": "Condición disponible solo en esta franja.",
  "Conectado como": "Conectado como",
  "Conectando...": "Conectando...",
  "Conectar Novo Pixel": "Conectar nuevo píxel",
  "Conectar Plataforma": "Conectar plataforma",
  "Conectar Rastreamento": "Conectar seguimiento",
  "Conecte com chat e notificações de vendas": "Conecta con el chat y las notificaciones de ventas",
  "Conecte ferramentas de automação, analytics, CRM e muito mais.": "Conecta herramientas de automatización, análisis, CRM y mucho más.",
  "Conecte pixels do Meta, Google e TikTok para rastrear conversões.": "Conecta píxeles de Meta, Google y TikTok para seguir las conversiones.",
  "Conecte seu rastreamento para ver o vídeo campeão.": "Conecta tu seguimiento para ver el video ganador.",
  "Conecte seu Tracking para ver receita": "Conecta tu seguimiento para ver los ingresos",
  "Conecte sua conta Google": "Conecta tu cuenta de Google",
  "Conecte sua plataforma para acompanhar vendas e receita. Acesso ao checkout não confirma compra.": "Conecta tu plataforma para seguir las ventas y los ingresos. Acceder a la página de pago no confirma una compra.",
  "Conecte sua primeira plataforma de pagamentos": "Conecta tu primera plataforma de pagos",
  "Conecte uma plataforma de conversão para ver vendas e receita por intro nas métricas do teste.": "Conecta una plataforma de conversión para ver las ventas y los ingresos por introducción en las métricas de la prueba.",
  "Conecte uma plataforma em Rastreamento para começar a acumular faturamento.": "Conecta una plataforma en Seguimiento para empezar a acumular ingresos.",
  "Conecte-se com o público através de histórias pessoais ou casos reais que despertem emoção.": "Conecta con el público mediante historias personales o casos reales que despierten emociones.",
  "Configuração aplicada com sucesso": "Configuración aplicada correctamente",
  "Configuração da thumbnail do vídeo": "Configuración de la miniatura del video",
  "Configuração dos vídeos": "Configuración de los videos",
  "Configuração não encontrada": "Configuración no encontrada",
  "Configuração salva com sucesso.": "Configuración guardada correctamente.",
  "Configurações aplicadas em {value0} vídeo(s)": "Configuración aplicada a {value0} video(s)",
  "Configurações Avançadas": "Configuración avanzada",
  "Configurações da barra de progresso": "Configuración de la barra de progreso",
  "Configurações da logo atualizadas": "Configuración del logotipo actualizada",
  "Configurações da thumbnail salvas": "Configuración de la miniatura guardada",
  "Configurações das Seções": "Configuración de las secciones",
  "Configurações de Captura de Dados": "Configuración de captura de datos",
  "Configurações de controle do player": "Configuración de los controles del reproductor",
  "Configurações de Notificações": "Configuración de notificaciones",
  "configurações de personalização atuais": "configuración de personalización actual",
  "Configurações de Temporizador": "Configuración del temporizador",
  "Configurações Prime Video Dark": "Configuración de Prime Video Dark",
  "Configurações prontas. Clique em \"Aplicar\" para iniciar o teste.": "Configuración lista. Haz clic en \"Aplicar\" para iniciar la prueba.",
  "Configurações resetadas": "Configuración restablecida",
  "Configurações técnicas e avançadas do player de vídeo.": "Configuración técnica y avanzada del reproductor de video.",
  "Configurar Feedback do Vídeo": "Configurar comentarios del video",
  "Configurar Funil": "Configurar embudo",
  "Configurar Pitch de Vendas": "Configurar oferta de ventas",
  "Configurar Pixel": "Configurar píxel",
  "Configurar Pixels": "Configurar píxeles",
  "Configurar Rastreamento": "Configurar seguimiento",
  "Configurar Tracking": "Configurar seguimiento",
  "Configure a página de inscrição do seu webinário. As alterações aparecem na prévia em tempo real.": "Configura la página de registro de tu seminario web. Los cambios aparecen en la vista previa en tiempo real.",
  "Configure as informações essenciais do seu webinário.": "Configura la información esencial de tu seminario web.",
  "Configure as informações principais do seu webinário": "Configura la información principal de tu seminario web",
  "Configure bordas personalizadas no player.": "Configura bordes personalizados en el reproductor.",
  "Configure campos, estilo e comportamento da captura de leads": "Configura los campos, el estilo y el comportamiento de la captura de leads",
  "Configure como o modal se comporta": "Configura cómo se comporta el diálogo",
  "Configure CTAs no momento certo do vídeo.": "Configura los CTA en el momento adecuado del video.",
  "Configure domínios personalizados para seus vídeos.": "Configura dominios personalizados para tus videos.",
  "Configure e ative o teste para coletar dados": "Configura y activa la prueba para recopilar datos",
  "Configure formulários de captura integrados ao seu vídeo.": "Configura formularios de captura integrados en tu video.",
  "Configure integrações para enviar seus leads capturados": "Configura integraciones para enviar los leads captados",
  "Configure limites e regras de entrada": "Configura límites y reglas de entrada",
  "Configure o agendamento para ver a prévia": "Configura la programación para ver la vista previa",
  "Configure o botão de inscrição": "Configura el botón de registro",
  "Configure o call-to-action principal": "Configura la llamada a la acción principal",
  "Configure o comportamento de reprodução do vídeo.": "Configura el comportamiento de reproducción del video.",
  "Configure o formulário para ver a prévia": "Configura el formulario para ver la vista previa",
  "Configure o rastreamento de conversões para ver suas vendas aqui.": "Configura el seguimiento de conversiones para ver tus ventas aquí.",
  "Configure o termo de consentimento": "Configura el consentimiento",
  "Configure o tracking de conversões para acompanhar receita, conversões e performance dos seus vídeos.": "Configura el seguimiento de conversiones para controlar los ingresos, las conversiones y el rendimiento de tus videos.",
  "Configure opções de qualidade adaptativa para diferentes velocidades de internet.": "Configura opciones de calidad adaptativa para distintas velocidades de internet.",
  "Configure os controles disponíveis para o espectador.": "Configura los controles disponibles para el espectador.",
  "Configure os módulos e bônus no painel de edição": "Configura los módulos y las bonificaciones en el panel de edición",
  "Configure os valores da oferta": "Configura los importes de la oferta",
  "Configure para recarregar plays automaticamente": "Configura la recarga automática de reproducciones",
  "Configure rastreamento avançado para acompanhar todo o funil.": "Configura el seguimiento avanzado para controlar todo el embudo.",
  "Configure seu primeiro funil": "Configura tu primer embudo",
  "Configure seu primeiro pixel": "Configura tu primer píxel",
  "Configure sua headline para ver o preview no vídeo principal": "Configura tu titular para ver la vista previa en el video principal",
  "Configure sua primeira proteção em poucos passos.": "Configura tu primera protección en pocos pasos.",
  "Configure sua Recarga Automática": "Configura tu recarga automática",
  "Configure tudo em uma única jornada": "Configura todo en un único recorrido",
  "Configure um teste na aba \"Teste A/B\" para visualizar curvas de retenção.": "Configura una prueba en la pestaña \"Prueba A/B\" para ver las curvas de retención.",
  "Confira o player com as alterações atuais. Esta prévia não contabiliza plays. Saídas exibem o endereço de destino.": "Revisa el reproductor con los cambios actuales. Esta vista previa no cuenta reproducciones. Las salidas muestran la dirección de destino.",
  "Confira se o arquivo está publicado em:": "Comprueba que el archivo está publicado en:",
  "Confirmar cancelamento": "Confirmar cancelación",
  "Confirmar Compra": "Confirmar compra",
  "Confirmar e Sacar": "Confirmar y retirar",
  "Confirmar e Sincronizar Banco": "Confirmar y sincronizar banco",
  "Confirmar Plataformas": "Confirmar plataformas",
  "Confirmar Recarga": "Confirmar recarga",
  "Confirmar Resgate": "Confirmar canje",
  "Confirmar senha": "Confirmar contraseña",
  "Confirme abaixo para adicionar o vídeo à sua conta HostVSL.": "Confirma abajo para añadir el video a tu cuenta de HostVSL.",
  "Confirme as variações e distribuição de tráfego antes de iniciar o teste.": "Confirma las variaciones y la distribución del tráfico antes de iniciar la prueba.",
  "Conforto": "Comodidad",
  "Conheça a AdSniper com uma condição especial para usuários da Host VSL.": "Descubre AdSniper con una oferta especial para los usuarios de Host VSL.",
  "Conheça os pilares da Host VSL e entenda como cada área se conecta para acelerar sua operação.": "Conoce los pilares de Host VSL y comprende cómo se conecta cada área para agilizar tu trabajo.",
  "Consentimento LGPD": "Consentimiento de la LGPD",
  "Considere aumentar o tráfego para": "Considera aumentar el tráfico hacia",
  "Considere otimizar o início do pitch.": "Considera optimizar el inicio de la oferta.",
  "Considere storytelling": "Considera la narración",
  "Considere testar campanhas neste horário para explorar oportunidades de crescimento.": "Prueba campañas en este horario para aprovechar las oportunidades de crecimiento.",
  "Consolida o resumo diário de métricas do período (dia de hoje é lido ao vivo)": "Consolida el resumen diario de métricas del período (el día actual se consulta en directo)",
  "Consultores de Vendas": "Consultores de ventas",
  "Consumo no seu plano": "Consumo de tu plan",
  "Conta bancária definida como principal!": "¡Cuenta bancaria definida como principal!",
  "Conta Bancária Tradicional": "Cuenta bancaria tradicional",
  "Conta bancária vinculada com sucesso!": "¡Cuenta bancaria vinculada correctamente!",
  "Conta com dígito": "Cuenta con dígito de control",
  "Conta corrente": "Cuenta corriente",
  "Conta definida pelo usuário para recebimento.": "Cuenta definida por el usuario para recibir pagos.",
  "conta Google": "cuenta de Google",
  "Contagem Final salva": "Cuenta atrás final guardada",
  "Contas de Recebimento": "Cuentas de cobro",
  "Contas vinculadas": "Cuentas vinculadas",
  "Conte um pouco mais": "Cuéntanos un poco más",
  "contém": "contiene",
  "Contém": "Contiene",
  "Content Preview": "Vista previa del contenido",
  "Contexto Global": "Contexto global",
  "Contexts": "Contextos",
  "Continuar assistindo": "Seguir viendo",
  "Continuar e Assistir": "Continuar y ver",
  "Continuar editando": "Seguir editando",
  "Continuar enviando": "Seguir enviando",
  "Continuar para o editor": "Continuar al editor",
  "Continuar sem rastreamento": "Continuar sin seguimiento",
  "Continue com storytelling": "Continúa con la narración",
  "Continue para a próxima aula": "Continúa con la siguiente lección",
  "Continue para personalizar seu vídeo com botões inteligentes e mais": "Continúa para personalizar tu video con botones inteligentes y más",
  "Continue refinando suas histórias. Adicione mais elementos emocionais, conflitos claros e resoluções satisfatórias.": "Sigue perfeccionando tus historias. Añade más elementos emocionales, conflictos claros y desenlaces satisfactorios.",
  "Continue testando diferentes abordagens para descobrir o que ressoa melhor com seu público.": "Sigue probando distintos enfoques para descubrir qué conecta mejor con tu público.",
  "Continue usando storytelling eficiente, já que sua curva de retenção mostra alta eficácia.": "Sigue usando una narración eficaz, ya que tu curva de retención muestra buenos resultados.",
  "Contraste adequado:": "Contraste adecuado:",
  "Contraste insuficiente (": "Contraste insuficiente (",
  "Contraste insuficiente: {value0}:1 (mínimo 4.5:1 para acessibilidade)": "Contraste insuficiente: {value0}:1 (mínimo 4,5:1 para accesibilidad)",
  "Controle a velocidade de reprodução.": "Controla la velocidad de reproducción.",
  "Controle como o player aparece em cada dispositivo: Desktop, Tablet e Celular": "Controla cómo aparece el reproductor en cada dispositivo: escritorio, tableta y móvil",
  "Controle o que é mostrado no formulário": "Controla qué se muestra en el formulario",
  "Controle por localização": "Control por ubicación",
  "Controle por origem de tráfego": "Control por origen del tráfico",
  "Controle quem pode assistir sua VSL por localização, dispositivo e comportamento.": "Controla quién puede ver tu VSL por ubicación, dispositivo y comportamiento.",
  "Controles desabilitados": "Controles deshabilitados",
  "Controles desativados automaticamente. Barra fake e controles não podem estar ativos ao mesmo tempo.": "Controles desactivados automáticamente. La barra simulada y los controles no pueden estar activos al mismo tiempo.",
  "Controles do player": "Controles del reproductor",
  "conv": "conv",
  "Conv": "Conv",
  "Conv:": "Conv:",
  "conv.": "conv.",
  "Conv.": "Conv.",
  "CONVERSÃO": "CONVERSIÓN",
  "Conversão em venda": "Conversión en venta",
  "Conversão final": "Conversión final",
  "Conversão por Dia": "Conversión por día",
  "Conversão por Horário": "Conversión por hora",
  "Conversão Total do Funil": "Conversión total del embudo",
  "Converse com a gente!": "¡Habla con nosotros!",
  "Conversion Rate": "Tasa de conversión",
  "Conversões & Receita": "Conversiones e ingresos",
  "Conversões e receita rastreadas pelas plataformas conectadas": "Conversiones e ingresos seguidos mediante las plataformas conectadas",
  "Conversões hoje": "Conversiones de hoy",
  "convertido": "convertido",
  "Convidado em:": "Invitado el:",
  "Convidar Cliente": "Invitar cliente",
  "Convidar Parceiro": "Invitar socio",
  "Convide clientes e vendedores para a Host VSL e receba comissões automáticas sempre que sua rede gerar resultados.": "Invita a clientes y vendedores a Host VSL y recibe comisiones automáticas cuando tu red genere resultados.",
  "Convite enviado com sucesso!": "¡Invitación enviada correctamente!",
  "Copiada": "Copiada",
  "Bom desempenho": "Buen rendimiento",
  "Borda Customizada": "Borde personalizado",
  "Botão Play Pequeno": "Botón play pequeño",
  "Controle de Volume": "Control de volumen",
  "Cor da Barra": "Color de la barra",
  "Cor do botão": "Color del botón",
  "Criando": "Creando",
  "Criar teste": "Crear prueba",
  "DIA": "DÍA",
  "Distribuição de tráfego:": "Distribución del tráfico:",
  "Duração do teste": "Duración de la prueba",
  "E-mail:": "Correo electrónico:",
  "Editar permissões": "Editar permisos",
  "Email": "Correo electrónico",
  "Engajamento:": "Interacción:",
  "Enviando…": "Enviando…",
  "Erro ao excluir.": "Error al eliminar.",
  "Exibir vídeo original": "Mostrar video original",
  "Exibição por dispositivo": "Visualización por dispositivo",
  "Exibição:": "Visualización:",
  "Fonte:": "Fuente:",
  "Forma de pagamento": "Método de pago",
  "Fundo:": "Fondo:",
  "Horários de pico": "Horas punta",
  "ID": "ID",
  "Inferior direito": "Inferior Derecho",
  "Intensidade:": "Intensidad:",
  "Mensagem Personalizada": "Mensaje personalizado",
  "Mensagem:": "Mensaje:",
  "Meus vídeos": "Mis Videos",
  "Mostrar Controles": "Mostrar controles",
  "Mover para...": "Mover a...",
  "Métricas:": "Métricas:",
  "Nova senha": "Nueva contraseña",
  "Número do Cartão": "Número de tarjeta",
  "O arquivo deve ter no máximo 100MB.": "El archivo debe ser de máximo 100MB.",
  "O código de incorporação foi copiado para a área de transferência": "Código de inserción copiado al portapapeles",
  "ORDENAR POR": "ORDENAR POR",
  "Original:": "Original:",
  "PITCH": "PITCH",
  "PRÉ-VISUALIZAÇÃO": "VISTA PREVIA",
  "Pasta excluída": "Carpeta eliminada",
  "País:": "País:",
  "Permissão:": "Permiso:",
  "Pitch:": "Pitch:",
  "Plataforma:": "Plataforma:",
  "Play rate": "Tasa de reproducción",
  "Playrate": "Tasa de reproducción",
  "Plays únicos:": "Reproducciones únicas:",
  "Plays:": "reproducciones:",
  "Política de privacidade": "Política de privacidad",
  "Ponto de entrada": "Punto de entrada",
  "Preview:": "Vista previa:",
  "Problemas": "problemas",
  "Progresso do teste": "Progreso de la prueba",
  "Próxima aula": "Siguiente lección",
  "REGIÕES": "REGIONES",
  "Recarregar página": "Recargar página",
  "Reprodução Automática": "Reproducción automática",
  "Retenção ao Longo do Tempo": "Retención a lo largo del tiempo",
  "Retenção média": "Retención media",
  "SALVAR": "GUARDAR",
  "SAÍDA": "SALIDA",
  "SEG": "S",
  "SEGURANÇA": "SEGURIDAD",
  "Salvando…": "Guardando…",
  "Seg": "s",
  "Selecionado:": "Seleccionado:",
  "Selecionar Vídeo *": "Seleccionar video *",
  "Selecione o vídeo": "Selecciona el video",
  "Selecione um vídeo.": "Selecciona un video.",
  "Selecione um vídeo...": "Selecciona un video...",
  "Selecione...": "Selecciona...",
  "Sucesso!": "Éxito!",
  "Sugestão Automática": "Sugerencia automática",
  "TRÁFEGO": "TRÁFICO",
  "Tablet:": "Tableta:",
  "Tamanho:": "Tamaño:",
  "Tela Cheia": "Pantalla completa",
  "Telefone": "Teléfono",
  "Tempo do vídeo": "Tiempo del Video",
  "Tempo real": "Tiempo real",
  "Tentar Novamente": "Intentar de nuevo",
  "Termos de uso": "Términos de uso",
  "Teste": "Prueba",
  "Ticket": "Importe",
  "Todas as plataformas": "Todas las plataformas",
  "Token de suporte": "Token de soporte",
  "Token:": "Token:",
  "Trocar Vídeo": "Cambiar video",
  "Tráfego:": "Tráfico:",
  "Término:": "Fin:",
  "URL de Destino": "URL de destino",
  "Usuário não encontrado.": "Usuario no encontrado.",
  "VSL alternativa": "VSL alternativa",
  "VSL protegida": "VSL PROTEGIDA",
  "Valor do Parâmetro": "Valor del parámetro",
  "Velocidade atual:": "Velocidad actual:",
  "Vencedor:": "Ganador:",
  "Ver métricas": "Ver Métricas",
  "Views:": "Visualizaciones:",
  "Visão geral": "Vista general",
  "Vídeo excluído com sucesso": "¡Video eliminado con éxito",
  "Vídeo selecionado": "video seleccionado",
  "Vídeos compartilhados": "Videos compartidos",
  "Vídeos selecionados:": "videos seleccionados:",
  "em execução": "en ejecución",
  "episódios": "episodios",
  "espectadores": "espectadores",
  "etapa": "etapa",
  "eventos": "eventos",
  "formulário": "formulario",
  "id:": "iD:",
  "média": "media",
  "nova aba": "nueva pestaña",
  "novo": "nuevo",
  "padrão": "estándar",
  "pausa": "pausa",
  "plays únicos": "reproducciones únicas",
  "rascunho": "borrador",
  "saída": "salida",
  "selecionado": "seleccionado",
  "senha": "contraseña",
  "taxa de conversão": "tasa de conversión",
  "total": "total",
  "usuário": "usuario",
  "variações:": "variaciones:",
  "visualizações únicas": "visualizaciones únicas",
  "vídeos em teste": "videos en prueba",
  "Ícone personalizado": "Icono personalizado",
  "Últimas atualizações": "Últimas actualizaciones",
  "Únicos": "únicos",
  "Copiando de:": "Copiando de:",
  "Copiando…": "Copiando…",
  "Copiar chave": "Copiar clave",
  "Copiar código de embed": "Copiar código de inserción",
  "Copiar código de incorporação": "Copiar código de inserción",
  "Copiar Código de Integração": "Copiar código de integración",
  "Copiar código de performance": "Copiar código de rendimiento",
  "Copiar código JS": "Copiar código JS",
  "Copiar código performance": "Copiar código de rendimiento",
  "Copiar cupom": "Copiar cupón",
  "Copiar dados": "Copiar datos",
  "Copiar Detalhes": "Copiar detalles",
  "Copiar e-mail": "Copiar correo electrónico",
  "Copiar Insight": "Copiar análisis",
  "Copiar para minha conta": "Copiar a mi cuenta",
  "Copiar telefone": "Copiar teléfono",
  "Copiar webhook": "Copiar webhook",
  "Cópias (7d)": "Copias (7 días)",
  "Cópias por Dia": "Copias por día",
  "Copie agora. Por segurança, não guardamos a chave — só uma impressão digital dela, que não tem volta. Esta é a única vez que a chave \"": "Cópiala ahora. Por seguridad, no guardamos la clave, solo una huella irreversible. Esta es la única vez que la clave \"",
  "Copie o código abaixo e cole onde deseja incorporar o player com o botão de ação configurado.": "Copia el código de abajo y pégalo donde quieras insertar el reproductor con el botón de acción configurado.",
  "Copie o código do teste e atualize o embed no seu site. Término: {value0}": "Copia el código de la prueba y actualiza el código insertado en tu sitio. Finalización: {value0}",
  "Cor 1": "Color 1",
  "Cor 2": "Color 2",
  "Cor ao passar o mouse": "Color al pasar el cursor",
  "Cor atual:": "Color actual:",
  "Cor Base": "Color base",
  "Cor da pergunta": "Color de la pregunta",
  "Cor de destaque": "Color destacado",
  "Cor de Destaque (botões e elementos interativos)": "Color destacado (botones y elementos interactivos)",
  "Cor de Fundo do Card": "Color de fondo de la tarjeta",
  "Cor do Header": "Color de la cabecera",
  "Cor do ícone e do texto": "Color del icono y del texto",
  "Cor do Play Grande": "Color del botón de reproducción grande",
  "Cor do Progresso": "Color del progreso",
  "Cor do Rodapé": "Color del pie de página",
  "Cor do texto no overlay": "Color del texto de la capa superpuesta",
  "Cor dos Controles": "Color de los controles",
  "Cor e espessura de cada texto. O tamanho é definido no card de Conteúdo.": "Color y grosor de cada texto. El tamaño se define en la tarjeta Contenido.",
  "Cor sólida uniforme": "Color sólido uniforme",
  "Cores do segundo botão em estado normal e ao passar o mouse.": "Colores del segundo botón en estado normal y al pasar el cursor.",
  "Cores do trilho, do preenchimento e do texto exibido sobre a barra.": "Colores del carril, del relleno y del texto mostrado sobre la barra.",
  "Cores Principais": "Colores principales",
  "Corrigir agora →": "Corregir ahora →",
  "Corrigir Problemas": "Corregir problemas",
  "Corrija e tente de novo.": "Corrígelo e inténtalo de nuevo.",
  "CPF": "CPF",
  "Cpf Cadastrado": "CPF registrado",
  "cpf:": "CPF:",
  "Crescimento de 27% nos cliques em botões de ação": "Crecimiento del 27 % en los clics en botones de acción",
  "Crescimento vs Período Anterior": "Crecimiento frente al período anterior",
  "Cria conexão emocional e aumenta a memorização do conteúdo": "Crea una conexión emocional y facilita recordar el contenido",
  "Criada em": "Creada el",
  "Criado por": "Creado por",
  "Criando cópia do vídeo na sua conta...": "Creando una copia del video en tu cuenta...",
  "Criando uma Nova Feature": "Creación de una nueva función",
  "Criar A/B": "Crear A/B",
  "Criar Ação": "Crear acción",
  "Criar Captura": "Crear captura",
  "Criar chave": "Crear clave",
  "Criar Componentes e Página": "Crear componentes y página",
  "Criar Funil": "Crear embudo",
  "Criar minha primeira proteção": "Crear mi primera protección",
  "Criar Nova Ação": "Crear nueva acción",
  "Criar nova pasta": "Crear nueva carpeta",
  "Criar Nova Playlist": "Crear nueva lista de reproducción",
  "Criar nova senha": "Crear nueva contraseña",
  "Criar novo Teste A/B": "Crear nueva prueba A/B",
  "Criar novo Teste de hook": "Crear nueva prueba de ganchos",
  "Criar Novo Vídeo": "Crear nuevo video",
  "Criar o Store (se necessário)": "Crear el almacén (si es necesario)",
  "Criar Primeira Ação": "Crear primera acción",
  "Criar primeira chave": "Crear primera clave",
  "Criar primeira pasta": "Crear primera carpeta",
  "Criar Primeira Pasta": "Crear primera carpeta",
  "Criar Primeiro Webinário": "Crear primer seminario web",
  "Criar proteção": "Crear protección",
  "Criar Proteção": "Crear protección",
  "Criar Quiz": "Crear cuestionario",
  "Criar Regra": "Crear regla",
  "Criar Regra UTM": "Crear regla UTM",
  "Criar saída": "Crear salida",
  "Criar Sites": "Crear sitios",
  "Criar Teste de Introdução": "Crear prueba de introducción",
  "Criar Teste de Introduções": "Crear prueba de introducciones",
  "Criar Teste de Velocidade": "Crear prueba de velocidad",
  "Crie capturas com e-mail ou senha, conecte integrações e acompanhe relatórios completos dos leads gerados.": "Crea capturas con correo electrónico o contraseña, conecta integraciones y consulta informes completos de los leads generados.",
  "Crie e clone sites com IA que permite personalizar e hospedar páginas web em segundos.": "Crea y clona sitios con IA que permite personalizar y alojar páginas web en segundos.",
  "Crie funis de conversão para entender como seus visitantes se comportam ao longo do vídeo.": "Crea embudos de conversión para comprender cómo se comportan tus visitantes a lo largo del video.",
  "Crie funis de vídeo em que o visitante escolhe o caminho até a compra": "Crea embudos de video donde el visitante elige el camino hasta la compra",
  "Crie funis interativos de vendas para todos os nichos.": "Crea embudos de venta interactivos para cualquier nicho.",
  "Crie jornadas interativas com botões que levam a vídeos diferentes.": "Crea recorridos interactivos con botones que llevan a distintos videos.",
  "Crie páginas de alta conversão em poucos cliques.": "Crea páginas de alta conversión en pocos clics.",
  "Crie páginas de captura em cima dos seus vídeos, colete leads e acompanhe o desempenho em tempo real.": "Crea páginas de captura sobre tus videos, recoge leads y sigue el rendimiento en tiempo real.",
  "Crie seu primeiro teste": "Crea tu primera prueba",
  "Crie seu primeiro webinário e comece a converter mais leads com experiências interativas.": "Crea tu primer seminario web y empieza a convertir más leads con experiencias interactivas.",
  "Crie seu primeiro webinário para começar a acompanhar métricas detalhadas de desempenho.": "Crea tu primer seminario web para empezar a seguir métricas detalladas de rendimiento.",
  "Crie Seu Teste de Hook": "Crea tu prueba de ganchos",
  "Crie sua Playlist": "Crea tu lista de reproducción",
  "Crie sua primeira ação para começar": "Crea tu primera acción para empezar",
  "Crie um gancho emocional": "Crea un gancho emocional",
  "Crie um teste para otimizar a velocidade do seu vídeo.": "Crea una prueba para optimizar la velocidad de tu video.",
  "Crie um título que prometa valor real e seja irresistível para seu público-alvo. Considere incluir números ou resultados específicos.": "Crea un título que prometa valor real y resulte irresistible para tu público objetivo. Considera incluir cifras o resultados concretos.",
  "Crie uma chave para conectar o Claude à sua conta e perguntar sobre as métricas dos seus vídeos por conversa.": "Crea una clave para conectar Claude con tu cuenta y preguntar por las métricas de tus videos en una conversación.",
  "Crie uma coleção organizada de vídeos": "Crea una colección organizada de videos",
  "Crie uma proteção para controlar quem pode assistir sua VSL, bloquear tráfego suspeito e redirecionar acessos inválidos para um vídeo alternativo.": "Crea una protección para controlar quién puede ver tu VSL, bloquear tráfico sospechoso y redirigir los accesos no válidos a un video alternativo.",
  "Crie uma subpasta ou adicione vídeos para organizar seu conteúdo": "Crea una subcarpeta o añade videos para organizar tu contenido",
  "Crie vídeos de entrada e saída para conduzir o espectador até a próxima ação": "Crea videos de entrada y salida para llevar al espectador a la siguiente acción",
  "Crie webinários ao vivo, simulados ou just-in-time": "Crea seminarios web en directo, simulados o bajo demanda inmediata",
  "Crítico": "Crítico",
  "CSV (.csv)": "CSV (.csv)",
  "CSV exportado com sucesso": "CSV exportado correctamente",
  "CSV exportado com sucesso!": "¡CSV exportado correctamente!",
  "CTA centralizado": "CTA centrado",
  "CTA do vídeo de entrada": "CTA del video de entrada",
  "CTA do vídeo de saída": "CTA del video de salida",
  "CTR do CTA final": "CTR del CTA final",
  "CTR Geral": "CTR general",
  "Cupom aplicado": "Cupón aplicado",
  "Cupom aplicado:": "Cupón aplicado:",
  "Cupom de desconto (opcional)": "Cupón de descuento (opcional)",
  "Cupom de desconto aplicado": "Cupón de descuento aplicado",
  "Cupom e sorteio (visual apenas no MVP)": "Cupón y sorteo (solo visual en el MVP)",
  "Cupom inválido": "Cupón no válido",
  "Cupom inválido. Corrija ou remova o cupom para continuar.": "Cupón no válido. Corrígelo o elimínalo para continuar.",
  "Cupom promocional aplicado automaticamente e não pode ser removido.": "El cupón promocional se ha aplicado automáticamente y no se puede eliminar.",
  "Curva de retenção ao longo do vídeo": "Curva de retención a lo largo del video",
  "Curva de retenção do vídeo ao longo do tempo": "Curva de retención del video a lo largo del tiempo",
  "Curva de retenção por origem de tráfego": "Curva de retención por origen del tráfico",
  "Custo atualizado com sucesso!": "¡Coste actualizado correctamente!",
  "Custo excluído!": "¡Coste eliminado!",
  "Custo médio por usuário": "Coste medio por usuario",
  "Custo Médio/Usuário": "Coste medio/usuario",
  "Custo total plataforma": "Coste total de la plataforma",
  "Custo Total Plataforma": "Coste total de la plataforma",
  "Custo Usuários": "Costes de usuarios",
  "customer id:": "ID del cliente:",
  "Custos": "Costes",
  "Custos de Infraestrutura": "Costes de infraestructura",
  "D = Desativado": "D = Desactivado",
  "da {value0}": "de {value0}",
  "da audiência ainda está assistindo (": "de la audiencia sigue viendo (",
  "da sua plataforma": "de tu plataforma",
  "Dados (": "Datos (",
  "Dados Bancários": "Datos bancarios",
  "Dados bancários inválidos na Stripe.": "Datos bancarios no válidos en Stripe.",
  "Dados cadastrais obrigatórios exigidos pela Stripe Connect.": "Datos de registro obligatorios exigidos por Stripe Connect.",
  "Dados de retenção, engajamento e conversão são coletados para cada intro.": "Se recopilan datos de retención, interacción y conversión para cada introducción.",
  "Dados do pagamento não encontrados.": "No se encontraron los datos del pago.",
  "Dados do titular": "Datos del titular",
  "Dados do vídeo não encontrados": "No se encontraron los datos del video",
  "Dados em tempo real sobre desempenho de captura para este vídeo": "Datos en tiempo real sobre el rendimiento de captura de este video",
  "Dados enviados! Sua conta está em análise temporária pela Stripe.": "¡Datos enviados! Stripe está revisando temporalmente tu cuenta.",
  "Dados Gerais": "Datos generales",
  "Dados insuficientes": "Datos insuficientes",
  "Dados para Pagamento": "Datos de pago",
  "Dados usados para validação da sua conta de recebimento.": "Datos utilizados para validar tu cuenta de cobro.",
  "Dashboard financeiro com totais, gráficos e listagem de custos AWS + despesas manuais.": "Panel financiero con totales, gráficos y listado de costes de AWS y gastos manuales.",
  "Data da próxima cobrança": "Fecha del próximo cobro",
  "Data de Captura": "Fecha de captura",
  "Data de Nascimento": "Fecha de nacimiento",
  "Data e Hora": "Fecha y hora",
  "Data e Horário": "Fecha y horario",
  "Data inicial e data final são obrigatórias": "Las fechas de inicio y fin son obligatorias",
  "Data Solicitação": "Fecha de solicitud",
  "DDD": "Prefijo telefónico",
  "De até 20% do valor do plano de assinatura do indicado.": "Hasta el 20 % del importe del plan de suscripción del referido.",
  "de Conteúdo": "de contenido",
  "De quem viu as opções": "De quienes vieron las opciones",
  "De R$": "De R$",
  "de retenção": "de retención",
  "Dê um nome para o seu teste de introduções. Escolha um nome descritivo que ajude você a identificar este teste no futuro.": "Pon un nombre a tu prueba de introducciones. Elige un nombre descriptivo que te ayude a identificar esta prueba en el futuro.",
  "Dê um nome que lembre onde a chave vai ser usada. É por ele que você vai saber qual revogar quando tiver mais de uma.": "Elige un nombre que recuerde dónde se utilizará la clave. Te servirá para saber cuál revocar cuando tengas más de una.",
  "Defina a capa ideal para seu vídeo.": "Define la portada ideal para tu video.",
  "Defina a data, duração e fuso. Nós cuidamos do resto.": "Define la fecha, la duración y la zona horaria. Nosotros nos encargamos del resto.",
  "Defina a porcentagem de tráfego que cada intro receberá no teste.": "Define el porcentaje de tráfico que recibirá cada introducción en la prueba.",
  "Defina a porcentagem de tráfego que cada vídeo receberá no teste.": "Define el porcentaje de tráfico que recibirá cada video en la prueba.",
  "Defina a senha que liberará o acesso ao vídeo": "Define la contraseña que dará acceso al video",
  "Defina as cores do botão e do texto em estado normal e ao passar o mouse.": "Define los colores del botón y del texto en estado normal y al pasar el cursor.",
  "Defina como o tráfego será distribuído entre as introduções. O total deve ser exatamente 100%.": "Define cómo se distribuirá el tráfico entre las introducciones. El total debe ser exactamente el 100 %.",
  "Defina como o tráfego será distribuído entre os vídeos selecionados. O total deve ser exatamente 100%.": "Define cómo se distribuirá el tráfico entre los videos seleccionados. El total debe ser exactamente el 100 %.",
  "Defina como os campos são exibidos no player": "Define cómo se muestran los campos en el reproductor",
  "Defina imagens estratégicas para reforçar atenção, retenção e conversão em momentos específicos do vídeo.": "Define imágenes estratégicas para reforzar la atención, la retención y la conversión en momentos concretos del video.",
  "Defina o comportamento do player por aparelho.": "Define el comportamiento del reproductor por dispositivo.",
  "Defina o momento e o comportamento que será executado no vídeo": "Define el momento y el comportamiento que se ejecutará en el video",
  "Defina o momento em que a oferta aparece no vídeo. Cada vídeo pode ter até": "Define el momento en que aparece la oferta en el video. Cada video puede tener hasta",
  "Defina o momento exato onde sua oferta principal aparece no vídeo": "Define el momento exacto en que aparece tu oferta principal en el video",
  "Defina o que acontece quando o espectador envia o feedback.": "Define qué ocurre cuando el espectador envía sus comentarios.",
  "Defina o ritmo de alteração da audiência para deixar a simulação mais natural.": "Define el ritmo de cambio de la audiencia para que la simulación sea más natural.",
  "Defina o tempo que o formulário será exibido durante o vídeo. O vídeo será pausado neste momento até que o formulário seja preenchido.": "Define cuándo aparecerá el formulario durante el video. El video se pausará en ese momento hasta que se complete el formulario.",
  "Defina o vídeo Principal": "Define el video principal",
  "Defina onde esta regra será aplicada": "Define dónde se aplicará esta regla",
  "Defina quando a oferta será exibida": "Define cuándo se mostrará la oferta",
  "Defina quando e como as sessões acontecem": "Define cuándo y cómo se celebran las sesiones",
  "Defina quando o formulário deve aparecer (formato min:seg)": "Define cuándo debe aparecer el formulario (formato min:s)",
  "Defina quando o teste deve encerrar": "Define cuándo debe finalizar la prueba",
  "Defina título e identificação da oferta": "Define el título y la identificación de la oferta",
  "Defina um percentual exclusivo para este seller. Deixe vazio para usar a comissão padrão global.": "Define un porcentaje exclusivo para este vendedor. Déjalo vacío para usar la comisión global predeterminada.",
  "Defina um valor em \"Base\" para exibir um contador numérico junto com a mensagem.": "Define un valor en \"Base\" para mostrar un contador numérico junto al mensaje.",
  "Defina uma data limite para o link funcionar": "Define una fecha límite de funcionamiento del enlace",
  "Defina uma data para encerrar o teste automaticamente.": "Define una fecha para finalizar la prueba automáticamente.",
  "Defina uma data para encerrar o teste e selecionar a melhor velocidade.": "Define una fecha para finalizar la prueba y seleccionar la mejor velocidad.",
  "Defina uma velocidade fixa ou rode um teste automático para descobrir a melhor.": "Define una velocidad fija o ejecuta una prueba automática para descubrir la mejor.",
  "Define o horário de referência para a sessão": "Define la hora de referencia de la sesión",
  "Define quando o formulário de senha será exibido durante o vídeo": "Define cuándo se mostrará el formulario de contraseña durante el video",
  "Definição do Vídeo Base": "Definición del video base",
  "Definir como atual": "Definir como actual",
  "Definir como cartão padrão": "Definir como tarjeta predeterminada",
  "Definir como início": "Definir como inicio",
  "Definir como padrão/principal": "Definir como predeterminado/principal",
  "Definir como principal": "Definir como principal",
  "Definir pitch": "Definir oferta",
  "Definir trecho do autoplay": "Definir fragmento de reproducción automática",
  "Deixe vazio para exibir apenas a mensagem, sem contador numérico.": "Déjalo vacío para mostrar solo el mensaje, sin contador numérico.",
  "Deixe vazio para infinito": "Déjalo vacío para que sea infinito",
  "Deixe vazio para usar o nome da playlist": "Déjalo vacío para usar el nombre de la lista de reproducción",
  "Delay Adicional (ms)": "Retraso adicional (ms)",
  "demais origens": "otros orígenes",
  "Demo: Modal de Incorporação": "Demostración: diálogo de inserción",
  "Demonstração do dashboard Host VSL": "Demostración del panel de Host VSL",
  "Dentro do formulário": "Dentro del formulario",
  "Depoimento de Cliente": "Testimonio de cliente",
  "Depois": "Después",
  "Depois do principal": "Después del principal",
  "Depois você envia os vídeos e monta as etapas no editor.": "Después podrás enviar los videos y montar las etapas en el editor.",
  "Deram play": "Reprodujeron",
  "Desativada": "Desactivada",
  "Desativadas": "Desactivadas",
  "Desativar captura": "Desactivar captura",
  "Desativar CTA": "Desactivar CTA",
  "Desativar recorrência": "Desactivar recurrencia",
  "Desative para pausar a ação sem removê-la": "Desactívalo para pausar la acción sin eliminarla",
  "Desbloquear": "Desbloquear",
  "Descer opção {value0}": "Bajar opción {value0}",
  "Desconectar": "Desconectar",
  "Desconhecido": "Desconocido",
  "Desconto": "Descuento",
  "Desconto Exclusivo para Seus Clientes": "Descuento exclusivo para tus clientes",
  "Descreva o objetivo deste teste...": "Describe el objetivo de esta prueba...",
  "Descreva o problema que você encontrou com este compartilhamento.": "Describe el problema que has encontrado con este enlace compartido.",
  "Descreva o problema...": "Describe el problema...",
  "Descrição / Rodapé": "Descripción / Pie de página",
  "Descrição da aula será exibida aqui. Esta é uma descrição de exemplo para demonstrar o layout do modal.": "La descripción de la lección aparecerá aquí. Esta descripción de ejemplo muestra el diseño del diálogo.",
  "Descrição da Playlist": "Descripción de la lista de reproducción",
  "Descrição da Transação": "Descripción de la transacción",
  "Descrição do Episódio": "Descripción del episodio",
  "Descubra os criativos e ofertas mais escaladas no META": "Descubre las creatividades y ofertas con mayor crecimiento en META",
  "Descubra os melhores horários para publicar seus vídeos com o novo recurso de Picos de Horários. Analise dados de performance por dia da semana e faixa horária para otimizar suas campanhas.": "Descubre las mejores horas para publicar tus videos con la nueva función de horas punta. Analiza el rendimiento por día de la semana y franja horaria para optimizar tus campañas.",
  "Descubra quais introduções engajam melhor sua audiência": "Descubre qué introducciones generan más interacción con tu audiencia",
  "Descubra qual performa melhor": "Descubre cuál rinde mejor",
  "Desde": "Desde",
  "Desempenho consolidado por plataforma de pagamento": "Rendimiento consolidado por plataforma de pago",
  "Desempenho do Seu Teste A/B": "Rendimiento de tu prueba A/B",
  "Desempenho do Seu Teste de Introduções": "Rendimiento de tu prueba de introducciones",
  "Desempenho do vídeo exibido antes do principal.": "Rendimiento del video mostrado antes del principal.",
  "Desempenho do vídeo exibido depois do principal.": "Rendimiento del video mostrado después del principal.",
  "Desempenho financeiro das suas VSLs": "Rendimiento financiero de tus VSL",
  "Desfazer": "Deshacer",
  "Desmarcar": "Desmarcar",
  "Desmarcar todas": "Desmarcar todas",
  "Desperte curiosidade nos primeiros segundos": "Despierta curiosidad en los primeros segundos",
  "Despesa cadastrada com sucesso!": "¡Gasto registrado correctamente!",
  "Despesa recorrente": "Gasto recurrente",
  "Despesas Manuais": "Gastos manuales",
  "Destaque o player com uma borda elegante sem pesar no visual.": "Destaca el reproductor con un borde elegante sin recargar el diseño.",
  "Destaque pontos de decisão": "Destaca los puntos de decisión",
  "Destaque sutil do overlay": "Realce sutil de la capa superpuesta",
  "Destaques de Performance": "Datos destacados de rendimiento",
  "Destino": "Destino",
  "Destino da opção {value0}": "Destino de la opción {value0}",
  "Destino URL": "URL de destino",
  "Detalhamento de Custos": "Desglose de costes",
  "Detalhamento de visualizações por navegador e sistema operacional.": "Desglose de visualizaciones por navegador y sistema operativo.",
  "Detalhamento por Fonte": "Desglose por fuente",
  "Detalhar por dispositivo": "Desglosar por dispositivo",
  "Detalhes da": "Detalles de la",
  "Detalhes da Estratégia": "Detalles de la estrategia",
  "Detalhes da integração": "Detalles de la integración",
  "Detalhes da referência": "Detalles de la referencia",
  "Detalhes da solicitação enviada pelo afiliado.": "Detalles de la solicitud enviada por el afiliado.",
  "Detalhes de {value0}": "Detalles de {value0}",
  "Detalhes de Conversões": "Detalles de conversiones",
  "Detalhes de Receita": "Detalles de ingresos",
  "Detalhes de Taxa de Conversão": "Detalles de la tasa de conversión",
  "Detalhes de Ticket Médio": "Detalles del importe medio",
  "Detalhes do erro (aberto por padrão)": "Detalles del error (abiertos de forma predeterminada)",
  "Detalhes do erro copiados para a área de transferência!": "¡Detalles del error copiados al portapapeles!",
  "Detalhes do feedback": "Detalles de los comentarios",
  "Detalhes do Pagamento": "Detalles del pago",
  "Detalhes do Ponto": "Detalles del punto",
  "Detalhes do Usuário": "Detalles del usuario",
  "Detalhes por Cidade": "Detalles por ciudad",
  "Detalhes por Dispositivo": "Detalles por dispositivo",
  "Detalhes por Estado": "Detalles por estado",
  "Detalhes por Navegador": "Detalles por navegador",
  "Detalhes por País": "Detalles por país",
  "Detalhes técnicos": "Detalles técnicos",
  "Detalhes Técnicos": "Detalles técnicos",
  "Detectado automaticamente": "Detectado automáticamente",
  "Detectar Interação": "Detectar interacción",
  "Deutsch": "Deutsch",
  "Deve ter no máximo 100 caracteres": "Debe tener como máximo 100 caracteres",
  "Dia Campeão": "Día ganador",
  "Dia da semana com melhor desempenho": "Día de la semana con mejor rendimiento",
  "Diagonal (↘)": "Diagonal (↘)",
  "Diagrama de Fluxo": "Diagrama de flujo",
  "Diário": "Diario",
  "Dias da semana": "Días de la semana",
  "dias restantes": "días restantes",
  "Dica de Melhoria": "Consejo de mejora",
  "Dica: Amplie o período no calendário.": "Consejo: amplía el período en el calendario.",
  "Dicas de Otimização": "Consejos de optimización",
  "Diferença": "Diferencia",
  "Diferença Percentual:": "Diferencia porcentual:",
  "Diferença Significativa:": "Diferencia significativa:",
  "Dificulte cópias do seu conteúdo e proteja sua propriedade intelectual.": "Dificulta las copias de tu contenido y protege tu propiedad intelectual.",
  "Digite": "Introduce",
  "Digite a mensagem que será exibida ao usuário bloqueado": "Introduce el mensaje que verá el usuario bloqueado",
  "Digite a senha para acessar o vídeo": "Introduce la contraseña para acceder al video",
  "Digite apenas números. Ex: 130 = 01:30": "Introduce solo números. Ej.: 130 = 01:30",
  "Digite as informações do cartão.": "Introduce los datos de la tarjeta.",
  "Digite o e-mail": "Introduce el correo electrónico",
  "Digite o e-mail completo": "Introduce el correo electrónico completo",
  "Digite o e-mail completo do usuário": "Introduce el correo electrónico completo del usuario",
  "Digite o ID do pixel": "Introduce el ID del píxel",
  "Digite o nome completo": "Introduce el nombre completo",
  "Digite o nome da sua playlist": "Introduce el nombre de tu lista de reproducción",
  "Digite o novo nome do vídeo": "Introduce el nuevo nombre del video",
  "Digite o subtítulo": "Introduce el subtítulo",
  "Digite o tempo no formato mm:ss (ex: 01:30 para 1 minuto e 30 segundos)": "Introduce el tiempo en formato mm:ss (ej.: 01:30 para 1 minuto y 30 segundos)",
  "Digite o título do vídeo": "Introduce el título del video",
  "Digite seu token...": "Introduce tu token...",
  "Digite sua nova senha para concluir a recuperação de acesso.": "Introduce tu nueva contraseña para completar la recuperación del acceso.",
  "Digite um nome para a pasta": "Introduce un nombre para la carpeta",
  "Digite um nome para identificar sua playlist": "Introduce un nombre para identificar tu lista de reproducción",
  "Digite uma expressão regular válida": "Introduce una expresión regular válida",
  "Digite uma URL válida": "Introduce una URL válida",
  "Diminuir valor": "Reducir valor",
  "Direção": "Dirección",
  "Disponível para saque": "Disponible para retirar",
  "Dispositivo": "Dispositivo",
  "Dispositivo principal": "Dispositivo principal",
  "Dispositivo:": "Dispositivo:",
  "Dispositivos & Navegadores": "Dispositivos y navegadores",
  "Dispositivos & Origem": "Dispositivos y origen",
  "Dispositivos permitidos": "Dispositivos permitidos",
  "Distribua promessas de valor ao longo do vídeo: 'Em breve vou mostrar como...', 'No próximo ponto você vai descobrir...'": "Distribuye promesas de valor a lo largo del video: 'Pronto te mostraré cómo...', 'En el próximo punto descubrirás...'",
  "Distribuição": "Distribución",
  "Distribuição das avaliações": "Distribución de valoraciones",
  "Distribuição de acessos": "Distribución de accesos",
  "Distribuição de tráfego atualizada!": "¡Distribución del tráfico actualizada!",
  "Distribuição de visualizações e engajamento por dispositivo.": "Distribución de visualizaciones e interacción por dispositivo.",
  "Distribuição de visualizações e engajamento por origem do tráfego.": "Distribución de visualizaciones e interacción por origen del tráfico.",
  "Distribuição inválida: {value0}% (deve somar 100%)": "Distribución no válida: {value0}% (debe sumar el 100 %)",
  "Distribuição por Categoria": "Distribución por categoría",
  "Distribuição por Cidades": "Distribución por ciudades",
  "Distribuição por Dia da Semana": "Distribución por día de la semana",
  "Distribuição por Dispositivo": "Distribución por dispositivo",
  "Distribuição por Dispositivos": "Distribución por dispositivos",
  "Distribuição por Estados": "Distribución por estados",
  "Distribuição por Fonte": "Distribución por fuente",
  "Distribuição por fonte de tráfego": "Distribución por fuente de tráfico",
  "Distribuição por Navegadores": "Distribución por navegadores",
  "Distribuição por Países": "Distribución por países",
  "Distribuição por Tipo": "Distribución por tipo",
  "Distribuição por tipo de dispositivo": "Distribución por tipo de dispositivo",
  "Distribuição proporcional dos custos de infraestrutura por usuário com base em métricas de consumo (retenção, plays, vídeos).": "Distribución proporcional de los costes de infraestructura por usuario según las métricas de consumo (retención, reproducciones y videos).",
  "Distribuição válida: 100%": "Distribución válida: 100 %",
  "do seu tráfego vem de dispositivos móveis.": "de tu tráfico procede de dispositivos móviles.",
  "do vídeo": "del video",
  "do vídeo.": "del video.",
  "Document indisponível (SSR?)": "Document no disponible (¿SSR?)",
  "Documentação enviada e associada com sucesso para análise!": "¡Documentación enviada y asociada correctamente para su revisión!",
  "Documentação Homologada": "Documentación aprobada",
  "Documentação HostVSL": "Documentación de HostVSL",
  "Documento fiscal oficial emitido pelo processador bancário.": "Documento fiscal oficial emitido por el procesador bancario.",
  "Dom": "Dom",
  "DOM": "DOM",
  "domínio": "dominio",
  "Domínio adicionado com sucesso": "Dominio añadido correctamente",
  "Domínio atualizado com sucesso": "Dominio actualizado correctamente",
  "Domínio exato": "Dominio exacto",
  "Domínio removido com sucesso": "Dominio eliminado correctamente",
  "dominio.com": "dominio.com",
  "Domínios cadastrados": "Dominios registrados",
  "dos seus usuários usam": "de tus usuarios utilizan",
  "Download CSV": "Descargar CSV",
  "Download iniciado": "Descarga iniciada",
  "Download iniciado com sucesso": "Descarga iniciada correctamente",
  "Drop no final pode apontar problema na oferta ou no CTA.": "Una caída al final puede indicar un problema con la oferta o el CTA.",
  "Duplicando…": "Duplicando…",
  "Duplicar pasta": "Duplicar carpeta",
  "Duração (minutos)": "Duración (minutos)",
  "Duração total do vídeo. Vídeos mais curtos geralmente têm maior taxa de visualização completa.": "Duración total del video. Los videos más cortos suelen tener una mayor tasa de visualización completa.",
  "Duration must be at least 1 second": "La duración debe ser de al menos 1 segundo",
  "Duration too long": "Duración demasiado larga",
  "e as métricas dele. O código colado nos sites para de funcionar. Não dá para desfazer.": "y sus métricas. El código insertado en los sitios dejará de funcionar. No se puede deshacer.",
  "e congela a tela. O espectador não pode pular nem voltar, apenas clicar no botão para seguir.": "y congela la pantalla. El espectador no puede saltar ni retroceder, solo hacer clic en el botón para continuar.",
  "é igual a": "es igual a",
  "É necessário definir uma senha.": "Debes definir una contraseña.",
  "É necessário selecionar um vídeo.": "Debes seleccionar un video.",
  "É necessário ter pelo menos 2 variações para criar um teste A/B": "Se necesitan al menos 2 variaciones para crear una prueba A/B",
  "e Negócios": "y negocios",
  "e Parceiros": "y socios",
  "E-mail Cadastrado": "Correo electrónico registrado",
  "E-mail copiado!": "¡Correo electrónico copiado!",
  "E-mail Corporativo ou Pessoal": "Correo electrónico profesional o personal",
  "E-mail da Conta PayPal": "Correo electrónico de la cuenta PayPal",
  "E-mail do cliente": "Correo electrónico del cliente",
  "E-mail muito longo": "Correo electrónico demasiado largo",
  "E-mail PayPal cadastrado": "Correo electrónico de PayPal registrado",
  "E-mail vinculado ao registro": "Correo electrónico vinculado al registro",
  "Economia de tempo significativa comparado a criar múltiplas páginas de teste": "Ahorro de tiempo considerable frente a crear varias páginas de prueba",
  "Edge": "Edge",
  "Edição": "Edición",
  "Edição dinâmica": "Edición dinámica",
  "Editar {value0}": "Editar {value0}",
  "Editar Ação": "Editar acción",
  "Editar captura": "Editar captura",
  "Editar clicks": "Editar clics",
  "Editar Clicks": "Editar clics",
  "Editar Clicks —": "Editar clics —",
  "Editar Custo": "Editar coste",
  "Editar Distribuição de Tráfego": "Editar distribución del tráfico",
  "Editar domínio": "Editar dominio",
  "Editar fluxo": "Editar flujo",
  "Editar informações do vídeo": "Editar información del video",
  "Editar Membro": "Editar miembro",
  "Editar membro {value0}": "Editar miembro {value0}",
  "Editar pagamento": "Editar pago",
  "Editar País": "Editar país",
  "Editar Permissão": "Editar permiso",
  "Editar Pixel": "Editar píxel",
  "Editar Playlist": "Editar lista de reproducción",
  "Editar proteção": "Editar protección",
  "Editar Região": "Editar región",
  "Editar término do teste": "Editar finalización de la prueba",
  "Editar tráfego": "Editar tráfico",
  "Editar valor": "Editar valor",
  "Editar Variação": "Editar variación",
  "Editar Variação de Headline": "Editar variación de titular",
  "Editar vídeo": "Editar video",
  "EditorServicesContext ausente": "Falta EditorServicesContext",
  "EditorStoreContext ausente": "Falta EditorStoreContext",
  "Efeitos e Recursos": "Efectos y funciones",
  "Ele perderá acesso imediatamente.": "Perderá el acceso inmediatamente.",
  "Ele pode ter sido excluído.": "Es posible que se haya eliminado.",
  "Elementos extras para aumentar conversão": "Elementos adicionales para aumentar la conversión",
  "Em {value0} {value1}": "En {value0} {value1}",
  "Em aberto": "Pendiente",
  "Em Análise": "En revisión",
  "Em Análise Preventiva": "En revisión preventiva",
  "Em andamento": "En curso",
  "Em breve novos parceiros estarão disponíveis.": "Pronto habrá nuevos socios disponibles.",
  "Em criação": "En creación",
  "em rascunho": "en borrador",
  "em receita": "en ingresos",
  "Em tempo personalizado": "En un momento personalizado",
  "em todas as variações, evitando diferenças no tamanho do player.": "en todas las variaciones, evitando diferencias de tamaño del reproductor.",
  "em todos os planos": "en todos los planes",
  "Em uso": "En uso",
  "em vendas": "en ventas",
  "Embaixo": "Abajo",
  "Embed": "Código de inserción",
  "Embed para Performance": "Código de inserción para rendimiento",
  "Emojis": "Emojis",
  "Empresa {value0} não encontrada no sistema.": "No se encontró la empresa {value0} en el sistema.",
  "Empresa muito longa": "Nombre de empresa demasiado largo",
  "Encerra o teste e deleta a configuração de A/B test.": "Finaliza la prueba y elimina la configuración de la prueba A/B.",
  "Encerrado": "Finalizado",
  "Encerrando...": "Finalizando...",
  "Encurte os primeiros 30 segundos e vá direto ao ponto. Elimine qualquer informação que não seja absolutamente essencial.": "Acorta los primeros 30 segundos y ve al grano. Elimina cualquier información que no sea imprescindible.",
  "Endereço Residencial": "Domicilio",
  "Engajamento ao Longo do Tempo": "Interacción a lo largo del tiempo",
  "Engajamento Médio": "Interacción media",
  "Entenda como funcionam os plays extras do seu plano e como utilizá-los a seu favor.": "Comprende cómo funcionan las reproducciones extra de tu plan y cómo aprovecharlas.",
  "Entenda como sua audiência acessa seu conteúdo": "Comprende cómo accede tu audiencia a tu contenido",
  "Entenda onde seu funil converte, onde perde leads e o impacto em cada campanha.": "Comprende dónde convierte tu embudo, dónde pierde leads y el impacto en cada campaña.",
  "Entenda os indicadores que importam e tome decisões baseadas em dados.": "Comprende los indicadores que importan y toma decisiones basadas en datos.",
  "Entenda qual VSL performa melhor com base em métricas claras.": "Descubre qué VSL rinde mejor con métricas claras.",
  "Entendi, vamos começar!": "¡Entendido, empecemos!",
  "Entrada direta na sala": "Entrada directa a la sala",
  "Entradas": "Entradas",
  "Entrar como suporte": "Entrar como soporte",
  "Entre 15 e 480 minutos": "Entre 15 y 480 minutos",
  "Entre em contato com nosso time e torne-se um parceiro Host VSL hoje mesmo!": "¡Contacta con nuestro equipo y conviértete hoy mismo en socio de Host VSL!",
  "Enviado": "Enviado",
  "Enviamos um código de 4 dígitos para seu e-mail. Digite-o abaixo para continuar.": "Hemos enviado un código de 4 dígitos a tu correo electrónico. Introdúcelo abajo para continuar.",
  "Enviando ·": "Enviando ·",
  "Enviando Arquivos e Homologando...": "Enviando archivos y verificando...",
  "Enviando frente do documento para a Stripe...": "Enviando el anverso del documento a Stripe...",
  "Enviando para o servidor...": "Enviando al servidor...",
  "Enviando seu vídeo...": "Enviando tu video...",
  "Enviando verso do documento para a Stripe...": "Enviando el reverso del documento a Stripe...",
  "Enviar código": "Enviar código",
  "Enviar comprovante": "Enviar justificante",
  "Enviar Convite": "Enviar invitación",
  "Enviar Documento de Identidade para Validação": "Enviar documento de identidad para validación",
  "Enviar e entrar na sala": "Enviar y entrar en la sala",
  "Enviar e ir para página de obrigado": "Enviar e ir a la página de agradecimiento",
  "Enviar feedback": "Enviar comentarios",
  "Enviar Imagem/GIF": "Enviar imagen/GIF",
  "Enviar Logo (220x60)": "Enviar logotipo (220×60)",
  "Enviar mensagem automática quando a oferta abrir": "Enviar mensaje automático cuando se abra la oferta",
  "Enviar meu primeiro vídeo": "Enviar mi primer video",
  "Enviar Notificação Teste": "Enviar notificación de prueba",
  "Enviar novo vídeo": "Enviar nuevo video",
  "Enviar vídeos": "Enviar videos",
  "Envie acessos bloqueados para um vídeo alternativo, URL segura ou mensagem personalizada.": "Redirige los accesos bloqueados a un video alternativo, una URL segura o un mensaje personalizado.",
  "Envie o favicon": "Envía el favicon",
  "Envie ou consulte o comprovante deste pagamento.": "Envía o consulta el justificante de este pago.",
  "Envie seu primeiro vídeo ou ative o rastreamento para ver seu desempenho.": "Envía tu primer video o activa el seguimiento para ver su rendimiento.",
  "Envie seu primeiro vídeo para começar a acompanhar a performance.": "Envía tu primer video para empezar a seguir el rendimiento.",
  "Envie seu primeiro vídeo para ver o engajamento.": "Envía tu primer video para ver la interacción.",
  "Envie sua logo": "Envía tu logotipo",
  "Envie um vídeo para ver a saúde do seu pitch.": "Envía un video para ver el estado de tu oferta.",
  "Envie uma imagem ou GIF para seu autoplay": "Envía una imagen o un GIF para tu reproducción automática",
  "Envie uma imagem para substituir o vídeo.": "Envía una imagen para sustituir el video.",
  "Envie uma imagem válida do comprovante.": "Envía una imagen válida del justificante.",
  "Envie vídeos do seu computador com upload rápido e seguro.": "Envía videos desde tu ordenador con una subida rápida y segura.",
  "Episode {value0}": "Episodio {value0}",
  "Episódio {value0}": "Episodio {value0}",
  "Episódios (": "Episodios (",
  "episódios •": "episodios •",
  "Erro ao adicionar pixel": "Error al añadir el píxel",
  "Erro ao adicionar pixel!": "¡Error al añadir el píxel!",
  "Erro ao adicionar vídeos": "Error al añadir videos",
  "Erro ao alterar plano.": "Error al cambiar el plan.",
  "Erro ao alterar senha": "Error al cambiar la contraseña",
  "Erro ao alterar senha.": "Error al cambiar la contraseña.",
  "Erro ao alterar senha. Tente novamente.": "Error al cambiar la contraseña. Inténtalo de nuevo.",
  "Erro ao alterar status": "Error al cambiar el estado",
  "Erro ao alterar status do link": "Error al cambiar el estado del enlace",
  "Erro ao aplicar alterações": "Error al aplicar los cambios",
  "Erro ao aplicar cupom": "Error al aplicar el cupón",
  "Erro ao ativar oferta": "Error al activar la oferta",
  "Erro ao ativar teste A/B": "Error al activar la prueba A/B",
  "Erro ao atualizar assinatura": "Error al actualizar la suscripción",
  "Erro ao atualizar cliques.": "Error al actualizar los clics.",
  "Erro ao atualizar comissão do seller.": "Error al actualizar la comisión del vendedor.",
  "Erro ao atualizar nível.": "Error al actualizar el nivel.",
  "Erro ao atualizar os dados cadastrais.": "Error al actualizar los datos de registro.",
  "Erro ao atualizar pagamento.": "Error al actualizar el pago.",
  "Erro ao atualizar permissões. Tente novamente.": "Error al actualizar los permisos. Inténtalo de nuevo.",
  "Erro ao atualizar pixel": "Error al actualizar el píxel",
  "Erro ao atualizar status.": "Error al actualizar el estado.",
  "Erro ao atualizar título": "Error al actualizar el título",
  "Erro ao atualizar tráfego": "Error al actualizar el tráfico",
  "Erro ao baixar o vídeo": "Error al descargar el video",
  "Erro ao baixar o vídeo. Tente novamente.": "Error al descargar el video. Inténtalo de nuevo.",
  "Erro ao buscar cartões": "Error al buscar las tarjetas",
  "Erro ao buscar compartilhamentos": "Error al buscar los enlaces compartidos",
  "Erro ao buscar informações do pagamento.": "Error al buscar la información del pago.",
  "Erro ao buscar métricas do teste": "Error al buscar las métricas de la prueba",
  "Erro ao buscar o vídeo": "Error al buscar el video",
  "Erro ao buscar pixels": "Error al buscar los píxeles",
  "Erro ao buscar registro.": "Error al buscar el registro.",
  "Erro ao buscar testes de velocidade": "Error al buscar las pruebas de velocidad",
  "Erro ao buscar usuário.": "Error al buscar el usuario.",
  "Erro ao buscar vídeos": "Error al buscar los videos",
  "Erro ao cancelar assinatura.": "Error al cancelar la suscripción.",
  "Erro ao carregar compartilhamentos": "Error al cargar los enlaces compartidos",
  "Erro ao carregar dados da rede.": "Error al cargar los datos de la red.",
  "Erro ao carregar detalhes do usuário.": "Error al cargar los detalles del usuario.",
  "Erro ao carregar imagem": "Error al cargar la imagen",
  "Erro ao carregar membros.": "Error al cargar los miembros.",
  "Erro ao carregar metadados do vídeo": "Error al cargar los metadatos del video",
  "Erro ao carregar métodos de pagamento.": "Error al cargar los métodos de pago.",
  "Erro ao carregar métricas": "Error al cargar las métricas",
  "Erro ao carregar métricas:": "Error al cargar las métricas:",
  "Erro ao carregar relatório de custos por usuário.": "Error al cargar el informe de costes por usuario.",
  "Erro ao carregar seu extrato de comissões.": "Error al cargar tu extracto de comisiones.",
  "Erro ao carregar testes:": "Error al cargar las pruebas:",
  "Erro ao carregar vídeos com captura de leads": "Error al cargar los videos con captura de leads",
  "Erro ao coletar balanço de auditoria.": "Error al recopilar el balance de auditoría.",
  "Erro ao compartilhar vídeo": "Error al compartir el video",
  "Erro ao consolidar resumo de métricas.": "Error al consolidar el resumen de métricas.",
  "Erro ao criar assinatura": "Error al crear la suscripción",
  "Erro ao criar integração": "Error al crear la integración",
  "Erro ao criar link": "Error al crear el enlace",
  "Erro ao criar link de compartilhamento": "Error al crear el enlace compartido",
  "Erro ao criar proteção": "Error al crear la protección",
  "Erro ao criar registro.": "Error al crear el registro.",
  "Erro ao criar teste A/B": "Error al crear la prueba A/B",
  "Erro ao criar teste automático": "Error al crear la prueba automática",
  "Erro ao criar teste de velocidade": "Error al crear la prueba de velocidad",
  "Erro ao definir conta como principal.": "Error al definir la cuenta como principal.",
  "Erro ao definir método como padrão.": "Error al definir el método como predeterminado.",
  "Erro ao deletar método de pagamento.": "Error al eliminar el método de pago.",
  "Erro ao deletar pixel": "Error al eliminar el píxel",
  "Erro ao deletar teste de velocidade": "Error al eliminar la prueba de velocidad",
  "Erro ao desativar recorrência.": "Error al desactivar la recurrencia.",
  "Erro ao enviar código de recuperação.": "Error al enviar el código de recuperación.",
  "Erro ao enviar código de recuperação. Tente novamente.": "Error al enviar el código de recuperación. Inténtalo de nuevo.",
  "Erro ao enviar convite. Tente novamente.": "Error al enviar la invitación. Inténtalo de nuevo.",
  "Erro ao enviar legenda.": "Error al enviar los subtítulos.",
  "Erro ao excluir compartilhamento": "Error al eliminar el enlace compartido",
  "Erro ao excluir pasta": "Error al eliminar la carpeta",
  "Erro ao excluir registro.": "Error al eliminar el registro.",
  "Erro ao exportar dados": "Error al exportar los datos",
  "Erro ao finalizar teste": "Error al finalizar la prueba",
  "Erro ao gerar PDF. Tente novamente.": "Error al generar el PDF. Inténtalo de nuevo.",
  "Erro ao gerar thumbnail": "Error al generar la miniatura",
  "Erro ao importar": "Error al importar",
  "Erro ao limpar cache": "Error al borrar la caché",
  "Erro ao obter URL de download": "Error al obtener la URL de descarga",
  "Erro ao processar compartilhamento": "Error al procesar el enlace compartido",
  "Erro ao processar compra": "Error al procesar la compra",
  "Erro ao reenviar código.": "Error al reenviar el código.",
  "Erro ao reenviar código. Tente novamente.": "Error al reenviar el código. Inténtalo de nuevo.",
  "Erro ao remover legenda.": "Error al eliminar los subtítulos.",
  "Erro ao remover logo": "Error al eliminar el logotipo",
  "Erro ao remover thumbnail": "Error al eliminar la miniatura",
  "Erro ao salvar custo.": "Error al guardar el coste.",
  "Erro ao salvar método de pagamento.": "Error al guardar el método de pago.",
  "Erro ao salvar velocidade manual": "Error al guardar la velocidad manual",
  "Erro ao selecionar todos os vídeos": "Error al seleccionar todos los videos",
  "Erro ao selecionar vídeo do teste": "Error al seleccionar el video de la prueba",
  "Erro ao sincronizar com AWS.": "Error al sincronizar con AWS.",
  "Erro ao validar código. Tente novamente.": "Error al validar el código. Inténtalo de nuevo.",
  "Erro de validação": "Error de validación",
  "Erro inesperado ao ativar oferta": "Error inesperado al activar la oferta",
  "Erro inesperado ao cancelar assinatura.": "Error inesperado al cancelar la suscripción.",
  "Erro inesperado ao processar compra": "Error inesperado al procesar la compra",
  "Erro interno no servidor ao salvar conta.": "Error interno del servidor al guardar la cuenta.",
  "Erro no Módulo Headline": "Error en el módulo de titulares",
  "Erro no upload": "Error en la subida",
  "Erro: Suba novamente o vídeo": "Error: vuelve a subir el video",
  "Erros de Reprodução": "Errores de reproducción",
  "Esc": "Esc",
  "Escolha a etapa inicial do fluxo para pré-visualizar.": "Elige la etapa inicial del flujo para ver la vista previa.",
  "Escolha a origem dos vídeos para começar.": "Elige el origen de los videos para empezar.",
  "Escolha ao menos uma origem de tráfego para comparar as curvas de retenção.": "Elige al menos un origen de tráfico para comparar las curvas de retención.",
  "Escolha como deseja capturar os dados antes do usuário acessar seu vídeo.": "Elige cómo quieres captar los datos antes de que el usuario acceda al video.",
  "Escolha como o formulário será exibido sobre o vídeo": "Elige cómo aparecerá el formulario sobre el video",
  "Escolha como o player será exibido neste dispositivo.": "Elige cómo se mostrará el reproductor en este dispositivo.",
  "Escolha entre bloquear ou liberar seus vídeos em países e regiões específicas. Esta proteção ajuda a controlar onde seu conteúdo será disponibilizado.": "Elige entre bloquear o permitir tus videos en países y regiones concretos. Esta protección ayuda a controlar dónde estará disponible tu contenido.",
  "Escolha entre um formato de texto ou imagem personalizados.": "Elige un formato de texto o imagen personalizado.",
  "Escolha manualmente a velocidade de reprodução do vídeo.": "Elige manualmente la velocidad de reproducción del video.",
  "Escolha o arranjo do bloco de oferta que aparece abaixo do vídeo.": "Elige la disposición del bloque de oferta que aparece debajo del video.",
  "Escolha o modelo da sua Playlist": "Elige el modelo de tu lista de reproducción",
  "Escolha o momento ideal do feedback.": "Elige el momento ideal para los comentarios.",
  "Escolha o tipo de captura": "Elige el tipo de captura",
  "Escolha o tipo e preencha com atenção os dados para repasse.": "Elige el tipo y completa con atención los datos para recibir los pagos.",
  "Escolha o trecho que será exibido como gancho no autoplay.": "Elige el fragmento que se mostrará como gancho en la reproducción automática.",
  "Escolha o vídeo base (sem introdução) onde as aberturas serão testadas.": "Elige el video base (sin introducción) donde se probarán los comienzos.",
  "Escolha o vídeo do seu webinar": "Elige el video de tu seminario web",
  "Escolha o vídeo onde o formulário será exibido": "Elige el video en el que aparecerá el formulario",
  "Escolha o vídeo que será protegido com senha": "Elige el video que se protegerá con contraseña",
  "Escolha onde suas conversões são processadas.": "Elige dónde se procesan tus conversiones.",
  "Escolha os vídeos no Google Drive": "Elige los videos en Google Drive",
  "Escolha os vídeos que deseja comparar lado a lado.": "Elige los videos que quieras comparar en paralelo.",
  "Escolha os vídeos que você deseja comparar. Cada visitante verá apenas um deles durante o teste.": "Elige los videos que quieras comparar. Cada visitante verá solo uno durante la prueba.",
  "Escolha outro vídeo para esta etapa.": "Elige otro video para esta etapa.",
  "Escolha um cartão ou adicione um novo.": "Elige una tarjeta o añade una nueva.",
  "Escolha um ícone e uma cor para personalizar sua pasta": "Elige un icono y un color para personalizar tu carpeta",
  "Escolha um modelo abaixo para começar": "Elige un modelo de abajo para empezar",
  "Escolha um período de até {value0} dias.": "Elige un período de hasta {value0} días.",
  "Escolha um template para a variação": "Elige una plantilla para la variación",
  "Escolha um template pré-configurado para começar rapidamente": "Elige una plantilla preconfigurada para empezar rápidamente",
  "Escolha um vídeo acima para visualizar os relatórios de captura.": "Elige un video arriba para ver los informes de captura.",
  "Escolha um vídeo da biblioteca para substituir o original.": "Elige un video de la biblioteca para sustituir el original.",
  "Escolha um vídeo da sua biblioteca para continuar.": "Elige un video de tu biblioteca para continuar.",
  "Escolha um vídeo para exibir no autoplay": "Elige un video para mostrarlo en la reproducción automática",
  "Escolha um vídeo processado da sua biblioteca e aplique personalizações avançadas": "Elige un video procesado de tu biblioteca y aplica personalizaciones avanzadas",
  "Escolha uma das opções abaixo para receber suporte.": "Elige una de las opciones de abajo para recibir soporte.",
  "Escolha uma data e horário para encerrar o teste.": "Elige una fecha y una hora para finalizar la prueba.",
  "Escolher Arquivo": "Elegir archivo",
  "Escolher arquivos": "Elegir archivos",
  "Escolher intervalo": "Elegir intervalo",
  "Escolher pitch": "Elegir oferta",
  "Escolher vídeos no Drive": "Elegir videos en Drive",
  "Escopo de aplicação": "Ámbito de aplicación",
  "Escurecer automaticamente": "Oscurecer automáticamente",
  "Escurecido": "Oscurecido",
  "Escurecimento atrás das opções": "Oscurecimiento detrás de las opciones",
  "espectadores ·": "espectadores ·",
  "Espessura da barra": "Grosor de la barra",
  "Espessura da Linha (1-6px)": "Grosor de la línea (1-6 px)",
  "Essa referência representa": "Esta referencia representa",
  "Esse vídeo não pôde ser baixado. Os outros continuam.": "No se pudo descargar este video. Los demás continúan.",
  "Esse vídeo não pode ser transmitido a partir deste navegador.": "No se puede transmitir este video desde este navegador.",
  "Esta ação irá encerrar o teste A/B de introduções e fixar a intro atual como definitiva. Esta ação não pode ser desfeita.": "Esta acción finalizará la prueba A/B de introducciones y fijará la introducción actual como definitiva. Esta acción no se puede deshacer.",
  "Esta ação irá encerrar o teste de introduções e nenhum dado adicional será coletado. Você poderá visualizar os resultados, mas não poderá reativar o teste.": "Esta acción finalizará la prueba de introducciones y no se recopilarán más datos. Podrás ver los resultados, pero no reactivar la prueba.",
  "Esta ação irá restaurar todas as configurações para os valores padrão.": "Esta acción restablecerá toda la configuración a los valores predeterminados.",
  "Esta ação não bloqueia vídeos já incorporados anteriormente.": "Esta acción no bloquea los videos insertados anteriormente.",
  "Esta ação não pode ser desfeita. A introdução \"": "Esta acción no se puede deshacer. La introducción \"",
  "Esta ação não pode ser desfeita. A playlist será removida permanentemente.": "Esta acción no se puede deshacer. La lista de reproducción se eliminará permanentemente.",
  "Esta ação não pode ser desfeita. O teste \"": "Esta acción no se puede deshacer. La prueba \"",
  "Esta ação remove a pasta e suas subpastas da sua organização. Os vídeos não serão apagados do sistema.": "Esta acción elimina la carpeta y sus subcarpetas de tu organización. Los videos no se borrarán del sistema.",
  "está apresentando os melhores resultados.": "está obteniendo los mejores resultados.",
  "está com melhor desempenho": "tiene mejor rendimiento",
  "Esta é uma visualização de como seu vídeo será exibido para o público.": "Esta es una vista previa de cómo se mostrará tu video al público.",
  "Esta etapa (repetir)": "Esta etapa (repetir)",
  "Esta integração está ativa e funcionando": "Esta integración está activa y funciona",
  "Esta integração está desativada": "Esta integración está desactivada",
  "Esta introdução está ativa e coletando dados. Continue monitorando o desempenho.": "Esta introducción está activa y recopila datos. Sigue controlando su rendimiento.",
  "Esta introdução está com desempenho inferior. Revise o conteúdo ou considere substituí-la.": "Esta introducción tiene un rendimiento inferior. Revisa el contenido o considera sustituirla.",
  "Esta introdução está performando melhor porque o storytelling ativa mais áreas do cérebro do espectador:": "Esta introducción rinde mejor porque la narración activa más áreas del cerebro del espectador:",
  "Esta introdução está performando melhor que as outras no teste. Considere aumentar o tráfego direcionado a ela.": "Esta introducción rinde mejor que las demás de la prueba. Considera aumentar el tráfico que recibe.",
  "Esta introdução está performando muito bem em termos de retenção. Continue aplicando os mesmos princípios em seus próximos vídeos.": "Esta introducción tiene una retención excelente. Sigue aplicando los mismos principios en tus próximos videos.",
  "Esta pasta está vazia": "Esta carpeta está vacía",
  "Esta pasta não tem vídeos.": "Esta carpeta no tiene videos.",
  "Esta playlist ainda não possui vídeos.": "Esta lista de reproducción todavía no tiene videos.",
  "Esta regra pode conflitar com outras regras existentes.": "Esta regla puede entrar en conflicto con otras reglas existentes.",
  "Esta seção será expandida com novas funcionalidades:": "Esta sección se ampliará con nuevas funciones:",
  "Esta seção será implementada em breve.": "Esta sección se implementará pronto.",
  "Esta versão do player não aceita pré-visualização.": "Esta versión del reproductor no admite vista previa.",
  "Estabilidade até 1min sugere boa narrativa.": "La estabilidad hasta el primer minuto sugiere una buena narrativa.",
  "Estado": "Estado",
  "Estamos preparando este vídeo para compartilhamento. Em instantes ele ficará disponível em": "Estamos preparando este video para compartirlo. En unos instantes estará disponible en",
  "Estamos prontos para analisar": "Estamos listos para analizar",
  "estão desativados. Sem eles, a legenda ficará sempre visível na tela quando ativada e o espectador não terá como desligar.": "están desactivados. Sin ellos, los subtítulos permanecerán visibles cuando estén activados y el espectador no podrá ocultarlos.",
  "Estas sugestões são baseadas nas métricas de reprodução, engajamento e conversão.": "Estas sugerencias se basan en las métricas de reproducción, interacción y conversión.",
  "Este ajuste sobrescreve o modelo selecionado": "Este ajuste sustituye el modelo seleccionado",
  "Este código inclui proteção ativa para:": "Este código incluye protección activa para:",
  "Este compartilhamento não está disponível": "Este enlace compartido no está disponible",
  "Este compartilhamento não está mais disponível": "Este enlace compartido ya no está disponible",
  "Este é o saldo liberado baseado nas indicações da sua carteira que você pode transferir imediatamente.": "Este es el saldo disponible basado en las recomendaciones de tu cartera que puedes transferir inmediatamente.",
  "Este é o vídeo usado na estratégia de captura. Clique em Editar para alterar configurações.": "Este es el video utilizado en la estrategia de captura. Haz clic en Editar para cambiar la configuración.",
  "Este é um horário de pico. Mantenha seus anúncios e campanhas ativos durante este período.": "Esta es una hora punta. Mantén tus anuncios y campañas activos durante este período.",
  "Este e-mail já possui um registro de incremento.": "Este correo electrónico ya tiene un registro de incremento.",
  "Este fluxo ainda não tem vídeos.": "Este flujo todavía no tiene videos.",
  "Este fluxo foi alterado em outra aba ou por outra pessoa.": "Este flujo se ha modificado en otra pestaña o por otra persona.",
  "Este fluxo não existe ou foi excluído.": "Este flujo no existe o se ha eliminado.",
  "Este link de compartilhamento pertence ao vídeo:": "Este enlace compartido pertenece al video:",
  "Este mês": "Este mes",
  "Este nome será usado para identificar o teste na lista": "Este nombre se usará para identificar la prueba en la lista",
  "Este parâmetro UTM já está sendo usado por outra regra.": "Otra regla ya utiliza este parámetro UTM.",
  "Este script acelera o carregamento do vídeo no seu site.": "Este script acelera la carga del video en tu sitio.",
  "Este teste ainda não foi iniciado.": "Esta prueba todavía no se ha iniciado.",
  "Este teste está ativo e recebendo tráfego": "Esta prueba está activa y recibe tráfico",
  "Este teste está em andamento. Clique em 'Ver Teste' para acompanhar os resultados em tempo real.": "Esta prueba está en curso. Haz clic en 'Ver prueba' para seguir los resultados en tiempo real.",
  "Este teste foi finalizado.": "Esta prueba ha finalizado.",
  "Este token não é mais válido.": "Este token ya no es válido.",
  "Este vídeo é propriedade intelectual do": "Este video es propiedad intelectual de",
  "Este vídeo está em uso numa etapa. Troque o vídeo da etapa antes de excluir.": "Este video se utiliza en una etapa. Cambia el video de la etapa antes de eliminarlo.",
  "Este vídeo já está sendo usado nesta plataforma.": "Este video ya se utiliza en esta plataforma.",
  "Este vídeo não está mais no fluxo.": "Este video ya no está en el flujo.",
  "Este vídeo pertence à sua conta. Não é necessário copiá-lo — você já tem acesso completo a ele na seção": "Este video pertenece a tu cuenta. No necesitas copiarlo: ya tienes acceso completo en la sección",
  "Estilo das legendas": "Estilo de subtítulos",
  "Estilo do botão": "Estilo del botón",
  "Estilo do Botão": "Estilo del botón",
  "Estilo do card": "Estilo de la tarjeta",
  "Estilo do Fundo": "Estilo del fondo",
  "Estimativa sobre o total": "Estimación sobre el total",
  "Estratégia ativa": "Estrategia activa",
  "Estratégia ativada": "Estrategia activada",
  "Estratégia desativada": "Estrategia desactivada",
  "Estratégia não encontrada ou tipo inválido.": "Estrategia no encontrada o tipo no válido.",
  "Estratégias e recomendações para otimizar seus testes e melhorar os resultados.": "Estrategias y recomendaciones para optimizar tus pruebas y mejorar los resultados.",
  "Estratégias para otimizar a retenção de \"": "Estrategias para optimizar la retención de \"",
  "Estrelas": "Estrellas",
  "Estrutura de Diretórios": "Estructura de directorios",
  "Estruture seu conteúdo em formato de história com início (problema), meio (agravamento) e fim (solução).": "Estructura tu contenido como una historia con inicio (problema), desarrollo (agravamiento) y final (solución).",
  "Estude os concorrentes bem-sucedidos para inspiração (sem copiar diretamente).": "Estudia a los competidores exitosos para inspirarte (sin copiarlos directamente).",
  "Etapa · {value0}": "Etapa · {value0}",
  "Etapa inicial": "Etapa inicial",
  "Etapa sem nome": "Etapa sin nombre",
  "etapas": "etapas",
  "Etapas da jornada do lead": "Etapas del recorrido del lead",
  "Europe/London": "Europe/London",
  "Evento": "Evento",
  "Evento começa em:": "El evento empieza en:",
  "evento(s) nas últimas 24h (": "evento(s) en las últimas 24 h (",
  "evento(s), mas nenhum nas últimas 24h (último:": "evento(s), pero ninguno en las últimas 24 h (último:",
  "Eventos enviados": "Eventos enviados",
  "Eventos enviados:": "Eventos enviados:",
  "Evite ofertar sessões em horários sensíveis": "Evita ofrecer sesiones en horarios sensibles",
  "Evite sobrepor partes importantes": "Evita cubrir partes importantes",
  "Evolução da entrada": "Evolución de la entrada",
  "Evolução da nota média": "Evolución de la puntuación media",
  "Evolução das referências": "Evolución de las referencias",
  "Evolução de Conversões": "Evolución de conversiones",
  "Evolução nos últimos 12 meses": "Evolución de los últimos 12 meses",
  "Ex: #FF0000, block, 20px": "Ej.: #FF0000, block, 20px",
  "Ex: 0001": "Ej.: 0001",
  "Ex: 12345-6": "Ej.: 12345-6",
  "Ex: 123456-7": "Ej.: 123456-7",
  "Ex: 1234567890123456": "Ej.: 1234567890123456",
  "Ex: 150": "Ej.: 150",
  "Ex: 71 99999-8888": "Ej.: 71 99999-8888",
  "Ex: Acesse todos os módulos do curso...": "Ej.: Accede a todos los módulos del curso...",
  "(Produto)": "(Producto)",
  "10 segundos": "10 segundos",
  "15 segundos": "15 segundos",
  "30 dias": "30 días",
  "7 dias": "7 días",
  "90 dias": "90 días",
  "A borda será aplicada ao redor do player conforme largura e cor escolhidas.": "El borde se aplicará alrededor del reproductor con el ancho y el color elegidos.",
  "Adicionar UTM": "Añadir UTM",
  "Adicionar sombra externa": "Añadir sombra exterior",
  "Adicionar vídeo por URL": "Añadir video por URL",
  "Adicione a sua marca ao vídeo e controle posição, tamanho, transparência e link de destino.": "Añade tu marca al video y controla la posición, el tamaño, la transparencia y el enlace de destino.",
  "Adicione cidades para usar a variável {cidade}": "Añade ciudades para utilizar la variable {cidade}",
  "Adicione nomes para usar a variável {nome}": "Añade nombres para utilizar la variable {nome}",
  "Adicione o produto para usar a variável {produto}": "Añade el producto para utilizar la variable {produto}",
  "Adicione pelo menos um nome": "Añade al menos un nombre",
  "Adicione pelo menos uma cidade": "Añade al menos una ciudad",
  "Adicione uma mensagem": "Añade un mensaje",
  "Afiliado": "Afiliado",
  "Afiliados": "Afiliados",
  "Ajuste o volume do som da notificação (0-100%).": "Ajusta el volumen del sonido de la notificación (0-100 %).",
  "Alertas importantes": "Alertas importantes",
  "Alta Conversão Garantida": "Alta conversión garantizada",
  "Alterar Senha": "Cambiar contraseña",
  "Ana, João, Maria, Pedro, Lucas": "Ana, João, Maria, Pedro, Lucas",
  "Ao Pausar": "Al pausar",
  "Ao Reproduzir": "Al reproducir",
  "Aos 100% Visualizados": "Al ver el 100 %",
  "Aos 25% Visualizados": "Al ver el 25 %",
  "Aos 50% Visualizados": "Al ver el 50 %",
  "Aparecer após iniciar o vídeo": "Aparecer tras iniciar el video",
  "Arraste para enviar": "Arrastra para enviar",
  "Arraste seu vídeo aqui ou clique para enviar um arquivo": "Arrastra tu video aquí o haz clic para enviar un archivo",
  "Arraste um vídeo aqui ou clique para enviar": "Arrastra un video aquí o haz clic para enviarlo",
  "Arredondamento da Borda": "Redondeado del borde",
  "Arredondamento dos cantos": "Redondeado de las esquinas",
  "Ativar Borda": "Activar borde",
  "Ativar Logo": "Activar logotipo",
  "Ativar Pixel": "Activar píxel",
  "Ativar Rastreamento de Afiliados": "Activar seguimiento de afiliados",
  "Ativar borda no player": "Activar borde en el reproductor",
  "Ativar reprodução automática": "Activar reproducción automática",
  "Ativar teste automático com múltiplas velocidades": "Activar prueba automática con varias velocidades",
  "Ativar teste de velocidade": "Activar prueba de velocidad",
  "Ativar velocidade personalizada": "Activar velocidad personalizada",
  "Ative para rastrear eventos e conversões em plataformas de anúncios": "Actívalo para seguir eventos y conversiones en plataformas de anuncios",
  "Atraso inicial ({value}s)": "Retraso inicial ({value}s)",
  "Atualizar Senha": "Actualizar contraseña",
  "Atualização em tempo real": "Actualización en tiempo real",
  "Atualize seus dados de contato": "Actualiza tus datos de contacto",
  "Atualize seus dados pessoais e avatar": "Actualiza tus datos personales y tu avatar",
  "Atualize sua senha e configurações de segurança": "Actualiza tu contraseña y la configuración de seguridad",
  "Audiência": "Audiencia",
  "Audiência Simulada": "Audiencia simulada",
  "Aumentar 5%": "Aumentar un 5 %",
  "Bordas Personalizadas": "Bordes personalizados",
  "Botões Inteligentes com Tempo e Ação": "Botones inteligentes con tiempo y acción",
  "Braip": "Braip",
  "Cakto": "Cakto",
  "CartPanda": "CartPanda",
  "Centro Direito": "Centro derecha",
  "Centro Esquerdo": "Centro izquierda",
  "Clarear 5%": "Aclarar un 5 %",
  "Clique para Editar": "Haz clic para editar",
  "Cloaker VSL": "Cloaker de VSL",
  "Cole o ID do pixel fornecido pela plataforma de anúncios": "Pega el ID del píxel proporcionado por la plataforma de anuncios",
  "Como funciona o teste de velocidade?": "¿Cómo funciona la prueba de velocidad?",
  "Como interpretar os testes de velocidade": "Cómo interpretar las pruebas de velocidad",
  "Concluídos": "Completados",
  "Configurar Integração": "Configurar integración",
  "Configurar Recurso": "Configurar función",
  "Configurar integração com Facebook": "Configurar integración con Facebook",
  "Configuração Manual": "Configuración manual",
  "Configuração de Velocidade Manual": "Configuración de velocidad manual",
  "Configurações da Borda": "Configuración del borde",
  "Configurações de Idioma": "Configuración de idioma",
  "Configure manualmente ou execute testes A/B automáticos para otimizar o engajamento.": "Configura manualmente o ejecuta pruebas A/B automáticas para optimizar la interacción.",
  "Configure opções de reprodução automática": "Configura las opciones de reproducción automática",
  "Configure seu link de afiliado e ganhe comissões quando novos usuários se cadastrarem.": "Configura tu enlace de afiliado y gana comisiones cuando se registren nuevos usuarios.",
  "Configure testes A/B automáticos com diferentes velocidades para otimizar o engajamento do seu público.": "Configura pruebas A/B automáticas con distintas velocidades para optimizar la interacción de tu público.",
  "Contagem base": "Conteo base",
  "Controles Adicionais": "Controles adicionales",
  "Critério de vitória": "Criterio de victoria",
  "Definir URL": "Definir URL",
  "Desabilitado enquanto o Teste Automático estiver ativo.": "Deshabilitado mientras la prueba automática esté activa.",
  "Desfocar fundo": "Desenfocar fondo",
  "Deslizar": "Deslizar",
  "Deslizar para cima": "Deslizar hacia arriba",
  "Destaque": "Destacado",
  "Destaque o player com bordas modernas e flexíveis, sem perder a identidade visual.": "Destaca el reproductor con bordes modernos y flexibles sin perder tu identidad visual.",
  "Desvanecer": "Desvanecer",
  "Dica para melhor qualidade": "Consejo para mejorar la calidad",
  "Dica: Configure um teste na aba 'Automático' para visualizar métricas comparativas por velocidade.": "Consejo: configura una prueba en la pestaña 'Automático' para ver métricas comparativas por velocidad.",
  "Dicas para testes ideais": "Consejos para pruebas óptimas",
  "Digital Guru": "Digital Guru",
  "Digite qualquer mensagem. Use {nome}, {cidade} e {produto} opcionalmente para personalizar.": "Escribe cualquier mensaje. Usa {nome}, {cidade} y {produto} de forma opcional para personalizarlo.",
  "Duração ({value}s)": "Duración ({value}s)",
  "Duração da contagem regressiva": "Duración de la cuenta atrás",
  "Duração mínima do teste": "Duración mínima de la prueba",
  "Editar Configuração": "Editar configuración",
  "Eduzz": "Eduzz",
  "Efeito ao passar o mouse": "Efecto al pasar el cursor",
  "Enviar Vídeo": "Enviar video",
  "Erro ao carregar a imagem": "Error al cargar la imagen",
  "Escolha a plataforma de anúncios que deseja integrar": "Elige la plataforma de anuncios que quieras integrar",
  "Escolha manualmente a velocidade desejada para o seu vídeo. Ideal para testes diretos e controle total sobre a reprodução.": "Elige manualmente la velocidad deseada para tu video. Ideal para pruebas directas y control total de la reproducción.",
  "Escolha onde exibir no vídeo": "Elige dónde mostrarlo en el video",
  "Escolha seu idioma preferido para o aplicativo": "Elige tu idioma preferido para la aplicación",
  "Escolha um estilo pronto ou ajuste manualmente abaixo.": "Elige un estilo predefinido o ajústalo manualmente abajo.",
  "Escurecer 5%": "Oscurecer un 5 %",
  "Este preview mostra como seus controles aparecerão no player real. As cores e configurações são aplicadas instantaneamente.": "Esta vista previa muestra cómo aparecerán tus controles en el reproductor real. Los colores y la configuración se aplican al instante.",
  "Estilo de borda (preset)": "Estilo de borde predefinido",
  "Estilos Rápidos": "Estilos rápidos",
  "Evento de Disparo": "Evento de activación",
  "Ex.: Funil Emagrecimento 30D": "Ej.: Embudo de adelgazamiento 30D",
  "Ex.: Oferta principal": "Ej.: Oferta principal",
  "Ex.: Toque para ativar o som": "Ej.: Toca para activar el sonido",
  "Ex: Agende agora sem custos": "Ej.: Reserva ahora sin coste",
  "Ex: Ao vivo agora": "Ej.: En directo ahora",
  "Ex: Assista até o final para descobrir o método": "Ej.: Mira hasta el final para descubrir el método",
  "Ex: Bem-vindo ao Curso": "Ej.: Bienvenido al curso",
  "Ex: Brasil, EUA": "Ej.: Brasil, EE. UU.",
  "Ex: Bônus Exclusivos": "Ej.: Bonificaciones exclusivas",
  "Ex: Comece sua jornada de transformação": "Ej.: Empieza tu camino de transformación",
  "Ex: Como Ganhar R$ 10.000 por Mês com Marketing Digital": "Ej.: Cómo ganar R$ 10.000 al mes con marketing digital",
  "Ex: Comprar Agora": "Ej.: Comprar ahora",
  "Ex: Concorra a um iPhone 15": "Ej.: Participa para ganar un iPhone 15",
  "Ex: Continue agora mesmo": "Ej.: Continúa ahora mismo",
  "Ex: Copie este vídeo para começar a divulgar...": "Ej.: Copia este video para empezar a compartirlo...",
  "Ex: Curso Completo de Marketing": "Ej.: Curso completo de marketing",
  "Ex: Diagnóstico Comercial Gratuito": "Ej.: Diagnóstico comercial gratuito",
  "Ex: Funil Low Ticket / Campanha Fevereiro": "Ej.: Embudo de bajo coste / Campaña de febrero",
  "Ex: IPINFO API, Amazon EC2...": "Ej.: IPINFO API, Amazon EC2...",
  "Ex: João Silva": "Ej.: João Silva",
  "Ex: Marketing, VSLs, Tutoriais...": "Ej.: Marketing, VSL, tutoriales...",
  "Ex: Materiais extras para acelerar seus resultados": "Ej.: Materiales adicionales para acelerar tus resultados",
  "Ex: Módulos Iniciais": "Ej.: Módulos iniciales",
  "Ex: Oferta Black Friday 2024": "Ej.: Oferta Black Friday 2024",
  "Ex: Olá! Tenho interesse no conteúdo da sua playlist.": "Ej.: ¡Hola! Me interesa el contenido de tu lista de reproducción.",
  "Ex: Plano Pro - 10k requests/mês": "Ej.: Plan Pro - 10.000 solicitudes/mes",
  "Ex: Proteção principal": "Ej.: Protección principal",
  "Ex: Próximo passo da sua jornada": "Ej.: Siguiente paso de tu recorrido",
  "Ex: Restam poucas vagas": "Ej.: Quedan pocas plazas",
  "Ex: SSL Seguro": "Ej.: SSL seguro",
  "Ex: Seus dados estão seguros conosco": "Ej.: Tus datos están seguros con nosotros",
  "Ex: São Paulo, Rio de Janeiro": "Ej.: São Paulo, Rio de Janeiro",
  "Ex: Teste de Aberturas – Produto X": "Ej.: Prueba de comienzos – Producto X",
  "Ex: Teste de Introduções - VSL Principal": "Ej.: Prueba de introducciones - VSL principal",
  "Ex: Teste de VSLs - Produto X": "Ej.: Prueba de VSL - Producto X",
  "Ex: Teste de VSLs – Produto X": "Ej.: Prueba de VSL – Producto X",
  "Ex: VSL Principal vs Variação Curta": "Ej.: VSL principal frente a variación corta",
  "Ex: Webinário de Lançamento Produto X": "Ej.: Seminario web de lanzamiento del producto X",
  "Ex: google, facebook, newsletter": "Ej.: google, facebook, newsletter",
  "Ex: joao@email.com": "Ej.: joao@email.com",
  "Ex: utm_source": "Ej.: utm_source",
  "Ex: Última chance": "Ej.: Última oportunidad",
  "Excel (.xlsx)": "Excel (.xlsx)",
  "Excluir Bônus?": "¿Eliminar bonificación?",
  "Excluir Estratégia": "Eliminar estrategia",
  "Excluir Módulo?": "¿Eliminar módulo?",
  "Excluir Todos": "Eliminar todos",
  "Excluir Tracking?": "¿Eliminar seguimiento?",
  "Excluir a etapa \"": "Eliminar la etapa \"",
  "Excluir compartilhamento": "Eliminar enlace compartido",
  "Excluir definitivamente": "Eliminar definitivamente",
  "Excluir fluxo e vídeos": "Eliminar flujo y videos",
  "Excluir fluxo e vídeos?": "¿Eliminar flujo y videos?",
  "Excluir pasta": "Eliminar carpeta",
  "Excluir pasta?": "¿Eliminar carpeta?",
  "Excluir playlist?": "¿Eliminar lista de reproducción?",
  "Excluir registro": "Eliminar registro",
  "Excluir saída": "Eliminar salida",
  "Excluir teste de introduções?": "¿Eliminar prueba de introducciones?",
  "Excluir vídeo da playlist": "Quitar video de la lista de reproducción",
  "Excluir vídeos selecionados": "Eliminar videos seleccionados",
  "Excluir {value0} pastas?": "¿Eliminar {value0} carpetas?",
  "Exemplo do endereço final": "Ejemplo de dirección final",
  "Exemplo:": "Ejemplo:",
  "Exemplo: Se o webinário começa às 20h e alguém entra às 20:15, o vídeo inicia automaticamente no minuto 15.": "Ejemplo: si el seminario web empieza a las 20:00 y alguien entra a las 20:15, el video empieza automáticamente en el minuto 15.",
  "Exemplo: StatsCard": "Ejemplo: StatsCard",
  "Exiba alertas de compras para gerar prova social em tempo real.": "Muestra avisos de compra para generar prueba social en tiempo real.",
  "Exiba imagens ou GIFs em momentos estratégicos do vídeo para reforçar a atenção": "Muestra imágenes o GIF en momentos estratégicos del video para reforzar la atención",
  "Exiba legendas sincronizadas no seu vídeo. Suporta arquivos .SRT e .VTT.": "Muestra subtítulos sincronizados en tu video. Admite archivos .SRT y .VTT.",
  "Exiba provas sociais de compras recentes enquanto o vídeo roda": "Muestra pruebas sociales de compras recientes mientras se reproduce el video",
  "Exiba sua logomarca sobre o vídeo e aumente a visibilidade da sua marca.": "Muestra tu logotipo sobre el video y aumenta la visibilidad de tu marca.",
  "Exiba uma ou mais imagens/GIFs em momentos estratégicos do vídeo para reforçar a atenção.": "Muestra una o varias imágenes/GIF en momentos estratégicos del video para reforzar la atención.",
  "Exibe a barra de progresso na parte inferior do player": "Muestra la barra de progreso en la parte inferior del reproductor",
  "Exibe a logo da HostVSL no player e ativa o redirecionamento pelo seu link": "Muestra el logotipo de HostVSL en el reproductor y activa la redirección mediante tu enlace",
  "Exibe controle deslizante de volume no player": "Muestra un control deslizante de volumen en el reproductor",
  "Exibe modal para retomar reprodução de onde o usuário parou.": "Muestra un diálogo para reanudar la reproducción donde se quedó el usuario.",
  "Exibe notificações de compra no player.": "Muestra notificaciones de compra en el reproductor.",
  "Exibe ou oculta os controles do player (play, pause, volume, etc.)": "Muestra u oculta los controles del reproductor (reproducir, pausar, volumen, etc.)",
  "Exibe sua logomarca sobre o vídeo.": "Muestra tu logotipo sobre el video.",
  "Exibe um botão permitindo que o usuário pule o preenchimento do formulário e continue assistindo o vídeo": "Muestra un botón que permite omitir el formulario y seguir viendo el video",
  "Exibe um contador de pessoas assistindo no player.": "Muestra un contador de personas viendo en el reproductor.",
  "Exibe uma barra visual no rodapé do player durante a reprodução.": "Muestra una barra visual al pie del reproductor durante la reproducción.",
  "Exibe uma mensagem sutil informando que o vídeo iniciou automaticamente.": "Muestra un mensaje discreto que informa de que el video se ha iniciado automáticamente.",
  "Exibido após o principal para apresentar sua oferta.": "Se muestra después del principal para presentar tu oferta.",
  "Exibir barra": "Mostrar barra",
  "Exibir botão de CTA abaixo do vídeo": "Mostrar botón CTA debajo del video",
  "Exibir contador regressivo": "Mostrar cuenta atrás",
  "Exibir contagem regressiva": "Mostrar cuenta atrás",
  "Exibir countdown antes do formulário": "Mostrar cuenta atrás antes del formulario",
  "Exibir depoimento": "Mostrar testimonio",
  "Exibir em (minutos:segundos)": "Mostrar en (minutos:segundos)",
  "Exibir esta primeiro": "Mostrar esta primero",
  "Exibir logo também no mobile": "Mostrar también el logotipo en móvil",
  "Exibir o formulário em um momento específico do vídeo": "Mostrar el formulario en un momento concreto del video",
  "Exibir selos de segurança": "Mostrar sellos de seguridad",
  "Exibir senha em um momento específico": "Mostrar contraseña en un momento concreto",
  "Exibir termo de consentimento": "Mostrar consentimiento",
  "Exibir texto sobre o banner": "Mostrar texto sobre el banner",
  "Exibir título": "Mostrar título",
  "Exibição e Capacidade": "Visualización y capacidad",
  "Exibição por dispositivo atualizada": "Visualización por dispositivo actualizada",
  "Exibições de entrada": "Visualizaciones de entrada",
  "Exibições de saída": "Visualizaciones de salida",
  "Expanda seu formulário com informações complementares": "Amplía tu formulario con información complementaria",
  "Experimente storytelling": "Prueba la narración",
  "Experiência Nativa": "Experiencia nativa",
  "Expirada": "Caducada",
  "Expiração do Link": "Caducidad del enlace",
  "Explicação das métricas": "Explicación de las métricas",
  "Exportar CSV (linha)": "Exportar CSV (fila)",
  "Exportar Extrato CSV": "Exportar extracto CSV",
  "Exportar PDF": "Exportar PDF",
  "Exportação concluída com sucesso!": "¡Exportación completada correctamente!",
  "Expressão Regular (Regex)": "Expresión regular (Regex)",
  "Extra-negrito": "Extranegrita",
  "Extrato Administrativo": "Extracto administrativo",
  "Extrato exportado!": "¡Extracto exportado!",
  "Extratos e Saques": "Extractos y retiradas",
  "Extremamente rápido": "Extremadamente rápido",
  "Failed to get canvas context": "No se pudo obtener el contexto del lienzo",
  "Falar no WhatsApp": "Hablar por WhatsApp",
  "Falar no chat": "Hablar por chat",
  "Fale com nossa equipe e resolva em poucos minutos.": "Habla con nuestro equipo y resuélvelo en pocos minutos.",
  "Fale com nossa equipe.": "Habla con nuestro equipo.",
  "Fale conosco no WhatsApp": "Contacta con nosotros por WhatsApp",
  "Falha ao baixar {value0}: HTTP {value1}{value2}": "Error al descargar {value0}: HTTP {value1}{value2}",
  "Falha ao carregar o módulo Picker": "Error al cargar el módulo Picker",
  "Falha ao carregar o player": "Error al cargar el reproductor",
  "Falha ao carregar o vídeo": "Error al cargar el video",
  "Falha ao carregar vídeo": "Error al cargar el video",
  "Falha ao criar o teste": "Error al crear la prueba",
  "Falha ao criar teste": "Error al crear la prueba",
  "Falha ao enviar": "Error al enviar",
  "Falha ao salvar alterações": "Error al guardar los cambios",
  "Falha ao salvar configuração.": "Error al guardar la configuración.",
  "Falha ao subir a imagem. Tente novamente.": "Error al subir la imagen. Inténtalo de nuevo.",
  "Falha em {value0}": "Error en {value0}",
  "Falha no envio: {value0}": "Error en el envío: {value0}",
  "Falha no processamento": "Error de procesamiento",
  "Falta resolver": "Pendiente de resolver",
  "Fantasma": "Fantasma",
  "Favicon otimizado": "Favicon optimizado",
  "Favicon preview": "Vista previa del favicon",
  "Favoritos": "Favoritos",
  "Fazer Upload e Solicitar Verificação": "Subir y solicitar verificación",
  "Faça login para gerenciar testes de velocidade.": "Inicia sesión para gestionar las pruebas de velocidad.",
  "Faça perguntas diretas ao espectador em momentos de queda para reconquistar a atenção.": "Haz preguntas directas al espectador en los momentos de abandono para recuperar su atención.",
  "Faça sessões e botões surgirem no momento exato do vídeo.": "Haz que las secciones y los botones aparezcan en el momento exacto del video.",
  "Faça uma nova conta de parceiro e gere a sua conta de parceiro.": "Crea una nueva cuenta de socio para obtener tu cuenta de socio.",
  "Faça upload de um ícone personalizado (opcional)": "Sube un icono personalizado (opcional)",
  "Faça upload do seu primeiro vídeo e ajuste as configurações iniciais.": "Sube tu primer video y ajusta la configuración inicial.",
  "Faça upload do seu vídeo": "Sube tu video",
  "Fechamento bloqueado por": "Cierre bloqueado durante",
  "Fechando automaticamente...": "Cerrando automáticamente...",
  "Fechar Interpretação": "Cerrar interpretación",
  "Fechar Janela": "Cerrar ventana",
  "Fechar automaticamente": "Cerrar automáticamente",
  "Fechar automaticamente após envio bem-sucedido": "Cerrar automáticamente tras un envío correcto",
  "Fechar recursos": "Cerrar funciones",
  "Fechar sem copiar": "Cerrar sin copiar",
  "Fechar tour": "Cerrar recorrido",
  "Feedback do Vídeo salvo": "Comentarios del video guardados",
  "Ferramentas Administrativas": "Herramientas administrativas",
  "Ferramentas de Administrador": "Herramientas de administrador",
  "Ferramentas · AdSniper": "Herramientas · AdSniper",
  "Ficará disponível como um vídeo enviado por você.": "Estará disponible como un video enviado por ti.",
  "Filled": "Relleno",
  "Filtrar por Provedor": "Filtrar por proveedor",
  "Filtrar por período": "Filtrar por período",
  "Filtrar por status": "Filtrar por estado",
  "Filtros": "Filtros",
  "Filtros Avançados": "Filtros avanzados",
  "Fim": "Fin",
  "Fim da oferta (opcional)": "Fin de la oferta (opcional)",
  "Fim da oferta deve ser após o início": "El fin de la oferta debe ser posterior al inicio",
  "Fim do dia": "Fin del día",
  "Final (min:seg)": "Final (min:s)",
  "Final (opcional)": "Final (opcional)",
  "Final do período": "Fin del período",
  "Finalizados": "Finalizados",
  "Finalizando em breve:": "Finaliza pronto:",
  "Finalizando processamento de dados": "Finalizando el procesamiento de datos",
  "Finalizar": "Finalizar",
  "Finalizar Teste de Introduções?": "¿Finalizar prueba de introducciones?",
  "Finalizar teste de intros?": "¿Finalizar prueba de introducciones?",
  "Finalize sua configuração para ativar o rastreamento.": "Completa la configuración para activar el seguimiento.",
  "Firefox": "Firefox",
  "Fluxo": "Flujo",
  "Fluxo de Estado - Zustand Stores": "Flujo de estado - Almacenes Zustand",
  "Fluxo excluído.": "Flujo eliminado.",
  "Fluxo não encontrado": "Flujo no encontrado",
  "Fluxo publicado": "Flujo publicado",
  "Fluxo renomeado.": "Nombre del flujo cambiado.",
  "Fontes de Tráfego (UTM)": "Fuentes de tráfico (UTM)",
  "Fora (acima do formulário)": "Fuera (encima del formulario)",
  "Form de mudança da quantidade de clicks do usuário. É um valor numérico manipulável diretamente.": "Formulario para modificar la cantidad de clics del usuario. Es un valor numérico que se puede cambiar directamente.",
  "Form de mudança de nível do usuário. Ela é setada com o nível atual do usuário automaticamente.": "Formulario para cambiar el nivel del usuario. Se establece automáticamente en su nivel actual.",
  "Form de mudança de status do usuário, aceitando os parâmetros operacionais de Ativo (A) ou Desativado (D).": "Formulario para cambiar el estado del usuario, con los valores operativos Activo (A) o Desactivado (D).",
  "Form de mudança do plano/subscription do usuário, exibindo dinamicamente o nome do plano atual.": "Formulario para cambiar el plan o la suscripción del usuario, que muestra dinámicamente el nombre del plan actual.",
  "Formas de Pagamento": "Métodos de pago",
  "Formato AIDA adaptado": "Formato AIDA adaptado",
  "Formato da mensagem": "Formato del mensaje",
  "Formato de arquivo não suportado. Use MP4, MOV, WEBM ou AVI.": "Formato de archivo no compatible. Usa MP4, MOV, WEBM o AVI.",
  "Formato de resposta inesperado do servidor.": "Formato de respuesta inesperado del servidor.",
  "Formato do vídeo": "Formato del video",
  "Formato não suportado. Use MP4, MOV ou WEBM.": "Formato no compatible. Usa MP4, MOV o WEBM.",
  "Formato: minutos:segundos (exemplo: 00:15 para 15 segundos)": "Formato: minutos:segundos (ejemplo: 00:15 para 15 segundos)",
  "Formatos aceitos: MP4, MOV, AVI": "Formatos admitidos: MP4, MOV, AVI",
  "Formatos aceitos: MP4, MOV, WEBM • até 5GB • H.264 recomendado": "Formatos admitidos: MP4, MOV, WEBM • hasta 5 GB • H.264 recomendado",
  "Formatos suportados": "Formatos compatibles",
  "Formatos suportados: MP4, MOV, AVI • Máximo 500MB": "Formatos compatibles: MP4, MOV, AVI • Máximo 500 MB",
  "Formulário não disponível para esta integração.": "Formulario no disponible para esta integración.",
  "Formulário vertical": "Formulario vertical",
  "Fornece recursos para intermediar a relação entre consumidores, afiliados e produtores.": "Ofrece funciones para conectar a consumidores, afiliados y productores.",
  "Fortaleça sua narrativa": "Refuerza tu narrativa",
  "Forte": "Fuerte",
  "Força da senha": "Fortaleza de la contraseña",
  "Forçando atualização...": "Forzando actualización...",
  "Forçar Atualização": "Forzar actualización",
  "Forçar atualização completa (limpa cache e recarrega)": "Forzar actualización completa (borrar caché y recargar)",
  "Français": "Français",
  "Freelancers e Profissionais": "Profesionales independientes",
  "Frente do Documento (Com Foto)": "Anverso del documento (con foto)",
  "Frequência ({value}s)": "Frecuencia ({value}s)",
  "Frequência de geração de sessões": "Frecuencia de generación de sesiones",
  "Funciona Offline": "Funciona sin conexión",
  "Funcionalidade de excluir em desenvolvimento": "Función de eliminación en desarrollo",
  "Funcionalidade em desenvolvimento": "Función en desarrollo",
  "Funcionalidades:": "Funciones:",
  "Fundo Sólido": "Fondo sólido",
  "Fundo com blur": "Fondo desenfocado",
  "Funil": "Embudo",
  "Funil Dinâmico": "Embudo dinámico",
  "Funil de Vídeos": "Embudo de videos",
  "Funil de Vídeos (Dinâmico)": "Embudo de videos (dinámico)",
  "Fuso atual:": "Zona horaria actual:",
  "Ganhe 20% de comissão sobre tudo enquanto o cliente estiver ativo.": "Gana un 20 % de comisión sobre todo mientras el cliente permanezca activo.",
  "Ganhe comissão recorrente": "Gana comisiones recurrentes",
  "Ganhe de Forma Recorrente com o Programa de Parcerias Host VSL": "Gana de forma recurrente con el programa de socios de Host VSL",
  "Ganhos Estimados": "Ingresos estimados",
  "Garanta maior retenção iniciando o vídeo automaticamente.": "Mejora la retención iniciando el video automáticamente.",
  "Garantir minha vaga": "Reservar mi plaza",
  "Gargalo": "Cuello de botella",
  "Georgia": "Georgia",
  "Gerado automaticamente": "Generado automáticamente",
  "Gerando PDF...": "Generando PDF...",
  "Gerando token...": "Generando token...",
  "Gerando...": "Generando...",
  "Gerar Análise": "Generar análisis",
  "Gerar Miniatura": "Generar miniatura",
  "Gere links de compartilhamento para que afiliados copiem seus vídeos rapidamente.": "Genera enlaces para que los afiliados copien tus videos rápidamente.",
  "Gerenciar": "Gestionar",
  "Gerenciar Incremento de Clicks": "Gestionar incremento de clics",
  "Gerenciar Ofertas": "Gestionar ofertas",
  "Gerenciar compartilhamentos": "Gestionar enlaces compartidos",
  "Gerenciar formulários não enviados": "Gestionar formularios sin enviar",
  "Gerenciar rastreamento": "Gestionar seguimiento",
  "Gerencie o status da solicitação de saque.": "Gestiona el estado de la solicitud de retirada.",
  "Gerencie os membros da sua equipe. Defina permissões de acesso por feature e por pasta.": "Gestiona los miembros de tu equipo. Define permisos de acceso por función y carpeta.",
  "Gerencie os tipos de alertas que você deseja receber sobre suas métricas e conversões": "Gestiona los tipos de alerta que quieres recibir sobre tus métricas y conversiones",
  "Gerencie pagamentos, solicitações e repasses da rede de afiliados.": "Gestiona los pagos, las solicitudes y las transferencias de la red de afiliados.",
  "Gerencie seus cartões e métodos de pagamento": "Gestiona tus tarjetas y métodos de pago",
  "Gerencie suas informações pessoais, segurança e preferências da conta.": "Gestiona tu información personal, la seguridad y las preferencias de la cuenta.",
  "Gerencie, pesquise e organize sua biblioteca de vídeos": "Gestiona, busca y organiza tu biblioteca de videos",
  "Gestão de Custos": "Gestión de costes",
  "Go to next page": "Ir a la página siguiente",
  "Go to previous page": "Ir a la página anterior",
  "Google Drive": "Google Drive",
  "Google Identity Services não disponível": "Google Identity Services no está disponible",
  "Google Picker não disponível": "Google Picker no está disponible",
  "Gráfico opcional": "Gráfico opcional",
  "Gráficos": "Gráficos",
  "Guia": "Guía",
  "Guia completo para criar headlines impactantes que convertem": "Guía completa para crear titulares impactantes que convierten",
  "Guia prático para desenvolver novas features na HostVSL seguindo os padrões estabelecidos.": "Guía práctica para desarrollar nuevas funciones en HostVSL siguiendo los estándares establecidos.",
  "Guia técnico completo • Última atualização:": "Guía técnica completa • Última actualización:",
  "HD": "HD",
  "Habilita a personalização de bordas ao redor do vídeo.": "Permite personalizar los bordes alrededor del video.",
  "Habilitados": "Habilitados",
  "Habilitar botão de pular": "Habilitar botón para omitir",
  "Habilitar sorteio": "Habilitar sorteo",
  "Headline: \"": "Titular: \"",
  "Headlines são textos chamativos que aparecem sobre o vídeo para capturar atenção, transmitir uma mensagem principal e incentivar o espectador a continuar assistindo. Subheadlines complementam com informações adicionais.": "Los titulares son textos llamativos que aparecen sobre el video para captar la atención, transmitir el mensaje principal y animar al espectador a seguir viendo. Los subtítulos aportan información adicional.",
  "Hero": "Principal",
  "Histórias pessoais ou cases de clientes geram mais conexão emocional e aumentam o interesse inicial.": "Las historias personales o los casos de clientes generan una mayor conexión emocional y aumentan el interés inicial.",
  "Histórico de Eventos": "Historial de eventos",
  "Histórico de Faturas": "Historial de facturas",
  "Histórico de Saques": "Historial de retiradas",
  "Histórico de Testes": "Historial de pruebas",
  "Histórico de ações e eventos do sistema.": "Historial de acciones y eventos del sistema.",
  "Histórico de melhorias e novas funcionalidades implementadas na plataforma. Esta seção é atualizada automaticamente quando novas features são adicionadas.": "Historial de mejoras y nuevas funciones de la plataforma. Esta sección se actualiza automáticamente cuando se añaden funciones.",
  "Hoje": "Hoy",
  "Horizontal (→)": "Horizontal (→)",
  "Horário": "Horario",
  "Horário Mais Consistente": "Horario más constante",
  "Horário Mais Consistente (": "Horario más constante (",
  "Horário Mais Consistente (Conversão)": "Horario más constante (conversión)",
  "Horário Mais Consistente (Volume)": "Horario más constante (volumen)",
  "Horário de funcionamento das sessões": "Horario de funcionamiento de las sesiones",
  "Horário de início é obrigatório": "La hora de inicio es obligatoria",
  "Horário detectado:": "Horario detectado:",
  "Horários": "Horarios",
  "Horários de Silêncio": "Horario de silencio",
  "Host VSL · Atualizações contínuas": "Host VSL · Actualizaciones continuas",
  "HostVSL Dashboard": "Panel de HostVSL",
  "HostVSL Documentation v3.0 (Dinâmica) • Última atualização:": "Documentación de HostVSL v3.0 (dinámica) • Última actualización:",
  "HostVSL Player - Plataforma completa para VSLs": "HostVSL Player - Plataforma completa para VSL",
  "HostVSL é uma plataforma de hospedagem e gerenciamento de VSLs (Video Sales Letters) construída com tecnologias modernas para oferecer a melhor experiência em reprodução de vídeos de vendas.": "HostVSL es una plataforma de alojamiento y gestión de VSL (cartas de venta en video), creada con tecnologías modernas para ofrecer la mejor experiencia de reproducción de videos de ventas.",
  "Hotmart": "Hotmart",
  "Há 2 horas": "Hace 2 horas",
  "ID Usuário": "ID de usuario",
  "ID Usuário:": "ID de usuario:",
  "ID copiado!": "¡ID copiado!",
  "ID da assinatura não encontrado.": "ID de suscripción no encontrado.",
  "ID da plataforma não encontrado": "ID de plataforma no encontrado",
  "ID da regra": "ID de la regla",
  "ID de conversão inválido. Use AW-123456789.": "ID de conversión no válido. Usa AW-123456789.",
  "ID do Afiliado": "ID del afiliado",
  "ID do Pixel": "ID del píxel",
  "ID do Pixel *": "ID del píxel *",
  "ID do Plano": "ID del plan",
  "ID do Vídeo": "ID del video",
  "ID do cliente Stripe não encontrado": "ID del cliente de Stripe no encontrado",
  "ID do pagamento não fornecido.": "No se ha proporcionado el ID del pago.",
  "ID do payout": "ID de la transferencia",
  "ID do usuário não encontrado": "ID del usuario no encontrado",
  "ID único do vídeo": "ID único del video",
  "IDIOMAS": "IDIOMAS",
  "IP": "IP",
  "Id de etapa inválido": "ID de etapa no válido",
  "Id de opção inválido": "ID de opción no válido",
  "Id de saída inválido": "ID de salida no válido",
  "Ideias personalizadas para otimizar \"": "Ideas personalizadas para optimizar \"",
  "Identidade": "Identidad",
  "Identificamos uma retenção preventiva temporária ou simulação técnica em sua conta Connect. Nossa engenharia interna está validando os repasses junto à Stripe Connect. Nenhuma ação manual é necessária.": "Hemos detectado una retención preventiva temporal o una simulación técnica en tu cuenta Connect. Nuestro equipo técnico está validando las transferencias con Stripe Connect. No se requiere ninguna acción manual.",
  "Identificação": "Identificación",
  "Identificação da Ação": "Identificación de la acción",
  "Identifique a melhor introdução para seu vídeo.": "Identifica la mejor introducción para tu video.",
  "Identifique momentos específicos onde há queda acentuada de retenção e revise o conteúdo nesses pontos.": "Identifica los momentos con caídas pronunciadas de retención y revisa el contenido de esos puntos.",
  "Identifique padrões de conversão por dia e horário": "Identifica patrones de conversión por día y hora",
  "Idioma do navegador": "Idioma del navegador",
  "Igual a": "Igual a",
  "Igual no banco": "Igual en el banco",
  "Imagem Substituta": "Imagen de sustitución",
  "Imagem de Fundo (Opcional)": "Imagen de fondo (opcional)",
  "Imagem do autoplay atualizada": "Imagen de reproducción automática actualizada",
  "Imagem quadrada PNG, recomendado 256×256 px": "Imagen PNG cuadrada, recomendado: 256×256 px",
  "Imagem real do momento em que os visitantes chegam ao seu vídeo": "Imagen real del momento en que los visitantes llegan a tu video",
  "Imagens da Oferta": "Imágenes de la oferta",
  "Imediato": "Inmediato",
  "Impacto:": "Impacto:",
  "Impede a publicação": "Impide la publicación",
  "Implemente storytelling": "Aplica la narración",
  "Importando do Google Drive": "Importando desde Google Drive",
  "Importando {value0} vídeo{value1}...": "Importando {value0} video{value1}...",
  "Importar do Drive": "Importar desde Drive",
  "Importar vídeos do Google Drive": "Importar videos de Google Drive",
  "Importação de {value0} em desenvolvimento": "Importación de {value0} en desarrollo",
  "Importe vídeos direto da sua conta Google Drive.": "Importa videos directamente desde tu cuenta de Google Drive.",
  "Impostos Estimados": "Impuestos estimados",
  "Inativos": "Inactivos",
  "Incluir botão externo": "Incluir botón externo",
  "Indicado para usuários avançados. Apenas HTML simples. Scripts não são permitidos.": "Recomendado para usuarios avanzados. Solo HTML sencillo. No se permiten scripts.",
  "Indicador de Disponibilidade": "Indicador de disponibilidad",
  "Indicador de fuso horário": "Indicador de zona horaria",
  "Indicadores Importantes": "Indicadores importantes",
  "Indicação": "Recomendación",
  "Indicações": "Recomendaciones",
  "Indique Clientes": "Recomienda clientes",
  "Indique Parceiros": "Recomienda socios",
  "Indique a plataforma nº1 de VSLs do Brasil e receba": "Recomienda la plataforma de VSL n.º 1 de Brasil y recibe",
  "Indique e Ganhe": "Recomienda y gana",
  "Indique e Ganhe e aumente seu valor para o Email.": "Recomienda y gana, y aumenta tu valor para el correo electrónico.",
  "Inferior central": "Inferior central",
  "Infinito": "Infinito",
  "Influenciadores e Educadores": "Influencers y educadores",
  "Informações Gerais": "Información general",
  "Informações Pessoais": "Información personal",
  "Informações atualizadas com sucesso": "Información actualizada correctamente",
  "Informações de ajuda não disponíveis para esta etapa.": "No hay información de ayuda disponible para esta etapa.",
  "Informações do Pagamento": "Información del pago",
  "Informações do vídeo": "Información del video",
  "Informações sobre sua assinatura e próxima cobrança": "Información sobre tu suscripción y el próximo cobro",
  "Informe a integration_key da Payt.": "Indica la integration_key de Payt.",
  "Informe este token ao atendente para autorizar o acesso temporário à sua conta.": "Facilita este token al agente para autorizar el acceso temporal a tu cuenta.",
  "Informe o Rótulo (Label) da ação de Play do Google Ads.": "Indica la etiqueta (Label) de la acción de reproducción de Google Ads.",
  "Informe o código de confirmação": "Introduce el código de confirmación",
  "Informe o token de": "Indica el token de",
  "Informe seu e-mail e enviaremos um código para redefinir sua senha.": "Indica tu correo electrónico y te enviaremos un código para restablecer tu contraseña.",
  "Informe um link válido iniciando com http:// ou https://.": "Introduce un enlace válido que empiece por http:// o https://.",
  "Informe um valor válido.": "Introduce un valor válido.",
  "Inicia o vídeo automaticamente quando o participante entra na sala.": "Inicia el video automáticamente cuando el participante entra en la sala.",
  "Inicia o vídeo com som sozinho, sem esperar o visitante clicar no aviso do autoplay. Navegadores só liberam som automático para quem já tem histórico na página — quando bloquearem, o aviso continua na tela e o primeiro toque em qualquer lugar libera o som.": "Inicia el video con sonido sin esperar al clic del visitante en el aviso de reproducción automática. Los navegadores solo permiten sonido automático cuando existe un historial previo en la página; si lo bloquean, el aviso permanece y el primer toque en cualquier lugar activa el sonido.",
  "Iniciado em:": "Iniciado el:",
  "Iniciado:": "Iniciado:",
  "Iniciar": "Iniciar",
  "Iniciar Teste A/B": "Iniciar prueba A/B",
  "Iniciar Teste A/B?": "¿Iniciar prueba A/B?",
  "Iniciar teste grátis": "Iniciar prueba gratis",
  "Iniciar vídeo principal automaticamente": "Iniciar el video principal automáticamente",
  "Inicie com problema → solução → benefício nos primeiros 30 segundos": "Empieza con problema → solución → beneficio en los primeros 30 segundos",
  "Inicie o teste na aba 'Teste A/B' para começar a coletar métricas.": "Inicia la prueba en la pestaña 'Prueba A/B' para empezar a recopilar métricas.",
  "Inicie o vídeo automaticamente com a melhor experiência.": "Inicia el video automáticamente con la mejor experiencia.",
  "Inscrição/Plano modificado com sucesso!": "¡Registro/plan modificado correctamente!",
  "Insight copiado!": "¡Análisis copiado!",
  "Insights": "Conclusiones",
  "Insights Automáticos": "Análisis automáticos",
  "Insights de Dispositivo": "Análisis de dispositivos",
  "Insira HTML simples. Scripts não são permitidos por segurança.": "Introduce HTML sencillo. No se permiten scripts por seguridad.",
  "Insira a senha para acessar o vídeo": "Introduce la contraseña para acceder al video",
  "Insira o nome do membro": "Introduce el nombre del miembro",
  "Insira o nome que aparecerá como criador do conteúdo na Playlist": "Introduce el nombre que aparecerá como creador del contenido en la lista de reproducción",
  "Insira os dados para continuar assistindo": "Introduce tus datos para seguir viendo",
  "Insira perguntas de engajamento": "Añade preguntas para generar interacción",
  "Insira seu código HTML personalizado para o botão": "Introduce tu código HTML personalizado para el botón",
  "Insira sua chave PIX aqui": "Introduce tu clave PIX aquí",
  "Insira um e-mail válido": "Introduce un correo electrónico válido",
  "Instalar": "Instalar",
  "Instalar Agora": "Instalar ahora",
  "Instalar HostVSL": "Instalar HostVSL",
  "Instale o HostVSL": "Instala HostVSL",
  "Instale o app para acesso rápido e funcionalidade offline": "Instala la aplicación para acceder rápidamente y usarla sin conexión",
  "Instituição Bancária": "Entidad bancaria",
  "Instituição Bancária (Cód. Banco)": "Entidad bancaria (código del banco)",
  "Instruções para iPhone/iPad": "Instrucciones para iPhone/iPad",
  "Integrar rastreamento": "Integrar seguimiento",
  "Integração com APIs de inteligência artificial para criação de conteúdo.": "Integración con API de inteligencia artificial para crear contenido.",
  "Integração com {value0} configurada com sucesso.": "Integración con {value0} configurada correctamente.",
  "Integração configurada com sucesso": "Integración configurada correctamente",
  "Integração criada": "Integración creada",
  "Integração criada. Configure o webhook na plataforma de vendas.": "Integración creada. Configura el webhook en la plataforma de ventas.",
  "Integração de rastreamento": "Integración de seguimiento",
  "Integração não configurada": "Integración sin configurar",
  "Integração salva com sucesso": "Integración guardada correctamente",
  "Integração vinculada. Vendas aprovadas são recebidas pelo webhook configurado na plataforma.": "Integración vinculada. Las ventas aprobadas se reciben mediante el webhook configurado en la plataforma.",
  "Integração/Real": "Integración/real",
  "Integrações Disponíveis": "Integraciones disponibles",
  "Integre Hotmart, Kirvano, Cakto, PerfectPay e muito mais.": "Integra Hotmart, Kirvano, Cakto, PerfectPay y mucho más.",
  "Integre plataformas de pagamento e rastreie conversões dos seus vídeos de forma simples.": "Integra plataformas de pago y sigue fácilmente las conversiones de tus videos.",
  "Integre suas plataformas para acompanhar métricas de vendas e conversões.": "Integra tus plataformas para seguir las métricas de ventas y conversiones.",
  "Intenso": "Intenso",
  "Intercale o talking head com imagens, gráficos ou textos para criar variação visual e manter atenção.": "Alterna la persona que habla con imágenes, gráficos o textos para crear variedad visual y mantener la atención.",
  "Interface otimizada que se comporta como um app nativo": "Interfaz optimizada que se comporta como una aplicación nativa",
  "Intervalo": "Intervalo",
  "Intervalo de Velocidades": "Intervalo de velocidades",
  "Intervalo de velocidades": "Intervalo de velocidades",
  "Intervalo entre sessões": "Intervalo entre sesiones",
  "Intervalo entre uma notificação e outra.": "Intervalo entre una notificación y otra.",
  "Intervalo testado:": "Intervalo probado:",
  "Intervalos": "Intervalos",
  "Intro #": "Introducción n.º",
  "Intro #{value0}": "Introducción n.º {value0}",
  "Intro Curiosidade": "Introducción de curiosidad",
  "Intro Problema-Solução": "Introducción de problema-solución",
  "Intro Testemunho": "Introducción de testimonio",
  "Intro atual": "Introducción actual",
  "Introdução": "Introducción",
  "Invalid or unsafe HTML content": "Contenido HTML no válido o inseguro",
  "Invalid or unsafe URL": "URL no válida o insegura",
  "Início (min:seg)": "Inicio (min:s)",
  "Início automático:": "Inicio automático:",
  "Início da Sessão": "Inicio de la sesión",
  "Início da headline": "Inicio del titular",
  "Início da oferta": "Inicio de la oferta",
  "Início do dia": "Inicio del día",
  "Início do período": "Inicio del período",
  "Início: quando as opções aparecem (vazio = fim do vídeo). Final: quando o vídeo pausa (opcional). Se o vídeo terminar sem escolha, ele congela no último quadro com as opções na tela.": "Inicio: cuando aparecen las opciones (vacío = final del video). Final: cuando se pausa el video (opcional). Si el video termina sin elegir, se congela en el último fotograma con las opciones en pantalla.",
  "Ir para Vídeos Compartilhados": "Ir a videos compartidos",
  "Ir para pagamento": "Ir al pago",
  "Ir para página da HostVSL (afiliado)": "Ir a la página de HostVSL (afiliado)",
  "Ir para site": "Ir al sitio",
  "Isso apaga o fluxo \"": "Esto elimina el flujo \"",
  "Isso interrompe o rastreamento deste vídeo. Esta ação não pode ser desfeita.": "Esto detiene el seguimiento de este video. Esta acción no se puede deshacer.",
  "Italiano": "Italiano",
  "JPG, PNG ou WEBP • Máx 2MB": "JPG, PNG o WEBP • Máx. 2 MB",
  "JPG, PNG • até": "JPG, PNG • hasta",
  "JS": "JS",
  "Janela Diária": "Franja diaria",
  "Janelas Campeãs de Conversão": "Franjas con mejor conversión",
  "JavaScript": "JavaScript",
  "Jornada de Conversão salva": "Recorrido de conversión guardado",
  "João Silva": "João Silva",
  "Já copiado:": "Ya copiado:",
  "Já copiei, fechar": "Ya lo he copiado, cerrar",
  "Já registrou": "Ya registró",
  "Kirvano": "Kirvano",
  "Kiwify": "Kiwify",
  "LOCALIZAÇÃO": "UBICACIÓN",
  "Layout do Formulário": "Diseño del formulario",
  "Lead capturado com sucesso": "Lead captado correctamente",
  "Leads Recentes": "Leads recientes",
  "Leads por Tipo": "Leads por tipo",
  "Legenda adicionada com sucesso!": "¡Subtítulos añadidos correctamente!",
  "Legenda removida.": "Subtítulos eliminados.",
  "Legendas adicionadas": "Subtítulos añadidos",
  "Legendas desativadas": "Subtítulos desactivados",
  "Legendas salvas": "Subtítulos guardados",
  "Leia atentamente as condições operacionais de repasse bancário.": "Lee atentamente las condiciones operativas de transferencia bancaria.",
  "Leia com atenção os termos operacionais de comissionamento.": "Lee atentamente las condiciones operativas de las comisiones.",
  "Lenta": "Lenta",
  "Lento": "Lento",
  "Leva para": "Lleva a",
  "Leve": "Ligero",
  "Li e concordo com as regras acima": "He leído y acepto las reglas anteriores",
  "Li e concordo com os termos acima": "He leído y acepto los términos anteriores",
  "Lib.": "Permit.",
  "Libera acesso ao vídeo somente após preenchimento de senha definida.": "Permite acceder al video solo después de introducir la contraseña definida.",
  "Libera dopamina e mantém a atenção por mais tempo": "Libera dopamina y mantiene la atención durante más tiempo",
  "Liberar botão após": "Habilitar botón después de",
  "Liberar ou bloquear por parâmetros UTM.": "Permitir o bloquear por parámetros UTM.",
  "Libere ou bloqueie países ou regiões específicas.": "Permite o bloquea países o regiones concretos.",
  "Libere um editor com botões inteligentes, player customizado e máxima conversão.": "Accede a un editor con botones inteligentes, reproductor personalizado y máxima conversión.",
  "Ligeiramente mais rápido": "Ligeramente más rápido",
  "Ligue vídeos curtos com perguntas e opções, leve cada visitante pela resposta dele até o checkout e veja onde cada um decide": "Conecta videos cortos con preguntas y opciones, guía a cada visitante hasta la página de pago según sus respuestas y observa dónde decide cada uno",
  "Limite de Cópias": "Límite de copias",
  "Limite de inscrições (opcional)": "Límite de inscripciones (opcional)",
  "Limite do plano": "Límite del plan",
  "Limite:": "Límite:",
  "Limpar": "Borrar",
  "Limpar Filtros": "Borrar filtros",
  "Limpar busca": "Borrar búsqueda",
  "Limpar busca e filtros": "Borrar búsqueda y filtros",
  "Line": "Línea",
  "Linha Fina": "Línea fina",
  "Linha estável até 50% = storytelling eficiente.": "Línea estable hasta el 50 % = narración eficaz.",
  "Link": "Enlace",
  "Link criado com sucesso!": "¡Enlace creado correctamente!",
  "Link de {value0} não encontrado.": "No se encontró el enlace de {value0}.",
  "Link discreto": "Enlace discreto",
  "Link do botão é obrigatório": "El enlace del botón es obligatorio",
  "Link do segundo botão": "Enlace del segundo botón",
  "Link público do webinário:": "Enlace público del seminario web:",
  "Link revogado com sucesso!": "¡Enlace revocado correctamente!",
  "Link verificado • Seguro": "Enlace verificado • Seguro",
  "Link único para acessar seu webinário. Exemplo: /w/meu-webinar": "Enlace único para acceder a tu seminario web. Ejemplo: /w/meu-webinar",
  "Links do Rodapé": "Enlaces del pie de página",
  "Lista de cidades": "Lista de ciudades",
  "Lista de domínios autorizados a exibir seus vídeos": "Lista de dominios autorizados para mostrar tus videos",
  "Lista de nomes": "Lista de nombres",
  "Locais": "Ubicaciones",
  "Localização": "Ubicación",
  "Localização atual": "Ubicación actual",
  "Logo Marca": "Logotipo de la marca",
  "Logo Preview": "Vista previa del logotipo",
  "Logo atualizada": "Logotipo actualizado",
  "Logo da Playlist": "Logotipo de la lista de reproducción",
  "Logo do Webinário": "Logotipo del seminario web",
  "Logo no Player": "Logotipo en el reproductor",
  "Logo removida": "Logotipo eliminado",
  "Logo {value0}": "Logotipo {value0}",
  "Logs Recentes": "Registros recientes",
  "MB": "MB",
  "MM / AA": "MM / AA",
  "MM/AA": "MM/AA",
  "MP4, MOV • até 5GB": "MP4, MOV • hasta 5 GB",
  "MP4, MOV, AVI | Máximo: 100MB": "MP4, MOV, AVI | Máximo: 100 MB",
  "MP4, MOV, AVI, WebM • Tamanho máximo: 100MB": "MP4, MOV, AVI, WebM • Tamaño máximo: 100 MB",
  "Maior Autoridade e Visibilidade": "Mayor autoridad y visibilidad",
  "Maior duração": "Mayor duración",
  "Maior eficiência": "Mayor eficiencia",
  "Maior faturamento": "Mayores ingresos",
  "Maior queda (16:00)": "Mayor caída (16:00)",
  "Mais Popular": "Más popular",
  "Mais ações de {value0}": "Más acciones de {value0}",
  "Mais detalhes": "Más detalles",
  "Mais do que um player de vídeo": "Más que un reproductor de video",
  "Mais opções": "Más opciones",
  "Mais opções do vídeo {value0}": "Más opciones del video {value0}",
  "Mais popular": "Más popular",
  "Mais recente": "Más reciente",
  "Mais recentes": "Más recientes",
  "Mais reproduzido": "Más reproducido",
  "Mais vistos": "Más vistos",
  "Major update": "Actualización importante",
  "Mantenha a excelência": "Mantén la excelencia",
  "Mantenha a excelência narrativa": "Mantén la excelencia narrativa",
  "Mantenha cada intro entre 30 segundos e 2 minutos": "Mantén cada introducción entre 30 segundos y 2 minutos",
  "Mantenha sua conta protegida": "Mantén tu cuenta protegida",
  "Manter modal": "Mantener diálogo",
  "Manter velocidade campeã após finalização": "Mantener la velocidad ganadora al finalizar",
  "Mapa de Calor (Conversão)": "Mapa de calor (conversión)",
  "Mapa de Calor (Volume)": "Mapa de calor (volumen)",
  "Mapa de Rotas": "Mapa de rutas",
  "Marcador do pitch (opcional)": "Marcador de oferta (opcional)",
  "Marcar agora": "Marcar ahora",
  "Marcar aula como concluída": "Marcar lección como completada",
  "Marcar como lidas": "Marcar como leídas",
  "Margem": "Margen",
  "Margens Internas (Padding):": "Márgenes interiores (relleno):",
  "Master Class Host VSL": "Clase magistral de Host VSL",
  "Medida de quanto tempo os usuários assistem ao vídeo em relação à duração total.": "Medida del tiempo que los usuarios ven el video en relación con su duración total.",
  "Meio": "Centro",
  "Melhor CTR": "Mejor CTR",
  "Melhor horário": "Mejor horario",
  "Melhor janela": "Mejor franja",
  "Melhor performance": "Mejor rendimiento",
  "Melhor vídeo do período:": "Mejor video del período:",
  "Melhores Janelas": "Mejores franjas",
  "Melhores Janelas (Volume)": "Mejores franjas (volumen)",
  "Melhores práticas": "Buenas prácticas",
  "Melhoria": "Mejora",
  "Membro": "Miembro",
  "Membro adicionado com sucesso!": "¡Miembro añadido correctamente!",
  "Membro atualizado com sucesso!": "¡Miembro actualizado correctamente!",
  "Membro bloqueado com sucesso!": "¡Miembro bloqueado correctamente!",
  "Membro desbloqueado com sucesso!": "¡Miembro desbloqueado correctamente!",
  "Membro removido com sucesso!": "¡Miembro eliminado correctamente!",
  "Membros da Rede": "Miembros de la red",
  "Mensagem Adicional": "Mensaje adicional",
  "Mensagem Exibida": "Mensaje mostrado",
  "Mensagem automática (opcional)": "Mensaje automático (opcional)",
  "Mensagem da Notificação": "Mensaje de la notificación",
  "Mensagem de Erro": "Mensaje de error",
  "Mensagem de agradecimento": "Mensaje de agradecimiento",
  "Mensagem de bloqueio": "Mensaje de bloqueo",
  "Mensagem do chat": "Mensaje del chat",
  "Mensal": "Mensual",
  "Menu da pasta": "Menú de la carpeta",
  "Meta Ideal": "Objetivo ideal",
  "Meta-análise:": "Metaanálisis:",
  "Meta:": "Objetivo:",
  "Metas Alcançadas": "Objetivos alcanzados",
  "Metas alcançadas": "Objetivos alcanzados",
  "Meu Perfil": "Mi perfil",
  "Meus Pixels": "Mis píxeles",
  "Meça conversões do Google Ads (ID AW- + rótulo) nos eventos do seu VSL: play, progresso e clique no checkout.": "Mide las conversiones de Google Ads (ID AW- y etiqueta) en los eventos de tu VSL: reproducción, progreso y clic en la página de pago.",
  "Meça eventos do TikTok Ads (Pixel Code) no seu VSL: visualização e clique no botão de compra.": "Mide los eventos de TikTok Ads (Pixel Code) en tu VSL: visualización y clic en el botón de compra.",
  "Microguru e Tutor": "Microgurú y tutor",
  "Minhas Playlists": "Mis listas de reproducción",
  "Mini Hooks salvos": "Mini Hooks guardados",
  "Miniaturas ao passar o mouse na barra": "Miniaturas al pasar el cursor por la barra",
  "Minimalista": "Minimalista",
  "Modele páginas com um clique e personalize do seu jeito.": "Modela páginas con un clic y personalízalas a tu gusto.",
  "Modelo do bloco": "Modelo del bloque",
  "Moderna": "Moderna",
  "Moderno": "Moderno",
  "Modo Educacional": "Modo educativo",
  "Modo Teste": "Modo de prueba",
  "Modo de Exibição da Thumbnail": "Modo de visualización de la miniatura",
  "Modo de filtragem": "Modo de filtrado",
  "Modo foco": "Modo de enfoque",
  "Modo foco: só a mesa em evidência": "Modo de enfoque: solo se destaca el panel",
  "Momento (min:seg)": "Momento (min:s)",
  "Momento do Vídeo": "Momento del video",
  "Momento do vídeo onde a audiência está mais engajada.": "Momento del video en el que la audiencia está más involucrada.",
  "Momento exato": "Momento exacto",
  "Momentos específicos no vídeo onde uma quantidade significativa de espectadores para de assistir. Revise estes pontos para manter o engajamento.": "Momentos concretos del video en los que muchos espectadores dejan de verlo. Revisa estos puntos para mantener la interacción.",
  "Momentos onde muitos espectadores abandonam o vídeo. Reduza este número para melhorar a retenção.": "Momentos en los que muchos espectadores abandonan el video. Reduce esta cifra para mejorar la retención.",
  "Monetizze": "Monetizze",
  "Monitoramento": "Supervisión",
  "Monitore conversões e eventos importantes do seu vídeo com pixels de rastreamento": "Controla las conversiones y los eventos importantes de tu video con píxeles de seguimiento",
  "Monitore todas as visitas, conversões e registos gerados através do seu tráfego em tempo real no nosso dashboard.": "Controla en tiempo real todas las visitas, conversiones y registros generados por tu tráfico en nuestro panel.",
  "Monospace": "Monoespaciada",
  "More": "Más",
  "More pages": "Más páginas",
  "Mostra o interesse inicial no vídeo. Gap alto = título forte, copy fraca.": "Muestra el interés inicial por el video. Una diferencia grande indica un título fuerte y un texto débil.",
  "Mostra o progresso visual do vídeo": "Muestra el progreso visual del video",
  "Mostra o tempo atual e duração do vídeo": "Muestra el tiempo actual y la duración del video",
  "Mostra os controles no rodapé do player": "Muestra los controles al pie del reproductor",
  "Mostra quanto o vídeo vencedor está à frente do segundo colocado nesta métrica.": "Muestra cuánto supera el video ganador al segundo clasificado en esta métrica.",
  "Mostrando 20 de": "Mostrando 20 de",
  "Mostrando detalhes da integração {value0}": "Mostrando detalles de la integración {value0}",
  "Mostrar": "Mostrar",
  "Mostrar Sombras": "Mostrar sombras",
  "Mostrar Tempo": "Mostrar tiempo",
  "Mostrar barra na parte inferior após fechar": "Mostrar barra en la parte inferior después de cerrar",
  "Mostrar borda": "Mostrar borde",
  "Mostrar durante todo o vídeo": "Mostrar durante todo el video",
  "Mostrar em todo vídeo": "Mostrar en todo el video",
  "Mostrar formulário em um momento específico do vídeo": "Mostrar formulario en un momento concreto del video",
  "Mostrar letra A–D": "Mostrar letra A–D",
  "Mostrar mensagem de agradecimento": "Mostrar mensaje de agradecimiento",
  "Mostrar novamente nos últimos 20 segundos": "Mostrar de nuevo en los últimos 20 segundos",
  "Mostrar ou ocultar o título do formulário": "Mostrar u ocultar el título del formulario",
  "Mostrar senha": "Mostrar contraseña",
  "Mostrar texto na barra": "Mostrar texto en la barra",
  "Mostrar token": "Mostrar token",
  "Mostre elementos que transmitam segurança": "Muestra elementos que transmitan seguridad",
  "Mostre um contador de pessoas assistindo o vídeo": "Muestra un contador de personas viendo el video",
  "Mostre um contador dinâmico de pessoas assistindo para gerar prova social durante o vídeo.": "Muestra un contador dinámico de personas viendo para generar prueba social durante el video.",
  "Mostre vagas disponíveis ou progresso": "Muestra plazas disponibles o progreso",
  "Mostre visualmente o avanço do vídeo e aumente a retenção.": "Muestra visualmente el avance del video y aumenta la retención.",
  "Mover": "Mover",
  "Mover de pasta": "Cambiar de carpeta",
  "Mover para outra pasta": "Mover a otra carpeta",
  "Mover pasta": "Mover carpeta",
  "Mudanças Recentes": "Cambios recientes",
  "Mudo há +24h": "Sin eventos desde hace más de 24 h",
  "Muito rápido": "Muy rápido",
  "Multiplicador de Velocidade": "Multiplicador de velocidad",
  "MÊS": "MES",
  "Máximo": "Máximo",
  "Máximo de 10 caracteres": "Máximo de 10 caracteres",
  "Média assistida do vídeo": "Media vista del video",
  "Média de Engajamento": "Interacción media",
  "Média mensal:": "Media mensual:",
  "Método avançado JavaScript com todas as opções de personalização e controle do botão de ação.": "Método JavaScript avanzado con todas las opciones de personalización y control del botón de acción.",
  "Método de pagamento adicionado com sucesso!": "¡Método de pago añadido correctamente!",
  "Método de pagamento definido como padrão!": "¡Método de pago definido como predeterminado!",
  "Método de pagamento removido.": "Método de pago eliminado.",
  "Métrica": "Métrica",
  "Métrica de cliques atualizada com sucesso!": "¡Métrica de clics actualizada correctamente!",
  "Métricas (7 dias)": "Métricas (7 días)",
  "Métricas (últimos": "Métricas (últimos",
  "Métricas Individuais das Introduções": "Métricas individuales de las introducciones",
  "Métricas de Picos de Horários": "Métricas de horas punta",
  "Métricas de Uso": "Métricas de uso",
  "Métricas do Teste": "Métricas de la prueba",
  "Métricas do Teste de Introduções": "Métricas de la prueba de introducciones",
  "Métricas do Vídeo": "Métricas del video",
  "Métricas do fluxo": "Métricas del flujo",
  "Módulo": "Módulo",
  "Módulo 1 Primeiros passos": "Módulo 1 Primeros pasos",
  "Módulo 2 Personalização": "Módulo 2 Personalización",
  "Módulo 3 Recursos de conversão": "Módulo 3 Funciones de conversión",
  "Módulo 4 Análises e performance": "Módulo 4 Análisis y rendimiento",
  "Módulo 5 Plano e plays": "Módulo 5 Plan y reproducciones",
  "Módulos (até 6)": "Módulos (hasta 6)",
  "Na Payt, cadastre esta URL para o evento de pagamento aprovado e use a mesma chave de integração.": "En Payt, registra esta URL para el evento de pago aprobado y usa la misma clave de integración.",
  "Na mesma aba": "En la misma pestaña",
  "Na playlist": "En la lista de reproducción",
  "Nada impede a publicação. Vale conferir os avisos.": "Nada impide la publicación. Conviene revisar los avisos.",
  "Nada novo para publicar": "Nada nuevo que publicar",
  "Narrativas bem estruturadas podem aumentar conversões em até 30%": "Las narrativas bien estructuradas pueden aumentar las conversiones hasta un 30 %",
  "Navegador Principal": "Navegador principal",
  "Navegadores e Sistemas": "Navegadores y sistemas",
  "Navegação": "Navegación",
  "Navegação da série": "Navegación de la serie",
  "Nederlands": "Nederlands",
  "Nenhum / Sem Plano Ativo": "Ninguno / Sin plan activo",
  "Nenhum Mini Hook adicionado ainda.": "Todavía no se ha añadido ningún Mini Hook.",
  "Nenhum acesso está ativo agora.": "No hay ningún acceso activo ahora.",
  "Nenhum banco cadastrado.": "No hay bancos registrados.",
  "Nenhum bônus criado. Clique em \"Adicionar Bônus\" para começar.": "No se han creado bonificaciones. Haz clic en \"Añadir bonificación\" para empezar.",
  "Nenhum cartão selecionado": "Ninguna tarjeta seleccionada",
  "Nenhum comentário encontrado com esse filtro.": "No se encontraron comentarios con este filtro.",
  "Nenhum comprovante enviado": "No se ha enviado ningún justificante",
  "Nenhum custo encontrado": "No se encontraron costes",
  "Nenhum dado de cidade disponível": "No hay datos de ciudades disponibles",
  "Nenhum dado de estado disponível": "No hay datos de estados disponibles",
  "Nenhum dado de funil disponível ainda": "Todavía no hay datos del embudo disponibles",
  "Nenhum dado de localização disponível": "No hay datos de ubicación disponibles",
  "Nenhum dado de país disponível": "No hay datos de países disponibles",
  "Nenhum dado encontrado": "No se encontraron datos",
  "Nenhum dado encontrado para o período selecionado": "No se encontraron datos para el período seleccionado",
  "Nenhum dado encontrado para o período selecionado.": "No se encontraron datos para el período seleccionado.",
  "Nenhum disparo registrado ainda. Abra o VSL uma vez com som e recarregue esta tela. Se já abriu e nada aparece, confira se a URL vinculada é a página onde o vídeo roda.": "Todavía no se ha registrado ningún envío. Abre la VSL una vez con sonido y recarga esta pantalla. Si ya lo has hecho y no aparece nada, comprueba que la URL vinculada es la página donde se reproduce el video.",
  "Nenhum dispositivo": "Ningún dispositivo",
  "Nenhum dispositivo ainda": "Todavía ningún dispositivo",
  "Nenhum dispositivo encontrado": "No se encontraron dispositivos",
  "Nenhum domínio encontrado para \"": "No se encontraron dominios para \"",
  "Nenhum evento detectado ainda. Verifique se o pixel está instalado na página vinculada.": "Todavía no se ha detectado ningún evento. Comprueba que el píxel está instalado en la página vinculada.",
  "Nenhum evento encontrado para este filtro.": "No se encontraron eventos para este filtro.",
  "Nenhum fluxo encontrado com esse filtro.": "No se encontraron flujos con este filtro.",
  "Nenhum incremento de clicks foi encontrado para o e-mail informado. Você pode criar um novo registro clicando no botão abaixo.": "No se encontró ningún incremento de clics para el correo electrónico indicado. Puedes crear un nuevo registro con el botón de abajo.",
  "Nenhum link definido.": "Ningún enlace definido.",
  "Nenhum log disponível ainda": "Todavía no hay registros disponibles",
  "Nenhum log encontrado com os filtros selecionados.": "No se encontraron registros con los filtros seleccionados.",
  "Nenhum membro encontrado": "No se encontraron miembros",
  "Nenhum membro encontrado na sua rede.": "No se encontraron miembros en tu red.",
  "Nenhum membro encontrado. Adicione membros para gerenciar sua equipe.": "No se encontraron miembros. Añade miembros para gestionar tu equipo.",
  "Nenhum método de pagamento cadastrado.": "No hay métodos de pago registrados.",
  "Nenhum módulo criado. Clique em \"Adicionar Módulo\" para começar.": "No se han creado módulos. Haz clic en \"Añadir módulo\" para empezar.",
  "Nenhum módulo ou bônus ainda": "Todavía no hay módulos ni bonificaciones",
  "Nenhum país adicionado. Clique em \"Adicionar País\" para começar.": "No se han añadido países. Haz clic en \"Añadir país\" para empezar.",
  "Nenhum pixel": "Ningún píxel",
  "Nenhum pixel configurado": "Ningún píxel configurado",
  "Nenhum pixel corresponde aos filtros selecionados.": "Ningún píxel coincide con los filtros seleccionados.",
  "Nenhum pixel encontrado": "No se encontraron píxeles",
  "Nenhum problema encontrado no fluxo.": "No se encontraron problemas en el flujo.",
  "Nenhum recurso encontrado": "No se encontraron funciones",
  "Nenhum recurso encontrado para \"": "No se encontraron funciones para \"",
  "Nenhum registro de incremento cadastrado.": "No hay registros de incremento.",
  "Nenhum registro encontrado para este e-mail. Você pode criar um novo.": "No se encontraron registros para este correo electrónico. Puedes crear uno nuevo.",
  "Nenhum registro selecionado": "Ningún registro seleccionado",
  "Nenhum resultado": "Sin resultados",
  "Nenhum resultado.": "Sin resultados.",
  "Nenhum selecionado": "Ninguno seleccionado",
  "Nenhum teste ativo no momento": "No hay pruebas activas en este momento",
  "Nenhum teste de introdução encontrado.": "No se encontraron pruebas de introducción.",
  "Nenhum teste de velocidade ativo.": "No hay pruebas de velocidad activas.",
  "Nenhum teste em execução": "No hay pruebas en ejecución",
  "Nenhum token ativo.": "Ningún token activo.",
  "Nenhum usuário selecionado": "Ningún usuario seleccionado",
  "Nenhum vídeo": "Ningún video",
  "Nenhum vídeo adicionado a este teste ainda.": "Todavía no se han añadido videos a esta prueba.",
  "Nenhum vídeo ainda. Envie os vídeos curtos de cada etapa do fluxo.": "Todavía no hay videos. Envía los videos cortos de cada etapa del flujo.",
  "Nenhum vídeo compartilhado ainda": "Todavía no se han compartido videos",
  "Nenhum vídeo de teste adicionado": "Ningún video de prueba añadido",
  "Nenhum vídeo disponível para seleção": "No hay videos disponibles para seleccionar",
  "Nenhum vídeo disponível. Faça upload de um vídeo primeiro.": "No hay videos disponibles. Sube un video primero.",
  "Nenhum vídeo encontrado neste teste A/B.": "No se encontraron videos en esta prueba A/B.",
  "Nenhum vídeo encontrado para \"": "No se encontraron videos para \"",
  "Nenhum vídeo encontrado para análise de performance.": "No se encontraron videos para el análisis de rendimiento.",
  "Nenhum vídeo encontrado para “": "No se encontraron videos para «",
  "Nenhum vídeo enviado ainda": "Todavía no se han enviado videos",
  "Nenhum vídeo finalizado": "Ningún video finalizado",
  "Nenhum vídeo importado": "Ningún video importado",
  "Nenhum vídeo original selecionado": "Ningún video original seleccionado",
  "Nenhum webinário criado ainda": "Todavía no se ha creado ningún seminario web",
  "Nenhuma alteração foi feita em sua conta.": "No se ha realizado ningún cambio en tu cuenta.",
  "Nenhuma atualização por aqui": "No hay actualizaciones por aquí",
  "Nenhuma aula ainda": "Todavía no hay lecciones",
  "Nenhuma aula disponível": "No hay lecciones disponibles",
  "Nenhuma aula encontrada": "No se encontraron lecciones",
  "Nenhuma aula encontrada.": "No se encontraron lecciones.",
  "Nenhuma aula publicada nesta série ainda.": "Todavía no hay lecciones publicadas en esta serie.",
  "Nenhuma ação configurada ainda": "Todavía no hay acciones configuradas",
  "Nenhuma chave ainda": "Todavía no hay claves",
  "Nenhuma chave ativa": "No hay claves activas",
  "Nenhuma conversão registrada ainda. Adicione plataformas e aguarde as primeiras conversões.": "Todavía no se han registrado conversiones. Añade plataformas y espera las primeras conversiones.",
  "Nenhuma cópia registrada ainda": "Todavía no se han registrado copias",
  "Nenhuma fatura encontrada": "No se encontraron facturas",
  "Nenhuma fonte de tráfego detectada": "No se ha detectado ninguna fuente de tráfico",
  "Nenhuma imagem disponível": "No hay imágenes disponibles",
  "Nenhuma integração encontrada para os filtros selecionados.": "No se encontraron integraciones para los filtros seleccionados.",
  "Nenhuma novidade encontrada.": "No se encontraron novedades.",
  "Nenhuma novidade por aqui": "No hay novedades por aquí",
  "Nenhuma opção leva a esta saída": "Ninguna opción lleva a esta salida",
  "Nenhuma origem encontrada": "No se encontraron orígenes",
  "Nenhuma pasta criada": "No se han creado carpetas",
  "Nenhuma plataforma selecionada. Adicione plataformas para visualizar os webhooks.": "No hay plataformas seleccionadas. Añade plataformas para ver los webhooks.",
  "Nenhuma proteção criada ainda": "Todavía no se han creado protecciones",
  "Nenhuma receita identificada": "No se han identificado ingresos",
  "Nenhuma região adicionada. Clique em \"Adicionar Região\" para começar.": "No se han añadido regiones. Haz clic en \"Añadir región\" para empezar.",
  "Nenhuma regra UTM adicionada. Clique em \"Adicionar Regra UTM\" para começar.": "No se han añadido reglas UTM. Haz clic en \"Añadir regla UTM\" para empezar.",
  "Nenhuma regra criada ainda. Adicione condições para liberar ou bloquear acessos.": "Todavía no se han creado reglas. Añade condiciones para permitir o bloquear accesos.",
  "Nenhuma selecionada": "Ninguna seleccionada",
  "Nenhuma solicitação encontrada": "No se encontraron solicitudes",
  "Nenhuma transferência ou comissão localizada para esta conta no BD.": "No se encontraron transferencias ni comisiones para esta cuenta en la base de datos.",
  "Nenhuma venda registrada": "No se han registrado ventas",
  "Neon": "Neon",
  "Netflix Dark": "Netflix Dark",
  "Next": "Siguiente",
  "Next slide": "Siguiente diapositiva",
  "Ninguém assistindo agora": "Nadie está viendo ahora",
  "No final do teste, você pode fixar a intro com melhor desempenho.": "Al final de la prueba, puedes fijar la introducción con mejor rendimiento.",
  "No final do vídeo": "Al final del video",
  "Nome (opcional)": "Nombre (opcional)",
  "Nome (só você vê)": "Nombre (solo lo ves tú)",
  "Nome A-Z": "Nombre A-Z",
  "Nome alterado para \"{value0}\"": "Nombre cambiado a \"{value0}\"",
  "Nome atualizado": "Nombre actualizado",
  "Nome da Playlist": "Nombre de la lista de reproducción",
  "Nome da etapa": "Nombre de la etapa",
  "Nome da legenda": "Nombre de los subtítulos",
  "Nome da proteção": "Nombre de la protección",
  "Nome de parâmetro inválido": "Nombre de parámetro no válido",
  "Nome do Criador": "Nombre del creador",
  "Nome do Serviço *": "Nombre del servicio *",
  "Nome do Teste *": "Nombre de la prueba *",
  "Nome do Titular da Conta": "Nombre del titular de la cuenta",
  "Nome do Usuário": "Nombre del usuario",
  "Nome do Webinário": "Nombre del seminario web",
  "Nome do Webinário *": "Nombre del seminario web *",
  "Nome do membro": "Nombre del miembro",
  "Nome do parâmetro": "Nombre del parámetro",
  "Nome exibido ao lado do favicon": "Nombre que aparece junto al favicon",
  "Nome igual ao documento": "Nombre tal como aparece en el documento",
  "Nome interno para identificação (não será exibido publicamente)": "Nombre interno para identificación (no se mostrará públicamente)",
  "Nome interno para identificação. Não será exibido ao público.": "Nombre interno para identificación. No se mostrará al público.",
  "Nome muito longo (máximo 80 caracteres)": "Nombre demasiado largo (máximo 80 caracteres)",
  "Nome no cartão": "Nombre en la tarjeta",
  "Nome obrigatório": "El nombre es obligatorio",
  "Nossa tecnologia de Cloaker protege sua VSL contra cópias de forma simples.": "Nuestra tecnología de Cloaker protege tu VSL de las copias de forma sencilla.",
  "Nota 1 a 5": "Puntuación del 1 al 5",
  "Nota média": "Puntuación media",
  "Notas internas (opcional)": "Notas internas (opcional)",
  "Notificação de Vendas salva": "Notificación de ventas guardada",
  "Notificação enviada": "Notificación enviada",
  "Notificações": "Notificaciones",
  "Notificações Ativas": "Notificaciones activas",
  "Notificações Bloqueadas": "Notificaciones bloqueadas",
  "Notificações Desativadas": "Notificaciones desactivadas",
  "Notificações Push": "Notificaciones push",
  "Notificações não disponíveis": "Notificaciones no disponibles",
  "Nova Permissão": "Nuevo permiso",
  "Nova Playlist": "Nueva lista de reproducción",
  "Nova Subpasta": "Nueva subcarpeta",
  "Nova Variação": "Nueva variación",
  "Nova Variação de Headline": "Nueva variación de titular",
  "Nova chave": "Nueva clave",
  "Nova chave de API": "Nueva clave de API",
  "Nova data de término": "Nueva fecha de fin",
  "Nova funcionalidade disponível": "Nueva función disponible",
  "Nova integração com {value0} será criada": "Se creará una nueva integración con {value0}",
  "Nova proteção": "Nueva protección",
  "Nova saída": "Nueva salida",
  "Nova tag...": "Nueva etiqueta...",
  "Novas Conversões": "Nuevas conversiones",
  "Novas conversões": "Nuevas conversiones",
  "Novo Dashboard Premium Host VSL 2.0": "Nuevo panel prémium de Host VSL 2.0",
  "Novo Método de Pagamento": "Nuevo método de pago",
  "Novo Registro": "Nuevo registro",
  "Novo Registro de Incremento": "Nuevo registro de incremento",
  "Novo Webinário": "Nuevo seminario web",
  "Novo lead: João Silva": "Nuevo lead: João Silva",
  "Novo link gerado com sucesso!": "¡Nuevo enlace generado correctamente!",
  "Novo nome": "Nuevo nombre",
  "Novo recurso": "Nueva función",
  "Novo status": "Nuevo estado",
  "Novo token gerado.": "Nuevo token generado.",
  "Novo valor": "Nuevo valor",
  "Novos recursos no editor": "Nuevas funciones en el editor",
  "Novos recursos, melhorias e orientações para usar a HostVSL.": "Nuevas funciones, mejoras y orientaciones para usar HostVSL.",
  "Numeração": "Numeración",
  "Não Configurado": "Sin configurar",
  "Não assistido": "Sin ver",
  "Não definida": "Sin definir",
  "Não encontramos aulas com os filtros selecionados. Tente ajustar sua busca ou explorar outras categorias.": "No se encontraron lecciones con los filtros seleccionados. Ajusta la búsqueda o explora otras categorías.",
  "Não encontramos nenhuma pasta com \"": "No se encontraron carpetas con \"",
  "Não encontramos um cupom com esse nome.": "No se encontró ningún cupón con ese nombre.",
  "Não encontramos vídeos com \"{value0}\"": "No se encontraron videos con \"{value0}\"",
  "Não existem testes de velocidade automáticos": "No existen pruebas automáticas de velocidad",
  "Não fechar automaticamente": "No cerrar automáticamente",
  "Não foi possível abrir a transmissão": "No se pudo abrir la transmisión",
  "Não foi possível abrir o fluxo": "No se pudo abrir el flujo",
  "Não foi possível abrir o seletor": "No se pudo abrir el selector",
  "Não foi possível abrir o seletor AirPlay": "No se pudo abrir el selector de AirPlay",
  "Não foi possível ativar o seu perfil de afiliado.": "No se pudo activar tu perfil de afiliado.",
  "Não foi possível atualizar o nome. Tente novamente.": "No se pudo actualizar el nombre. Inténtalo de nuevo.",
  "Não foi possível carregar a audiência ao vivo": "No se pudo cargar la audiencia en directo",
  "Não foi possível carregar a comparação": "No se pudo cargar la comparación",
  "Não foi possível carregar a lista de vídeos": "No se pudo cargar la lista de videos",
  "Não foi possível carregar a lista de vídeos.": "No se pudo cargar la lista de videos.",
  "Não foi possível carregar as aulas": "No se pudieron cargar las lecciones",
  "Não foi possível carregar as métricas.": "No se pudieron cargar las métricas.",
  "Não foi possível carregar as plataformas.": "No se pudieron cargar las plataformas.",
  "Não foi possível carregar o player da VSL Dinâmica.": "No se pudo cargar el reproductor de la VSL dinámica.",
  "Não foi possível carregar os dados para edição.": "No se pudieron cargar los datos para editar.",
  "Não foi possível carregar os vídeos. Tentar de novo": "No se pudieron cargar los videos. Intentar de nuevo",
  "Não foi possível carregar seus fluxos.": "No se pudieron cargar tus flujos.",
  "Não foi possível carregar seus vídeos.": "No se pudieron cargar tus videos.",
  "Não foi possível carregar suas chaves": "No se pudieron cargar tus claves",
  "Não foi possível conectar": "No se pudo conectar",
  "Não foi possível copiar as configurações. Tente novamente.": "No se pudo copiar la configuración. Inténtalo de nuevo.",
  "Não foi possível copiar o código.": "No se pudo copiar el código.",
  "Não foi possível copiar. Copie o código pelo editor do fluxo.": "No se pudo copiar. Copia el código desde el editor del flujo.",
  "Não foi possível copiar. Selecione a URL para copiar.": "No se pudo copiar. Selecciona la URL para copiarla.",
  "Não foi possível copiar. Selecione o código e copie manualmente.": "No se pudo copiar. Selecciona el código y cópialo manualmente.",
  "Não foi possível copiar. Selecione o texto e copie manualmente.": "No se pudo copiar. Selecciona el texto y cópialo manualmente.",
  "Não foi possível criar contexto do canvas": "No se pudo crear el contexto del lienzo",
  "Não foi possível criar o fluxo.": "No se pudo crear el flujo.",
  "Não foi possível criar o teste de velocidade": "No se pudo crear la prueba de velocidad",
  "Não foi possível criar o teste de velocidade.": "No se pudo crear la prueba de velocidad.",
  "Não foi possível criar o teste. Tente novamente.": "No se pudo crear la prueba. Inténtalo de nuevo.",
  "Não foi possível deletar o teste de velocidade.": "No se pudo eliminar la prueba de velocidad.",
  "Não foi possível deletar o teste. Tente novamente.": "No se pudo eliminar la prueba. Inténtalo de nuevo.",
  "Não foi possível desativar a captura.": "No se pudo desactivar la captura.",
  "Não foi possível duplicar o vídeo. Tente novamente.": "No se pudo duplicar el video. Inténtalo de nuevo.",
  "Não foi possível gerar a thumbnail. Tente novamente.": "No se pudo generar la miniatura. Inténtalo de nuevo.",
  "Não foi possível gerar o código": "No se pudo generar el código",
  "Não foi possível gerar o token. Tentar novamente.": "No se pudo generar el token. Intentar de nuevo.",
  "Não foi possível identificar o usuário. Faça login novamente.": "No se pudo identificar al usuario. Vuelve a iniciar sesión.",
  "Não foi possível processar o saque.": "No se pudo procesar la retirada.",
  "Não foi possível renomear o fluxo.": "No se pudo cambiar el nombre del flujo.",
  "Não foi possível salvar a regra. Tente novamente.": "No se pudo guardar la regla. Inténtalo de nuevo.",
  "Não foi possível salvar a velocidade": "No se pudo guardar la velocidad",
  "Não foi possível salvar as alterações. Tente novamente.": "No se pudieron guardar los cambios. Inténtalo de nuevo.",
  "Não foi possível salvar o rascunho. Tente novamente.": "No se pudo guardar el borrador. Inténtalo de nuevo.",
  "Não foi possível salvar. Tente novamente": "No se pudo guardar. Inténtalo de nuevo",
  "Não foi salvo": "No se ha guardado",
  "Não há capturas para os filtros aplicados. Tente ajustar os filtros ou selecione outro período.": "No hay capturas para los filtros aplicados. Ajusta los filtros o selecciona otro período.",
  "Não há dados de vídeos disponíveis para exibir o gráfico de retenção.": "No hay datos de videos disponibles para mostrar el gráfico de retención.",
  "Não há visualizações com parâmetros UTM neste período. Use parâmetros UTM nas suas URLs para rastrear a origem do tráfego.": "No hay visualizaciones con parámetros UTM en este período. Usa parámetros UTM en tus URL para seguir el origen del tráfico.",
  "Não salvo (conflito)": "Sin guardar (conflicto)",
  "Não selecionada": "Sin seleccionar",
  "Não solicitar dados": "No solicitar datos",
  "Não, obrigado": "No, gracias",
  "Nível de Acesso": "Nivel de acceso",
  "Nível do usuário atualizado com sucesso!": "¡Nivel del usuario actualizado correctamente!",
  "Número": "Número",
  "Número da Conta com DV": "Número de cuenta con dígito de control",
  "Número de Linhas": "Número de líneas",
  "Número de cliques no botão": "Número de clics en el botón",
  "Número de cliques nos elementos interativos do vídeo.": "Número de clics en los elementos interactivos del video.",
  "Número de pessoas que clicaram no botão de ação (CTA) dentro do vídeo.": "Número de personas que hicieron clic en el botón de acción (CTA) del video.",
  "Número de vezes que o vídeo foi iniciado por visitantes.": "Número de veces que los visitantes iniciaron el video.",
  "Número de visitantes únicos que ativaram este evento": "Número de visitantes únicos que activaron este evento",
  "Número de visitantes únicos que visualizaram o vídeo.": "Número de visitantes únicos que visualizaron el video.",
  "Número do WhatsApp": "Número de WhatsApp",
  "Número máximo de afiliados que podem copiar": "Número máximo de afiliados que pueden copiar",
  "Número total de carregamentos do seu vídeo.": "Número total de cargas de tu video.",
  "Número total de cliques recebidos por este evento": "Número total de clics recibidos por este evento",
  "Número total de vendas confirmadas pelas plataformas de pagamento": "Número total de ventas confirmadas por las plataformas de pago",
  "O \"Vídeo Principal\" é o arquivo sem introdução. Depois, você adiciona as intros que serão tocadas antes dele para medir qual abertura gera mais atenção e conversão.": "El \"Video principal\" es el archivo sin introducción. Después, añades las introducciones que se reproducirán antes para medir qué comienzo genera más atención y conversión.",
  "O CEP deve conter exatamente 8 dígitos.": "El código postal debe contener exactamente 8 dígitos.",
  "O CPF deve conter exatamente 11 dígitos.": "El CPF debe contener exactamente 11 dígitos.",
  "O JavaScript oferece mais customização e integração com eventos.": "JavaScript ofrece más personalización e integración con eventos.",
  "O Smart Autoplay exibe um vídeo automático antes do usuário clicar para assistir. Ideal para aumentar retenção e curiosidade.": "La reproducción automática inteligente muestra un video antes de que el usuario haga clic para verlo. Ideal para aumentar la retención y la curiosidad.",
  "O Teste de hook alterna automaticamente entre intros diferentes e coleta dados como retenção e cliques.": "La prueba de ganchos alterna automáticamente entre distintas introducciones y recopila datos como retención y clics.",
  "O URL deve iniciar com https://": "La URL debe empezar por https://",
  "O app já está instalado ou seu navegador não suporta instalação.": "La aplicación ya está instalada o tu navegador no permite instalarla.",
  "O arquivo deve ter no máximo 500KB": "El archivo debe ocupar como máximo 500 KB",
  "O arquivo precisa ter até 10MB.": "El archivo debe ocupar como máximo 10 MB.",
  "O botão será aplicado automaticamente ao vídeo ativo no preview": "El botón se aplicará automáticamente al video activo de la vista previa",
  "O botão será exibido após este tempo de reprodução do vídeo": "El botón aparecerá después de este tiempo de reproducción del video",
  "O contador oscilará dentro deste intervalo durante o vídeo.": "El contador oscilará dentro de este intervalo durante el video.",
  "O código de integração foi copiado para a área de transferência.": "El código de integración se ha copiado al portapapeles.",
  "O código foi copiado para a área de transferência.": "El código se ha copiado al portapapeles.",
  "O código que já está nos seus sites passa a mostrar esta versão nas próximas visitas. Não precisa colar de novo.": "El código que ya está en tus sitios mostrará esta versión en las próximas visitas. No tienes que pegarlo de nuevo.",
  "O dashboard foi completamente redesenhado com cards executivos de métricas, feed de vídeos em tempo real e insights de performance. Uma experiência visual nível Apple para gerenciar seus vídeos.": "El panel se ha rediseñado por completo con tarjetas ejecutivas de métricas, un feed de videos en tiempo real y análisis de rendimiento. Una experiencia visual al nivel de Apple para gestionar tus videos.",
  "O domínio \"": "El dominio \"",
  "O download do arquivo CSV começará em instantes.": "La descarga del archivo CSV comenzará en unos instantes.",
  "O ecossistema definitivo": "El ecosistema definitivo",
  "O editor da VSL Dinâmica precisa de uma tela com pelo menos 1024 px. A lista e as métricas funcionam no celular.": "El editor de VSL dinámica necesita una pantalla de al menos 1024 px. La lista y las métricas funcionan en el móvil.",
  "O endereço salvo continua o anterior.": "La dirección guardada sigue siendo la anterior.",
  "O engajamento em mobile está": "La interacción en móvil está",
  "O estilo será controlado pelo código HTML inserido na aba Configuração. Use CSS inline ou classes personalizadas para estilizar seu botão.": "El estilo se controlará mediante el código HTML introducido en la pestaña Configuración. Usa CSS en línea o clases personalizadas para dar estilo al botón.",
  "O fluxo ainda não tem etapas.": "El flujo todavía no tiene etapas.",
  "O fluxo ainda não tem opções.": "El flujo todavía no tiene opciones.",
  "O fluxo ainda não tem saídas.": "El flujo todavía no tiene salidas.",
  "O fluxo continua em rascunho.": "El flujo sigue en borrador.",
  "O fluxo pode ter no máximo {value0} saídas.": "El flujo puede tener un máximo de {value0} salidas.",
  "O fluxo tem": "El flujo tiene",
  "O formato de história tem provado ser muito eficaz para manter o engajamento do início ao fim.": "El formato de historia ha demostrado ser muy eficaz para mantener la interacción de principio a fin.",
  "O formato narrativo está funcionando bem! Continue contando histórias que se conectam emocionalmente com seu público.": "¡El formato narrativo funciona bien! Sigue contando historias que conecten emocionalmente con tu público.",
  "O gráfico será atualizado quando houver atividade": "El gráfico se actualizará cuando haya actividad",
  "O iFrame é a forma mais simples de incorporar, mas oferece menos customização.": "El iFrame es la forma más sencilla de insertar el video, pero ofrece menos personalización.",
  "O ideal: curva lenta e constante, mantendo acima de 50% até o minuto 1.": "Lo ideal: una curva lenta y constante, por encima del 50 % hasta el primer minuto.",
  "O link da playlist foi copiado para a área de transferência.": "El enlace de la lista de reproducción se ha copiado al portapapeles.",
  "O link de afiliado é obrigatório quando o recurso está ativado.": "El enlace de afiliado es obligatorio cuando la función está activada.",
  "O link para {value0} já está na sua área de transferência.": "El enlace de {value0} ya está en el portapapeles.",
  "O nome da estratégia foi atualizado com sucesso.": "El nombre de la estrategia se ha actualizado correctamente.",
  "O nome deve ter pelo menos 2 caracteres": "El nombre debe tener al menos 2 caracteres",
  "O nome do seu teste não pode estar vazio.": "El nombre de la prueba no puede estar vacío.",
  "O número definido em \"Base\" será exibido automaticamente após a mensagem.": "El número definido en \"Base\" aparecerá automáticamente después del mensaje.",
  "O pitch precisa de ajustes urgentes.": "La oferta necesita ajustes urgentes.",
  "O pixel do Facebook é uma ferramenta de análise que permite medir a eficácia da sua publicidade ao compreender as ações que as pessoas realizam no seu site.": "El píxel de Facebook es una herramienta de análisis que permite medir la eficacia de tu publicidad al comprender las acciones que las personas realizan en tu sitio.",
  "O pixel foi conectado com sucesso.": "El píxel se ha conectado correctamente.",
  "O pixel foi configurado e ativado com sucesso.": "El píxel se ha configurado y activado correctamente.",
  "O pixel foi desativado com sucesso.": "El píxel se ha desactivado correctamente.",
  "O pixel foi removido com sucesso.": "El píxel se ha eliminado correctamente.",
  "O que acontece após o usuário enviar o formulário": "Qué ocurre después de que el usuario envíe el formulario",
  "O que acontece quando a regra for atendida": "Qué ocurre cuando se cumple la regla",
  "O que vai acontecer": "Qué va a ocurrir",
  "O que você vai aprender:": "Lo que aprenderás:",
  "O rascunho continua salvo. Só a publicação fica bloqueada até resolver.": "El borrador sigue guardado. Solo se bloquea la publicación hasta resolver el problema.",
  "O recurso foi desativado com sucesso.": "La función se ha desactivado correctamente.",
  "O servidor recusou este vínculo. Preencha primeiro o 'Perfil Comercial' à esquerda antes de adicionar o banco.": "El servidor ha rechazado esta vinculación. Completa primero el 'Perfil comercial' de la izquierda antes de añadir el banco.",
  "O sistema de rotas é gerenciado pelo React Router v6. Todas as rotas principais são protegidas pelo componente ProtectedRoute que verifica autenticação.": "React Router v6 gestiona el sistema de rutas. Todas las rutas principales están protegidas por el componente ProtectedRoute, que comprueba la autenticación.",
  "O sistema distribuirá o tráfego entre as introduções selecionadas, garantindo uma amostra estatística válida.": "El sistema distribuirá el tráfico entre las introducciones seleccionadas para garantizar una muestra estadística válida.",
  "O sistema distribuirá o tráfego entre os vídeos selecionados, garantindo uma amostra estatística válida.": "El sistema distribuirá el tráfico entre los videos seleccionados para garantizar una muestra estadística válida.",
  "O template da mensagem não pode estar vazio": "La plantilla del mensaje no puede estar vacía",
  "O tempo do pitch foi salvo com sucesso.": "El tiempo de la oferta se ha guardado correctamente.",
  "O teste de introduções foi finalizado com sucesso.": "La prueba de introducciones ha finalizado correctamente.",
  "O teste de velocidade foi criado e está coletando dados": "La prueba de velocidad se ha creado y está recopilando datos",
  "O teste está coletando dados em tempo real": "La prueba recopila datos en tiempo real",
  "O teste roda normalmente, mas sem as métricas de conversão das plataformas de pagamento.": "La prueba funciona normalmente, pero sin las métricas de conversión de las plataformas de pago.",
  "O teste só encerra quando você clicar em \"Finalizar Teste\".": "La prueba solo finaliza cuando haces clic en \"Finalizar prueba\".",
  "O teste usará as": "La prueba usará las",
  "O texto foi copiado para a área de transferência.": "El texto se ha copiado al portapapeles.",
  "O texto principal que aparece no formulário": "El texto principal que aparece en el formulario",
  "O token é de uso único, expira em 30 minutos e não dá acesso ao seu e-mail ou senha.": "El token es de un solo uso, caduca en 30 minutos y no permite acceder a tu correo electrónico ni a tu contraseña.",
  "O título deve ter no máximo 100 caracteres": "El título debe tener como máximo 100 caracteres",
  "O vídeo": "El video",
  "O vídeo \"": "El video \"",
  "O vídeo ainda está processando.": "El video todavía se está procesando.",
  "O vídeo começará exatamente no horário agendado. Participantes que entrarem depois verão o vídeo já em andamento.": "El video comenzará exactamente a la hora programada. Quienes entren después lo verán ya en curso.",
  "O vídeo deve ter no máximo 2GB": "El video debe ocupar como máximo 2 GB",
  "O vídeo deve ter no máximo 500MB": "El video debe ocupar como máximo 500 MB",
  "O vídeo foi adicionado à sua conta com sucesso. Os plays serão contabilizados no seu plano.": "El video se ha añadido correctamente a tu cuenta. Las reproducciones se contabilizarán en tu plan.",
  "O vídeo foi movido para a pasta selecionada.": "El video se ha movido a la carpeta seleccionada.",
  "O vídeo foi removido da playlist.": "El video se ha quitado de la lista de reproducción.",
  "O vídeo inicia no momento correspondente ao horário atual": "El video empieza en el momento correspondiente a la hora actual",
  "O vídeo pausa após o envio do formulário": "El video se pausa después de enviar el formulario",
  "O vídeo pausa após o usuário enviar a senha correta": "El video se pausa después de que el usuario envíe la contraseña correcta",
  "O vídeo pausa automaticamente quando o visitante sai da aba, retomando ao voltar.": "El video se pausa automáticamente cuando el visitante sale de la pestaña y se reanuda al volver.",
  "O vídeo pausa quando o formulário aparecer": "El video se pausa cuando aparece el formulario",
  "O vídeo pausa quando o formulário de senha aparece": "El video se pausa cuando aparece el formulario de contraseña",
  "O vídeo que mais gerou receita": "El video que más ingresos ha generado",
  "O vídeo selecionado não está disponível": "El video seleccionado no está disponible",
  "O vídeo selecionado, será exibido após todas as introduções testadas.": "El video seleccionado aparecerá después de todas las introducciones probadas.",
  "O vídeo será pausado automaticamente nesse tempo": "El video se pausará automáticamente en este momento",
  "O ícone do HostVSL aparecerá na sua tela inicial": "El icono de HostVSL aparecerá en tu pantalla de inicio",
  "O ícone será exibido automaticamente conforme a plataforma.": "El icono se mostrará automáticamente según la plataforma.",
  "OAuth cancelado": "OAuth cancelado",
  "Obrigado pelo seu feedback!": "¡Gracias por tus comentarios!",
  "Obrigado por nos informar!": "¡Gracias por informarnos!",
  "Observação interna": "Nota interna",
  "Observação:": "Nota:",
  "Observe a taxa de cliques em botões de ação": "Observa la tasa de clics en los botones de acción",
  "Observe se a diferença se mantém constante ao longo de diversos dias.": "Comprueba si la diferencia se mantiene constante durante varios días.",
  "Ocorreu um erro ao carregar o conteúdo. Verifique sua conexão e tente novamente.": "Se ha producido un error al cargar el contenido. Comprueba tu conexión e inténtalo de nuevo.",
  "Ocorreu um erro ao carregar o vídeo": "Se ha producido un error al cargar el video",
  "Ocorreu um erro ao configurar a integração.": "Se ha producido un error al configurar la integración.",
  "Ocorreu um erro ao gerar o gráfico de retenção. Por favor, tente novamente mais tarde.": "Se ha producido un error al generar el gráfico de retención. Inténtalo más tarde.",
  "Ocorreu um erro ao processar a ativação.": "Se ha producido un error al procesar la activación.",
  "Ocorreu um erro ao remover a logo": "Se ha producido un error al eliminar el logotipo",
  "Ocorreu um erro ao remover a thumbnail": "Se ha producido un error al eliminar la miniatura",
  "Ocorreu um erro ao salvar as configurações. Tente novamente.": "Se ha producido un error al guardar la configuración. Inténtalo de nuevo.",
  "Ocorreu um erro ao salvar suas alterações": "Se ha producido un error al guardar tus cambios",
  "Ocorreu um erro inesperado ao carregar as configurações de headline.": "Se ha producido un error inesperado al cargar la configuración de titulares.",
  "Ocorreu um erro inesperado ao carregar esta página. Tente recarregar ou limpar o cache.": "Se ha producido un error inesperado al cargar esta página. Prueba a recargar o borrar la caché.",
  "Ocorreu um erro inesperado. Por favor, recarregue a página.": "Se ha producido un error inesperado. Recarga la página.",
  "Ocultar": "Ocultar",
  "Ocultar modal": "Ocultar diálogo",
  "Ocultar senha": "Ocultar contraseña",
  "Ocultar token": "Ocultar token",
  "Ofereça vantagens especiais para quem comprar com você (ex. bônus exclusivo com link).": "Ofrece ventajas especiales a quienes compren contigo (por ejemplo, una bonificación exclusiva mediante enlace).",
  "Oferta": "Oferta",
  "Oferta ativada! Plano atualizado com sucesso.": "¡Oferta activada! Plan actualizado correctamente.",
  "Oferta exclusiva": "Oferta exclusiva",
  "Oferta expirada": "Oferta caducada",
  "Oferta relâmpago": "Oferta relámpago",
  "Oferta termina em": "La oferta termina en",
  "Ofertas": "Ofertas",
  "Ofertas nos Vídeos": "Ofertas en los videos",
  "Offset Horizontal": "Desplazamiento horizontal",
  "Offset Vertical": "Desplazamiento vertical",
  "Olá, {value0}": "Hola, {value0}",
  "Online": "En línea",
  "Only safe HTML elements are allowed. Scripts and event handlers will be removed.": "Solo se permiten elementos HTML seguros. Se eliminarán los scripts y los controladores de eventos.",
  "Ontem": "Ayer",
  "Oops! Page not found": "¡Vaya! Página no encontrada",
  "Opacidade ao passar o mouse": "Opacidad al pasar el cursor",
  "Opaco": "Opaco",
  "Opera": "Opera",
  "Operador": "Operador",
  "Oportunidades Escondidas": "Oportunidades ocultas",
  "Optimize sua thumbnail": "Optimiza tu miniatura",
  "Opção": "Opción",
  "Opções": "Opciones",
  "Opções avançadas": "Opciones avanzadas",
  "Organize e personalize os campos de inscrição (arraste para reordenar)": "Organiza y personaliza los campos de registro (arrastra para reordenarlos)",
  "Organize por campanha ou grupo": "Organiza por campaña o grupo",
  "Organize seus vídeos como nunca antes com o novo sistema hierárquico de pastas. Crie pastas, subpastas, arraste e solte vídeos para organizar seu conteúdo de forma profissional.": "Organiza tus videos como nunca con el nuevo sistema jerárquico de carpetas. Crea carpetas y subcarpetas, arrastra y suelta videos para organizar tu contenido de forma profesional.",
  "Organize seus vídeos criando pastas e subpastas": "Organiza tus videos creando carpetas y subcarpetas",
  "Organize seus vídeos em sequência e compartilhe com seu público": "Organiza tus videos en secuencia y compártelos con tu público",
  "Organize seus vídeos em sequências e publique com 1 clique.": "Organiza tus videos en secuencias y publica con un clic.",
  "Origem Top": "Origen principal",
  "Origem dos Leads": "Origen de los leads",
  "Origem dos visitantes": "Origen de los visitantes",
  "Origem principal:": "Origen principal:",
  "Origens": "Orígenes",
  "Origens (": "Orígenes (",
  "Origens de Tráfego": "Orígenes del tráfico",
  "Origens no gráfico": "Orígenes en el gráfico",
  "Os": "Los",
  "Os 3 dígitos no verso do cartão": "Los 3 dígitos del reverso de la tarjeta",
  "Os dados de dispositivos aparecerão após os primeiros acessos.": "Los datos de dispositivos aparecerán después de los primeros accesos.",
  "Os dados estão sendo exportados em CSV": "Los datos se están exportando en CSV",
  "Os dados serão exibidos aqui quando houver interações com o seu conteúdo.": "Los datos aparecerán aquí cuando haya interacciones con tu contenido.",
  "Os dados são atualizados a cada 15 minutos.": "Los datos se actualizan cada 15 minutos.",
  "Os downloads falharam. Tente novamente.": "Las descargas han fallado. Inténtalo de nuevo.",
  "Os plays serão consumidos do seu plano.": "Las reproducciones se consumirán de tu plan.",
  "Os relatórios de performance ficarão disponíveis aqui após a criação de estratégias.": "Los informes de rendimiento estarán disponibles aquí después de crear estrategias.",
  "Os serviços de segurança da Stripe estão carregando. Aguarde.": "Los servicios de seguridad de Stripe se están cargando. Espera.",
  "Os seus saldos acumulados são liquidados diretamente na sua carteira configurada de forma segura e pontual.": "Tus saldos acumulados se liquidan directamente en tu cartera configurada de forma segura y puntual.",
  "Os sites que já têm o código passam a mostrar esta versão nas próximas visitas.": "Los sitios que ya tienen el código mostrarán esta versión en las próximas visitas.",
  "Os testes A/B de headlines requerem que o autoplay esteja ativado para garantir que os usuários vejam as variações antes de interagir com o vídeo.": "Las pruebas A/B de titulares requieren la reproducción automática activada para que los usuarios vean las variaciones antes de interactuar con el video.",
  "Os testes de velocidade permitem comparar diferentes configurações para encontrar a melhor para seu público.": "Las pruebas de velocidad permiten comparar distintas configuraciones para encontrar la mejor para tu público.",
  "Os testes de velocidade permitem que você faça testes A/B de diferentes velocidades de reprodução para encontrar a configuração ideal para engajamento e conversões.": "Las pruebas de velocidad permiten hacer pruebas A/B de distintas velocidades de reproducción para encontrar la configuración ideal de interacción y conversiones.",
  "Os uploads em andamento serão cancelados. Esta ação não pode ser desfeita.": "Las subidas en curso se cancelarán. Esta acción no se puede deshacer.",
  "Otimizar Introdução": "Optimizar introducción",
  "Otimize suas ofertas com base em dados de performance": "Optimiza tus ofertas con datos de rendimiento",
  "Ou URL de destino (opcional)": "O URL de destino (opcional)",
  "Ou envie um WhatsApp para:": "O envía un WhatsApp a:",
  "Outro": "Otro",
  "Outro idioma…": "Otro idioma…",
  "Outros": "Otros",
  "Overlay de Pausa": "Capa de pausa",
  "Overlay escuro (VTurb)": "Capa oscura (VTurb)",
  "Overlay escuro para leitura": "Capa oscura para facilitar la lectura",
  "PDF gerado com sucesso!": "¡PDF generado correctamente!",
  "PDF pronto para impressão": "PDF listo para imprimir",
  "PLAYER": "REPRODUCTOR",
  "PNG 256×256px recomendado": "PNG de 256×256 px recomendado",
  "PNG com fundo transparente • Máx. 1MB": "PNG con fondo transparente • Máx. 1 MB",
  "PNG ou JPG · até 10MB": "PNG o JPG · hasta 10 MB",
  "PNG recomendado": "PNG recomendado",
  "PNG transparente branco recomendado": "PNG blanco transparente recomendado",
  "PNG, JPG, GIF • Máx. 5MB": "PNG, JPG, GIF • Máx. 5 MB",
  "Padronizar configurações": "Unificar configuración",
  "Padrão de Uso": "Patrón de uso",
  "Padrão do player": "Predeterminado del reproductor",
  "Padrões de interrupção": "Cambios de patrón",
  "Pagamento atualizado com sucesso!": "¡Pago actualizado correctamente!",
  "Pagamento criptografado e processado com segurança.": "Pago cifrado y procesado de forma segura.",
  "Pagar agora": "Pagar ahora",
  "Pague faturas em aberto e baixe as anteriores": "Paga las facturas pendientes y descarga las anteriores",
  "Painel lateral": "Panel lateral",
  "Painéis": "Paneles",
  "Para VSLs de venda, recomendamos exibir o feedback apenas no final ou após o pitch para não interromper a conversão.": "Para las VSL de ventas, recomendamos mostrar la valoración solo al final o después de la oferta para no interrumpir la conversión.",
  "Para acompanhar conversões, conecte o Rastreamento.": "Para seguir las conversiones, conecta Seguimiento.",
  "Para exibir a thumbnail de início, desabilite a reprodução automática.": "Para mostrar la miniatura inicial, desactiva la reproducción automática.",
  "Para finalizar": "Para finalizar",
  "Para melhores resultados, use vídeos com a": "Para obtener mejores resultados, usa videos con la",
  "Para onde o botão HTML vai redirecionar o visitante.": "Dónde redirigirá el botón HTML al visitante.",
  "Para onde o visitante vai ao escolher uma opção: checkout, WhatsApp ou outra página.": "Dónde va el visitante al elegir una opción: página de pago, WhatsApp u otra página.",
  "Para otimizar ainda mais, considere aumentar o ritmo ou adicionar elementos visuais entre 45-60% do vídeo.": "Para optimizar aún más, aumenta el ritmo o añade elementos visuales entre el 45 % y el 60 % del video.",
  "Para que as alterações da headline funcionem, você precisa copiar o código do vídeo depois de salvar e colar no seu site.": "Para que funcionen los cambios del titular, copia el código del video después de guardar y pégalo en tu sitio.",
  "Para que as alterações do botão de ação abaixo do vídeo funcionem, você precisa copiar o código do vídeo depois de salvar e colar no seu site.": "Para que funcionen los cambios del botón de acción bajo el video, copia el código del video después de guardar y pégalo en tu sitio.",
  "Para resultados confiáveis, espere pelo menos 100-200 visualizações por variação.": "Para obtener resultados fiables, espera al menos entre 100 y 200 visualizaciones por variación.",
  "Para visualizar todos os dados de receita, conversões e desempenho, conecte sua plataforma de pagamento. É rápido e seguro.": "Para ver todos los datos de ingresos, conversiones y rendimiento, conecta tu plataforma de pago. Es rápido y seguro.",
  "Parabéns!": "¡Enhorabuena!",
  "Parabéns! A sua conta de afiliado foi ativada.": "¡Enhorabuena! Tu cuenta de afiliado está activada.",
  "Parabéns! 🏆": "¡Enhorabuena! 🏆",
  "Parceiros Oficiais": "Socios oficiales",
  "Parcerias": "Colaboraciones",
  "Participantes entram direto na sala sem preencher formulário": "Los participantes entran directamente en la sala sin completar un formulario",
  "Parâmetro UTM": "Parámetro UTM",
  "Parâmetros fixos": "Parámetros fijos",
  "Pasta": "Carpeta",
  "Pasta criada": "Carpeta creada",
  "Pasta criada.": "Carpeta creada.",
  "Pasta não encontrada": "Carpeta no encontrada",
  "Pasta personalizada criada": "Carpeta personalizada creada",
  "Pasta renomeada": "Nombre de la carpeta cambiado",
  "Pasta renomeada com sucesso!": "¡Nombre de la carpeta cambiado correctamente!",
  "Pasta renomeada.": "Nombre de la carpeta cambiado.",
  "Pasta vazia": "Carpeta vacía",
  "Pastas específicas": "Carpetas específicas",
  "Pausados": "Pausados",
  "Pausar": "Pausar",
  "Pausar ao abrir a senha": "Pausar al abrir la contraseña",
  "Pausar ao enviar senha": "Pausar al enviar la contraseña",
  "Pausar em (min:seg)": "Pausar en (min:s)",
  "Pausar fluxo": "Pausar flujo",
  "Pausar vídeo ao abrir": "Pausar video al abrir",
  "Pausar vídeo ao enviar": "Pausar video al enviar",
  "PayPal (E-mail)": "PayPal (correo electrónico)",
  "País das regiões": "País de las regiones",
  "País não encontrado": "País no encontrado",
  "País sem regiões mapeadas": "País sin regiones registradas",
  "País: {value0}": "País: {value0}",
  "Percentual": "Porcentaje",
  "Percentual da largura do player": "Porcentaje del ancho del reproductor",
  "Percentual de espectadores que ainda assistiam quando cada pitch começou.": "Porcentaje de espectadores que seguían viendo al comenzar cada oferta.",
  "Percentual de visitantes que clicaram para iniciar o vídeo. Melhore sua thumbnail para aumentar este número.": "Porcentaje de visitantes que hicieron clic para iniciar el video. Mejora la miniatura para aumentar esta cifra.",
  "Percentual do vídeo {value0}": "Porcentaje del video {value0}",
  "Percepção do conteúdo ao longo do período.": "Percepción del contenido a lo largo del período.",
  "Perda no fim = oferta fraca ou muito longa.": "Pérdida al final = oferta débil o demasiado larga.",
  "Perdendo": "Perdiendo",
  "Perfect Pay": "Perfect Pay",
  "Perfil comercial updated e saques liberados!": "¡Perfil comercial actualizado y retiradas habilitadas!",
  "Perfis ideais para o programa de parcerias": "Perfiles ideales para el programa de socios",
  "Performance de Engajamento": "Rendimiento de interacción",
  "Performance neste horário": "Rendimiento en este horario",
  "Pergunta (opcional)": "Pregunta (opcional)",
  "Perguntas Frequentes": "Preguntas frecuentes",
  "Permissões atualizadas com sucesso!": "¡Permisos actualizados correctamente!",
  "Permissões limitadas atribuídas.": "Permisos limitados asignados.",
  "Permissões por Recurso": "Permisos por función",
  "Permita ou bloqueie a reprodução dos seus vídeos com base na localização.": "Permite o bloquea la reproducción de tus videos según la ubicación.",
  "Permita que espectadores avaliem o vídeo e acompanhe a percepção real do conteúdo.": "Permite que los espectadores valoren el video y conoce la percepción real del contenido.",
  "Permita que o espectador retome de onde parou.": "Permite que el espectador reanude donde se quedó.",
  "Permita que o usuário controle a velocidade do vídeo": "Permite que el usuario controle la velocidad del video",
  "Permita uma observação após a nota.": "Permite añadir un comentario después de la puntuación.",
  "Permite ajustar a velocidade do vídeo": "Permite ajustar la velocidad del video",
  "Permite assistir em janela flutuante": "Permite ver en una ventana flotante",
  "Permite entrada direta na sala sem formulário de login. Ideal para tráfego qualificado.": "Permite entrar directamente en la sala sin formulario de acceso. Ideal para tráfico cualificado.",
  "Permite expandir o vídeo para tela cheia": "Permite ampliar el video a pantalla completa",
  "Permite pular rapidamente trechos": "Permite omitir fragmentos rápidamente",
  "Permite que o usuário continue de onde parou": "Permite que el usuario continúe donde se quedó",
  "Permite que o usuário continue sem preencher o formulário": "Permite que el usuario continúe sin completar el formulario",
  "Permite que visitantes entrem direto na sala sem fazer login. Útil para maximizar acessos, mas reduz a captação de leads.": "Permite que los visitantes entren directamente en la sala sin iniciar sesión. Útil para maximizar los accesos, pero reduce la captación de leads.",
  "Permitidas": "Permitidas",
  "Permitido": "Permitido",
  "Permitido: {value0}": "Permitido: {value0}",
  "Permitidos": "Permitidos",
  "Permitir": "Permitir",
  "Permitir apenas": "Permitir solo",
  "Permitir apenas e-mails de domínios específicos": "Permitir solo correos electrónicos de dominios concretos",
  "Permitir comentário após avaliação": "Permitir comentarios después de la valoración",
  "Permitir entrada até (minutos após início)": "Permitir la entrada hasta (minutos después del inicio)",
  "Permitir fechar no \"X\"": "Permitir cerrar con la \"X\"",
  "Permitir repetir este vídeo ao terminar.": "Permitir repetir este video al terminar.",
  "Persistir como barra fixa": "Mantener como barra fija",
  "Persistência": "Persistencia",
  "Persistência:": "Persistencia:",
  "Personalizar Logo…": "Personalizar logotipo…",
  "Personalizar Tema": "Personalizar tema",
  "Personalizar Vídeo": "Personalizar video",
  "Personalizar Vídeos": "Personalizar videos",
  "Personalização Total": "Personalización total",
  "Personalização da Logo": "Personalización del logotipo",
  "Personalizações": "Personalizaciones",
  "Personalize a aparência da página de inscrição": "Personaliza el aspecto de la página de registro",
  "Personalize a barra de progresso do player.": "Personaliza la barra de progreso del reproductor.",
  "Personalize as cores e aparência do player.": "Personaliza los colores y el aspecto del reproductor.",
  "Personalize as cores e espessura da barra de progresso.": "Personaliza los colores y el grosor de la barra de progreso.",
  "Personalize as cores, opacidade e bordas dos controles do player para combinar com sua marca.": "Personaliza los colores, la opacidad y los bordes de los controles del reproductor para adaptarlos a tu marca.",
  "Personalize as mensagens do feedback.": "Personaliza los mensajes de valoración.",
  "Personalize estilo, cor e posição do card.": "Personaliza el estilo, el color y la posición de la tarjeta.",
  "Personalize headline e subheadline": "Personaliza el titular y el subtítulo",
  "Personalize o Player": "Personaliza el reproductor",
  "Personalize o comportamento do player para cada tipo de dispositivo": "Personaliza el comportamiento del reproductor para cada tipo de dispositivo",
  "Período *": "Período *",
  "Peso:": "Peso:",
  "Pesquisar nesta pasta...": "Buscar en esta carpeta...",
  "Pesquisar novidades...": "Buscar novedades...",
  "Pesquisar vídeo ou pasta...": "Buscar video o carpeta...",
  "Pesquisar...": "Buscar...",
  "Pessoas cadastradas através dos seus links.": "Personas registradas a través de tus enlaces.",
  "Pessoas que assistiram": "Personas que vieron",
  "Pessoas únicas": "Personas únicas",
  "Pico Absoluto": "Pico absoluto",
  "Pico Absoluto (": "Pico absoluto (",
  "Pico Absoluto (Volume)": "Pico absoluto (volumen)",
  "Pico Absoluto de Conversão": "Pico absoluto de conversión",
  "Pico de audiência": "Pico de audiencia",
  "Pill": "Cápsula",
  "Pitch atualizado": "Oferta actualizada",
  "Pitch atualizado com sucesso!": "¡Oferta actualizada correctamente!",
  "Pitch não configurado — clique para definir": "Oferta sin configurar: haz clic para definirla",
  "Pixel ID": "ID del píxel",
  "Pixel ID deve ter 15-16 dígitos numéricos": "El ID del píxel debe tener entre 15 y 16 dígitos numéricos",
  "Pixel ID do TikTok inválido. Use o ID alfanumérico do Events Manager.": "ID del píxel de TikTok no válido. Usa el ID alfanumérico de Events Manager.",
  "Pixel adicionado com sucesso!": "¡Píxel añadido correctamente!",
  "Pixel ativo": "Píxel activo",
  "Pixel atualizado": "Píxel actualizado",
  "Pixel atualizado com sucesso!": "¡Píxel actualizado correctamente!",
  "Pixel conectado": "Píxel conectado",
  "Pixel configurado": "Píxel configurado",
  "Pixel configurado com sucesso!": "¡Píxel configurado correctamente!",
  "Pixel desativado": "Píxel desactivado",
  "Pixel do Google Ads": "Píxel de Google Ads",
  "Pixel do TikTok": "Píxel de TikTok",
  "Pixel excluído com sucesso!": "¡Píxel eliminado correctamente!",
  "Pixel removido": "Píxel eliminado",
  "/ mês": "/ mes",
  "/mês": "/mes",
  "30.000 plays por mês": "30.000 reproducciones al mes",
  "6 cards premium com métricas essenciais": "6 tarjetas prémium con métricas esenciales",
  "6.000 plays por mês": "6.000 reproducciones al mes",
  "60.000 plays por mês": "60.000 reproducciones al mes",
  "A Builderall oferece a plataforma mais completa de marketing e automação para você expandir seus negócios.": "Builderall ofrece una plataforma completa de marketing y automatización para hacer crecer tu negocio.",
  "A Ferramenta Mais Fácil Para Criar Chatbots Sem Código Do Brasil. Agora você pode automatizar seu marketing, geração de lead, atendimento e muito mais com um robô.": "La herramienta más sencilla de Brasil para crear chatbots sin código. Automatiza tu marketing, la generación de leads, la atención al cliente y mucho más con un bot.",
  "A curva mostra o play rate de cada hora": "La curva muestra la tasa de reproducción de cada hora",
  "A distribuição precisa totalizar 100%": "La distribución debe sumar el 100 %",
  "A etapa {value0} não tem vídeo.": "La etapa {value0} no tiene video.",
  "A etapa {value0} não é alcançada a partir do início.": "No se puede llegar a la etapa {value0} desde el inicio.",
  "A melhorar": "Por mejorar",
  "A notificação pode virar um link clicável que abre a sua oferta em uma nova aba": "La notificación puede convertirse en un enlace que abra tu oferta en una nueva pestaña",
  "A pausa precisa vir depois de as opções aparecerem.": "La pausa debe producirse después de que aparezcan las opciones.",
  "A solução perfeita para aumentar suas vendas! Com SMS Funnel você divulga seu produto ou serviço em tempo real para todo Brasil e todas as operadoras.": "¡La solución perfecta para aumentar tus ventas! Con SMS Funnel promocionas tu producto o servicio en tiempo real en todo Brasil y con todos los operadores.",
  "AS senhas não correspondem!": "¡Las contraseñas no coinciden!",
  "Abra a pré-visualização e percorra os caminhos como um visitante. Também dá para começar por uma etapa específica. A prévia não contabiliza plays e mostra o endereço das saídas sem abrir a página. Confira a aba Problemas e resolva as pendências antes de publicar.": "Abre la vista previa y recorre los caminos como un visitante. También puedes empezar por una etapa concreta. La vista previa no cuenta reproducciones y muestra las direcciones de salida sin abrirlas. Revisa la pestaña Problemas y resuelve las incidencias antes de publicar.",
  "Abra as métricas do fluxo para entender quantas pessoas começaram a assistir, por quais etapas passaram e quais opções escolheram. Na aba Vídeos, selecione um vídeo para analisar sua curva de retenção, a duração, a retenção média e a quantidade de plays usada na análise.": "Abre las métricas del flujo para saber cuántas personas empezaron a ver, qué etapas recorrieron y qué opciones eligieron. En la pestaña Videos, selecciona uno para analizar su curva de retención, duración, retención media y número de reproducciones utilizadas en el análisis.",
  "Accordion de Estilo Avançado agora inicia aberto por padrão. Texto atualizado de \"overlay\" para \"Autoplay\".": "El acordeón de estilo avanzado ahora se abre de forma predeterminada. Se ha cambiado el texto de \"overlay\" a \"Reproducción automática\".",
  "Acessar o checkout não significa comprar. A Taxa de acesso ao checkout mede esse avanço no funil; ela é diferente da Conversão em venda. Para acompanhar vendas aprovadas e receita atribuída, use Conectar rastreamento, escolha a saída de checkout e a plataforma de vendas e siga as instruções para cadastrar o webhook na plataforma, direcionado às compras desse checkout. Sem conexão, os indicadores de vendas aparecem como “—”.": "Acceder a la página de pago no significa comprar. La tasa de acceso a la página de pago mide ese avance en el embudo y es distinta de la conversión en venta. Para seguir las ventas aprobadas y los ingresos atribuidos, usa Conectar seguimiento, elige la salida de pago y la plataforma de ventas, y sigue las instrucciones para registrar el webhook de las compras de esa página. Sin conexión, los indicadores de ventas muestran «—».",
  "Acesse Métricas para ver detalhes por vídeo": "Accede a Métricas para ver los detalles por video",
  "Acesse Métricas para ver por vídeo": "Accede a Métricas para ver por video",
  "Acesse Teste de hook para otimizar retenção": "Accede a la prueba de ganchos para optimizar la retención",
  "Acesse VSL Dinâmica no menu do painel e monte o primeiro caminho do seu funil.": "Accede a VSL dinámica desde el menú del panel y crea el primer camino de tu embudo.",
  "Acesse pelo menu lateral em Análises → Tempo Real": "Accede desde el menú lateral en Análisis → Tiempo real",
  "Acesse pelo seu avatar, no canto superior direito, em \"Membros\"": "Accede desde tu avatar, en la esquina superior derecha, en \"Miembros\"",
  "Acesse uma trilha completa de aulas para dominar todos os recursos da Host VSL.": "Accede a un recorrido completo de lecciones para dominar todas las funciones de Host VSL.",
  "Acessibilidade e retenção em um só recurso.": "Accesibilidad y retención en una sola función.",
  "Acesso Rota": "Acceso a la ruta",
  "Acesso por pasta: libere só as pastas de vídeos que aquela pessoa precisa": "Acceso por carpeta: permite solo las carpetas de videos que necesita cada persona",
  "Acesso total, incluindo gestão de usuários e faturamento": "Acceso completo, incluida la gestión de usuarios y la facturación",
  "Acompanhe a saúde de cada pixel: registrando, mudo há mais de 24h ou aguardando o 1º disparo": "Controla el estado de cada píxel: registrando, sin eventos desde hace más de 24 h o esperando el primer envío",
  "Acompanhe cópias por dia, top estados e histórico completo de eventos": "Consulta las copias por día, los estados principales y el historial completo de eventos",
  "Acompanhe entradas, plays, escolhas, acessos às saídas e a retenção de cada vídeo nas métricas do fluxo.": "Consulta entradas, reproducciones, elecciones, accesos a las salidas y retención de cada video en las métricas del flujo.",
  "Acompanhe métricas de compartilhamento": "Consulta las métricas de los enlaces compartidos",
  "Acompanhe quantos acessos cada proteção já bloqueou direto nos cards": "Consulta directamente en las tarjetas cuántos accesos ha bloqueado cada protección",
  "Adiciona blur sutil ao vídeo de fundo": "Añade un desenfoque sutil al video de fondo",
  "Adiciona um botão nos controles que abre o seletor nativo de dispositivos do navegador (AirPlay no Safari, Chromecast no Chrome). Só aparece pra quem tem receptor compatível na rede.": "Añade un botón a los controles que abre el selector nativo de dispositivos del navegador (AirPlay en Safari, Chromecast en Chrome). Solo aparece si hay un receptor compatible en la red.",
  "Adicionada aba \"Parceiros\" com ícone Handshake no menu lateral desktop (Sidebar) e mobile (DrawerContent), posicionada após \"Membros\".": "Se ha añadido la pestaña \"Socios\" con el icono Handshake al menú lateral de escritorio (Sidebar) y móvil (DrawerContent), después de \"Miembros\".",
  "Adicione arquivos de legenda ao vídeo para melhorar acessibilidade e retenção do público.": "Añade archivos de subtítulos al video para mejorar la accesibilidad y la retención del público.",
  "Adicione elementos visuais para reforçar os pontos principais": "Añade elementos visuales para reforzar los puntos principales",
  "Adicione essa oferta ao seu pedido agora e aproveite por apenas:": "Añade esta oferta a tu pedido ahora y aprovéchala por solo:",
  "Adicione essa oferta ao seu pedido antes de continuar": "Añade esta oferta a tu pedido antes de continuar",
  "Adicione pelo menos uma opção antes de pausar.": "Añade al menos una opción antes de pausar.",
  "Adicione um vídeo": "Añade un video",
  "Adicione uma pergunta de engajamento aos 25s para reter atenção": "Añade una pregunta a los 25 s para mantener la atención",
  "Adicione vários hooks com tempo de início e fim independentes": "Añade varios ganchos con tiempos de inicio y fin independientes",
  "Afiliado Gerente": "Afiliado gestor",
  "Afiliado copia o vídeo com um clique e já pode usar sem upload": "El afiliado copia el video con un clic y puede usarlo sin subirlo",
  "Afiliado vendedor": "Afiliado vendedor",
  "Ainda não há conversões registradas neste período para gerar um insight.": "Todavía no hay conversiones registradas en este período para generar un análisis.",
  "Ajuste os tempos: Início define quando as opções aparecem; Final, que é opcional, define quando o vídeo pausa para a escolha. Se Início ficar vazio, as opções aparecem no fim do vídeo. Se o visitante não escolher, o último quadro permanece com as opções disponíveis.": "Ajusta los tiempos: Inicio define cuándo aparecen las opciones; Final, que es opcional, define cuándo se pausa el video para elegir. Si Inicio está vacío, las opciones aparecen al final del video. Si el visitante no elige, el último fotograma permanece con las opciones disponibles.",
  "Ajuste título, subtítulo, texto do botão, mensagem de agradecimento, estilo, cor, posição e tamanho": "Ajusta el título, el subtítulo, el texto del botón, el mensaje de agradecimiento, el estilo, el color, la posición y el tamaño",
  "Ajustes automáticos de layout e interação por tela": "Ajustes automáticos de diseño e interacción según la pantalla",
  "Alinhada com quem busca escala, performance e operação profissional.": "Pensada para quienes buscan crecer, mejorar el rendimiento y trabajar de forma profesional.",
  "Alinhe melhor o gancho curiosidade com o tema central": "Alinea mejor el gancho de curiosidad con el tema central",
  "Analise o mapa de calor por dia e hora para enxergar padrões": "Analiza el mapa de calor por día y hora para detectar patrones",
  "Analise o mapa de calor por dia e hora para enxergar padrões de audiência em segundos": "Analiza el mapa de calor por día y hora para detectar patrones de audiencia en segundos",
  "Analytics por etapa e evento": "Análisis por etapa y evento",
  "Analítico para recomendação.": "Análisis para recomendaciones.",
  "Animações suaves de entrada e saída sem quebrar a imersão": "Animaciones suaves de entrada y salida que mantienen la inmersión",
  "Análise detalhada de performance e engajamento": "Análisis detallado de rendimiento e interacción",
  "Ao finalizar, o tráfego volta para a VSL Principal. Esta ação não pode ser desfeita.": "Al finalizar, el tráfico vuelve a la VSL principal. Esta acción no se puede deshacer.",
  "Apenas visualização de vídeos e métricas": "Solo visualización de videos y métricas",
  "Aplica overlay escuro para destacar o CTA": "Aplica una capa oscura para destacar el CTA",
  "Aprenda as melhores estratégias e técnicas neste curso completo. Conteúdo exclusivo desenvolvido para transformar seus resultados.": "Aprende las mejores estrategias y técnicas en este curso completo. Contenido exclusivo diseñado para transformar tus resultados.",
  "Aprenda no seu ritmo, direto do menu Academy.": "Aprende a tu ritmo desde el menú Academy.",
  "Aproveite essa condição especial": "Aprovecha esta oferta especial",
  "Aqui ficam todos os recursos para personalizar seu player. Ative controles, botões, headline e muito mais.": "Aquí están todas las funciones para personalizar tu reproductor. Activa controles, botones, titulares y mucho más.",
  "Arraste a caixa para qualquer posição dentro do player": "Arrastra el cuadro a cualquier posición dentro del reproductor",
  "Arraste e solte vídeos entre pastas": "Arrastra y suelta videos entre carpetas",
  "As comissões são pagas mensalmente via PIX ou transferência bancária, desde que o cliente indicado mantenha o plano ativo.": "Las comisiones se pagan mensualmente mediante PIX o transferencia bancaria, siempre que el cliente referido mantenga su plan activo.",
  "As opções precisam aparecer antes da pausa.": "Las opciones deben aparecer antes de la pausa.",
  "Ativa a reprodução automática do vídeo": "Activa la reproducción automática del video",
  "Ative com um clique direto no painel de recursos": "Actívalo con un clic desde el panel de funciones",
  "Ative com um clique no painel de recursos do vídeo": "Actívalo con un clic en el panel de funciones del video",
  "Ative na aba \"Controles\" da personalização do vídeo, na opção \"Assistir na Smart TV\"": "Actívalo en la pestaña \"Controles\" de personalización del video, en \"Ver en Smart TV\"",
  "Ative na aba \"Controles\" da personalização do vídeo, na opção \"Preview na Timeline\"": "Actívalo en la pestaña \"Controles\" de personalización del video, en \"Vista previa en la línea de tiempo\"",
  "Ative na personalização do vídeo e simule a contagem no preview do player ao lado": "Actívalo en la personalización del video y simula la cuenta atrás en la vista previa del reproductor de al lado",
  "Ative na personalização do vídeo, na categoria Conversão, em \"Feedback do Vídeo\"": "Actívalo en la personalización del video, en la categoría Conversión, en \"Comentarios del video\"",
  "Ative na personalização do vídeo, na opção \"Jornada de Conversão\"": "Actívalo en la personalización del video, en \"Recorrido de conversión\"",
  "Ative na personalização do vídeo, na opção \"Notificação de Vendas\"": "Actívalo en la personalización del video, en \"Notificación de ventas\"",
  "Ativável por vídeo na personalização.": "Se puede activar por video en la personalización.",
  "Atraso inicial de até 3 minutos, intervalo de 5 segundos a 5 minutos e duração de 1 a 20 segundos": "Retraso inicial de hasta 3 minutos, intervalo de 5 segundos a 5 minutos y duración de 1 a 20 segundos",
  "Atualização de toda documentação para usar Azul Host (#1D4FFF) como cor primária única. Corrigidas inconsistências entre DESIGN_SYSTEM.md, FEATURE_CONFIGS_STANDARD.md, PWA_README.md e colors.ts.": "Se ha actualizado toda la documentación para usar Azul Host (#1D4FFF) como único color principal. Se han corregido incoherencias entre DESIGN_SYSTEM.md, FEATURE_CONFIGS_STANDARD.md, PWA_README.md y colors.ts.",
  "Aulas curtas e objetivas com player premium integrado": "Lecciones breves y prácticas con reproductor prémium integrado",
  "Aulas exclusivas para acelerar sua evolução": "Lecciones exclusivas para acelerar tu progreso",
  "Aumenta retenção em vídeos longos": "Aumenta la retención en videos largos",
  "Automatize emails personalizados, escale experiências únicas para clientes e transforme leads em receita.": "Automatiza correos electrónicos personalizados, amplía las experiencias únicas de tus clientes y convierte leads en ingresos.",
  "Automatize mensagens de texto, áudio e vídeo, recupere vendas perdidas de Pix e boletos, compras canceladas e carrinhos abandonados, crie chatbots, envie mensagens em massa, rastreie vendas e mais com nossas 271 funções.": "Automatiza mensajes de texto, audio y video; recupera ventas perdidas de Pix y boletos bancarios, compras canceladas y carritos abandonados; crea chatbots, envía mensajes masivos, sigue las ventas y mucho más con nuestras 271 funciones.",
  "AutoplayStyleSection - Accordion Aberto por Padrão": "AutoplayStyleSection - Acordeón abierto de forma predeterminada",
  "Avaliações": "Valoraciones",
  "Avançar para Intros em Teste": "Avanzar a introducciones en prueba",
  "Avançaram ao conteúdo": "Avanzaron al contenido",
  "Azul Host claro - hover states": "Azul Host claro - estados al pasar el cursor",
  "Azul Host escuro - estados pressionados": "Azul Host oscuro - estados pulsados",
  "Azul Host oficial - cor principal": "Azul Host oficial - color principal",
  "Ação de Play obrigatória, disparada no primeiro play do vídeo": "Acción de reproducción obligatoria, activada en la primera reproducción del video",
  "Ações de Pitch (quando a oferta aparece) e Checkout (clique no botão de compra) opcionais": "Acciones opcionales de oferta (cuando aparece) y pago (clic en el botón de compra)",
  "Ações geradas": "Acciones generadas",
  "Backend": "Backend",
  "Banner hero": "Banner principal",
  "Base preparada para liberar novas funcionalidades com mais velocidade": "Base preparada para ofrecer nuevas funciones más rápido",
  "Base preparada para novas funcionalidades com mais velocidade": "Base preparada para incorporar nuevas funciones más rápido",
  "Bloqueie ou remova o acesso na hora em que alguém sair do time": "Bloquea o elimina el acceso en cuanto alguien salga del equipo",
  "Bloqueio por dispositivo (desktop, celular, tablet) e por VPN/Proxy": "Bloqueo por dispositivo (escritorio, móvil, tableta) y por VPN/proxy",
  "Bordas padrão": "Bordes predeterminados",
  "Border-radius de botões": "Radio del borde de los botones",
  "Border-radius de cards": "Radio del borde de las tarjetas",
  "Border-radius de dropdowns": "Radio del borde de los desplegables",
  "Border-radius de modais": "Radio del borde de los diálogos",
  "Border-radius de switch cards": "Radio del borde de las tarjetas con interruptor",
  "Botão \"Ir Agora\" opcional, pra quem já decidiu e não quer esperar a contagem terminar": "Botón opcional \"Ir ahora\" para quienes ya han decidido y no quieren esperar a que termine la cuenta atrás",
  "Botão de aceite com um link de recusa discreto abaixo.": "Botón de aceptación con un enlace discreto para rechazar debajo.",
  "Botão de pular com contagem regressiva no vídeo de entrada": "Botón para omitir con cuenta atrás en el video de entrada",
  "Brasília (GMT-3)": "Brasilia (GMT-3)",
  "Broip lidera com 53% das conversões hoje.": "Broip lidera con el 53 % de las conversiones de hoy.",
  "Build Tool": "Herramienta de compilación",
  "Busca rápida por aula em qualquer módulo": "Búsqueda rápida de lecciones en cualquier módulo",
  "Busque e selecione múltiplos vídeos de uma vez": "Busca y selecciona varios videos a la vez",
  "CONTINUAR SEM ESSA OFERTA": "CONTINUAR SIN ESTA OFERTA",
  "CVC inválido": "CVC no válido",
  "Cabeçalho desktop": "Cabecera de escritorio",
  "Cabeçalho mobile": "Cabecera móvil",
  "Cada etapa é um vídeo com uma pergunta e até 4 opções. Cada opção leva a outra etapa ou a uma saída, como o checkout ou o WhatsApp. Você escolhe quando as opções aparecem e se o vídeo pausa até o visitante responder.": "Cada etapa es un video con una pregunta y hasta 4 opciones. Cada opción lleva a otra etapa o a una salida, como la página de pago o WhatsApp. Elige cuándo aparecen las opciones y si se pausa el video hasta que el visitante responda.",
  "Cada opção pode levar a outro vídeo ou a uma saída, como uma oferta, um checkout ou o WhatsApp.": "Cada opción puede llevar a otro video o a una salida, como una oferta, una página de pago o WhatsApp.",
  "Cadastre quantas pessoas precisar, cada uma com o próprio e-mail e a própria senha": "Registra a tantas personas como necesites, cada una con su propio correo electrónico y contraseña",
  "Campanha (Campaign)": "Campaña (Campaign)",
  "Campo desconhecido: {value0}": "Campo desconocido: {value0}",
  "Card com a sua cara: título, descrição, cores, tamanho, arredondamento e animação de entrada": "Tarjeta a tu gusto: título, descripción, colores, tamaño, redondeado y animación de entrada",
  "Card de CTA clicável estilo YouTube: título, descrição, botão e link pra sua oferta": "Tarjeta CTA con enlace al estilo YouTube: título, descripción, botón y enlace a tu oferta",
  "Card de métricas unificado": "Tarjeta de métricas unificada",
  "Card de parceiro premium": "Tarjeta de socio prémium",
  "Card de playlist": "Tarjeta de lista de reproducción",
  "Card de teste na lista": "Tarjeta de prueba en la lista",
  "Card de vídeo": "Tarjeta de video",
  "Card sortável com slider": "Tarjeta ordenable con control deslizante",
  "Cards de métricas": "Tarjetas de métricas",
  "Cards de regras com footer mostrando data de criação, toggle de ativação, modais de seleção de vídeo premium.": "Tarjetas de reglas con pie que muestra la fecha de creación, interruptor de activación y diálogos prémium de selección de video.",
  "Carregamento mais rápido no início do vídeo": "Carga más rápida al inicio del video",
  "Carregaram o fluxo": "Cargaron el flujo",
  "Cartão expirado": "Tarjeta caducada",
  "Chamada da oferta": "Llamada de la oferta",
  "Chamada de oferta com botão e link de saída.": "Llamada de oferta con botón y enlace de salida.",
  "Checkout ÷ plays. Não confirma a compra.": "Accesos a pago ÷ reproducciones. No confirma la compra.",
  "Cinco etapas do funil: Carregamentos, Visualizações Únicas, Plays Únicos, Cliques no Botão e Conversões": "Cinco etapas del embudo: cargas, visualizaciones únicas, reproducciones únicas, clics en el botón y conversiones",
  "Clean 2.0 — Template Horizontal": "Clean 2.0 — Plantilla horizontal",
  "Clicaram em pular": "Hicieron clic en omitir",
  "Clicaram no botão": "Hicieron clic en el botón",
  "Clicaram para assistir": "Hicieron clic para ver",
  "Clique no botão azul para abrir o upload e enviar seu primeiro vídeo.": "Haz clic en el botón azul para abrir la subida y enviar tu primer video.",
  "Cliques sobre exibições": "Clics sobre visualizaciones",
  "Cloaker — Sistema de Regras": "Cloaker — Sistema de reglas",
  "Clone páginas existentes em minutos para acelerar testes": "Clona páginas existentes en minutos para acelerar las pruebas",
  "Clone páginas validadas": "Clona páginas validadas",
  "Clássico para satisfação rápida.": "Clásico para una valoración rápida.",
  "Cole o código em um bloco HTML da sua página de vendas. Publique a página e pronto: seu vídeo já estará no ar.": "Pega el código en un bloque HTML de tu página de ventas. Publica la página y listo: tu video estará disponible.",
  "Coloque um vídeo de entrada antes da sua VSL e um de saída depois, no estilo anúncio do YouTube, pra conduzir o espectador até a próxima ação.": "Coloca un video de entrada antes de tu VSL y uno de salida después, al estilo de los anuncios de YouTube, para guiar al espectador a la siguiente acción.",
  "Combine com Botão de Ação e Headline para reforçar a oferta": "Combínalo con el botón de acción y el titular para reforzar la oferta",
  "Pixels Ativos": "Píxeles activos",
  "Pixels Cadastrados": "Píxeles registrados",
  "Pixels ativos": "Píxeles activos",
  "Placeholder do comentário": "Texto de ejemplo del comentario",
  "Plano / Subscription": "Plan / Suscripción",
  "Plano / Valor": "Plan / Precio",
  "Plano Ativo": "Plan activo",
  "Plano Ativo — {value0}": "Plan activo — {value0}",
  "Plano indisponível no momento": "Plan no disponible por el momento",
  "Plano mais rápido": "Plan más rápido",
  "Plano {value0}": "Plan {value0}",
  "Plano {value0} ativado com sucesso! Aproveite os 15 dias grátis!": "¡Plan {value0} activado correctamente! ¡Disfruta de 15 días gratis!",
  "Plataforma conectada. Aguardando primeiros eventos de venda.": "Plataforma conectada. Esperando los primeros eventos de venta.",
  "Plataforma de comunicação para atendimento ao cliente e marketing.": "Plataforma de comunicación para atención al cliente y marketing.",
  "Plataforma de e-commerce para lojas online e pagamentos.": "Plataforma de comercio electrónico para tiendas online y pagos.",
  "Plataforma para email marketing e automação de campanhas.": "Plataforma de email marketing y automatización de campañas.",
  "Plataformas": "Plataformas",
  "Play Grande": "Reproducción grande",
  "Play Pequeno": "Reproducción pequeña",
  "Play Rate Médio": "Tasa media de reproducción",
  "Play Rate do Dia": "Tasa de reproducción del día",
  "Play Rate hoje": "Tasa de reproducción hoy",
  "Play após carregar a página": "Reproducir después de cargar la página",
  "Play, som e tela cheia": "Reproducción, sonido y pantalla completa",
  "Player com sua Identidade Visual": "Reproductor con tu identidad visual",
  "Player de Vídeo": "Reproductor de vídeo",
  "Player grande + lista lateral (desktop) ou lista abaixo (mobile). Layout limpo e profissional.": "Reproductor grande + lista lateral (escritorio) o lista inferior (móvil). Diseño limpio y profesional.",
  "Playlist com {value0}MB. Considere usar imagens menores para evitar problemas.": "La playlist ocupa {value0}MB. Considera usar imágenes más pequeñas para evitar problemas.",
  "Playlist criada!": "¡Playlist creada!",
  "Playlist salva!": "¡Playlist guardada!",
  "Playlist sem título": "Playlist sin título",
  "Playlist vazia": "Playlist vacía",
  "Playlists": "Playlists",
  "Plays Extras Adquiridos": "Reproducciones extra adquiridas",
  "Plays Totais": "Reproducciones totales",
  "Plays extras": "Reproducciones extra",
  "Plays extras adquiridos": "Reproducciones extra adquiridas",
  "Plays hoje": "Reproducciones hoy",
  "Plugin de comércio eletrônico para WordPress.": "Plugin de comercio electrónico para WordPress.",
  "Poderá solicitar o resgate dos seus valores acumulados assim que atingir o piso mínimo estipulado no extrato.": "Podrás solicitar el retiro de tus fondos acumulados cuando alcances el mínimo indicado en el extracto.",
  "Polski": "Polski",
  "Política de Cookies": "Política de cookies",
  "Ponto crítico onde os espectadores abandonam o vídeo.": "Punto crítico donde los espectadores abandonan el vídeo.",
  "Ponto do pitch": "Punto del pitch",
  "Pontuação geral de engajamento baseada em múltiplos fatores: retenção, cliques e interações.": "Puntuación general de interacción basada en varios factores: retención, clics e interacciones.",
  "Popup bloqueado. Permita popups para exportar.": "Ventana emergente bloqueada. Permite las ventanas emergentes para exportar.",
  "Por": "Por",
  "Por Categoria": "Por categoría",
  "Por Provedor": "Por proveedor",
  "Por Serviço": "Por servicio",
  "Por etapa": "Por etapa",
  "Por favor, anexe o comprovante de transferência.": "Adjunta el comprobante de transferencia.",
  "Por favor, corrija os erros antes de continuar.": "Corrige los errores antes de continuar.",
  "Por favor, envie um arquivo de vídeo.": "Sube un archivo de vídeo.",
  "Por favor, insira o nome completo (Nome e Sobrenome) exigido pela Stripe.": "Introduce el nombre completo (nombre y apellidos) requerido por Stripe.",
  "Por favor, insira um nome para o teste.": "Introduce un nombre para la prueba.",
  "Por favor, preencha a chave PIX.": "Completa la clave PIX.",
  "Por favor, preencha o e-mail do PayPal.": "Completa el correo de PayPal.",
  "Por favor, selecione ambos os arquivos (Frente e Verso) do seu documento.": "Selecciona ambos archivos de tu documento (anverso y reverso).",
  "Por favor, selecione apenas arquivos de vídeo": "Selecciona solo archivos de vídeo",
  "Por favor, selecione um arquivo de vídeo": "Selecciona un archivo de vídeo",
  "Por favor, selecione um país": "Selecciona un país",
  "Por favor, selecione um vídeo": "Selecciona un vídeo",
  "Por favor, selecione um vídeo principal.": "Selecciona un vídeo principal.",
  "Por favor, selecione uma imagem válida (JPG, PNG, WEBP)": "Selecciona una imagen válida (JPG, PNG, WEBP)",
  "Por favor, selecione uma região": "Selecciona una región",
  "Por favor, verifique se a distribuição de tráfego soma 100%": "Comprueba que la distribución de tráfico sume el 100%",
  "Por opção": "Por opción",
  "Por quanto tempo a notificação permanece visível.": "Cuánto tiempo permanece visible la notificación.",
  "Por que o Storytelling Funciona?": "¿Por qué funciona el storytelling?",
  "Por saída": "Por salida",
  "Por vídeo": "Por vídeo",
  "Porcentagem": "Porcentaje",
  "Porcentagem de espectadores ao longo do tempo": "Porcentaje de espectadores a lo largo del tiempo",
  "Porcentagem de espectadores que continuam assistindo ao vídeo em cada momento. Quedas bruscas indicam pontos de abandono.": "Porcentaje de espectadores que siguen viendo el vídeo en cada momento. Las caídas bruscas indican puntos de abandono.",
  "Porcentagem de pessoas que ainda estavam assistindo": "Porcentaje de personas que seguían viendo",
  "Porcentagem de visualizadores que iniciam a reprodução do vídeo.": "Porcentaje de espectadores que inician la reproducción del vídeo.",
  "Porcentagem de visualizações que resultaram em uma conversão (clique no botão de ação).": "Porcentaje de visualizaciones que dieron lugar a una conversión (clic en el botón de acción).",
  "Porcentagem média de tempo que os espectadores assistem. Um bom número é acima de 70%.": "Porcentaje medio del tiempo que ven los espectadores. Un buen valor supera el 70%.",
  "Português (BR)": "Português (BR)",
  "Português (Brasil)": "Português (Brasil)",
  "Português (PT)": "Português (PT)",
  "Posicionamento estratégico": "Posicionamiento estratégico",
  "Posição da Notificação": "Posición de la notificación",
  "Posição das opções": "Posición de las opciones",
  "Posição do Formulário": "Posición del formulario",
  "Posição do Título": "Posición del título",
  "Posição do modal": "Posición de la ventana",
  "Posição média:": "Posición media:",
  "Posição na tela": "Posición en pantalla",
  "Powered by HostVSL": "Powered by HostVSL",
  "Prazo de Cookies de infinitos": "Duración ilimitada de cookies",
  "Prazo mínimo de processamento das solicitações bancárias:": "Plazo mínimo de procesamiento de solicitudes bancarias:",
  "Precisa de ajuda? Clique aqui": "¿Necesitas ayuda? Haz clic aquí",
  "Precisamos de alguns dados para registrar sua resposta.": "Necesitamos algunos datos para registrar tu respuesta.",
  "Preencha a data de nascimento completa.": "Introduce la fecha de nacimiento completa.",
  "Preencha abaixo para continuar assistindo.": "Completa los datos a continuación para seguir viendo.",
  "Preencha as informações abaixo para configurar esta etapa": "Completa la información siguiente para configurar esta etapa",
  "Preencha o e-mail.": "Introduce el correo.",
  "Preencha o nome do serviço.": "Introduce el nombre del servicio.",
  "Preencha para acessar o vídeo": "Completa los datos para acceder al vídeo",
  "Preencha pelo menos um dos textos": "Completa al menos uno de los textos",
  "Preencha todos os campos antes de enviar.": "Completa todos los campos antes de enviar.",
  "Preencha todos os campos da conta bancária.": "Completa todos los campos de la cuenta bancaria.",
  "Preencha todos os campos para continuar.": "Completa todos los campos para continuar.",
  "Preencha todos os dados bancários obrigatórios.": "Completa todos los datos bancarios obligatorios.",
  "Premium": "Premium",
  "Preparando QR Code": "Preparando código QR",
  "Preparando compartilhamento": "Preparando contenido compartido",
  "Preparando download...": "Preparando descarga...",
  "Preview da Oferta": "Vista previa de la oferta",
  "Preview da thumbnail": "Vista previa de la miniatura",
  "Preview de vídeo": "Vista previa de vídeo",
  "Preview do Gradiente": "Vista previa del degradado",
  "Preview do Vídeo": "Vista previa del vídeo",
  "Preview em tempo real do seu template selecionado": "Vista previa en tiempo real de la plantilla seleccionada",
  "Preview gerada automaticamente": "Vista previa generada automáticamente",
  "Preview: Como a oferta aparecerá no webinário": "Vista previa: cómo aparecerá la oferta en el webinar",
  "Previous": "Anterior",
  "Previous slide": "Diapositiva anterior",
  "Preço com desconto (opcional)": "Precio con descuento (opcional)",
  "Preço com desconto deve ser menor que o original": "El precio con descuento debe ser inferior al original",
  "Preço original (opcional)": "Precio original (opcional)",
  "Preços": "Precios",
  "Primeira página visualizada pelos visitantes": "Primera página vista por los visitantes",
  "Principais Origens de Tráfego": "Principales fuentes de tráfico",
  "Principal origem:": "Fuente principal:",
  "Princípios Básicos": "Principios básicos",
  "Prioridade": "Prioridad",
  "Prioridade da regra": "Prioridad de la regla",
  "Privacidade protegida": "Privacidad protegida",
  "Processado": "Procesado",
  "Processamento seguro e imediato": "Procesamiento seguro e inmediato",
  "Processando no servidor...": "Procesando en el servidor...",
  "Processando vídeo": "Procesando vídeo",
  "Processando vídeo...": "Procesando vídeo...",
  "Procure pelo ícone": "Busca el icono",
  "Programa de Afiliados Oficial": "Programa oficial de afiliados",
  "Progresso": "Progreso",
  "Progresso Inicial (0-100%)": "Progreso inicial (0-100%)",
  "Progresso de Configuração": "Progreso de configuración",
  "Progresso:": "Progreso:",
  "Projeção de Hoje": "Proyección de hoy",
  "Promessas de valor contínuas": "Promesas de valor continuas",
  "Pronto para Começar a Ganhar?": "¿Listo para empezar a ganar?",
  "Pronto para começar a faturar?": "¿Listo para empezar a facturar?",
  "Pronto para editar": "Listo para editar",
  "Pronto para envio": "Listo para subir",
  "Propriedade CSS": "Propiedad CSS",
  "Proteja suas campanhas e direcione tráfego com inteligência.": "Protege tus campañas y dirige el tráfico de forma inteligente.",
  "Proteção Anti-Plágio de VSL": "Protección antiplagio de VSL",
  "Proteção atualizada": "Protección actualizada",
  "Proteção criada": "Protección creada",
  "Proteção de Acesso": "Protección de acceso",
  "Proteção excluída": "Protección eliminada",
  "Proteção por Domínio": "Protección por dominio",
  "Proxy/VPN": "Proxy/VPN",
  "Proxy/VPN bloqueado": "Proxy/VPN bloqueado",
  "Proxy/VPN liberado": "Proxy/VPN permitido",
  "Pré-visualizar sala": "Vista previa de la sala",
  "Pré-visualização do Header": "Vista previa de la cabecera",
  "Prévia da Pasta": "Vista previa de la carpeta",
  "Prévia da Página de Inscrição": "Vista previa de la página de inscripción",
  "Prévia da página de inscrição": "Vista previa de la página de inscripción",
  "Prévia em Tempo Real": "Vista previa en tiempo real",
  "Prévia sem som": "Vista previa sin sonido",
  "Próxima Renovação": "Próxima renovación",
  "Próxima cobrança": "Próximo cobro",
  "Próxima sessão aparecerá daqui a pelo menos": "La próxima sesión aparecerá dentro de al menos",
  "Próximas sessões": "Próximas sesiones",
  "Publicados": "Publicados",
  "Publicar alterações": "Publicar cambios",
  "Publicar alterações?": "¿Publicar cambios?",
  "Publicar no chat": "Publicar en el chat",
  "Publicar o fluxo?": "¿Publicar el flujo?",
  "Publique e Compartilhe": "Publica y comparte",
  "Pular": "Omitir",
  "Pular Dados": "Omitir datos",
  "Pular em": "Omitir en",
  "Pular em {segundos}s": "Omitir en {segundos}s",
  "Pular em {value0}": "Omitir en {value0}",
  "Pular →": "Omitir →",
  "Pularam": "Omitieron",
  "Página específica": "Página específica",
  "Página externa": "Página externa",
  "Página {value0}": "Página {value0}",
  "QR Code baixado!": "¡Código QR descargado!",
  "QUA": "MIÉ",
  "QUA • 16h-18h": "MIÉ • 16:00-18:00",
  "QUI": "JUE",
  "QUI • 10h-12h": "JUE • 10:00-12:00",
  "QUI • 20h-22h": "JUE • 20:00-22:00",
  "Qua": "Mié",
  "Quadro do fluxo": "Lienzo del flujo",
  "Qualidade": "Calidad",
  "Qualidade Média": "Calidad media",
  "Qualidade adaptativa": "Calidad adaptativa",
  "Qualidade dos Leads": "Calidad de los leads",
  "Qualidade dos Leads (Score)": "Calidad de los leads (puntuación)",
  "Qualquer ferramenta que estiver usando esta chave perde o acesso na hora, e não há como reativá-la. Suas outras chaves continuam funcionando.": "Cualquier herramienta que use esta clave perderá el acceso inmediatamente y no se podrá reactivar. Tus otras claves seguirán funcionando.",
  "Quando a regra for atendida": "Cuando se cumpla la regla",
  "Quando acessar": "Al acceder",
  "Quando atingir": "Al alcanzar",
  "Quando espectadores avaliarem este vídeo, as respostas aparecerão aqui com nota média, comentários e distribuição das avaliações.": "Cuando los espectadores valoren este vídeo, las respuestas aparecerán aquí con la nota media, los comentarios y la distribución de valoraciones.",
  "Quando esses dois indicadores estão altos, você tem um vídeo que atrai e mantém a atenção do início ao fim.": "Cuando ambos indicadores son altos, tienes un vídeo que atrae y mantiene la atención de principio a fin.",
  "Quando exibir": "Cuándo mostrar",
  "Quando houver novidades, elas aparecem neste painel.": "Las novedades aparecerán en este panel.",
  "Quando o formulário deve aparecer (formato: mm:ss)": "Cuándo debe aparecer el formulario (formato: mm:ss)",
  "Quando o visitante rola a página e o vídeo sai da tela, ele vira uma caixinha no canto e continua tocando. Ao rolar de volta, o vídeo retorna ao lugar de origem.": "Cuando el visitante desplaza la página y el vídeo sale de la pantalla, se convierte en una pequeña ventana en la esquina y sigue reproduciéndose. Al volver, el vídeo regresa a su posición original.",
  "Quando o vídeo atingir o tempo definido, ele será pausado automaticamente e a thumbnail de pausa será exibida.": "Cuando el vídeo llegue al tiempo definido, se pausará automáticamente y aparecerá la miniatura de pausa.",
  "Quando o vídeo de saída terminar, o player exibe um": "Cuando termine el vídeo de salida, el reproductor mostrará un",
  "Quando seu vídeo recebe mais interação": "Cuándo recibe más interacción tu vídeo",
  "Quando tivermos atualizações, elas aparecem nesta tela.": "Las actualizaciones aparecerán en esta pantalla.",
  "Quando um vídeo terminar o processamento, você verá aqui e poderá editá-lo.": "Cuando termine el procesamiento de un vídeo, lo verás aquí y podrás editarlo.",
  "Quando você compartilhar um vídeo, ele aparecerá aqui com links e métricas.": "Cuando compartas un vídeo, aparecerá aquí con enlaces y métricas.",
  "Quantidade de clicks": "Cantidad de clics",
  "Quanto do seu vídeo é assistido em média pelos espectadores": "Qué parte de tu vídeo ven los espectadores de media",
  "Quanto tempo em média os espectadores assistem ao seu vídeo": "Cuánto tiempo ven tu vídeo los espectadores de media",
  "Quantos horários mostrar ao visitante": "Cuántos horarios mostrar al visitante",
  "Quarta-feira, 16h-18h": "Miércoles, 16:00-18:00",
  "Que bom ter você por aqui": "Qué bueno tenerte aquí",
  "Que tal adicionar seu primeiro vídeo aqui?": "¿Qué tal si añades tu primer vídeo aquí?",
  "Queda acentuada nos primeiros 10-30s = problema no gancho.": "Caída brusca en los primeros 10-30s = problema con el gancho.",
  "Queda de": "Caída de",
  "Queda em": "Caída en",
  "Quedas acentuadas no início indicam problema no gancho.": "Las caídas bruscas al inicio indican un problema con el gancho.",
  "Quedas suaves são normais. Quedas abruptas indicam problemas de conteúdo ou ritmo.": "Las caídas suaves son normales. Las caídas abruptas indican problemas de contenido o ritmo.",
  "Quem Pode Ser Parceiro": "Quién puede ser socio",
  "Quem está assistindo às suas VSLs agora, pelo mundo.": "Quién está viendo tus VSL ahora en todo el mundo.",
  "Quem tem esta chave consegue ler as métricas dos seus vídeos. Guarde como guardaria uma senha e, se ela vazar, revogue na lista desta tela — a revogação vale na hora e não afeta suas outras chaves.": "Quien tenga esta clave podrá leer las métricas de tus vídeos. Guárdala como una contraseña y, si se filtra, revócala en la lista de esta pantalla: la revocación es inmediata y no afecta a tus otras claves.",
  "Quero acessar agora": "Quiero acceder ahora",
  "Qui": "Jue",
  "R$ 25/mês": "R$ 25/mes",
  "REGRA": "REGLA",
  "RESUME": "REANUDAR",
  "Raio da borda": "Radio del borde",
  "Raio de canto:": "Radio de esquina:",
  "Raio dos Cantos": "Radio de las esquinas",
  "Ranking de Vídeos": "Clasificación de vídeos",
  "Rascunho descartado": "Borrador descartado",
  "Rascunhos": "Borradores",
  "Rastreamento com Pixel": "Seguimiento con píxel",
  "Rastreamento configurado": "Seguimiento configurado",
  "Rastreamento de vendas": "Seguimiento de ventas",
  "Rastreamento de vendas por plataforma": "Seguimiento de ventas por plataforma",
  "Rastreamento e Engajamento": "Seguimiento e interacción",
  "Rastreamento e análise de tráfego para websites e aplicações.": "Seguimiento y análisis de tráfico para sitios web y aplicaciones.",
  "Rastreamento parcial": "Seguimiento parcial",
  "Rastreie eventos e integre com plataformas de anúncios.": "Rastrea eventos e integra plataformas publicitarias.",
  "Rastreie receita": "Rastrea ingresos",
  "Reabrir se não enviado": "Reabrir si no se ha enviado",
  "React Query": "React Query",
  "React Renderers:": "Renderizadores de React:",
  "React Version:": "Versión de React:",
  "Reafirme o benefício principal em múltiplos momentos do vídeo para manter o engajamento constante.": "Refuerza el beneficio principal en varios momentos del vídeo para mantener la interacción constante.",
  "Real": "Real",
  "Reativar": "Reactivar",
  "Reativar plano": "Reactivar plan",
  "Recarga Automática Ativada": "Recarga automática activada",
  "Recarga automática de {value0} plays ativada!": "¡Recarga automática de {value0} reproducciones activada!",
  "Recarregar": "Recargar",
  "Recarregar (sem cache)": "Recargar (sin caché)",
  "Recarregue a página para tentar de novo.": "Recarga la página para volver a intentarlo.",
  "Receba 10% sobre todas as comissões geradas pelos vendedores indicados diretamente por você.": "Recibe el 10% de todas las comisiones generadas por vendedores que hayas referido directamente.",
  "Receba 20% do valor de cada cliente ativo todos os meses.": "Recibe el 20% del valor de cada cliente activo todos los meses.",
  "Receba 25% todos os meses enquanto o cliente permanecer ativo na plataforma.": "Recibe el 25% cada mes mientras el cliente siga activo en la plataforma.",
  "Receba alertas em tempo real sobre conversões, métricas importantes e atualizações do sistema.": "Recibe alertas en tiempo real sobre conversiones, métricas importantes y actualizaciones del sistema.",
  "Receba alertas quando houver novas conversões nos seus vídeos": "Recibe alertas cuando haya nuevas conversiones en tus vídeos",
  "Receba alertas sobre conversões, métricas e atualizações importantes em tempo real": "Recibe alertas en tiempo real sobre conversiones, métricas y actualizaciones importantes",
  "Receba notificações sobre os melhores horários de visualização": "Recibe notificaciones sobre los mejores horarios de visualización",
  "Receba recomendações personalizadas baseadas nos dados de retenção do seu vídeo.": "Recibe recomendaciones personalizadas basadas en los datos de retención de tu vídeo.",
  "Receba seu link exclusivo e indique para sua audiência.": "Recibe tu enlace exclusivo y compártelo con tu audiencia.",
  "Receba todos os meses enquanto os seus indicados continuarem ativos na plataforma.": "Cobra cada mes mientras tus referidos sigan activos en la plataforma.",
  "Receita Gerada": "Ingresos generados",
  "Recentes": "Recientes",
  "Recomendado: 400×400 px": "Recomendado: 400×400 px",
  "Recomendamos manter opcional.": "Recomendamos mantenerlo opcional.",
  "Recomendamos usar um tom levemente mais escuro para o hover.": "Recomendamos un tono ligeramente más oscuro al pasar el cursor.",
  "Recomendações:": "Recomendaciones:",
  "Recomende a nossa plataforma e ganhe": "Recomienda nuestra plataforma y gana",
  "Recomeçar": "Reiniciar",
  "Reconsidere o estilo narrativo": "Reconsidera el estilo narrativo",
  "Recorrente": "Recurrente",
  "Recorrência desativada": "Recurrencia desactivada",
  "Recorrência desativada com sucesso!": "¡Recurrencia desactivada correctamente!",
  "Recuperar Acesso": "Recuperar acceso",
  "Recurso Configurado": "Función configurada",
  "Recurso desativado!": "¡Función desactivada!",
  "Recursos Extras": "Funciones extra",
  "Redigite a senha": "Vuelve a escribir la contraseña",
  "Redirecionados": "Redirigidos",
  "Redirecionamento Inteligente": "Redirección inteligente",
  "Redirecionando para a lista de playlists...": "Redirigiendo a la lista de playlists...",
  "Redirecionando para configuração de integrações...": "Redirigiendo a la configuración de integraciones...",
  "Redirecionando para lista de estratégias...": "Redirigiendo a la lista de estrategias...",
  "Redirecionar para vídeo alternativo ou URL": "Redirigir a un vídeo alternativo o URL",
  "Reduza a introdução": "Acorta la introducción",
  "Redução de 42% na taxa de abandono nos primeiros 30 segundos": "Reducción del 42% en el abandono durante los primeros 30 segundos",
  "Reenviar convite para": "Reenviar invitación a",
  "Reenviar código": "Reenviar código",
  "Reenviar código em": "Reenviar código en",
  "Referência": "Referencia",
  "Referência visual de onde começa o pitch da oferta": "Referencia visual de dónde empieza el pitch de la oferta",
  "Reforce a curiosidade": "Refuerza la curiosidad",
  "Reforce a promessa inicial": "Refuerza la promesa inicial",
  "Reformulamos o Cloaker da HostVSL, a proteção anti-plágio das suas VSLs. Você decide quem pode assistir ao vídeo original por país, região, origem do tráfego (UTM), dispositivo e bloqueio de VPN/Proxy — e quem não se encaixa nas regras é desviado automaticamente para um vídeo alternativo, sem nunca carregar a sua VSL real. Perfeito pra esconder sua oferta de concorrentes, espiões de anúncios e ferramentas de moderação.": "Rediseñamos el Cloaker de HostVSL, la protección antiplagio de tus VSL. Decide quién puede ver el vídeo original por país, región, fuente de tráfico (UTM), dispositivo y bloqueo de VPN/Proxy. Quien no cumpla las reglas se redirige automáticamente a un vídeo alternativo sin cargar tu VSL real. Ideal para ocultar tu oferta a competidores, espías publicitarios y herramientas de moderación.",
  "Reformule o gancho inicial": "Reformula el gancho inicial",
  "Regenerar": "Regenerar",
  "Regional": "Regional",
  "Registrando ·": "Registrando ·",
  "Registro Encontrado": "Registro encontrado",
  "Registro criado com sucesso!": "¡Registro creado correctamente!",
  "Registro encontrado!": "¡Registro encontrado!",
  "Registro excluído com sucesso!": "¡Registro eliminado correctamente!",
  "Região não encontrada": "Región no encontrada",
  "Região/Estado": "Región/Estado",
  "Região: {value0}": "Región: {value0}",
  "Regiões ({value0})": "Regiones ({value0})",
  "Regiões ainda não cadastradas para este país.": "Todavía no hay regiones registradas para este país.",
  "Regra UTM": "Regla UTM",
  "Regra ativa": "Regla activa",
  "Regra desativada": "Regla desactivada",
  "Regra do Cloaker": "Regla del Cloaker",
  "Regra salva com sucesso": "Regla guardada correctamente",
  "Regras ativas": "Reglas activas",
  "Regras de Operação": "Reglas de operación",
  "Regras de UTM": "Reglas UTM",
  "Regras e Distribuição de Comissão": "Reglas y distribución de comisiones",
  "Reinicia a sequência de notificações ao chegar ao fim.": "Reinicia la secuencia de notificaciones al llegar al final.",
  "Reiniciar preview": "Reiniciar vista previa",
  "Reiniciar tour": "Reiniciar recorrido",
  "Relatório enviado com sucesso": "Informe enviado correctamente",
  "Relatórios de Captura": "Informes de captura",
  "Remove completamente a interação com os controles do player": "Elimina por completo la interacción con los controles del reproductor",
  "Remove from favorites": "Eliminar de favoritos",
  "Remove todos os controles do player": "Elimina todos los controles del reproductor",
  "Removendo...": "Eliminando...",
  "Remover arquivo?": "¿Eliminar archivo?",
  "Remover cartão": "Eliminar tarjeta",
  "Remover classe": "Eliminar clase",
  "Remover domínio": "Eliminar dominio",
  "Remover domínio?": "¿Eliminar dominio?",
  "Remover dos favoritos": "Eliminar de favoritos",
  "Remover foto": "Eliminar foto",
  "Remover foto de perfil": "Eliminar foto de perfil",
  "Remover introdução?": "¿Eliminar introducción?",
  "Remover link": "Eliminar enlace",
  "Remover logo": "Eliminar logo",
  "Remover opção {value0}": "Eliminar opción {value0}",
  "Remover parâmetro": "Eliminar parámetro",
  "Remover pitch": "Eliminar pitch",
  "Remover pixel": "Eliminar píxel",
  "Remover pixel?": "¿Eliminar píxel?",
  "Remover seleção": "Quitar selección",
  "Remover vídeo da fila?": "¿Quitar vídeo de la cola?",
  "Remover {value0} do gráfico": "Quitar {value0} del gráfico",
  "Renomear estratégia": "Renombrar estrategia",
  "Renomear fluxo": "Renombrar flujo",
  "Renomear pasta": "Renombrar carpeta",
  "Renomear vídeo": "Renombrar vídeo",
  "Renova em": "Se renueva el",
  "Renovação": "Renovación",
  "Repassar os parâmetros da página": "Reenviar los parámetros de la página",
  "Repetir Vídeo": "Repetir vídeo",
  "Repita a senha": "Repite la contraseña",
  "Reproduz um som curto junto da notificação.": "Reproduce un sonido breve junto con la notificación.",
  "Reproduzindo": "Reproduciendo",
  "Reproduzindo...": "Reproduciendo...",
  "Reproduzir": "Reproducir",
  "Reproduzir automaticamente a próxima aula quando o vídeo terminar": "Reproducir automáticamente la siguiente clase al terminar el vídeo",
  "Reproduções no período": "Reproducciones del período",
  "Resetar Configurações": "Restablecer configuración",
  "Resolução recomendada: 1920×700 pixels": "Resolución recomendada: 1920×700 píxeles",
  "Resposta A": "Respuesta A",
  "Resposta B": "Respuesta B",
  "Respostas": "Respuestas",
  "Restaurar padrões": "Restaurar valores predeterminados",
  "Restaurar principais origens": "Restaurar fuentes principales",
  "Resultado": "Resultado",
  "Resultados do Teste": "Resultados de la prueba",
  "Resultados em tempo real das variações de autoplay": "Resultados en tiempo real de las variantes de autoplay",
  "Resultados em tempo real das variações de headline": "Resultados en tiempo real de las variantes de titular",
  "Resultados esperados": "Resultados esperados",
  "Resumo (A vs B)": "Resumen (A vs B)",
  "Resumo Geral": "Resumen general",
  "Resumo da proteção": "Resumen de protección",
  "Resumo de desempenho desta URL no período selecionado.": "Resumen del rendimiento de esta URL en el período seleccionado.",
  "Resumo de métricas consolidado: {value0} dias processados.": "Resumen de métricas consolidado: {value0} días procesados.",
  "Resumo do desempenho no período": "Resumen del rendimiento del período",
  "Retenção & Tempo": "Retención y tiempo",
  "Retenção & Tempo de Exibição": "Retención y tiempo de visualización",
  "Retenção Ideal": "Retención ideal",
  "Retenção Pitch": "Retención del pitch",
  "Retenção ao Longo do Vídeo": "Retención durante el vídeo",
  "Retenção de Audiência": "Retención de audiencia",
  "Retenção mostra quantas pessoas continuam assistindo ao vídeo ao longo do tempo.": "La retención muestra cuántas personas siguen viendo el vídeo a lo largo del tiempo.",
  "Retenção média hoje": "Retención media hoy",
  "Retenção no Vídeo": "Retención del vídeo",
  "Retenção no momento": "Retención en este momento",
  "Retenção no momento chave": "Retención en el momento clave",
  "Retenção por Vídeo": "Retención por vídeo",
  "Retenção próximo ao pitch": "Retención cerca del pitch",
  "Retirada Mínima Permitida": "Retiro mínimo permitido",
  "Retomar fluxo": "Reanudar flujo",
  "Retroceder": "Retroceder",
  "Return to Home": "Volver al inicio",
  "Revise a etapa atual antes de iniciar o teste.": "Revisa la etapa actual antes de iniciar la prueba.",
  "Revise seus últimos 5-10 testes para identificar padrões comuns nos vencedores.": "Revisa tus últimas 5-10 pruebas para identificar patrones comunes entre las ganadoras.",
  "Revogada": "Revocada",
  "Revogar": "Revocar",
  "Revogar \"": "Revocar \"",
  "Revogar chave": "Revocar clave",
  "Ritmo dinâmico": "Ritmo dinámico",
  "Role para baixo e toque em \"Adicionar à Tela de Início\"": "Desplázate hacia abajo y toca \"Añadir a pantalla de inicio\"",
  "Role para ver mais faturas": "Desplázate para ver más facturas",
  "Role para ver todas as faturas": "Desplázate para ver todas las facturas",
  "Rota": "Ruta",
  "Rotas Protegidas": "Rutas protegidas",
  "Rua, Avenida, Número e Complemento": "Calle, avenida, número e información adicional",
  "Rápido": "Rápido",
  "Rótulo (Label) da conversão de checkout": "Etiqueta de conversión de checkout",
  "Rótulo (Label) da conversão de play": "Etiqueta de conversión de reproducción",
  "Rótulo (Label) da conversão do pitch": "Etiqueta de conversión del pitch",
  "Rótulo da ação \"Checkout\" (opcional)": "Etiqueta de la acción \"Checkout\" (opcional)",
  "Rótulo da ação \"Pitch\" (opcional)": "Etiqueta de la acción \"Pitch\" (opcional)",
  "Rótulo da ação \"Play\" *": "Etiqueta de la acción \"Play\" *",
  "Rótulo do campo": "Etiqueta del campo",
  "SEG • 08h-10h": "LUN • 08:00-10:00",
  "SEG • 18h-20h": "LUN • 18:00-20:00",
  "SEX": "VIE",
  "SEX • 18h-20h": "VIE • 18:00-20:00",
  "Safari": "Safari",
  "Sair da tela cheia": "Salir de pantalla completa",
  "Sair do modo foco": "Salir del modo enfoque",
  "Sair do modo foco (Esc)": "Salir del modo enfoque (Esc)",
  "Sala do Webinário": "Sala del webinar",
  "Saldo insuficiente para saque (Mínimo R$ 100,00).": "Saldo insuficiente para retirar (mínimo R$ 100,00).",
  "Salvar & Continuar": "Guardar y continuar",
  "Salvar / Publicar": "Guardar / Publicar",
  "Salvar Ação": "Guardar acción",
  "Salvar Configurações": "Guardar configuración",
  "Salvar Distribuição": "Guardar distribución",
  "Salvar Informações": "Guardar información",
  "Salvar Método de Recebimento": "Guardar método de cobro",
  "Salvar Playlist": "Guardar playlist",
  "Salvar Teste": "Guardar prueba",
  "Salvar Tudo": "Guardar todo",
  "Salvar alteração": "Guardar cambio",
  "Salvar e Ativar": "Guardar y activar",
  "Salvar e Fechar": "Guardar y cerrar",
  "Salvar e Sincronizar": "Guardar y sincronizar",
  "Salvar nova senha": "Guardar nueva contraseña",
  "Salvar proteção": "Guardar protección",
  "Salvar rascunho": "Guardar borrador",
  "Salvar tudo": "Guardar todo",
  "Salve o vídeo antes de adicionar imagens aos mini-hooks.": "Guarda el vídeo antes de añadir imágenes a los mini hooks.",
  "Salve o vídeo para visualizar as métricas de feedback.": "Guarda el vídeo para ver las métricas de valoraciones.",
  "Saque": "Retiro",
  "Saque solicitado com sucesso!": "¡Retiro solicitado correctamente!",
  "Saques": "Retiros",
  "Saques mínimos autorizados a partir de": "Retiros mínimos autorizados a partir de",
  "Satisfação": "Satisfacción",
  "Saída removida": "Salida eliminada",
  "Saída sem nome": "Salida sin nombre",
  "Saída · {value0}": "Salida · {value0}",
  "Saúde & Velocidade": "Estado y velocidad",
  "Saúde do Pitch": "Estado del pitch",
  "Saúde do Player & Velocidade": "Estado del reproductor y velocidad",
  "Score de Engajamento": "Puntuación de interacción",
  "Se": "Si",
  "Se configurado na etapa \"Vendas\"": "Si se configura en la etapa \"Ventas\"",
  "Se não concordar, você pode recusar e nada será adicionado.": "Si no estás de acuerdo, puedes rechazarlo y no se añadirá nada.",
  "Se o campo \"Final\" estiver vazio, o botão será exibido até o final do vídeo.": "Si el campo \"Final\" está vacío, el botón se mostrará hasta el final del vídeo.",
  "Se o usuário recarregar a página sem enviar, mostrar novamente": "Mostrar de nuevo si el usuario recarga la página sin enviar",
  "Se o vídeo estiver dentro de um iframe, a página inteira é trocada.": "Si el vídeo está dentro de un iframe, se cambia toda la página.",
  "Se preenchido, redireciona para esta URL em vez do vídeo alternativo": "Si se completa, redirige a esta URL en lugar del vídeo alternativo",
  "Se vazio, será exibido o nome da playlist": "Si está vacío, se mostrará el nombre de la playlist",
  "Se você adicionar o connector numa organização do Claude (planos Team ou Enterprise), a chave passa a ser compartilhada por toda a equipe — todos os membros verão as métricas da conta HostVSL de quem a cadastrou.": "Si añades el conector a una organización de Claude (planes Team o Enterprise), la clave se comparte con todo el equipo: todos los miembros verán las métricas de la cuenta HostVSL de quien la registró.",
  "Se você não concordar, clique em": "Si no estás de acuerdo, haz clic en",
  "Segmentado (Pills)": "Segmentado (píldoras)",
  "Segmentação por Fonte:": "Segmentación por fuente:",
  "Segundo Botão (Opcional)": "Segundo botón (opcional)",
  "Segurança Avançada": "Seguridad avanzada",
  "Seguro": "Seguro",
  "Seja notificado quando suas métricas atingirem marcos importantes": "Recibe notificaciones cuando tus métricas alcancen hitos importantes",
  "Selecionando...": "Seleccionando...",
  "Selecionar Arquivo": "Seleccionar archivo",
  "Selecionar Cartão": "Seleccionar tarjeta",
  "Selecionar Evento": "Seleccionar evento",
  "Selecionar Introdução": "Seleccionar introducción",
  "Selecionar Modelo": "Seleccionar modelo",
  "Selecionar Tipo de Pixel": "Seleccionar tipo de píxel",
  "Selecionar VSL": "Seleccionar VSL",
  "Selecionar Vídeo Alternativo": "Seleccionar vídeo alternativo",
  "Selecionar Vídeo Original": "Seleccionar vídeo original",
  "Selecionar Vídeo Principal": "Seleccionar vídeo principal",
  "Selecionar Vídeo da Biblioteca": "Seleccionar vídeo de la biblioteca",
  "Selecionar Vídeo para Análise": "Seleccionar vídeo para analizar",
  "Selecionar Vídeo para Personalizar": "Seleccionar vídeo para personalizar",
  "Selecionar cor {value0}": "Seleccionar color {value0}",
  "Selecionar idioma": "Seleccionar idioma",
  "Selecionar manualmente": "Seleccionar manualmente",
  "Selecionar template": "Seleccionar plantilla",
  "Selecionar todos": "Seleccionar todos",
  "Selecionar vídeo de entrada": "Seleccionar vídeo de entrada",
  "Selecionar vídeo de saída": "Seleccionar vídeo de salida",
  "Selecionar vídeo para comparação": "Seleccionar vídeo para comparar",
  "Selecionar vídeos para upload": "Seleccionar vídeos para subir",
  "Selecione a data": "Selecciona la fecha",
  "Selecione a modalidade": "Selecciona la modalidad",
  "Selecione a parte da VSL sem a introdução. Assim, você poderá testar diferentes começos.": "Selecciona la parte de la VSL sin introducción. Así podrás probar distintos comienzos.",
  "Selecione a plataforma": "Selecciona la plataforma",
  "Selecione a prioridade": "Selecciona la prioridad",
  "Selecione a região": "Selecciona la región",
  "Selecione a velocidade desejada do seu vídeo": "Selecciona la velocidad deseada del vídeo",
  "Selecione arquivos de imagem nítidos da sua CNH ou RG (Formatos aceitos: PNG ou JPEG).": "Selecciona imágenes nítidas de tu permiso de conducir o documento de identidad (formatos: PNG o JPEG).",
  "Selecione as velocidades que deseja testar. Recomendamos testar pelo menos 2 velocidades diferentes para comparar os resultados.": "Selecciona las velocidades que quieras probar. Recomendamos al menos 2 velocidades distintas para comparar resultados.",
  "Selecione de 2 a 6 vídeos diferentes para comparar o desempenho em tempo real.": "Selecciona entre 2 y 6 vídeos distintos para comparar el rendimiento en tiempo real.",
  "Selecione diferentes introduções (hooks) para comparar o desempenho em tempo real.": "Selecciona distintas introducciones (hooks) para comparar el rendimiento en tiempo real.",
  "Selecione o fuso horário": "Selecciona la zona horaria",
  "Selecione o layout ideal para o seu conteúdo": "Selecciona el diseño ideal para tu contenido",
  "Selecione o operador": "Selecciona el operador",
  "Selecione o parâmetro": "Selecciona el parámetro",
  "Selecione o período.": "Selecciona el período.",
  "Selecione o tráfego dos vídeos": "Selecciona el tráfico de los vídeos",
  "Selecione o vídeo onde a captura será exibida": "Selecciona el vídeo donde aparecerá la captura",
  "Selecione o vídeo para a captura": "Selecciona el vídeo para la captura",
  "Selecione o vídeo que deseja adicionar ao slot": "Selecciona el vídeo que quieras añadir al espacio",
  "Selecione os vídeos de teste": "Selecciona los vídeos de prueba",
  "Selecione os vídeos para teste (min. 2, máx. 6)": "Selecciona vídeos para la prueba (mín. 2, máx. 6)",
  "Selecione os vídeos que deseja adicionar à playlist": "Selecciona los vídeos que quieras añadir a la playlist",
  "Selecione os vídeos que participarão do teste A/B": "Selecciona los vídeos de la prueba A/B",
  "Selecione os vídeos que receberão as configurações do vídeo atual.": "Selecciona los vídeos que recibirán la configuración del vídeo actual.",
  "Selecione ou arraste os arquivos de vídeo para importar na sua biblioteca.": "Selecciona o arrastra archivos de vídeo para importarlos a tu biblioteca.",
  "Selecione pelo menos 2 velocidades para realizar um teste comparativo.": "Selecciona al menos 2 velocidades para realizar una prueba comparativa.",
  "Selecione um país para configurar regiões": "Selecciona un país para configurar regiones",
  "Selecione um período": "Selecciona un período",
  "Selecione um plano para continuar": "Selecciona un plan para continuar",
  "Selecione um teste para visualizar as métricas.": "Selecciona una prueba para ver las métricas.",
  "Selecione um vídeo *": "Selecciona un vídeo *",
  "Selecione um vídeo da biblioteca ou faça upload de um novo": "Selecciona un vídeo de la biblioteca o sube uno nuevo",
  "Selecione um vídeo da sua biblioteca ou faça upload de um novo": "Selecciona un vídeo de tu biblioteca o sube uno nuevo",
  "Selecione um vídeo da sua biblioteca para começar a personalizar e configurar seus recursos.": "Selecciona un vídeo de tu biblioteca para empezar a personalizar y configurar sus funciones.",
  "Selecione um vídeo diferente.": "Selecciona un vídeo diferente.",
  "Selecione um vídeo e pelo menos um campo para captura (Nome, E-mail ou WhatsApp).": "Selecciona un vídeo y al menos un campo de captura (nombre, correo o WhatsApp).",
  "Selecione um vídeo e um período com visualizações para ver o funil de conversão.": "Selecciona un vídeo y un período con visualizaciones para ver el embudo de conversión.",
  "Selecione um vídeo para acessar os recursos de personalização.": "Selecciona un vídeo para acceder a las funciones de personalización.",
  "Selecione um vídeo para começar a personalizar": "Selecciona un vídeo para empezar a personalizar",
  "Selecione um vídeo para continuar.": "Selecciona un vídeo para continuar.",
  "Selecione um vídeo para personalizar": "Selecciona un vídeo para personalizar",
  "Selecione um vídeo para personalizar...": "Selecciona un vídeo para personalizar...",
  "Selecione um vídeo para visualizar a captura": "Selecciona un vídeo para ver la captura",
  "Selecione um vídeo para visualizar os dados de resultado.": "Selecciona un vídeo para ver los resultados.",
  "Selecione um vídeo para visualizar os horários de pico.": "Selecciona un vídeo para ver las horas pico.",
  "Selecione um webinário": "Selecciona un webinar",
  "Selecione uma aula": "Selecciona una clase",
  "Selecione uma aula para ver a descrição.": "Selecciona una clase para ver la descripción.",
  "Selecione uma etapa ou saída no quadro para editar.": "Selecciona una etapa o salida del lienzo para editar.",
  "Selecione uma solicitação.": "Selecciona una solicitud.",
  "Selecione vídeos da sua conta Google Drive.": "Selecciona vídeos de tu cuenta de Google Drive.",
  "Seletor": "Selector",
  "Seletor CSS *": "Selector CSS *",
  "Seletor copiado!": "¡Selector copiado!",
  "Seletor de cor personalizado": "Selector de color personalizado",
  "Seleção de pastas em desenvolvimento": "Selección de carpetas en desarrollo",
  "Seleção de vídeos em desenvolvimento": "Selección de vídeos en desarrollo",
  "Selos de Confiança": "Sellos de confianza",
  "Sem Borda": "Sin borde",
  "Sem Leads ainda": "Sin leads todavía",
  "Sem Pasta": "Sin carpeta",
  "Sem Plano": "Sin plan",
  "Sem acesso": "Sin acceso",
  "Sem arredondamento (0px)": "Sin redondeo (0px)",
  "Sem conversões": "Sin conversiones",
  "Sem conversões ainda": "Sin conversiones todavía",
  "Sem dados ao vivo": "Sin datos en directo",
  "Sem dados de dispositivos disponíveis": "No hay datos de dispositivos disponibles",
  "Sem dados de horários no período": "No hay datos horarios en el período",
  "Sem dados de performance": "Sin datos de rendimiento",
  "Sem dados de referência no período": "No hay datos de referencia en el período",
  "Sem dados de retenção no período selecionado.": "No hay datos de retención en el período seleccionado.",
  "Sem dados de {value0} no período": "No hay datos de {value0} en el período",
  "Sem dados no período.": "No hay datos en el período.",
  "Sem dados para exibir": "No hay datos para mostrar",
  "Sem dados para mostrar": "No hay datos para mostrar",
  "Sem dados suficientes": "Datos insuficientes",
  "Sem dados suficientes para exibir": "No hay datos suficientes para mostrar",
  "Sem engajamento ainda": "Sin interacción todavía",
  "Sem etapa": "Sin etapa",
  "Sem eventos": "Sin eventos",
  "Sem fundo visível": "Sin fondo visible",
  "Sem métricas ainda": "Sin métricas todavía",
  "Sem nome (apenas imagem)": "Sin nombre (solo imagen)",
  "Sem pergunta": "Sin pregunta",
  "Sem permissão": "Sin permiso",
  "Sem permissão para adicionar pixels": "Sin permiso para añadir píxeles",
  "Sem permissão para adicionar vídeos": "Sin permiso para añadir vídeos",
  "Sem permissão para compartilhar vídeos": "Sin permiso para compartir vídeos",
  "Sem permissão para criar Teste de hook": "Sin permiso para crear pruebas de hook",
  "Sem permissão para criar pastas": "Sin permiso para crear carpetas",
  "Sem permissão para criar regras UTM": "Sin permiso para crear reglas UTM",
  "Sem permissão para criar testes de Hook": "Sin permiso para crear pruebas de hook",
  "Sem permissão para criar testes de velocidade": "Sin permiso para crear pruebas de velocidad",
  "Sem permissão para editar ações de sincronização": "Sin permiso para editar acciones de sincronización",
  "Sem permissão para editar pitches": "Sin permiso para editar pitches",
  "Sem permissão para editar pixels": "Sin permiso para editar píxeles",
  "Sem permissão para editar regras do Cloaker": "Sin permiso para editar reglas del Cloaker",
  "Sem permissão para editar regras geográficas": "Sin permiso para editar reglas geográficas",
  "Sem permissão para excluir pastas": "Sin permiso para eliminar carpetas",
  "Sem permissão para finalizar testes A/B": "Sin permiso para finalizar pruebas A/B",
  "Sem permissão para remover pixels": "Sin permiso para eliminar píxeles",
  "Sem permissão para renomear pastas": "Sin permiso para renombrar carpetas",
  "Sem permissão para renomear vídeos": "Sin permiso para renombrar vídeos",
  "Sem plataforma": "Sin plataforma",
  "Sem redistribuição": "Sin redistribución",
  "Sem regras UTM": "Sin reglas UTM",
  "Sem texto": "Sin texto",
  "Sem thumb": "Sin miniatura",
  "Sem visualizações no período selecionado": "Sin visualizaciones en el período seleccionado",
  "Sem vídeo": "Sin vídeo",
  "Semanal": "Semanal",
  "Semi-negrito": "Seminegrita",
  "Sempre que pausar": "Siempre que se pause",
  "Sempre uma próxima sessão em poucos minutos": "Siempre una próxima sesión en pocos minutos",
  "Sempre visível": "Siempre visible",
  "Senha (": "Contraseña (",
  "Senha Definida *": "Contraseña definida *",
  "Senha alterada com sucesso! Faça login com sua nova senha.": "¡Contraseña cambiada correctamente! Inicia sesión con tu nueva contraseña.",
  "Senha atual incorreta": "Contraseña actual incorrecta",
  "Senha do cliente": "Contraseña del cliente",
  "Senha incorreta. Tente novamente.": "Contraseña incorrecta. Inténtalo de nuevo.",
  "Separe as cidades por vírgula.": "Separa las ciudades con comas.",
  "Separe múltiplos domínios por vírgula": "Separa varios dominios con comas",
  "Separe os nomes por vírgula.": "Separa los nombres con comas.",
  "Seria": "Sería",
  "Seria:": "Sería:",
  "Será criada automaticamente no mesmo dia a cada mês": "Se creará automáticamente el mismo día de cada mes",
  "Sessão": "Sesión",
  "Sessão atualizada hoje": "Sesión actualizada hoy",
  "Seu arquivo excede 2GB. Envie um arquivo menor.": "Tu archivo supera los 2GB. Sube uno más pequeño.",
  "Seu link de indicação estará sempre ativo, nunca expira.": "Tu enlace de referido estará siempre activo y nunca caduca.",
  "Seu maior ponto de queda está antes do pitch. Considere antecipar a proposta de valor ou adicionar um gancho mais forte nos primeiros 15 minutos.": "Tu mayor caída ocurre antes del pitch. Considera adelantar la propuesta de valor o añadir un gancho más fuerte durante los primeros 15 minutos.",
  "Seu navegador não suporta a reprodução de vídeo.": "Tu navegador no admite la reproducción de vídeo.",
  "Seu navegador não suporta notificações push ou o recurso está desabilitado.": "Tu navegador no admite notificaciones push o la función está desactivada.",
  "Seu navegador não suporta notificações push. Utilize Chrome, Firefox ou Safari para ativar este recurso.": "Tu navegador no admite notificaciones push. Usa Chrome, Firefox o Safari para activar esta función.",
  "Seu nome": "Tu nombre",
  "Seu pitch está performando muito bem!": "¡Tu pitch funciona muy bien!",
  "Seu pitch ocorre quando": "Tu pitch ocurre cuando",
  "Seu progresso foi salvo automaticamente.": "Tu progreso se guardó automáticamente.",
  "Seu progresso foi salvo.": "Tu progreso se guardó.",
  "Seu público hoje": "Tu audiencia hoy",
  "Seu teste A/B está ativo e coletando dados.": "Tu prueba A/B está activa y recopilando datos.",
  "Seu teste de introduções está ativo e coletando dados.": "Tu prueba de introducciones está activa y recopilando datos.",
  "Seu teste de intros foi finalizado com sucesso.": "Tu prueba de intros finalizó correctamente.",
  "Seus Melhores Horários desta Semana": "Tus mejores horarios de esta semana",
  "Seus arquivos de identificación (frente e verso) foram enviados e aprovados com sucesso pelo setor de validação da Stripe Connect. Nenhuma ação adicional é requerida neste bloco.": "Tus archivos de identificación (anverso y reverso) se enviaron y aprobaron correctamente por el equipo de validación de Stripe Connect. No se requiere ninguna acción adicional en este bloque.",
  "Seus dados estão seguros conosco.": "Tus datos están seguros con nosotros.",
  "Seus dados serão mantidos por 30 dias": "Tus datos se conservarán durante 30 días",
  "Seus melhores horários": "Tus mejores horarios",
  "Seus testes A/B são mais eficazes quando você entende como interpretar os dados corretamente:": "Tus pruebas A/B son más eficaces cuando sabes interpretar los datos correctamente:",
  "Seus vídeos não serão mais exibidos": "Tus vídeos dejarán de mostrarse",
  "Sex": "Vie",
  "Seção de Bônus": "Sección de bonus",
  "Seção de Módulos": "Sección de módulos",
  "Sidebar de recursos do vídeo": "Barra lateral de funciones del vídeo",
  "Siga estes passos para instalar no Safari": "Sigue estos pasos para instalar en Safari",
  "Silenciar": "Silenciar",
  "Silencioso": "Silencioso",
  "Sim": "Sí",
  "Simulada": "Simulada",
  "Simular Localização": "Simular ubicación",
  "Simular visualização": "Simular visualización",
  "Simulação de Audiência": "Simulación de audiencia",
  "Simulação de Ganhos": "Simulación de ganancias",
  "Simule como a regra se comportaria:": "Simula cómo se comportaría la regla:",
  "Sincronizar Métricas": "Sincronizar métricas",
  "Sincronizar Vídeo com Horário": "Sincronizar vídeo con el horario",
  "Sincronizar com Horário": "Sincronizar con el horario",
  "Sincronização com AWS concluída!": "¡Sincronización con AWS completada!",
  "Sincronização com o Vídeo": "Sincronización con el vídeo",
  "Sistema Pré-pago": "Sistema de prepago",
  "Sistema de Pastas e Subpastas": "Sistema de carpetas y subcarpetas",
  "Site URL": "URL del sitio",
  "Slide": "Deslizar",
  "Slide direito": "Deslizar a la derecha",
  "Smart TV": "Smart TV",
  "Sobre esta aula": "Sobre esta clase",
  "Sobreposições de Conteúdo": "Superposiciones de contenido",
  "Sobrescrever com a minha": "Sobrescribir con la mía",
  "Solicitado em": "Solicitado el",
  "Solicitar Saque Imediato ›": "Solicitar retiro inmediato ›",
  "Solicitar nome": "Solicitar nombre",
  "Solicitar nome e e-mail": "Solicitar nombre y correo",
  "Solicitar nome, e-mail e WhatsApp": "Solicitar nombre, correo y WhatsApp",
  "Solicitações Pendentes": "Solicitudes pendientes",
  "Solicitações de Pagamento": "Solicitudes de pago",
  "Soltar aqui": "Soltar aquí",
  "Solte arquivos aqui, cole, navegue ou importe de": "Suelta archivos aquí, pega, busca o importa desde",
  "Solte seu vídeo aqui,": "Suelta tu vídeo aquí,",
  "Sombra no texto": "Sombra del texto",
  "Sombra nos cards": "Sombra en las tarjetas",
  "Sombras": "Sombras",
  "Spark Points": "Spark Points",
  "Stack Trace:": "Traza de pila:",
  "Start time must be non-negative": "El tiempo inicial no puede ser negativo",
  "Start time too large": "Tiempo inicial demasiado grande",
  "Status atual": "Estado actual",
  "Status atualizado com sucesso!": "¡Estado actualizado correctamente!",
  "Status da Regra": "Estado de la regla",
  "Status da captura:": "Estado de la captura:",
  "Status da conta atualizado!": "¡Estado de la cuenta actualizado!",
  "Status do Cadastro": "Estado del registro",
  "Status geral": "Estado general",
  "Status: Enviado para CRM": "Estado: enviado al CRM",
  "Step 10 - Em desenvolvimento": "Paso 10 - En desarrollo",
  "Step 6 - Em desenvolvimento": "Paso 6 - En desarrollo",
  "Step 7 - Em desenvolvimento": "Paso 7 - En desarrollo",
  "Step 8 - Em desenvolvimento": "Paso 8 - En desarrollo",
  "Step 9 - Em desenvolvimento": "Paso 9 - En desarrollo",
  "Stores Principais": "Stores principales",
  "Stripe não está carregado": "Stripe no está cargado",
  "Sua VSL agora pergunta e escuta: o Feedback do Vídeo é um card de avaliação que aparece dentro do player, no momento que você escolher, e recolhe a opinião de quem assistiu sem tirar a pessoa da página. Você define o formato da nota, o gatilho de exibição, os textos e o visual do card. Na aba Métricas do vídeo você acompanha a nota média, o total de respostas, a distribuição das avaliações e a evolução ao longo do tempo.": "Tu VSL ahora pregunta y escucha: las valoraciones del vídeo aparecen en una tarjeta dentro del reproductor en el momento que elijas y recogen la opinión del espectador sin sacarlo de la página. Define el formato de la nota, el activador, los textos y el diseño. En la pestaña Métricas del vídeo verás la nota media, el total de respuestas, la distribución y la evolución temporal.",
  "Sua assinatura está ativa e deve ser renovada na data de": "Tu suscripción está activa y se renovará el",
  "Sua assinatura foi cancelada com sucesso.": "Tu suscripción se canceló correctamente.",
  "Sua assinatura será encerrada ao final do período atual.": "Tu suscripción finalizará al terminar el período actual.",
  "Sua conta deixou de ser de uma pessoa só. Com Membros, você cadastra quem trabalha com você e define, recurso por recurso, o que cada pessoa pode ver e o que pode editar — ou marca como Administrador e libera todas as áreas de uma vez. Também dá pra liberar apenas as pastas de vídeos que interessam àquela pessoa, deixando o resto da sua biblioteca fora do alcance. Cada um entra com o próprio e-mail e a própria senha, então você para de compartilhar o seu login com o time.": "Tu cuenta ya no es para una sola persona. Con Miembros, añade a quienes trabajan contigo y define, función por función, qué puede ver y editar cada uno; o asígnale Administrador para permitir todas las áreas. También puedes permitir solo las carpetas de vídeos relevantes para cada persona y mantener el resto de la biblioteca fuera de su alcance. Cada uno inicia sesión con su propio correo y contraseña para que dejes de compartir tu acceso con el equipo.",
  "Sua resposta ajuda a melhorar a experiência.": "Tu respuesta ayuda a mejorar la experiencia.",
  "Sua resposta foi registrada com sucesso.": "Tu respuesta se registró correctamente.",
  "Suas chaves": "Tus claves",
  "Suas configurações de notificações foram atualizadas.": "Tu configuración de notificaciones se actualizó.",
  "Suas histórias estão funcionando! Tente adicionar mais elementos de conflito e resolução para aumentar ainda mais o engajamento.": "¡Tus historias funcionan! Añade más elementos de conflicto y resolución para aumentar aún más la interacción.",
  "Suas métricas de conversão aparecerão aqui.": "Tus métricas de conversión aparecerán aquí.",
  "Suas últimas alterações não foram salvas.": "Tus últimos cambios no se guardaron.",
  "Subdomínio específico": "Subdominio específico",
  "Subheadline (Opcional)": "Subtítulo (opcional)",
  "Subheadline: \"": "Subtítulo: \"",
  "Subindo arquivo...": "Subiendo archivo...",
  "Subir opção {value0}": "Subir opción {value0}",
  "Subtexto": "Subtexto",
  "Subtítulo": "Subtítulo",
  "Subtítulo (máx 160 caracteres)": "Subtítulo (máx. 160 caracteres)",
  "Subtítulo (opcional)": "Subtítulo (opcional)",
  "Subtítulo de exemplo": "Subtítulo de ejemplo",
  "Subtítulo do webinar": "Subtítulo del webinar",
  "Sugestão:": "Sugerencia:",
  "Sugestões Avançadas": "Sugerencias avanzadas",
  "Sugestões Avançadas de Retenção": "Sugerencias avanzadas de retención",
  "Sugestões Avançadas para Teste A/B de Vídeos": "Sugerencias avanzadas para pruebas A/B de vídeos",
  "Sugestões baseadas nos dados de dispositivos para otimizar seu conteúdo.": "Sugerencias basadas en datos de dispositivos para optimizar tu contenido.",
  "Supabase": "Supabase",
  "Superior Direito": "Superior derecha",
  "Superior Esquerdo": "Superior izquierda",
  "Suporte Prioritário": "Soporte prioritario",
  "Suporte ao cliente e sistema de tickets para resolução de problemas.": "Atención al cliente y sistema de tickets para resolver problemas.",
  "Suporte: contato@seudominio.com": "Soporte: contato@seudominio.com",
  "Sync AWS": "Sincronizar AWS",
  "SÁB": "SÁB",
  "Sáb": "Sáb",
  "São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Salvador": "São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Salvador",
  "TER": "MAR",
  "TER • 20h-22h": "MAR • 20:00-22:00",
  "Tabela Consolidada": "Tabla consolidada",
  "Tags de Campanha": "Etiquetas de campaña",
  "Tamanho do botão": "Tamaño del botón",
  "Tamanho dos Cards": "Tamaño de las tarjetas",
  "Taxa de E-mail": "Tasa de correo",
  "Taxa de Telefone": "Tasa de teléfono",
  "Taxa de acesso ao checkout": "Tasa de acceso al checkout",
  "Taxa de conversão final": "Tasa de conversión final",
  "Taxa de conversão geral:": "Tasa de conversión general:",
  "Taxa média de conversão calculada entre todas as plataformas": "Tasa media de conversión calculada entre todas las plataformas",
  "Taxa média de retenção": "Tasa media de retención",
  "Taxas": "Comisiones",
  "Taxas Acumuladas": "Comisiones acumuladas",
  "Taxas cobradas sobre pagamentos.": "Comisiones cobradas sobre los pagos.",
  "Telefone copiado!": "¡Teléfono copiado!",
  "Telefone inválido": "Teléfono inválido",
  "Telefone/WhatsApp": "Teléfono/WhatsApp",
  "Tem certeza que deseja cancelar?": "¿Seguro que quieres cancelar?",
  "Tem certeza que deseja deletar este teste de velocidade? Esta ação não pode ser desfeita.": "¿Seguro que quieres eliminar esta prueba de velocidad? Esta acción no se puede deshacer.",
  "Tem certeza que deseja desativar a captura de \"": "¿Seguro que quieres desactivar la captura de \"",
  "Tem certeza que deseja desativar o link de compartilhamento? O link deixará de funcionar imediatamente.": "¿Seguro que quieres desactivar el enlace compartido? Dejará de funcionar inmediatamente.",
  "Tem certeza que deseja excluir": "¿Seguro que quieres eliminar",
  "Tem certeza que deseja excluir \"": "¿Seguro que quieres eliminar \"",
  "Tem certeza que deseja excluir este compartilhamento? Esta ação não pode ser desfeita.": "¿Seguro que quieres eliminar este contenido compartido? Esta acción no se puede deshacer.",
  "Tem certeza que deseja excluir o registro de": "¿Seguro que quieres eliminar el registro de",
  "Tem certeza que deseja excluir o registro de {value0}?": "¿Seguro que quieres eliminar el registro de {value0}?",
  "Tem certeza que deseja excluir o tracking da plataforma": "¿Seguro que quieres eliminar el seguimiento de la plataforma",
  "Tem certeza que deseja excluir os": "¿Seguro que quieres eliminar los",
  "Tem certeza que deseja remover": "¿Seguro que quieres eliminar",
  "Tem certeza que deseja remover '": "¿Seguro que quieres eliminar '",
  "Tem certeza que deseja remover esta imagem?": "¿Seguro que quieres eliminar esta imagen?",
  "Tem certeza que deseja remover esta imagem? Esta ação não pode ser desfeita.": "¿Seguro que quieres eliminar esta imagen? Esta acción no se puede deshacer.",
  "Tem certeza que deseja remover este método de pagamento?": "¿Seguro que quieres eliminar este método de pago?",
  "Tem certeza que deseja remover sua foto de perfil? Esta ação não pode ser desfeita.": "¿Seguro que quieres eliminar tu foto de perfil? Esta acción no se puede deshacer.",
  "Tem certeza que deseja sair?": "¿Seguro que quieres salir?",
  "Tem todas as permissões.": "Tiene todos los permisos.",
  "Tema": "Tema",
  "Template Base": "Plantilla base",
  "Template não encontrado": "Plantilla no encontrada",
  "Template {value0}": "Plantilla {value0}",
  "Templates Sugeridos": "Plantillas sugeridas",
  "Tempo Médio Assistido": "Tiempo medio visto",
  "Tempo de Carregamento": "Tiempo de carga",
  "Tempo de espera mínimo (minutos)": "Tiempo de espera mínimo (minutos)",
  "Tempo de preenchimento": "Tiempo de cumplimentación",
  "Tempo do Pitch": "Tiempo del pitch",
  "Tempo do Vídeo (min:seg) *": "Tiempo del vídeo (min:seg) *",
  "Tempo do pitch": "Tiempo del pitch",
  "Tempo do pitch:": "Tiempo del pitch:",
  "Tempo médio do pitch:": "Tiempo medio del pitch:",
  "Tempo no vídeo": "Tiempo en el vídeo",
  "Tempo para exibir a primeira notificação após o play.": "Tiempo hasta la primera notificación tras iniciar la reproducción.",
  "Tempo: 00:00 - Início do Vídeo": "Tiempo: 00:00 - Inicio del vídeo",
  "Tendência Consistente:": "Tendencia consistente:",
  "Tendência Diária": "Tendencia diaria",
  "Tendência de Captura": "Tendencia de captura",
  "Tendência por Hora": "Tendencia por hora",
  "Tenha atendimento exclusivo para parceiros.": "Recibe atención exclusiva para socios.",
  "Tentativas:": "Intentos:",
  "Tente abrir o vídeo no Chrome (Chromecast) ou Safari (AirPlay).": "Prueba a abrir el vídeo en Chrome (Chromecast) o Safari (AirPlay).",
  "Tente ajustar seus filtros de busca ou categoria.": "Prueba a ajustar los filtros de búsqueda o categoría.",
  "Tente ajustar sua busca ou limpar os filtros.": "Prueba a ajustar la búsqueda o borrar los filtros.",
  "Tente ampliar o período, escolher outra métrica ou verifique se há uma integração de conversão configurada.": "Prueba a ampliar el período, elegir otra métrica o comprobar que haya una integración de conversión configurada.",
  "Tente buscar por outro termo ou campanha": "Prueba otro término o campaña",
  "Tente novamente em instantes. Se o problema persistir, entre em contato com o suporte.": "Inténtalo de nuevo en unos instantes. Si el problema persiste, contacta con soporte.",
  "Tente outro termo ou revise a ortografia.": "Prueba otro término o revisa la ortografía.",
  "Tente outro termo.": "Prueba otro término.",
  "Tente reduzir o tamanho do vídeo ou usar adaptação de qualidade para melhorar o tempo de carregamento.": "Prueba a reducir el tamaño del vídeo o usar calidad adaptativa para mejorar el tiempo de carga.",
  "Tente uma busca diferente.": "Prueba una búsqueda diferente.",
  "Tente verificar a ortografia ou usar palavras-chave diferentes": "Comprueba la ortografía o usa otras palabras clave",
  "Ter": "Mar",
  "Termina com": "Termina con",
  "Termina em:": "Termina el:",
  "Termos": "Términos",
  "Testando...": "Probando...",
  "Testar abertura do modal": "Probar apertura de la ventana",
  "Testar notificação agora": "Probar notificación ahora",
  "Teste A/B criado com sucesso!": "¡Prueba A/B creada correctamente!",
  "Teste A/B criado e ativado!": "¡Prueba A/B creada y activada!",
  "Teste AB": "Prueba A/B",
  "Teste Automático": "Prueba automática",
  "Teste Automático com Múltiplas Velocidades": "Prueba automática con varias velocidades",
  "Teste Sequencial:": "Prueba secuencial:",
  "Teste automático em andamento. A velocidade manual será aplicada quando o teste finalizar.": "Prueba automática en curso. La velocidad manual se aplicará cuando termine.",
  "Teste automático iniciado": "Prueba automática iniciada",
  "Teste criado!": "¡Prueba creada!",
  "Teste de Integrações": "Prueba de integraciones",
  "Teste de headline carregado!": "¡Prueba de titular cargada!",
  "Teste de hook criado com sucesso!": "¡Prueba de hook creada correctamente!",
  "Teste de velocidade criado com sucesso.": "Prueba de velocidad creada correctamente.",
  "Teste de velocidade iniciado": "Prueba de velocidad iniciada",
  "Teste deletado com sucesso!": "¡Prueba eliminada correctamente!",
  "Teste deletado!": "¡Prueba eliminada!",
  "Teste diferentes introduções e descubra a que converte mais": "Prueba distintas introducciones y descubre cuál convierte más",
  "Teste diferentes posições do vídeo na página. Acima da dobra geralmente tem melhores resultados.": "Prueba distintas posiciones del vídeo en la página. Por encima del pliegue suele funcionar mejor.",
  "Teste diferentes variações e otimize suas conversões.": "Prueba distintas variantes y optimiza tus conversiones.",
  "Teste encerrado": "Prueba terminada",
  "Teste finalizado e deletado com sucesso!": "¡Prueba finalizada y eliminada correctamente!",
  "Teste grátis": "Prueba gratis",
  "Teste grátis iniciado! Seu plano {value0} está ativo. Você não será cobrado pelos próximos 15 dias.": "¡Prueba gratis iniciada! Tu plan {value0} está activo. No se te cobrará durante los próximos 15 días.",
  "Teste múltiplos botões ao longo do vídeo (não apenas no final)": "Prueba varios botones durante el vídeo (no solo al final)",
  "Teste no mínimo 3 abordagens de intro diferentes": "Prueba al menos 3 enfoques distintos de introducción",
  "Teste não iniciado": "Prueba no iniciada",
  "Teste seu vídeo neste navegador para garantir a melhor experiência.": "Prueba tu vídeo en este navegador para garantizar la mejor experiencia.",
  "Teste títulos com números específicos ou perguntas intrigantes": "Prueba títulos con cifras concretas o preguntas intrigantes",
  "Teste uma abordagem diferente: se está usando problema-solução, experimente curiosidade ou história de transformação.": "Prueba otro enfoque: si usas problema-solución, experimenta con curiosidad o historias de transformación.",
  "Teste variações": "Prueba variantes",
  "Testes A/B Integrados": "Pruebas A/B integradas",
  "Testes Ativos": "Pruebas activas",
  "Testes de Velocidade": "Pruebas de velocidad",
  "Texto Personalizado": "Texto personalizado",
  "Texto abaixo da imagem": "Texto bajo la imagen",
  "Texto acima do indicador (opcional, máx 40 caracteres)": "Texto sobre el indicador (opcional, máx. 40 caracteres)",
  "Texto adicional de segurança ou informação": "Texto adicional de seguridad o información",
  "Texto antes de liberar": "Texto antes de desbloquear",
  "Texto da barra": "Texto de la barra",
  "Texto da opção {value0}": "Texto de la opción {value0}",
  "Texto de Copyright (editável)": "Texto de copyright (editable)",
  "Texto de Exibição": "Texto mostrado",
  "Texto dentro da imagem (com overlay)": "Texto dentro de la imagen (con superposición)",
  "Texto do Botão (máx 40 caracteres)": "Texto del botón (máx. 40 caracteres)",
  "Texto do Campo": "Texto del campo",
  "Texto do Link": "Texto del enlace",
  "Texto do Termo (máx 250 caracteres)": "Texto de consentimiento (máx. 250 caracteres)",
  "Texto do Título": "Texto del título",
  "Texto do aviso": "Texto del aviso",
  "Texto do botão de envio do formulário": "Texto del botón de envío del formulario",
  "Texto do botão de início": "Texto del botón de inicio",
  "Texto do botão para iniciar": "Texto del botón para iniciar",
  "Texto do botão é obrigatório": "El texto del botón es obligatorio",
  "Texto do overlay": "Texto de la superposición",
  "Texto do segundo botão": "Texto del segundo botón",
  "Texto do texto secundário": "Texto secundario",
  "Texto do timer": "Texto del temporizador",
  "Texto exibido na página de compartilhamento": "Texto mostrado en la página compartida",
  "Texto livre permitido - variáveis são opcionais": "Se permite texto libre; las variables son opcionales",
  "Texto para pular": "Texto para omitir",
  "Texto personalizado...": "Texto personalizado...",
  "Texto sobre a barra": "Texto sobre la barra",
  "Textos do bloco": "Textos del bloque",
  "Thumbnail aplicada!": "¡Miniatura aplicada!",
  "Thumbnail atualizada": "Miniatura actualizada",
  "Thumbnail gerada!": "¡Miniatura generada!",
  "Thumbnail removida": "Miniatura eliminada",
  "Thumbnail será exibida {value0}": "La miniatura se mostrará {value0}",
  "Thumbnails atualizadas": "Miniaturas actualizadas",
  "Ticto": "Ticto",
  "Timer e Urgência": "Temporizador y urgencia",
  "Timestamp (min:seg)": "Marca de tiempo (min:seg)",
  "Timing:": "Momento:",
  "Tipo Acesso": "Tipo de acceso",
  "Tipo da Regra": "Tipo de regla",
  "Tipo de Indicador": "Tipo de indicador",
  "Tipo de Pixel": "Tipo de píxel",
  "Tipo de Recebimento": "Tipo de cobro",
  "Tipo de arquivo inválido": "Tipo de archivo inválido",
  "Tipo de botão": "Tipo de botón",
  "Tipo de conta": "Tipo de cuenta",
  "Tipo de evento": "Tipo de evento",
  "Tipo de notificação": "Tipo de notificación",
  "Tipo de regra:": "Tipo de regla:",
  "Tipos de Notificações": "Tipos de notificaciones",
  "Tirar dúvidas no WhatsApp": "Resolver dudas por WhatsApp",
  "Tire suas dúvidas sobre o programa": "Resuelve tus dudas sobre el programa",
  "Titular": "Titular",
  "Todas as Pastas": "Todas las carpetas",
  "Todas as alterações são aplicadas instantaneamente": "Todos los cambios se aplican al instante",
  "Todas as alterações são aplicadas instantaneamente.": "Todos los cambios se aplican al instante.",
  "Todas as configurações voltaram ao padrão": "Toda la configuración volvió a los valores predeterminados",
  "Todas as legendas foram removidas do vídeo.": "Todos los subtítulos se eliminaron del vídeo.",
  "Todas as personalizações foram aplicadas ao seu vídeo.": "Todas las personalizaciones se aplicaron al vídeo.",
  "Todas as regiões bloqueadas": "Todas las regiones bloqueadas",
  "Todas as regiões permitidas": "Todas las regiones permitidas",
  "Todas as saídas de checkout já possuem uma integração.": "Todas las salidas de checkout ya tienen una integración.",
  "Todas as solicitações enviadas pelos afiliados da plataforma.": "Todas las solicitudes enviadas por afiliados de la plataforma.",
  "Todo o vídeo": "Todo el vídeo",
  "Todos dispositivos": "Todos los dispositivos",
  "Todos os Custos": "Todos los costes",
  "Todos os Registros": "Todos los registros",
  "Todos os campos disponíveis foram adicionados": "Se añadieron todos los campos disponibles",
  "Todos os direitos reservados": "Todos los derechos reservados",
  "Todos os planos incluem": "Todos los planes incluyen",
  "Todos os recursos e benefícios para seu negócio": "Todas las funciones y ventajas para tu negocio",
  "Todos os vídeos foram carregados": "Se cargaron todos los vídeos",
  "Todos os vídeos usados estão prontos": "Todos los vídeos utilizados están listos",
  "Todos que comprarem hoje participam...": "Todos los que compren hoy participan...",
  "Todos que se cadastraram através dos seus links.": "Todos los que se registraron a través de tus enlaces.",
  "Toggle": "Alternar",
  "Toggle {value0} section": "Alternar sección {value0}",
  "Token da plataforma (se exigido)": "Token de la plataforma (si se requiere)",
  "Token de Acesso": "Token de acceso",
  "Token de Acesso *": "Token de acceso *",
  "Token de acesso fornecido pelo": "Token de acceso proporcionado por",
  "Token de acesso fornecido pelo Facebook": "Token de acceso proporcionado por Facebook",
  "Token de {value0}": "Token de {value0}",
  "Token deve ter no máximo 500 caracteres": "El token debe tener como máximo 500 caracteres",
  "Token fornecido pelo Facebook": "Token proporcionado por Facebook",
  "Token não disponível": "Token no disponible",
  "Token não pode estar vazio": "El token no puede estar vacío",
  "Token revogado.": "Token revocado.",
  "Token vazio retornado pelo Google": "Google devolvió un token vacío",
  "Top": "Top",
  "Top 10 Usuários por Custo": "Top 10 usuarios por coste",
  "Top 10 comentários enviados após a avaliação.": "Últimos 10 comentarios enviados tras la valoración.",
  "Top 3 horários com maior consistência": "Top 3 horarios más consistentes",
  "Top 3 horários com melhor": "Top 3 horarios con mejor",
  "Top 3 por visualizações": "Top 3 por visualizaciones",
  "Top 4 por visualizações": "Top 4 por visualizaciones",
  "Top 5 Vídeos por Receita": "Top 5 vídeos por ingresos",
  "Top 5 vídeos com mais captura": "Top 5 vídeos con más capturas",
  "Top Estados": "Principales estados",
  "Top VSL do Período": "Mejor VSL del período",
  "Top fontes de tráfego": "Principales fuentes de tráfico",
  "Top lugares": "Principales lugares",
  "Top vídeos": "Principales vídeos",
  "Toque em \"Adicionar\"": "Toca \"Añadir\"",
  "Toque no botão de compartilhar": "Toca el botón de compartir",
  "Tornar Principal": "Establecer como principal",
  "Tornar comentário obrigatório": "Hacer obligatorio el comentario",
  "Tornar obrigatório": "Hacer obligatorio",
  "Torne-se um Afiliado": "Conviértete en afiliado",
  "Totais": "Totales",
  "Total (12m):": "Total (12m):",
  "Total Cliques": "Total de clics",
  "Total Estimado Próxima Cobrança": "Total estimado del próximo cobro",
  "Total Plays": "Total de reproducciones",
  "Total Usuários": "Total de usuarios",
  "Total Vídeos": "Total de vídeos",
  "Total após taxas aplicadas.": "Total después de las comisiones aplicables.",
  "Total atual:": "Total actual:",
  "Total c/ Taxo": "Total con comisiones",
  "Total consumido": "Total consumido",
  "Total de Capturas": "Total de capturas",
  "Total de Comissões": "Total de comisiones",
  "Total de Indicados": "Total de referidos",
  "Total de Leads do Vídeo": "Total de leads del vídeo",
  "Total de Plays Únicos": "Total de reproducciones únicas",
  "Total de Visualizações Únicas": "Total de visualizaciones únicas",
  "Total de integrações:": "Total de integraciones:",
  "Total de pessoas que viram e interagiram com seu vídeo": "Total de personas que vieron e interactuaron con tu vídeo",
  "Total de reproduções": "Total de reproducciones",
  "Total de visualizações": "Total de visualizaciones",
  "Total deve ser 100%. Atualmente:": "El total debe ser 100%. Actualmente:",
  "Total do período": "Total del período",
  "Total do teste": "Total de la prueba",
  "Total em BRL": "Total en BRL",
  "Total geral pago (sem descontos):": "Total general pagado (sin descuentos):",
  "Total recebido através da sua rede.": "Total recibido a través de tu red.",
  "Total solicitado": "Total solicitado",
  "Totalizadores gerais no sistema:": "Totales generales del sistema:",
  "Tracking": "Seguimiento",
  "Tracking excluído com sucesso!": "¡Seguimiento eliminado correctamente!",
  "Tracking para {value0} adicionado": "Seguimiento añadido para {value0}",
  "Tracking salvo com sucesso!": "¡Seguimiento guardado correctamente!",
  "Transmissão indisponível": "Transmisión no disponible",
  "Transmissão não suportada neste navegador": "Transmisión no compatible con este navegador",
  "Transmitir para TV": "Transmitir a TV",
  "Treinamento prático para criar, configurar e abrir sua sala": "Formación práctica para crear, configurar y abrir tu sala",
  "Trilha": "Itinerario",
  "Trilho": "Pista",
  "Trocar vídeo de fundo": "Cambiar vídeo de fondo",
  "Três passos simples para começar a faturar hoje mesmo.": "Tres pasos sencillos para empezar a facturar hoy.",
  "Tudo OK": "Todo OK",
  "Tudo certo para publicar": "Todo listo para publicar",
  "Tudo para escalar VSLs com performance, proteção e métricas.": "Todo para escalar VSL con rendimiento, protección y métricas.",
  "Tutoriais": "Tutoriales",
  "Tutorial do Produto": "Tutorial del producto",
  "Técnica do PAS": "Técnica PAS",
  "Término automático em:": "Finaliza automáticamente el:",
  "Título (Headline)": "Título (titular)",
  "Título Principal (máx 150 caracteres)": "Título principal (máx. 150 caracteres)",
  "Título Público": "Título público",
  "Título Público *": "Título público *",
  "Título atualizado com sucesso!": "¡Título actualizado correctamente!",
  "Título convincente": "Título convincente",
  "Título da Oferta": "Título de la oferta",
  "Título da Playlist": "Título de la playlist",
  "Título da Página": "Título de la página",
  "Título da oferta": "Título de la oferta",
  "Título de Exemplo": "Título de ejemplo",
  "Título do Episódio": "Título del episodio",
  "Título do Header (opcional)": "Título de cabecera (opcional)",
  "Título do Vídeo": "Título del vídeo",
  "Título do Webinar": "Título del webinar",
  "Título do sorteio": "Título del sorteo",
  "Título que será exibido na sala para os participantes.": "Título que se mostrará a los participantes en la sala.",
  "Título que será exibido para os participantes": "Título que se mostrará a los participantes",
  "Título é obrigatório": "El título es obligatorio",
  "Türkçe": "Türkçe",
  "UF": "Estado",
  "URL Amigável": "URL amigable",
  "URL Amigável *": "URL amigable *",
  "URL Site": "URL del sitio",
  "URL com parâmetros UTM": "URL con parámetros UTM",
  "URL copiada para a área de transferência": "URL copiada al portapapeles",
  "URL da Página de Obrigado": "URL de la página de agradecimiento",
  "URL de Teste": "URL de prueba",
  "URL de download não disponível": "URL de descarga no disponible",
  "URL de redirecionamento (opcional)": "URL de redirección (opcional)",
  "URL deve ter no máximo 500 caracteres": "La URL debe tener como máximo 500 caracteres",
  "URL do Vídeo": "URL del vídeo",
  "URL do botão principal inválida": "URL del botón principal inválida",
  "URL do segundo botão inválida": "URL del segundo botón inválida",
  "URL do site onde o pixel será instalado": "URL del sitio donde se instalará el píxel",
  "URL não navegável": "URL no navegable",
  "URL não suportada. Use Vimeo, Bunny, Cloudflare ou MP4 direto.": "URL no compatible. Usa Vimeo, Bunny, Cloudflare o un MP4 directo.",
  "URL vinculada:": "URL vinculada:",
  "URL válida": "URL válida",
  "URLs": "URLs",
  "URLs de referência": "URLs de referencia",
  "USD": "USD",
  "UTM": "UTM",
  "UTM Campaign": "UTM Campaign",
  "UTM Content": "UTM Content",
  "UTM Medium": "UTM Medium",
  "UTM Source": "UTM Source",
  "UTM Term": "UTM Term",
  "UTM criada": "UTM creada",
  "UTM •": "UTM •",
  "UTM: {value0}={value1}": "UTM: {value0}={value1}",
  "UTMs e referências associadas": "UTM y referencias asociadas",
  "UTMs, src, sck e click ids seguem para o destino.": "Los UTM, src, sck e identificadores de clic se envían al destino.",
  "Um funil de vídeos em que cada resposta do visitante leva ao próximo vídeo, até o checkout.": "Un embudo de vídeos donde cada respuesta lleva al siguiente vídeo hasta el checkout.",
  "Um vídeo bem-sucedido precisa tanto atrair cliques iniciais quanto manter o interesse ao longo do conteúdo.": "Un vídeo exitoso debe atraer clics iniciales y mantener el interés durante el contenido.",
  "Uma chave de API permite que uma ferramenta externa leia, em seu nome, as métricas dos seus vídeos e a lista de vídeos da conta — hoje, o connector da HostVSL no Claude. Ela é de leitura: não altera vídeos, não acessa seus dados de cobrança e não faz login no painel.": "Una clave API permite que una herramienta externa lea en tu nombre las métricas de tus vídeos y la lista de vídeos de la cuenta; actualmente, el conector HostVSL en Claude. Es de solo lectura: no modifica vídeos, no accede a los datos de facturación ni inicia sesión en el panel.",
  "Uma legenda por idioma": "Un subtítulo por idioma",
  "Uma máquina de conversão": "Una máquina de conversión",
  "Uma plataforma de processamento e gerenciamento de pagamentos online.": "Una plataforma de procesamiento y gestión de pagos online.",
  "Uma variação vencedora normalmente supera as outras em pelo menos 10-15% em métricas-chave.": "Una variante ganadora suele superar a las demás al menos un 10-15% en métricas clave.",
  "Uma vez por sessão em cada saída. Atualiza a cada minuto.": "Una vez por sesión en cada salida. Se actualiza cada minuto.",
  "Uplift:": "Mejora:",
  "Upload cancelado": "Subida cancelada",
  "Upload do computador": "Subir desde el ordenador",
  "Upload do vídeo": "Subida del vídeo",
  "UploadBox is deprecated. Use UploadQueueModal from @/components/upload instead.": "UploadBox está obsoleto. Usa UploadQueueModal de @/components/upload.",
  "UploadDialog is deprecated. Use UploadQueueModal from @/components/upload instead.": "UploadDialog está obsoleto. Usa UploadQueueModal de @/components/upload.",
  "Usa uma versão menor do botão de play no centro do player": "Usa una versión más pequeña del botón de reproducción en el centro del reproductor",
  "Usada por {value0} {value1}": "Usada por {value0} {value1}",
  "Usar Esta Thumbnail": "Usar esta miniatura",
  "Usar em nova etapa": "Usar en una nueva etapa",
  "Usar transparência no fundo": "Usar transparencia en el fondo",
  "Usaremos este cartão para cobranças futuras.": "Usaremos esta tarjeta para futuros cobros.",
  "Use \"{count}\" para inserir o número de pessoas dinamicamente.": "Usa \"{count}\" para insertar dinámicamente el número de personas.",
  "Use UTM, token, chave de URL e bloqueio de VPN/Proxy para reforçar a segurança.": "Usa UTM, tokens, claves URL y bloqueo VPN/Proxy para reforzar la seguridad.",
  "Use a estrutura Problema, Agitação, Solução para criar tensão e resolução.": "Usa la estructura Problema, Agitación, Solución para crear tensión y resolución.",
  "Use a gamificação": "Usa la gamificación",
  "Use a normalização por dia para comparar horários dentro do mesmo dia, independente do volume absoluto.": "Usa la normalización diaria para comparar horarios del mismo día, independientemente del volumen absoluto.",
  "Use comandos diretos e claros (\"Clique Agora\" vs \"Saiba Mais\")": "Usa instrucciones claras y directas (\"Haz clic ahora\" frente a \"Más información\")",
  "Use esses dados para planejar estratégias e otimizar suas conversões.": "Usa estos datos para planificar estrategias y optimizar conversiones.",
  "Use este vídeo como modelo para aplicar as mesmas configurações nos outros vídeos.": "Usa este vídeo como modelo para aplicar la misma configuración a otros vídeos.",
  "Use imagens com proporção 16:9 para melhor resultado": "Usa imágenes con proporción 16:9 para mejores resultados",
  "Use imagens de alta qualidade e texto claro que capture a essência do seu conteúdo. Teste diferentes cores de fundo e expressões faciais.": "Usa imágenes de alta calidad y textos claros que capten la esencia del contenido. Prueba distintos colores de fondo y expresiones faciales.",
  "Use imagens/GIFs com proporção 16:9 para melhor resultado": "Usa imágenes/GIF con proporción 16:9 para mejores resultados",
  "Use m:ss ou segundos (ex.: 0:38 ou 38,5).": "Usa m:ss o segundos (p. ej.: 0:38 o 38,5).",
  "Use mini hooks para aumentar retenção.": "Usa mini hooks para aumentar la retención.",
  "Use mudanças de cenário, efeitos sonoros ou visuais para 'acordar' o espectador periodicamente e evitar monotonia.": "Usa cambios de escenario y efectos visuales o sonoros para despertar periódicamente al espectador y evitar la monotonía.",
  "Use mudanças de câmera, efeitos sonoros ou transições visuais a cada 15-20 segundos para renovar a atenção.": "Usa cambios de cámara, efectos sonoros o transiciones visuales cada 15-20 segundos para renovar la atención.",
  "Use o botão": "Usa el botón",
  "Use o cupom abaixo no checkout do plano que você escolher.": "Usa el cupón siguiente al pagar el plan que elijas.",
  "Use o código abaixo para colocar o vídeo no seu site. Funciona em qualquer plataforma.": "Usa el código siguiente para colocar el vídeo en tu sitio. Funciona en cualquier plataforma.",
  "Use os resultados para melhorar criativos, páginas e escala.": "Usa los resultados para mejorar anuncios, páginas y escalabilidad.",
  "Use parâmetros UTM nas suas URLs para rastrear a origem do tráfego": "Usa parámetros UTM en tus URL para rastrear la fuente del tráfico",
  "Use plays extras se o limite mensal expirar antes da renovação.": "Usa reproducciones extra si el límite mensual se agota antes de renovar.",
  "Use thumbnails com expressões faciais fortes e cores contrastantes": "Usa miniaturas con expresiones faciales intensas y colores contrastantes",
  "Use um checkout dedicado a este fluxo e cadastre apenas as compras dele neste webhook. Os indicadores passam a receber as vendas após a configuração na plataforma.": "Usa un checkout exclusivo para este flujo y registra solo sus compras en este webhook. Los indicadores empezarán a recibir ventas tras configurar la plataforma.",
  "Use uma cor no formato #RRGGBB": "Usa un color en formato #RRGGBB",
  "Use várias quebras de padrão ou fatos surpreendentes": "Usa varias interrupciones de patrón o hechos sorprendentes",
  "User ID not found": "ID de usuario no encontrado",
  "User not authenticated": "Usuario no autenticado",
  "Uso interno. Aparece no dashboard, não aparece no player público.": "Uso interno. Aparece en el panel, no en el reproductor público.",
  "Usuário Comum": "Usuario común",
  "Usuário ID #{value0}": "ID de usuario #{value0}",
  "Usuário carregado com sucesso!": "¡Usuario cargado correctamente!",
  "Usuário não identificado": "Usuario no identificado",
  "Usuário não pode fechar sem preencher": "El usuario no puede cerrar sin completar los datos",
  "Usuários": "Usuarios",
  "Usuários ativos no período": "Usuarios activos en el período",
  "Usuários podem entrar até": "Los usuarios pueden entrar hasta",
  "Usuários que clicaram no botão de play e iniciaram o vídeo": "Usuarios que pulsaron reproducir e iniciaron el vídeo",
  "VER SITE": "VER SITIO",
  "VISUAL": "VISUAL",
  "VITE_GOOGLE_CLIENT_ID não configurado. Adicione no .env e reinicie o dev server.": "VITE_GOOGLE_CLIENT_ID no configurado. Añádelo a .env y reinicia el servidor de desarrollo.",
  "VITE_GOOGLE_DEVELOPER_KEY não configurado. Adicione no .env e reinicie o dev server.": "VITE_GOOGLE_DEVELOPER_KEY no configurado. Añádelo a .env y reinicia el servidor de desarrollo.",
  "VSL Direcionada A": "VSL dirigida A",
  "VSL Direcionada B": "VSL dirigida B",
  "VSL Dynamic": "VSL Dynamic",
  "VSL Principal": "VSL principal",
  "VSL {value0}": "VSL {value0}",
  "Vai para": "Va a",
  "Vai para sua biblioteca": "Va a tu biblioteca",
  "Validando cupom...": "Validando cupón...",
  "Validação falhou": "Validación fallida",
  "Valor (R$) *": "Importe (R$) *",
  "Valor Líquido": "Importe neto",
  "Valor Mensal": "Importe mensual",
  "Valor a ser pago": "Importe a pagar",
  "Valor inicial do contador de audiência": "Valor inicial del contador de audiencia",
  "Valor inicial para o contador.": "Valor inicial del contador.",
  "Valor líquido": "Importe neto",
  "Valor mensal": "Importe mensual",
  "Valor médio por venda realizada no período": "Valor medio por venta en el período",
  "Valor pode variar caso você compre plays extras ou caso a recarga automática seja acionada antes da renovação.": "El importe puede variar si compras reproducciones extra o se activa la recarga automática antes de renovar.",
  "Valor total": "Importe total",
  "Valor total de vendas confirmadas no período": "Valor total de ventas confirmadas en el período",
  "Vantagens exclusivas para parceiros Host VSL": "Ventajas exclusivas para socios Host VSL",
  "Variante": "Variante",
  "Variação máxima": "Variación máxima",
  "Variação mínima": "Variación mínima",
  "Varie o ritmo da sua narrativa para manter o interesse ao longo do vídeo. Evite longos períodos apenas falando sem estímulos visuais.": "Varía el ritmo de la narración para mantener el interés durante el vídeo. Evita largos períodos hablando sin estímulos visuales.",
  "Vega": "Vega",
  "Veja em que ponto do vídeo a audiência se engaja e onde ocorre a maior queda.": "Descubre dónde interactúa la audiencia y dónde ocurre la mayor caída.",
  "Veja o desempenho completo das introduções testadas.": "Consulta el rendimiento completo de las introducciones probadas.",
  "Veja o desempenho detalhado de cada introdução testada.": "Consulta el rendimiento detallado de cada introducción probada.",
  "Veja plays, retenção, conversão e outros indicadores importantes.": "Consulta reproducciones, retención, conversiones y otros indicadores importantes.",
  "Veja quais páginas enviaram tráfego para este vídeo.": "Consulta qué páginas enviaron tráfico a este vídeo.",
  "Veja quais vídeos convertem mais": "Descubre qué vídeos convierten más",
  "Veja quanto você pode ganhar por mês": "Descubre cuánto puedes ganar al mes",
  "Velocidade atual: {value0}": "Velocidad actual: {value0}",
  "Velocidade configurada para {value0}x": "Velocidad configurada a {value0}x",
  "Velocidade da Simulação": "Velocidad de simulación",
  "Velocidade de Carregamento": "Velocidad de carga",
  "Velocidade de Reprodução": "Velocidad de reproducción",
  "Velocidade de carregamento": "Velocidad de carga",
  "Velocidade de reprodução": "Velocidad de reproducción",
  "Velocidade de reprodução do vídeo. O padrão é 1.0x.": "Velocidad de reproducción del vídeo. Por defecto, 1.0x.",
  "Velocidade e Teste A/B": "Velocidad y prueba A/B",
  "Velocidade manual salva": "Velocidad manual guardada",
  "Velocidade normal de reprodução.": "Velocidad normal de reproducción.",
  "Velocidade padrão": "Velocidad predeterminada",
  "Velocidade {value0}x": "Velocidad {value0}x",
  "Velocidades de teste (": "Velocidades de prueba (",
  "Velocidades:": "Velocidades:",
  "Venda do dia": "Venta del día",
  "Vendas": "Ventas",
  "Vendedor gerou R$ 10.000 em comissões": "El vendedor generó R$ 10.000 en comisiones",
  "Vendedores Ativos": "Vendedores activos",
  "Vendedores indicados que já geraram comissões.": "Vendedores referidos que ya generaron comisiones.",
  "Ver Dados Detalhados": "Ver datos detallados",
  "Ver Horários de Pico": "Ver horas pico",
  "Ver Meus Vídeos": "Ver mis vídeos",
  "Ver Módulos": "Ver módulos",
  "Ver Prévia": "Ver vista previa",
  "Ver Relatório": "Ver informe",
  "Ver Relatório Completo": "Ver informe completo",
  "Ver Teste": "Ver prueba",
  "Ver Testes": "Ver pruebas",
  "Ver Tracking": "Ver seguimiento",
  "Ver como funciona": "Ver cómo funciona",
  "Ver comprovante": "Ver comprobante",
  "Ver conversões por vídeo": "Ver conversiones por vídeo",
  "Ver detalhes do teste": "Ver detalles de la prueba",
  "Ver detalhes do vídeo": "Ver detalles del vídeo",
  "Ver horários de pico": "Ver horas pico",
  "Ver opções de importação": "Ver opciones de importación",
  "Ver regra em conflito": "Ver regla en conflicto",
  "Ver relatório completo": "Ver informe completo",
  "Ver retenção de {value0}": "Ver retención de {value0}",
  "Ver todos os logs": "Ver todos los registros",
  "Ver todos os logs →": "Ver todos los registros →",
  "Ver tracking detalhado": "Ver seguimiento detallado",
  "Ver tudo": "Ver todo",
  "Verificada": "Verificada",
  "Verificando...": "Verificando...",
  "Verifique se recebeu a notificação de teste.": "Comprueba si recibiste la notificación de prueba.",
  "Verifique se sua Chromecast/Smart TV está ligada e conectada na mesma rede Wi-Fi.": "Comprueba que tu Chromecast/Smart TV esté encendido y conectado a la misma red Wi-Fi.",
  "Verso do Documento": "Reverso del documento",
  "Vertical (↓)": "Vertical (↓)",
  "Via {platformName}": "Mediante {platformName}",
  "Video Preview": "Vista previa del vídeo",
  "Video preview": "Vista previa del vídeo",
  "Vidro escuro": "Cristal oscuro",
  "Views e Plays ao longo do tempo": "Visualizaciones y reproducciones a lo largo del tiempo",
  "Views Únicos": "Visualizaciones únicas",
  "Vinculando documentos ao seu cadastro financeiro...": "Vinculando documentos a tu registro financiero...",
  "Vincular Conta Bancária": "Vincular cuenta bancaria",
  "Vincular VSL no Rastreamento": "Vincular VSL en Seguimiento",
  "Vincule a resposta ao lead, quando disponível.": "Vincula la respuesta al lead cuando esté disponible.",
  "Vincule uma plataforma de vendas à saída de checkout deste fluxo. Acessar o checkout não significa comprar.": "Vincula una plataforma de ventas a la salida de checkout del flujo. Acceder al checkout no significa comprar.",
  "Vis.": "Vis.",
  "Visibilidade:": "Visibilidad:",
  "Visitar": "Visitar",
  "Visitar parceiro {value0}": "Visitar socio {value0}",
  "Visual apenas • Sem lógica de sorteio": "Solo visual • Sin lógica de sorteo",
  "Visual apenas • Sem validação": "Solo visual • Sin validación",
  "Visualizar em dispositivo": "Vista previa en dispositivo",
  "Visualizar este vídeo": "Ver este vídeo",
  "Visualizar no celular": "Vista previa en móvil",
  "Visualizar no desktop": "Vista previa en escritorio",
  "Visualizar no tablet": "Vista previa en tablet",
  "Visualização": "Visualización",
  "Visualização do fluxo": "Vista previa del flujo",
  "Visualização do player com": "Vista previa del reproductor con",
  "Visualizações e insights sobre o desempenho de captura": "Visualizaciones e información sobre el rendimiento de captura",
  "Visualizações hoje": "Visualizaciones hoy",
  "Visualizações únicas e plays únicos contam aparelhos diferentes no período. Clique num vídeo para ver a retenção.": "Las visualizaciones y reproducciones únicas cuentan dispositivos distintos en el período. Haz clic en un vídeo para ver su retención.",
  "Visualize a evolução da retenção durante o vídeo": "Visualiza cómo evoluciona la retención durante el vídeo",
  "Visualize como a retenção evoluiu entre as diferentes introduções testadas.": "Visualiza cómo evolucionó la retención entre las distintas introducciones probadas.",
  "Visualize como a retenção evoluiu entre os diferentes vídeos testados.": "Visualiza cómo evolucionó la retención entre los distintos vídeos probados.",
  "Visualize como ficará seu autoplay": "Visualiza cómo quedará tu autoplay",
  "Visão Geral da Plataforma": "Vista general de la plataforma",
  "Visão geral da plataforma": "Vista general de la plataforma",
  "Você ainda não compartilhou nenhum vídeo": "Todavía no has compartido ningún vídeo",
  "Você ainda não convidou nenhum membro para sua equipe. Comece adicionando membros para colaborar em seus projetos.": "Todavía no has invitado a nadie al equipo. Añade miembros para colaborar en tus proyectos.",
  "Você ainda não criou playlists": "Todavía no has creado playlists",
  "Você ainda não tem vídeos processados": "Todavía no tienes vídeos procesados",
  "Você ainda não tem webinários": "Todavía no tienes webinars",
  "Você ainda pode aplicar a regra para o país inteiro.": "Aún puedes aplicar la regla a todo el país.",
  "Você ainda pode enviar {value0} vídeo{value1} agora. Aguarde os atuais terminarem para enviar mais.": "Aún puedes subir {value0} vídeo{value1} ahora. Espera a que terminen los actuales para subir más.",
  "Você ainda pode importar {value0} vídeo{value1} agora.": "Aún puedes importar {value0} vídeo{value1} ahora.",
  "Você atingiu o limite de vídeos do período de teste. Ative seu plano agora para voltar a enviar vídeos — leva menos de um minuto.": "Alcanzaste el límite de vídeos de la prueba. Activa tu plan para volver a subir vídeos: tarda menos de un minuto.",
  "Você bloqueou as notificações. Para ativá-las novamente, acesse as configurações do seu navegador e permita notificações para este site.": "Bloqueaste las notificaciones. Para reactivarlas, abre los ajustes del navegador y permite notificaciones para este sitio.",
  "Você bloqueou as notificações. Para ativá-las novamente, acesse as configurações do seu navegador.": "Bloqueaste las notificaciones. Para reactivarlas, abre los ajustes del navegador.",
  "Você completou esta série!": "¡Completaste esta serie!",
  "Você concluiu toda a playlist \"": "Completaste toda la playlist \"",
  "Você conectou plataformas, agora vincule sua VSL para capturar as vendas.": "Conectaste plataformas; ahora vincula tu VSL para capturar ventas.",
  "Você confirma que deseja excluir este vídeo da playlist?": "¿Confirmas que quieres eliminar este vídeo de la playlist?",
  "Você encerra o teste quando quiser.": "Puedes finalizar la prueba cuando quieras.",
  "Você está offline. Verifique sua conexão.": "Estás sin conexión. Comprueba tu conexión.",
  "Você está prestes a iniciar um teste com": "Estás a punto de iniciar una prueba con",
  "Você está recebendo notificações push sobre eventos importantes da sua conta. Configure abaixo quais tipos de alertas deseja receber.": "Recibes notificaciones push sobre eventos importantes de tu cuenta. Configura a continuación los tipos de alertas que quieres recibir.",
  "Você está solicitando o saque do seu saldo liberado de": "Estás solicitando el retiro de tu saldo disponible de",
  "Você está visualizando o Dashboard no Modo Teste.": "Estás viendo el panel en modo de prueba.",
  "Você gerou tokens demais hoje. Tente novamente em 1 hora.": "Generaste demasiados tokens hoy. Inténtalo de nuevo en 1 hora.",
  "Você já clonou este vídeo. Cada vídeo pode ser copiado apenas uma vez para sua conta.": "Ya clonaste este vídeo. Solo se puede copiar una vez a tu cuenta.",
  "Você já pode acessá-lo em": "Ya puedes acceder en",
  "Você não poderá compartilhar este vídeo com outras pessoas.": "No podrás compartir este vídeo con otras personas.",
  "Você não possui nenhum Rastreamento ativo": "No tienes ningún seguimiento activo",
  "Você não tem permissão para fazer upload de vídeos.": "No tienes permiso para subir vídeos.",
  "Você parou em": "Te quedaste en",
  "Você perderá acesso a todos os recursos da HostVSL": "Perderás acceso a todas las funciones de HostVSL",
  "Você pode adicionar quantos vídeos quiser para testar diferentes abordagens.": "Puedes añadir tantos vídeos como quieras para probar distintos enfoques.",
  "Você poderá escolher arquivos da sua conta Google com segurança.": "Podrás elegir archivos de tu cuenta de Google de forma segura.",
  "Você poderá mover vídeos para esta pasta depois. (": "Podrás mover vídeos a esta carpeta después. (",
  "Você precisa estar autenticado.": "Debes estar autenticado.",
  "Você precisa estar logado para criar um teste.": "Debes iniciar sesión para crear una prueba.",
  "Você precisa selecionar um vídeo para continuar": "Debes seleccionar un vídeo para continuar",
  "Você recusou o compartilhamento": "Rechazaste el contenido compartido",
  "Você será cobrado R$": "Se te cobrará R$",
  "Você é o dono do vídeo": "Eres el dueño del vídeo",
  "Você é o proprietário deste vídeo": "Eres el propietario de este vídeo",
  "Voltando em": "Volviendo en",
  "Voltar 10 segundos": "Retroceder 10 segundos",
  "Voltar ao Dashboard": "Volver al panel",
  "Voltar ao dashboard": "Volver al panel",
  "Voltar para Detalhes": "Volver a detalles",
  "Voltar para Extrato Administrativo": "Volver al extracto administrativo",
  "Voltar para Playlists": "Volver a playlists",
  "Voltar para a lista de fluxos": "Volver a la lista de flujos",
  "Voltar para login": "Volver a iniciar sesión",
  "Voltar para o login": "Volver a iniciar sesión",
  "Volume ({value}%)": "Volumen ({value}%)",
  "Volume Contratado": "Volumen contratado",
  "Vá até a aba Configurações para cadastrar seu primeiro pixel.": "Ve a la pestaña Configuración para registrar tu primer píxel.",
  "Vá para a aba \"Automático\" e ative um teste de velocidade para ver as métricas aqui.": "Ve a la pestaña \"Automático\" y activa una prueba de velocidad para ver las métricas aquí.",
  "Válida enquanto durar o evento": "Válida durante el evento",
  "Válido por:": "Válido por:",
  "Vídeo \"{value0}\" excluído com sucesso": "Vídeo \"{value0}\" eliminado correctamente",
  "Vídeo 1": "Vídeo 1",
  "Vídeo 2": "Vídeo 2",
  "Vídeo 3": "Vídeo 3",
  "Vídeo A": "Vídeo A",
  "Vídeo B": "Vídeo B",
  "Vídeo C": "Vídeo C",
  "Vídeo ID:": "ID del vídeo:",
  "Vídeo Institucional": "Vídeo corporativo",
  "Vídeo adicionado": "Vídeo añadido",
  "Vídeo adicionado com sucesso": "Vídeo añadido correctamente",
  "Vídeo compartilhado": "Vídeo compartido",
  "Vídeo copiado para sua biblioteca": "Vídeo copiado a tu biblioteca",
  "Vídeo de Lançamento": "Vídeo de lanzamiento",
  "Vídeo de origem": "Vídeo de origen",
  "Vídeo de origem não encontrado.": "Vídeo de origen no encontrado.",
  "Vídeo de saída não configurado": "Vídeo de salida no configurado",
  "Vídeo de segurança": "Vídeo de seguridad",
  "Vídeo de vendas": "Vídeo de ventas",
  "Vídeo duplicado com configurações padrão.": "Vídeo duplicado con configuración predeterminada.",
  "Vídeo e tempos": "Vídeo y tiempos",
  "Vídeo em preparo. Acesse Vídeos Compartilhados para gerenciar.": "Vídeo en preparación. Accede a Vídeos compartidos para gestionarlo.",
  "Vídeo excluído.": "Vídeo eliminado.",
  "Vídeo importado com sucesso!": "¡Vídeo importado correctamente!",
  "Vídeo já clonado": "Vídeo ya clonado",
  "Vídeo já está sendo usado em": "El vídeo ya se usa en",
  "Vídeo principal exibido após as variações": "Vídeo principal mostrado después de las variantes",
  "Vídeo pronto para personalização!": "¡Vídeo listo para personalizar!",
  "Vídeo renomeado": "Vídeo renombrado",
  "Vídeo sem pitch nesta posição — clique para definir": "Vídeo sin pitch en esta posición: haz clic para definirlo",
  "Vídeo sem título": "Vídeo sin título",
  "Vídeo usado como variação no teste": "Vídeo usado como variante en la prueba",
  "Vídeo vinculado": "Vídeo vinculado",
  "Vídeos (1)": "Vídeos (1)",
  "Vídeos adicionados à fila": "Vídeos añadidos a la cola",
  "Vídeos aplicados:": "Vídeos aplicados:",
  "Vídeos de Teste": "Vídeos de prueba",
  "Vídeos disponíveis": "Vídeos disponibles",
  "Vídeos em HD (1080p) oferecem melhor experiência aos espectadores": "Los vídeos HD (1080p) ofrecen una mejor experiencia a los espectadores",
  "Vídeos específicos": "Vídeos específicos",
  "Vídeos ilimitados": "Vídeos ilimitados",
  "Vídeos na plataforma": "Vídeos en la plataforma",
  "Vídeos nesta pasta": "Vídeos en esta carpeta",
  "Vídeos rastreados": "Vídeos rastreados",
  "Webhook copiado.": "Webhook copiado.",
  "Webhooks": "Webhooks",
  "Webinário de Lançamento": "Webinar de lanzamiento",
  "Zoom": "Zoom",
  "Zoom leve": "Zoom suave",
  "dias de teste": "días de prueba",
  "ex: Português": "p. ej.: Portugués",
  "ex: dominio.com ou dominio.com/pagina": "p. ej.: dominio.com o dominio.com/pagina",
  "ex: pt-BR, zh-TW": "p. ej.: pt-BR, zh-TW",
  "exemplo.com/vendas": "ejemplo.com/ventas",
  "fatura": "factura",
  "faturas": "facturas",
  "ficou no topo": "quedó en primer lugar",
  "fim": "fin",
  "foi copiado para sua conta.": "se copió a tu cuenta.",
  "gapi indisponível após carregar api.js": "gapi no disponible después de cargar api.js",
  "group-[.toast]:text-muted-foreground": "group-[.toast]:text-muted-foreground",
  "hrs": "h",
  "iFrame": "iFrame",
  "inscrições": "inscripciones",
  "intro": "intro",
  "intro será rastreada": "se rastreará la intro",
  "introduções": "introducciones",
  "intros": "intros",
  "intros serão rastreadas": "se rastrearán las intros",
  "itens)": "elementos)",
  "leads (": "leads (",
  "maior número de conversões": "mayor número de conversiones",
  "maior receita gerada": "mayores ingresos generados",
  "melhor taxa de conversão": "mejor tasa de conversión",
  "mensal": "mensual",
  "mesma proporção": "misma proporción",
  "minutos após o início": "minutos después del inicio",
  "modo compacto": "modo compacto",
  "na barra inferior do Safari": "en la barra inferior de Safari",
  "nas variações já criadas.": "en las variantes ya creadas.",
  "navegue": "explora",
  "no 1º mês": "en el primer mes",
  "no menu": "en el menú",
  "no menu esquerdo.": "en el menú izquierdo.",
  "no total).": "en total).",
  "nos controles.": "en los controles.",
  "não contém": "no contiene",
  "não serão refletidas": "no se reflejarán",
  "número de conversões": "número de conversiones",
  "o vídeo de saída começa assim que o principal termina, conduzindo o espectador para a próxima ação.": "el vídeo de salida comienza cuando termina el principal y guía al espectador a la siguiente acción.",
  "opções": "opciones",
  "origem detectada": "fuente detectada",
  "origens com curva de retenção": "fuentes con curva de retención",
  "origens detectadas": "fuentes detectadas",
  "origens no gráfico. Veja todas na tabela abaixo.": "fuentes en el gráfico. Consulta todas en la tabla siguiente.",
  "ou clique no botão abaixo para escolher seus arquivos": "o haz clic en el botón siguiente para elegir archivos",
  "ou clique no botão abaixo para selecionar": "o haz clic en el botón siguiente para seleccionar",
  "ou clique para selecionar": "o haz clic para seleccionar",
  "ou clique para selecionar do seu computador": "o haz clic para seleccionar desde tu ordenador",
  "ou importe de": "o importa desde",
  "outras regras...": "otras reglas...",
  "pagination": "paginación",
  "para aumentar a retenção na marca de 1:45, onde ocorre uma queda significativa no engajamento.": "para aumentar la retención en 1:45, donde la interacción cae significativamente.",
  "para cada intro. Sem isso, a plataforma não envia as conversões. Você também encontra estas URLs em": "para cada intro. Sin esto, la plataforma no envía conversiones. También encontrarás estas URL en",
  "para começar o fluxo.": "para iniciar el flujo.",
  "para confirmar": "para confirmar",
  "para escalar VSLs.": "para escalar VSL.",
  "para melhorar o carregamento.": "para mejorar la carga.",
  "pitches.": "pitches.",
  "plataforma configurada": "plataforma configurada",
  "plataformas atingido": "límite de plataformas alcanzado",
  "plataformas configuradas": "plataformas configuradas",
  "plataformas para comparar": "plataformas para comparar",
  "plays analisados": "reproducciones analizadas",
  "plays extras": "reproducciones extra",
  "plays inclusos por mês": "reproducciones incluidas al mes",
  "plays utilizados": "reproducciones utilizadas",
  "por": "por",
  "quando seus plays acabarem": "cuando se agoten tus reproducciones",
  "queda de": "caída de",
  "receita gerada": "ingresos generados",
  "regra": "regla",
  "restantes": "restantes",
  "rotas •": "rutas •",
  "s após abertura": "s después de abrir",
  "s do Pitch": "s del pitch",
  "s do vídeo": "s del vídeo",
  "s restantes": "s restantes",
  "saídas": "salidas",
  "segundo": "segundo",
  "selecionadas)": "seleccionadas)",
  "selecionados": "seleccionados",
  "sem destino": "sin destino",
  "sem window": "sin window",
  "seu-link": "tu-enlace",
  "sobre os planos ativados pelos clientes que você indicar.": "sobre los planes activados por los clientes que refieras.",
  "src/components/": "src/components/",
  "status da inscrição:": "estado de la suscripción:",
  "stores •": "stores •",
  "sua_chave_api_do_activecampaign": "sua_chave_api_do_activecampaign",
  "terminando em": "terminando en",
  "todo mês!": "¡cada mes!",
  "tracking(s)?": "¿seguimiento(s)?",
  "trackings selecionados? Esta ação não pode ser desfeita.": "¿seguimientos seleccionados? Esta acción no se puede deshacer.",
  "usados": "usados",
  "useCustomAuth must be used within CustomAuthProvider": "useCustomAuth debe usarse dentro de CustomAuthProvider",
  "useDashboard must be used within a DashboardProvider": "useDashboard debe usarse dentro de DashboardProvider",
  "useDrawer must be used within a DrawerProvider": "useDrawer debe usarse dentro de DrawerProvider",
  "useNewVideoModal must be used within a NewVideoModalProvider": "useNewVideoModal debe usarse dentro de NewVideoModalProvider",
  "useSidebar must be used within a SidebarProvider.": "useSidebar debe usarse dentro de SidebarProvider.",
  "useSupportTokenModal must be used within SupportTokenProvider": "useSupportTokenModal debe usarse dentro de SupportTokenProvider",
  "useTestMode must be used within a TestModeProvider": "useTestMode debe usarse dentro de TestModeProvider",
  "useTheme must be used within ThemeProvider": "useTheme debe usarse dentro de ThemeProvider",
  "useTour must be inside TourProvider": "useTour debe estar dentro de TourProvider",
  "userId é obrigatório para ativar um teste": "userId es obligatorio para activar una prueba",
  "userId é obrigatório para criar um teste": "userId es obligatorio para crear una prueba",
  "utm_campaign": "utm_campaign",
  "utm_content": "utm_content",
  "utm_medium": "utm_medium",
  "utm_source": "utm_source",
  "utm_term": "utm_term",
  "v1.1.0 | dev": "v1.1.0 | dev",
  "vazio": "vacío",
  "vezes": "veces",
  "videoId é obrigatório para criar um teste": "videoId es obligatorio para crear una prueba",
  "visualizações)": "visualizaciones)",
  "visualizações).": "visualizaciones).",
  "vídeo(s)": "vídeo(s)",
  "vídeo(s)? Esta ação não pode ser desfeita.": "vídeo(s)? Esta acción no se puede deshacer.",
  "vídeos sem funil configurado": "vídeos sin embudo configurado",
  "vídeos)": "vídeos)",
  "Áudio": "Audio",
  "Ícone de Exibição": "Icono de visualización",
  "Última atividade detectada": "Última actividad detectada",
  "Última atualização: agora": "Última actualización: ahora",
  "Última edição": "Última edición",
  "Último Teste": "Última prueba",
  "Último salvamento:": "Último guardado:",
  "Último uso": "Último uso",
  "Últimos Eventos": "Últimos eventos",
  "🎬 Vamos começar sua transformação em vídeo?": "🎬 ¿Empezamos tu transformación en vídeo?",
  "🏆 Velocidade Campeã": "🏆 Velocidad ganadora",
  "💡 Pronto? Suba seu vídeo agora e surpreenda seus espectadores.": "💡 ¿Listo? Sube tu vídeo y sorprende a tus espectadores.",
  "Comece a usar direto pelo menu Ferramentas": "Empieza a usarlo desde el menú Herramientas",
  "Comece com um vídeo perguntando “Qual é o seu maior desafio?”. A resposta “Estou começando” leva a uma explicação dos fundamentos; “Já vendo e quero crescer” leva a um vídeo mais avançado. Cada sequência pode terminar em uma oferta específica ou encaminhar a pessoa para conversar no WhatsApp. É o visitante quem escolhe a próxima etapa, sem sair do player entre os vídeos.": "Empieza con un video que pregunte «¿Cuál es tu mayor desafío?». La respuesta «Estoy empezando» lleva a una explicación de los fundamentos; «Ya vendo y quiero crecer», a un video más avanzado. Cada secuencia puede terminar en una oferta específica o llevar a WhatsApp. El visitante elige la siguiente etapa sin salir del reproductor.",
  "Comece dando um nome ao seu teste": "Empieza dando un nombre a tu prueba",
  "Comece enviando seu primeiro vídeo.": "Empieza enviando tu primer video.",
  "Como acompanhar os resultados": "Cómo seguir los resultados",
  "Como acompanho meus resultados?": "¿Cómo consulto mis resultados?",
  "Como funciona o pagamento da comissão?": "¿Cómo se paga la comisión?",
  "Como montar seu fluxo": "Cómo montar tu flujo",
  "Como você deseja continuar?": "¿Cómo quieres continuar?",
  "Comparação dos melhores horários por device": "Comparación de los mejores horarios por dispositivo",
  "Compare horários recomendados com ranking de melhores faixas": "Compara los horarios recomendados con la clasificación de las mejores franjas",
  "Compare horários recomendados com ranking de melhores faixas para repetir o que já funciona": "Compara los horarios recomendados con la clasificación de las mejores franjas para repetir lo que ya funciona",
  "Compare métricas por período": "Compara las métricas por período",
  "Compartilhe vídeos com afiliados por link e acompanhe tudo.": "Comparte videos con afiliados mediante enlaces y sigue toda la actividad.",
  "Compartilhe vídeos com link seguro": "Comparte videos con un enlace seguro",
  "Compatibilidade": "Compatibilidad",
  "Complete esta etapa para continuar": "Completa esta etapa para continuar",
  "Componentes e modais com padrão unificado": "Componentes y diálogos con un estándar unificado",
  "Componentes e modais com padrão unificado do novo front": "Componentes y diálogos con el estándar unificado de la nueva interfaz",
  "Compras aprovadas na integração do fluxo": "Compras aprobadas en la integración del flujo",
  "Condição secundária": "Condición secundaria",
  "Conecte o Google Ads às suas VSLs e envie as conversões de play, oferta e checkout para as suas campanhas.": "Conecta Google Ads con tus VSL y envía las conversiones de reproducción, oferta y pago a tus campañas.",
  "Conecte sua conta Google com permissão somente de leitura — não tocamos em nada do seu Drive": "Conecta tu cuenta de Google con permisos de solo lectura: no modificamos nada de tu Drive",
  "Config. Player": "Config. del reproductor",
  "Configurar Distribuição": "Configurar distribución",
  "Configuração guiada passo a passo": "Configuración guiada paso a paso",
  "Configure a distribuição de tráfego para continuar": "Configura la distribución del tráfico para continuar",
  "Configure no menu Pixel, na aba Configurações, no card \"Google Ads\"": "Configúralo en el menú Píxel, pestaña Configuración, tarjeta \"Google Ads\"",
  "Configure no menu Pixel, na aba Configurações, no card \"TikTok\"": "Configúralo en el menú Píxel, pestaña Configuración, tarjeta \"TikTok\"",
  "Configure o botão de ação dos seus vídeos": "Configura el botón de acción de tus videos",
  "Configure seu vídeo com recursos inteligentes para máxima conversão": "Configura tu video con funciones inteligentes para maximizar la conversión",
  "Considere substituir por uma das outras introduções que performam melhor": "Considera sustituirla por otra introducción con mejor rendimiento",
  "Construa funil de vendas em minutos": "Crea un embudo de ventas en minutos",
  "Construa quizzes em minutos com editor visual": "Crea cuestionarios en minutos con el editor visual",
  "Construtor visual com etapas conectadas: cada vídeo pode ter uma pergunta e até quatro opções de resposta.": "Constructor visual con etapas conectadas: cada video puede tener una pregunta y hasta cuatro opciones de respuesta.",
  "Conta Bancária": "Cuenta bancaria",
  "Conta apenas quem está realmente assistindo com o som ativo — audiência engajada de verdade": "Solo cuenta a quienes están viendo con el sonido activado: una audiencia realmente implicada",
  "Contador de \"assistindo agora\" que se atualiza sozinho a cada poucos segundos": "Contador de personas «viendo ahora» que se actualiza automáticamente cada pocos segundos",
  "Contagem regressiva de 3 a 60 segundos ao final do vídeo, sobreposta ao player ou em tela cheia": "Cuenta atrás de 3 a 60 segundos al final del video, sobre el reproductor o a pantalla completa",
  "Conteúdo (Content)": "Contenido (Content)",
  "Controle em quais dispositivos o vídeo será exibido: desktop, tablet ou celular.": "Controla en qué dispositivos se mostrará el video: escritorio, tableta o móvil.",
  "Controle o acesso com toggle de ativação, limite de cópias e data de expiração": "Controla el acceso con un interruptor de activación, límite de copias y fecha de caducidad",
  "Controle quando as opções aparecem, quando o vídeo pausa e se é possível assistir novamente à última etapa.": "Controla cuándo aparecen las opciones, cuándo se pausa el video y si se puede volver a ver la última etapa.",
  "Controle quem pode copiar seus vídeos": "Controla quién puede copiar tus videos",
  "Controle total sobre a aparência do seu autoplay.": "Control total del aspecto de tu reproducción automática.",
  "Conversão de abertura": "Conversión de apertura",
  "Conversões por dia e horário": "Conversiones por día y hora",
  "Cor da Headline": "Color del titular",
  "Cor do play grande": "Color del botón de reproducción grande",
  "Cor do rodapé": "Color del pie de página",
  "Cor dos controles": "Color de los controles",
  "Corrigida borda azul do vídeo selecionado que estava sendo cortada no modal de upload. Adicionado padding ao grid e substituído ring por border sólida.": "Se ha corregido el borde azul del video seleccionado, que se cortaba en el diálogo de subida. Se ha añadido relleno a la cuadrícula y sustituido el anillo por un borde sólido.",
  "Corrigido bug onde isFinalStep calculava incorretamente, fazendo o botão Iniciar Teste aparecer na etapa 2. Alterado de currentStep === totalSteps - 1 para currentStep === totalSteps.": "Se ha corregido el cálculo de isFinalStep, que hacía aparecer el botón Iniciar prueba en la etapa 2. Se ha cambiado currentStep === totalSteps - 1 por currentStep === totalSteps.",
  "Criando conta...": "Creando cuenta...",
  "Criar Captura com E-mail": "Crear captura con correo electrónico",
  "Criar Formulário com E-mail": "Crear formulario con correo electrónico",
  "Criar conta grátis": "Crear cuenta gratis",
  "Criar e abrir o editor": "Crear y abrir el editor",
  "Crie e clone páginas em poucos minutos com a Replic, sem cartão de crédito.": "Crea y clona páginas en pocos minutos con Replic, sin tarjeta de crédito.",
  "Crie pastas e subpastas ilimitadas": "Crea carpetas y subcarpetas ilimitadas",
  "Crie pelo menos 2 variações para continuar": "Crea al menos 2 variaciones para continuar",
  "Crie proteções num passo a passo simples, do vídeo às regras": "Crea protecciones con un proceso sencillo, desde el video hasta las reglas",
  "Crie quizzes interativos para qualificar leads e aumentar conversão com a FunnelX.": "Crea cuestionarios interactivos para cualificar leads y aumentar la conversión con FunnelX.",
  "Crie sites do zero com blocos prontos e premium": "Crea sitios desde cero con bloques prémium predefinidos",
  "Crie um Funil Poderoso que permite 1X1 baseado em eventos e disparos em massa multicanais. É tudo o que você precisa para mandar a mensagem certa na hora certa e maximizar as suas vendas!": "Crea un potente embudo que permite interacciones individuales basadas en eventos y envíos masivos por varios canales. ¡Todo lo que necesitas para enviar el mensaje adecuado en el momento oportuno y maximizar tus ventas!",
  "Crie uma pasta": "Crea una carpeta",
  "Cupom exclusivo 50%OFF para 50% de desconto em qualquer plano": "Cupón exclusivo 50%OFF para obtener un 50 % de descuento en cualquier plan",
  "Dados por timezone configurável": "Datos por zona horaria configurable",
  "Dark Members 2.0 — Template Premium": "Dark Members 2.0 — Plantilla prémium",
  "Dashboard principal (vídeos)": "Panel principal (videos)",
  "Dashboard redesenhado com 6 cards executivos: Overview, TopVSL, PitchHealth, Engagement, ConversionsRevenue, Audience. Altura fixa 260px, skeletons com shimmer.": "Panel rediseñado con 6 tarjetas ejecutivas: Overview, TopVSL, PitchHealth, Engagement, ConversionsRevenue y Audience. Altura fija de 260 px y esqueletos con brillo animado.",
  "Dashboard — 6 Cards Premium": "Panel — 6 tarjetas prémium",
  "Data Fetching": "Obtención de datos",
  "Defina a etapa inicial. Em cada etapa, selecione o vídeo, escreva a pergunta e adicione as respostas. Conecte cada resposta a outra etapa ou crie uma saída com o endereço de destino; você também escolhe se a página abre na mesma aba ou em uma nova.": "Define la etapa inicial. En cada etapa, selecciona el video, escribe la pregunta y añade las respuestas. Conecta cada respuesta a otra etapa o crea una salida con la dirección de destino; también puedes elegir si abre en la misma pestaña o en una nueva.",
  "Defina a ordem das variações": "Define el orden de las variaciones",
  "Defina antes quando as opções aparecem.": "Define primero cuándo aparecen las opciones.",
  "Defina como o tráfego será distribuído": "Define cómo se distribuirá el tráfico",
  "Defina limites de cópias e expiração": "Define límites de copias y caducidad",
  "Defina o nível de cada recurso: sem acesso, visualização ou edição": "Define el nivel de cada función: sin acceso, visualización o edición",
  "Define a primeira impressão antes do play": "Define la primera impresión antes de la reproducción",
  "Delay sincronizado com vídeo": "Retraso sincronizado con el video",
  "Desativa completamente os controles do player, deixando apenas o vídeo visível.": "Desactiva por completo los controles del reproductor y deja visible solo el video.",
  "Descubra criativos, ângulos e funis vencedores": "Descubre creatividades, enfoques y embudos ganadores",
  "Descubra o horário campeão do período com o melhor volume de plays": "Descubre el mejor horario del período por número de reproducciones",
  "Descubra o horário campeão do período com o melhor volume de plays e visualizações": "Descubre el mejor horario del período por número de reproducciones y visualizaciones",
  "Descubra ofertas validadas na Meta com a AdSniper e ganhe 50% OFF com o cupom 50%OFF.": "Descubre ofertas validadas en Meta con AdSniper y obtén un 50 % de descuento con el cupón 50%OFF.",
  "Descubra quando seu público mais assiste seus vídeos.": "Descubre cuándo ve más tu público tus videos.",
  "Deseja aproveitar essa oportunidade?": "¿Quieres aprovechar esta oportunidad?",
  "Design responsivo otimizado para mobile": "Diseño adaptable optimizado para móvil",
  "Destaque visual para chamar atenção": "Realce visual para llamar la atención",
  "Detalhes do vídeo": "Detalles del video",
  "Digite o código de 4 dígitos": "Introduce el código de 4 dígitos",
  "Direto / sem origem": "Directo / sin origen",
  "Dispara no clique do botão de compra": "Se activa al hacer clic en el botón de compra",
  "Dispara no primeiro play do vídeo": "Se activa en la primera reproducción del video",
  "Dispara quando a oferta aparece": "Se activa cuando aparece la oferta",
  "Disponível agora no menu Ferramentas.": "Ya disponible en el menú Herramientas.",
  "Disponível apenas em vídeos novos — enviados a partir de agora": "Disponible solo en videos nuevos, enviados a partir de ahora",
  "Disponível no modal \"Importar vídeos\" do seu painel.": "Disponible en el diálogo \"Importar videos\" de tu panel.",
  "Disponível somente nesta página": "Disponible solo en esta página",
  "Disponível só nestes locais.": "Disponible solo en estas ubicaciones.",
  "Distribua seus vídeos com velocidade e controle.": "Distribuye tus videos con rapidez y control.",
  "Distribua seus vídeos com velocidade e controle. Menos etapas, mais escala para sua operação com afiliados.": "Distribuye tus videos con rapidez y control. Menos pasos y más capacidad para trabajar con afiliados.",
  "Distribuição drag-and-drop": "Distribución mediante arrastrar y soltar",
  "Distribuição horária dos plays do dia": "Distribución horaria de las reproducciones del día",
  "Documentação - Padronização Cores #1D4FFF": "Documentación - Unificación de colores #1D4FFF",
  "Documentação técnica": "Documentación técnica",
  "Dois botões empilhados, para opções com textos longos.": "Dos botones apilados para opciones con textos largos.",
  "Dois botões lado a lado, com o mesmo peso visual.": "Dos botones en paralelo con el mismo peso visual.",
  "Domingo 10-12h: Alta consistência, mas baixa saturação": "Domingo 10:00-12:00: alta constancia y baja saturación",
  "Domínio já cadastrado.": "Dominio ya registrado.",
  "Drag and Drop": "Arrastrar y soltar",
  "Dropdown de seleção de vídeo agora herda largura exata do botão trigger usando CSS variable do Radix. Aplicados estilos premium: border #E6E8EC, radius 10px, shadow, altura 48px por item.": "El selector de videos ahora hereda el ancho exacto del botón mediante una variable CSS de Radix. Se han aplicado estilos prémium: borde #E6E8EC, radio de 10 px, sombra y altura de 48 px por elemento.",
  "Dubai (GMT+4)": "Dubái (GMT+4)",
  "Dupla Escolha": "Doble elección",
  "Dê acesso ao seu painel para quem trabalha com você, com permissões definidas recurso por recurso.": "Da acceso a tu panel a quienes trabajan contigo, con permisos definidos función por función.",
  "Dê um nome ao fluxo. Cada fluxo é um funil de vídeos curtos em que o visitante escolhe o próprio caminho.": "Da un nombre al flujo. Cada flujo es un embudo de videos cortos donde el visitante elige su propio camino.",
  "E-mail é obrigatório": "El correo electrónico es obligatorio",
  "Editar Captura com E-mail": "Editar captura con correo electrónico",
  "Editar Formulário com E-mail": "Editar formulario con correo electrónico",
  "Edite texto e estilo direto no painel, com preview em tempo real": "Edita el texto y el estilo en el panel con vista previa en tiempo real",
  "Editor da VSL Dinâmica (um store por editor)": "Editor de VSL dinámica (un almacén por editor)",
  "Editor de playlist": "Editor de listas de reproducción",
  "Editor unificado": "Editor unificado",
  "Editor unificado inline para todos os templates, eliminando navegação entre páginas. Configurações específicas aparecem inline por template.": "Editor unificado en línea para todas las plantillas, sin navegar entre páginas. La configuración específica aparece en línea en cada plantilla.",
  "Editor visual intuitivo, sem necessidade de código": "Editor visual intuitivo, sin necesidad de código",
  "Edição inline de texto e tempos diretamente no painel": "Edición de texto y tiempos directamente en el panel",
  "Efeito de foco ao passar o mouse: destaca a barra selecionada e suaviza as demais": "Efecto de enfoque al pasar el cursor: destaca la barra seleccionada y suaviza las demás",
  "Email já cadastrado, por favor insira um email diferente, ou recupere sua senha!": "Este correo electrónico ya está registrado. Introduce otro o recupera tu contraseña.",
  "Embed Code Modal — Premium": "Diálogo de código de inserción — Prémium",
  "Emojis personalizáveis para cada pasta": "Emojis personalizables para cada carpeta",
  "Endereço inválido: use uma URL http:// ou https://": "Dirección no válida: usa una URL http:// o https://",
  "Engajamento Médio (%)": "Interacción media (%)",
  "Entenda de onde vem sua audiência e como ela se comporta": "Comprende de dónde viene tu audiencia y cómo se comporta",
  "Entenda onde sua audiência cai e onde a conversão acontece.": "Comprende dónde abandona tu audiencia y dónde se produce la conversión.",
  "Entre com as credenciais do cliente e o código de acesso fornecido.": "Introduce las credenciales del cliente y el código de acceso proporcionado.",
  "Entrega de replay automática": "Entrega automática de la grabación",
  "Entregue a experiência ideal em qualquer tela.": "Ofrece la experiencia ideal en cualquier pantalla.",
  "Envie a lista de pitches.": "Envía la lista de ofertas.",
  "Envie os eventos das suas VSLs para o TikTok Ads e otimize as campanhas com base em quem assistiu de verdade.": "Envía los eventos de tus VSL a TikTok Ads y optimiza las campañas según quién ha visto realmente los videos.",
  "Envie os vídeos dentro do próprio fluxo e aguarde o processamento. Eles ficam na biblioteca desse fluxo, separados de Meus vídeos. Arraste um vídeo para o quadro ou use a opção Usar em nova etapa.": "Envía los videos dentro del propio flujo y espera a que se procesen. Permanecen en la biblioteca de ese flujo, separados de Mis videos. Arrastra un video al panel o usa la opción Usar en nueva etapa.",
  "Envio pausado": "Envío pausado",
  "Envio pelo servidor: visualização da página, play, retenção e tempo assistido": "Envío desde el servidor: visualización de página, reproducción, retención y tiempo visto",
  "Equilíbrio ideal": "Equilibrio ideal",
  "Erro ao adicionar domínio": "Error al añadir el dominio",
  "Erro ao atualizar domínio": "Error al actualizar el dominio",
  "Erro ao buscar assinaturas": "Error al buscar las suscripciones",
  "Erro ao buscar dados do usuário": "Error al buscar los datos del usuario",
  "Erro ao buscar informações": "Error al buscar la información",
  "Erro ao cancelar assinatura": "Error al cancelar la suscripción",
  "Erro ao carregar configuração": "Error al cargar la configuración",
  "Erro ao carregar respostas": "Error al cargar las respuestas",
  "Erro ao criar a chave": "Error al crear la clave",
  "Erro ao criar cartão": "Error al crear la tarjeta",
  "Erro ao criar fatura": "Error al crear la factura",
  "Erro ao criar token de suporte": "Error al crear el token de soporte",
  "Erro ao deletar cartão": "Error al eliminar la tarjeta",
  "Erro ao enviar e-mail de recuperação": "Error al enviar el correo de recuperación",
  "Erro ao excluir alguns trackings.": "Error al eliminar algunos seguimientos.",
  "Erro ao excluir tracking. Tente novamente.": "Error al eliminar el seguimiento. Inténtalo de nuevo.",
  "Erro ao fazer login": "Error al iniciar sesión",
  "Erro ao fazer logout": "Error al cerrar sesión",
  "Erro ao processar pagamento.": "Error al procesar el pago.",
  "Erro ao realizar cadastro": "Error al completar el registro",
  "Erro ao remover domínio": "Error al eliminar el dominio",
  "Erro ao renovar token": "Error al renovar el token",
  "Erro ao revogar a chave": "Error al revocar la clave",
  "Erro ao salvar tracking. Tente novamente.": "Error al guardar el seguimiento. Inténtalo de nuevo.",
  "Erro ao validar código": "Error al validar el código",
  "Escolha a VSL protegida e um vídeo alternativo para os acessos bloqueados": "Elige la VSL protegida y un video alternativo para los accesos bloqueados",
  "Escolha a etapa inicial do fluxo.": "Elige la etapa inicial del flujo.",
  "Escolha o canto do vídeo, o tamanho, as cores e o arredondamento, com som de caixa registradora opcional": "Elige la esquina del video, el tamaño, los colores y el redondeado, con sonido opcional de caja registradora",
  "Escolha o desfecho: redirecionar automaticamente para o seu link ou apenas exibir o aviso": "Elige el desenlace: redirigir automáticamente a tu enlace o mostrar solo el aviso",
  "Escolha os vídeos direto da sua biblioteca, sem precisar de um novo upload": "Elige los videos directamente de tu biblioteca sin volver a subirlos",
  "Escolha os vídeos que deseja comparar": "Elige los videos que quieras comparar",
  "Escolha quando o card aparece: no final do vídeo, ao pausar ou em um tempo personalizado": "Elige cuándo aparece la tarjeta: al final del video, al pausar o en un momento personalizado",
  "Escolha uma das opções abaixo": "Elige una de las opciones de abajo",
  "Escolha uma opção": "Elige una opción",
  "Escolha uma opção abaixo para continuar": "Elige una opción de abajo para continuar",
  "Escreva o texto com nome, cidade e produto — use a sugestão automática ou a sua própria lista": "Escribe el texto con nombre, ciudad y producto; usa la sugerencia automática o tu propia lista",
  "Espere! Oferta especial": "¡Espera! Oferta especial",
  "Espere! Temos uma condição especial para você": "¡Espera! Tenemos una oferta especial para ti",
  "Essa atualização deixa a Host VSL ainda mais alinhada com quem busca escala, performance e operação profissional.": "Esta actualización adapta aún más Host VSL a quienes buscan crecer, mejorar el rendimiento y trabajar de forma profesional.",
  "Essa condição está disponível somente nesta página": "Esta oferta está disponible solo en esta página",
  "Esse tempo passa da duração do vídeo.": "Este tiempo supera la duración del video.",
  "Esses locais serão bloqueados.": "Estas ubicaciones se bloquearán.",
  "Este e-mail já foi convidado": "Este correo electrónico ya ha sido invitado",
  "Este teste ainda não possui dados suficientes para análise. Os dados começam a ser gerados assim que os vídeos forem visualizados.": "Esta prueba todavía no tiene datos suficientes para el análisis. Los datos empiezan a generarse cuando se visualizan los videos.",
  "Estilo avançado autoplay": "Estilo avanzado de reproducción automática",
  "Event handlers inline não são permitidos.": "No se permiten controladores de eventos en línea.",
  "Excelente trabalho! Sua introdução está performando bem em todos os aspectos. A combinação de alta taxa de play e bom engajamento mostra que tanto seu thumbnail quanto seu conteúdo estão alinhados com as expectativas do público.": "¡Excelente trabajo! Tu introducción rinde bien en todos los aspectos. La combinación de una alta tasa de reproducción y buena interacción muestra que tu miniatura y tu contenido están alineados con las expectativas del público.",
  "Excelente! Esta introdução com storytelling está performance muito bem. O formato narrativo cria uma conexão emocional com o espectador e mantém o engajamento alto. Continue usando histórias relevantes que ressoam com seu público-alvo.": "¡Excelente! Esta introducción narrativa rinde muy bien. El formato de historia crea una conexión emocional con el espectador y mantiene una alta interacción. Sigue usando historias relevantes que conecten con tu público objetivo.",
  "Exiba um botão de ação durante o vídeo de entrada.": "Muestra un botón de acción durante el video de entrada.",
  "Exiba um botão de ação durante o vídeo de saída.": "Muestra un botón de acción durante el video de salida.",
  "Exibe a barra inferior com os controles do player. Quando desativada, os controles ficam ocultos mesmo com o tema personalizado.": "Muestra la barra inferior con los controles del reproductor. Al desactivarla, los controles quedan ocultos incluso con un tema personalizado.",
  "Exibe miniaturas do vídeo ao passar o mouse na barra de progresso. Requer controles do player ativos (não funciona com a barra fake). Disponível apenas em vídeos processados após esta atualização.": "Muestra miniaturas al pasar el cursor por la barra de progreso. Requiere los controles del reproductor activos (no funciona con la barra simulada). Disponible solo en videos procesados después de esta actualización.",
  "Exibe um botão para abrir o vídeo em uma janela flutuante (PiP), permitindo que o espectador continue assistindo enquanto navega em outras abas.": "Muestra un botón para abrir el video en una ventana flotante (PiP), de modo que el espectador pueda seguir viendo mientras navega por otras pestañas.",
  "Exibido antes do principal para preparar o espectador.": "Se muestra antes del principal para preparar al espectador.",
  "Experiência mais clara para reduzir erros e acelerar decisões": "Una experiencia más clara para reducir errores y agilizar decisiones",
  "Experiência mais fluida para a sua audiência": "Una experiencia más fluida para tu audiencia",
  "Exporte o histórico de eventos em CSV para seus relatórios": "Exporta el historial de eventos en CSV para tus informes",
  "Exporte os dados em CSV para usar em relatórios e rotinas de otimização": "Exporta los datos en CSV para tus informes y procesos de optimización",
  "Expressão regex inválida": "Expresión regular no válida",
  "Faixa de urgência": "Franja de urgencia",
  "Faixa de urgência e barra de progresso acima da oferta.": "Franja de urgencia y barra de progreso encima de la oferta.",
  "Faça o upgrade agora e continue usando a HostVSL com player premium, recursos de conversão e mais limite de plays.": "Mejora tu plan ahora y sigue usando HostVSL con reproductor prémium, funciones de conversión y más reproducciones.",
  "Faça seu site, gere textos persuasivos em segundos, potencialize o relacionamento com seu público por Whatsapp, Instagram, e-mail, SMS e converta mais com a leadlovers!": "Crea tu sitio, genera textos persuasivos en segundos, mejora la relación con tu público mediante WhatsApp, Instagram, correo electrónico y SMS, y convierte más con leadlovers.",
  "Fecha o vídeo com uma ação clara": "Termina el video con una acción clara",
  "Feed de vídeos": "Feed de videos",
  "Feed de vídeos com filtros inteligentes": "Feed de videos con filtros inteligentes",
  "Filtros avançados por nicho, formato e tempo no ar": "Filtros avanzados por nicho, formato y tiempo publicado",
  "Filtros por UTM (origem, campanha, conteúdo, etc.) para barrar tráfego de espionagem": "Filtros por UTM (origen, campaña, contenido, etc.) para bloquear tráfico de espionaje",
  "Finalizar agora?": "¿Finalizar ahora?",
  "Footer com navegação": "Pie de página con navegación",
  "Formato inválido. Use PNG, JPG ou GIF.": "Formato no válido. Usa PNG, JPG o GIF.",
  "Formato inválido. Use algo como seudominio.com.br.": "Formato no válido. Usa algo como tudominio.com.br.",
  "Funciona com AirPlay no Safari (iPhone, iPad, Mac)": "Funciona con AirPlay en Safari (iPhone, iPad, Mac)",
  "Funciona com Chromecast no Chrome/Edge (Windows, Mac, Android)": "Funciona con Chromecast en Chrome/Edge (Windows, Mac, Android)",
  "Funciona com a Page Visibility API para máxima compatibilidade": "Funciona con Page Visibility API para máxima compatibilidad",
  "Fundo de cards": "Fondo de las tarjetas",
  "Fundo de switch cards": "Fondo de las tarjetas con interruptor",
  "Fundo do overlay": "Fondo de la capa superpuesta",
  "Fundo principal": "Fondo principal",
  "Funil dinâmico": "Embudo dinámico",
  "Ganhe de forma recorrente indicando a plataforma nº1 de VSLs do Brasil": "Gana de forma recurrente recomendando la plataforma de VSL n.º 1 de Brasil",
  "Garanta essa condição especial agora": "Aprovecha esta oferta especial ahora",
  "Garanta que cada segundo do seu vídeo seja assistido.": "Haz que se vea cada segundo de tu video.",
  "Gere um link compartilhável para qualquer vídeo original do seu painel": "Genera un enlace para compartir cualquier video original de tu panel",
  "Gerencia tema light/dark/auto": "Gestiona el tema claro, oscuro y automático",
  "Gestão com pastas": "Gestión con carpetas",
  "Gestão de leads integrada ao funil": "Gestión de leads integrada en el embudo",
  "Google Ads": "Google Ads",
  "Gráfico de Momento de Conversão no Vídeo para identificar os pontos de maior interesse": "Gráfico del momento de conversión en el video para identificar los puntos de mayor interés",
  "Gráfico de retenção": "Gráfico de retención",
  "Gráfico de visualizações": "Gráfico de visualizaciones",
  "Guias de snap para alinhamento preciso (centro, bordas)": "Guías de alineación precisa (centro y bordes)",
  "HTML contains potentially dangerous content": "El HTML contiene contenido potencialmente peligroso",
  "HTML content too long (max 10,000 characters)": "Contenido HTML demasiado largo (máximo 10.000 caracteres)",
  "HTML input must be a non-empty string": "La entrada HTML debe ser una cadena de texto no vacía",
  "Heatmap de horários": "Mapa de calor de horarios",
  "Heatmap refinado com cores suavizadas, legenda de intensidade e tooltips premium com sombra unificada.": "Mapa de calor mejorado con colores suaves, leyenda de intensidad y tooltips prémium con sombra unificada.",
  "Hora do dia": "Hora del día",
  "Horário com maior volume de espectadores": "Horario con mayor número de espectadores",
  "Horário com mais espectadores": "Horario con más espectadores",
  "Horários alternativos recomendados": "Horarios alternativos recomendados",
  "Houve uma instabilidade ao processar arquivos.": "Se ha producido un problema al procesar los archivos.",
  "Há limite de indicações?": "¿Hay un límite de recomendaciones?",
  "Há parâmetros com o mesmo nome.": "Hay parámetros con el mismo nombre.",
  "Id repetido: {value0}": "ID repetido: {value0}",
  "Ideal para aulas e conteúdos rápidos.": "Ideal para lecciones y contenidos breves.",
  "Ideal para campanhas em escala": "Ideal para campañas a gran escala",
  "Ideal para tráfego quente e vídeos curtos": "Ideal para tráfico interesado y videos cortos",
  "Ideal para vídeos de vitrine, demonstrações e VSLs em loop.": "Ideal para videos de escaparate, demostraciones y VSL en bucle.",
  "Identifique horários de pico automaticamente": "Identifica automáticamente las horas punta",
  "Implementado drag-and-drop na distribuição de tráfego, badge de ordem (#1, #2, #3) nos cards de intros, e cards sortáveis com slider Radix idênticos ao Teste A/B.": "Se ha implementado arrastrar y soltar en la distribución del tráfico, insignias de orden (#1, #2, #3) en las tarjetas de introducciones y tarjetas ordenables con un control deslizante Radix igual al de la prueba A/B.",
  "Implementação de registry centralizado para documentação auto-atualizada. Rotas, stores, componentes e design tokens agora são documentados dinamicamente.": "Se ha implementado un registro centralizado para actualizar automáticamente la documentación. Las rutas, los almacenes, los componentes y los tokens de diseño se documentan ahora dinámicamente.",
  "Inclui 15 dias grátis": "Incluye 15 días gratis",
  "Inferior esquerdo": "Inferior izquierda",
  "Informe no formato mm:ss ou hh:mm:ss.": "Usa el formato mm:ss o hh:mm:ss.",
  "Informe o ID de conversão (AW-) e um rótulo para cada ação de conversão criada no Google Ads": "Indica el ID de conversión (AW-) y una etiqueta para cada acción de conversión creada en Google Ads",
  "Informe o ID do pixel e o token de acesso gerados no Events Manager do TikTok": "Indica el ID del píxel y el token de acceso generados en Events Manager de TikTok",
  "Informe um endereço http:// ou https:// válido.": "Introduce una dirección http:// o https:// válida.",
  "Inicie com a dor principal + superação antes do depoimento": "Empieza con el problema principal y su superación antes del testimonio",
  "Insira ganchos curtos ao longo do vídeo para aumentar retenção e reengajar o espectador.": "Añade ganchos breves a lo largo del video para aumentar la retención y recuperar la atención del espectador.",
  "Inspiração direta para suas próximas VSLs e campanhas": "Inspiración directa para tus próximas VSL y campañas",
  "Integração nativa com VSLs e funis da Host VSL": "Integración nativa con VSL y embudos de Host VSL",
  "Introduções": "Introducciones",
  "Invalid URL format": "Formato de URL no válido",
  "Invalid URL protocol": "Protocolo de URL no válido",
  "Isso encerra o teste antes do término agendado e o tráfego volta para a VSL Principal. Esta ação não pode ser desfeita.": "Esto finaliza la prueba antes de la fecha prevista y devuelve el tráfico a la VSL principal. Esta acción no se puede deshacer.",
  "Janelas Campeãs de Receita": "Franjas con mejores ingresos",
  "Já disponível na personalização dos seus vídeos.": "Ya disponible en la personalización de tus videos.",
  "Já disponível no menu Cloaker do seu painel.": "Ya disponible en el menú Cloaker de tu panel.",
  "Já disponível no menu Pixel do seu painel.": "Ya disponible en el menú Píxel de tu panel.",
  "Já está disponível na personalização dos seus novos vídeos.": "Ya disponible en la personalización de tus nuevos videos.",
  "Já está disponível no menu Análises do seu painel.": "Ya disponible en el menú Análisis de tu panel.",
  "Labels simplificados: \"Controle de Volume\" → \"Volume\", \"Controle de Velocidade\" → \"Velocidade\", \"Esconder no Início\" → \"Esconder Início\".": "Etiquetas simplificadas: \"Control de volumen\" → \"Volumen\", \"Control de velocidad\" → \"Velocidad\", \"Ocultar al inicio\" → \"Ocultar inicio\".",
  "Layout otimizado para mobile, tablet e desktop": "Diseño optimizado para móvil, tableta y escritorio",
  "Layout principal": "Diseño principal",
  "Layout responsivo de cápsula central com largura adaptativa por dispositivo": "Diseño adaptable de cápsula central con ancho ajustado por dispositivo",
  "Li e aceito os": "He leído y acepto los",
  "Ligue o campo de comentário e peça nome, e-mail e WhatsApp junto com a nota": "Activa el campo de comentario y solicita nombre, correo electrónico y WhatsApp junto con la puntuación",
  "Lisboa (GMT+0)": "Lisboa (GMT+0)",
  "Lista de Testes A/B": "Lista de pruebas A/B",
  "Lista de Testes de Hook": "Lista de pruebas de ganchos",
  "Lista de playlists": "Lista de listas de reproducción",
  "Login Falhou": "Error al iniciar sesión",
  "Londres (GMT+0)": "Londres (GMT+0)",
  "Loop contínuo quando combinado com Autoplay ativo": "Bucle continuo al combinarlo con la reproducción automática activada",
  "Los Angeles (GMT-8)": "Los Ángeles (GMT-8)",
  "Lógica condicional para personalizar a jornada de cada lead": "Lógica condicional para personalizar el recorrido de cada lead",
  "Mais ativa": "Más activa",
  "Mais natural e estável": "Más natural y estable",
  "Mande vídeos direto da sua conta do Google Drive pra HostVSL, sem precisar baixar antes.": "Envía videos directamente de tu cuenta de Google Drive a HostVSL, sin descargarlos primero.",
  "Mantenha o gancho inicial que está funcionando bem": "Mantén el gancho inicial que funciona bien",
  "Mantenha o público colado do início ao fim.": "Mantén al público atento de principio a fin.",
  "Mapa ao vivo com os espectadores que estão assistindo agora, por cidade e país": "Mapa en directo de quienes están viendo ahora, por ciudad y país",
  "Mapa de calor semanal com plays e visualizações": "Mapa de calor semanal con reproducciones y visualizaciones",
  "Meio direito": "Centro derecha",
  "Meio esquerdo": "Centro izquierda",
  "Melhor escolha para campanhas ativas": "La mejor opción para campañas activas",
  "Melhor momento": "Mejor momento",
  "Melhor período de performance": "Mejor período de rendimiento",
  "Melhoria de performance completa na abertura dos vídeos — carregamento mais rápido e menos travamentos.": "Mejora completa del rendimiento al abrir los videos: cargas más rápidas y menos bloqueos.",
  "Membro Atualizado": "Miembro actualizado",
  "Membro Criado": "Miembro creado",
  "Membro Removido": "Miembro eliminado",
  "Menos achismo, mais performance.": "Menos suposiciones, más rendimiento.",
  "Menos travamentos durante a reprodução": "Menos bloqueos durante la reproducción",
  "Mensagem de bloqueio deve ter no máximo 140 caracteres": "El mensaje de bloqueo debe tener como máximo 140 caracteres",
  "Mensagem de bloqueio é obrigatória": "El mensaje de bloqueo es obligatorio",
  "Mensagem obrigatória": "El mensaje es obligatorio",
  "Menu drawer mobile": "Menú desplegable móvil",
  "Menu mobile": "Menú móvil",
  "Menu mobile com overlay click blocking, animações sincronizadas, plan card com progress bar animado, navegação reorganizada.": "Menú móvil con bloqueo de clics bajo la capa, animaciones sincronizadas, tarjeta de plan con barra de progreso animada y navegación reorganizada.",
  "Meta Pixel": "Meta Pixel",
  "Meus clientes têm desconto?": "¿Mis clientes tienen descuento?",
  "Meça a percepção real do conteúdo": "Mide la percepción real del contenido",
  "Mini-preview do frame ao passar o mouse na barra de progresso": "Vista previa del fotograma al pasar el cursor por la barra de progreso",
  "Mobile Menu — Layout Final": "Menú móvil — Diseño final",
  "Modal de código embed com tabs JavaScript/iFrame, cards de código com 160px altura fixa, botões de cópia integrados.": "Diálogo de código de inserción con pestañas JavaScript/iFrame, tarjetas de código de 160 px de altura fija y botones de copia integrados.",
  "Modo de teste para demonstrações": "Modo de prueba para demostraciones",
  "Monitore ofertas validadas que estão rodando na Meta agora": "Sigue ofertas validadas que se anuncian ahora en Meta",
  "Mostra o preço em destaque com a condição de pagamento.": "Muestra el precio destacado con las condiciones de pago.",
  "Mostra um botão para iniciar o vídeo principal manualmente.": "Muestra un botón para iniciar manualmente el video principal.",
  "Mostre a plataforma de venda ao lado do aviso ou envie a sua própria logo": "Muestra la plataforma de ventas junto al aviso o sube tu propio logotipo",
  "Mostre avisos de compra por cima da sua VSL e crie prova social enquanto o vídeo roda.": "Muestra avisos de compra sobre tu VSL y genera prueba social mientras se reproduce el video.",
  "Muito ruim": "Muy malo",
  "Multiplique as suas vendas de forma automática com o chatbot que vende 24h por dia.": "Multiplica tus ventas automáticamente con el chatbot que vende las 24 horas.",
  "Máximo 140 caracteres": "Máximo 140 caracteres",
  "Média de quanto do vídeo foi assistido. Valores acima de 60% são considerados bons. Indica que o conteúdo manteve interesse contínuo.": "Media del porcentaje de video visto. Los valores superiores al 60 % se consideran buenos e indican que el contenido mantuvo un interés continuo.",
  "Média geral": "Media general",
  "Métricas detalhadas": "Métricas detalladas",
  "Métricas por etapa: exibições, conclusão, quem pulou, quem chegou ao principal e cliques no CTA": "Métricas por etapa: visualizaciones, finalización, omisiones, llegadas al principal y clics en el CTA",
  "Métricas — Padrão Visual Definitivo": "Métricas — Estándar visual definitivo",
  "Mês inválido": "Mes no válido",
  "Na aba Métricas: nota média, total de respostas, distribuição, evolução e os comentários mais recentes": "En la pestaña Métricas: puntuación media, total de respuestas, distribución, evolución y comentarios más recientes",
  "Na aba Tema, ajuste o visual do player. Escolha o formato, as cores da pergunta e dos botões, a posição das opções, o escurecimento do fundo, a borda, o progresso e os controles. Você pode começar com uma prévia sem som ou com um clique para iniciar.": "En la pestaña Tema, ajusta el aspecto del reproductor. Elige el formato, los colores de la pregunta y los botones, la posición de las opciones, el oscurecimiento del fondo, el borde, el progreso y los controles. Puedes empezar con una vista previa sin sonido o con un clic para iniciar.",
  "Na etapa {value0}, a opção \"{value1}\" aponta para uma saída que não existe.": "En la etapa {value0}, la opción \"{value1}\" apunta a una salida que no existe.",
  "Na etapa {value0}, a opção \"{value1}\" não leva a lugar nenhum.": "En la etapa {value0}, la opción \"{value1}\" no lleva a ningún destino.",
  "Na etapa {value0}, duas opções têm o texto \"{value1}\".": "En la etapa {value0}, dos opciones tienen el texto \"{value1}\".",
  "Na etapa {value0}, uma opção está sem texto.": "En la etapa {value0}, una opción no tiene texto.",
  "Navegação lateral": "Navegación lateral",
  "Navegação mais rápida e responsiva em qualquer tela": "Navegación más rápida y adaptable en cualquier pantalla",
  "Navegação rápida com breadcrumbs": "Navegación rápida con rutas de navegación",
  "Nenhum código extra na sua página: o token de acesso fica guardado só no servidor": "Sin código adicional en tu página: el token de acceso se guarda solo en el servidor",
  "Nenhum envio ativo": "Ningún envío activo",
  "Nenhuma saída está marcada como checkout; a conversão não será medida.": "Ninguna salida está marcada como página de pago; no se medirá la conversión.",
  "No menu VSL Dinâmica, crie um fluxo e dê um nome para identificar seu funil. Esse nome é para sua organização no painel.": "En el menú VSL dinámica, crea un flujo y dale un nombre para identificar tu embudo. Este nombre sirve para organizarte en el panel.",
  "No modal de upload, escolha entre \"Upload do computador\" ou \"Google Drive\"": "En el diálogo de subida, elige entre \"Subir desde el ordenador\" o \"Google Drive\"",
  "No máximo {value0} parâmetros fixos": "Máximo de {value0} parámetros fijos",
  "No tema, defina o formato do vídeo, as cores, o estilo das opções, a barra de progresso e como o vídeo começa (prévia sem som ou clicar para iniciar).": "En el tema, define el formato del video, los colores, el estilo de las opciones, la barra de progreso y cómo empieza el video (vista previa sin sonido o clic para iniciar).",
  "Nome do Teste A/B": "Nombre de la prueba A/B",
  "Nome é obrigatório": "El nombre es obligatorio",
  "Nova York (GMT-5)": "Nueva York (GMT-5)",
  "Nova venda!": "¡Nueva venta!",
  "Novo template Prime Video Dark com hero banner, grid de aulas com paginação, modal de reprodução com navegação entre episódios.": "Nueva plantilla Prime Video Dark con banner principal, cuadrícula de lecciones con paginación y diálogo de reproducción con navegación entre episodios.",
  "Novo template de área de membros com hero banner 1920×700, módulos/bônus em grid, progress tracking persistente, CTAs por vídeo.": "Nueva plantilla de área de miembros con banner principal de 1920×700, cuadrícula de módulos y bonificaciones, seguimiento persistente del progreso y CTA por video.",
  "NÃO, OBRIGADO": "NO, GRACIAS",
  "Não foi possível concluir. Tente novamente.": "No se pudo completar. Inténtalo de nuevo.",
  "Não foi possível salvar o pitch. Tente novamente.": "No se pudo guardar la oferta. Inténtalo de nuevo.",
  "Não! A participação no programa é 100% gratuita. Você só precisa se cadastrar e começar a indicar.": "¡No! Participar en el programa es 100 % gratis. Solo tienes que registrarte y empezar a recomendar.",
  "Não! Você pode fazer quantas indicações quiser. Quanto mais clientes ativos você tiver, maior será sua comissão recorrente mensal.": "¡No! Puedes hacer tantas recomendaciones como quieras. Cuantos más clientes activos tengas, mayor será tu comisión mensual recurrente.",
  "Não, obrigado. Quero continuar": "No, gracias. Quiero continuar",
  "Não, obrigado. Quero continuar sem essa oferta": "No, gracias. Quiero continuar sin esta oferta",
  "Número do cartão inválido": "Número de tarjeta no válido",
  "Números principais em métricas": "Cifras principales de las métricas",
  "Números principais em toda área de Métricas ajustados para font-weight 500, criando hierarquia visual mais clara e premium.": "Se han ajustado las cifras principales de toda el área de Métricas a un peso de fuente de 500 para crear una jerarquía visual más clara y prémium.",
  "O Meta Pixel é uma ferramenta de automação de marketing que ajuda a aumentar a conversão de vendas e a retenção de clientes.": "Meta Pixel es una herramienta de automatización de marketing que ayuda a aumentar la conversión de ventas y la retención de clientes.",
  "O botão só aparece pra quem tem um dispositivo compatível na rede — sem poluir o player de quem não usa": "El botón solo aparece si hay un dispositivo compatible en la red, sin recargar el reproductor de quienes no lo usan",
  "O cupom aplicado na sua assinatura é mantido na ativação.": "El cupón aplicado a tu suscripción se mantiene al activarla.",
  "O código de segurança está incorreto.": "El código de seguridad es incorrecto.",
  "O engajamento está baixo. Isso significa que as pessoas estão desistindo cedo do vídeo. Considere revisar os primeiros 15 segundos - eles são críticos! Adicione um 'gancho' atrativo no início e evite introduções longas.": "La interacción es baja. Esto significa que las personas abandonan pronto el video. Revisa los primeros 15 segundos: son cruciales. Añade un gancho atractivo al inicio y evita las introducciones largas.",
  "O fim deve ser 0 ou maior/igual ao início.": "El final debe ser 0 o mayor o igual que el inicio.",
  "O início deve ser maior ou igual a zero.": "El inicio debe ser mayor o igual que cero.",
  "O nome da playlist precisa ter pelo menos 3 caracteres": "El nombre de la lista de reproducción debe tener al menos 3 caracteres",
  "O nome do teste precisa ter pelo menos 3 caracteres": "El nombre de la prueba debe tener al menos 3 caracteres",
  "O principal começa logo após o vídeo de entrada.": "El principal empieza justo después del video de entrada.",
  "O que acontece ao terminar ou pular.": "Qué ocurre al terminar u omitir.",
  "O que é o Programa de Parcerias Host VSL?": "¿Qué es el programa de socios de Host VSL?",
  "O rascunho é salvo sozinho e não muda o que está no ar. Pré-visualize, publique e cole o código na sua página. O código é sempre o mesmo: publicar de novo atualiza o vídeo no site.": "El borrador se guarda automáticamente y no modifica lo que está publicado. Revisa la vista previa, publica y pega el código en tu página. El código siempre es el mismo: al volver a publicar, se actualiza el video del sitio.",
  "O tempo informado é maior que a duração do vídeo.": "El tiempo indicado supera la duración del video.",
  "O vídeo da etapa {value0} ainda está processando.": "El video de la etapa {value0} todavía se está procesando.",
  "O vídeo da etapa {value0} não existe mais neste fluxo.": "El video de la etapa {value0} ya no existe en este flujo.",
  "OFERTA ESPECIAL PARA VOCÊ": "OFERTA ESPECIAL PARA TI",
  "OFERTA ÚNICA!": "¡OFERTA ÚNICA!",
  "Oferta Especial": "Oferta especial",
  "Oferta com Preço": "Oferta con precio",
  "Oferta com Progresso": "Oferta con progreso",
  "Oferta com Riscado": "Oferta con precio tachado",
  "Oferta disponível somente nesta página": "Oferta disponible solo en esta página",
  "Operador obrigatório": "El operador es obligatorio",
  "Operador é obrigatório": "El operador es obligatorio",
  "Opção de recusa": "Opción para rechazar",
  "Origem (Source)": "Origen (Source)",
  "Os vídeos são enviados dentro do fluxo e ficam só nele: não aparecem em \"Meus vídeos\". Assim que terminam de processar, já podem ser usados nas etapas.": "Los videos se envían dentro del flujo y permanecen solo en él: no aparecen en \"Mis videos\". Cuando termina el procesamiento, se pueden usar en las etapas.",
  "Otimize a experiência mobile sem comprometer o desktop": "Optimiza la experiencia móvil sin perjudicar la de escritorio",
  "Overlay drag visual": "Capa visual arrastrable",
  "Pagamento Atualizado": "Pago actualizado",
  "Pagamento Criado": "Pago creado",
  "Pagamento Falhou": "Error en el pago",
  "Para alto volume de tráfego": "Para un gran volumen de tráfico",
  "Para começar com mais limite": "Para empezar con más capacidad",
  "Para operações com alto volume": "Para operaciones de gran volumen",
  "Para pausar o vídeo, a etapa precisa de pelo menos uma opção.": "Para pausar el video, la etapa debe tener al menos una opción.",
  "Para pausar o vídeo, defina quando as opções aparecem.": "Para pausar el video, define cuándo aparecen las opciones.",
  "Parceiros oficiais": "Socios oficiales",
  "Parceiros — Página Premium 10/10": "Socios — Página prémium 10/10",
  "Paris (GMT+1)": "París (GMT+1)",
  "Parâmetro UTM é obrigatório": "El parámetro UTM es obligatorio",
  "Parâmetro obrigatório": "El parámetro es obligatorio",
  "Pastas Hierárq.": "Carpetas jerárquicas",
  "Pausa automática ao detectar que o espectador saiu da aba": "Pausa automática al detectar que el espectador sale de la pestaña",
  "Pausa o vídeo ao sair da aba e retoma ao voltar automaticamente.": "Pausa el video al salir de la pestaña y lo reanuda automáticamente al volver.",
  "País e região obrigatórios": "País y región obligatorios",
  "País e região são obrigatórios": "El país y la región son obligatorios",
  "País obrigatório": "El país es obligatorio",
  "País é obrigatório": "El país es obligatorio",
  "Percentual de visitantes que clicaram play no vídeo. Valores acima de 70% são considerados bons. Impactada principalmente pelo thumbnail e título.": "Porcentaje de visitantes que hicieron clic para reproducir el video. Los valores superiores al 70 % se consideran buenos. Depende principalmente de la miniatura y el título.",
  "Percentual médio assistido dos vídeos": "Porcentaje medio visto de los videos",
  "Perfil do usuário": "Perfil del usuario",
  "Pergunte a quem assistiu o que achou da sua VSL e receba a nota dentro do próprio player.": "Pregunta a quienes vieron tu VSL qué les pareció y recibe la puntuación en el propio reproductor.",
  "Permissão Alterada": "Permiso cambiado",
  "Permissão é obrigatória": "El permiso es obligatorio",
  "Permissões agrupadas por área: Vídeos, Conversão, Análises, Otimização, Proteção e Conta": "Permisos agrupados por área: Videos, Conversión, Análisis, Optimización, Protección y Cuenta",
  "Permite pular o vídeo de entrada.": "Permite omitir el video de entrada.",
  "Permite que o vídeo reinicie automaticamente quando terminar": "Permite que el video se reinicie automáticamente al terminar",
  "Permite reiniciar automaticamente o vídeo assim que ele terminar.": "Permite reiniciar el video automáticamente en cuanto termine.",
  "Personalize formato, cores, botões, borda, barra de progresso e a forma de iniciar o player, com opções adaptadas ao mobile.": "Personaliza el formato, los colores, los botones, el borde, la barra de progreso y el inicio del reproductor con opciones adaptadas al móvil.",
  "Personalize o player de forma independente para cada tipo de dispositivo": "Personaliza el reproductor de forma independiente para cada tipo de dispositivo",
  "Período não definido": "Período sin definir",
  "Pico no horário de maior audiência": "Pico en el horario de mayor audiencia",
  "Play extra por R$ 0,02": "Reproducción extra por R$ 0,02",
  "Player premium desbloqueado": "Reproductor prémium desbloqueado",
  "Playlists — Sistema Unificado de Edição": "Listas de reproducción — Sistema de edición unificado",
  "Plays divididos pelas visualizações únicas do dia": "Reproducciones divididas por las visualizaciones únicas del día",
  "Plays ÷ visualizações": "Reproducciones ÷ visualizaciones",
  "Plays únicos por dia e horário": "Reproducciones únicas por día y hora",
  "Pode editar e adicionar vídeos, mas não gerenciar usuários": "Puede editar y añadir videos, pero no gestionar usuarios",
  "Posso ser parceiro como pessoa física?": "¿Puedo ser socio como persona física?",
  "Pra ativar: copie novamente o código do seu vídeo e cole no lugar do antigo, lá onde ele está hospedado": "Para activarlo: vuelve a copiar el código de tu video y sustituye el antiguo donde esté insertado",
  "Pra liberar o recurso em um vídeo antigo, basta refazer o upload: o processamento gera o storyboard automaticamente": "Para habilitar la función en un video antiguo, vuelve a subirlo: el procesamiento genera automáticamente el storyboard",
  "Preciso pagar para participar?": "¿Tengo que pagar para participar?",
  "Preferências UI": "Preferencias de interfaz",
  "Preview de template": "Vista previa de plantilla",
  "Preço antigo riscado e o novo em destaque — ancoragem de valor.": "Precio anterior tachado y nuevo precio destacado: anclaje de valor.",
  "Preço em destaque": "Precio destacado",
  "Preço principal": "Precio principal",
  "Preço riscado": "Precio tachado",
  "Prime Video Dark — Template Substituindo Netflix": "Prime Video Dark — Plantilla que sustituye a Netflix",
  "Primeiro Nome": "Nombre",
  "Primeiro nome": "Nombre",
  "Primitives": "Primitivas",
  "Principal gatilho de conversão": "Principal impulsor de conversión",
  "Prioridade deve ser entre 1 e 10": "La prioridad debe estar entre 1 y 10",
  "ProgressBarConfig - Remoção Borda Extra": "ProgressBarConfig - Eliminación del borde extra",
  "Progresso salvo por aula e por módulo, com indicadores visuais": "Progreso guardado por lección y módulo, con indicadores visuales",
  "Pronto! Agora é só colar 🎉": "¡Listo! Ahora solo tienes que pegarlo 🎉",
  "Pronto! Depois disso, sua audiência já passa a aproveitar todas as melhorias": "¡Listo! A partir de entonces, tu audiencia disfrutará de todas las mejoras",
  "Prova social no momento da oferta": "Prueba social en el momento de la oferta",
  "Próximo: Ordem": "Siguiente: orden",
  "Próximo: Tráfego": "Siguiente: tráfico",
  "Publicação rápida com domínio próprio ou subdomínio": "Publicación rápida con dominio propio o subdominio",
  "Publique o fluxo, copie o Código do fluxo e cole na página onde o player deve aparecer. O rascunho é salvo automaticamente, mas só entra no ar quando você publica. Nas próximas alterações, publique novamente: o código de incorporação continua o mesmo.": "Publica el flujo, copia el código del flujo y pégalo en la página donde deba aparecer el reproductor. El borrador se guarda automáticamente, pero solo se publica cuando tú lo decides. Para futuros cambios, vuelve a publicar: el código de inserción sigue siendo el mismo.",
  "Páginas ultra rápidas em HTML": "Páginas HTML ultrarrápidas",
  "QUERO APROVEITAR A OFERTA": "QUIERO APROVECHAR LA OFERTA",
  "QUERO CONTINUAR": "QUIERO CONTINUAR",
  "Qual o valor das comissões?": "¿Cuál es el importe de las comisiones?",
  "Qual opção combina mais com você?": "¿Qué opción encaja mejor contigo?",
  "Qualquer dúvida no caminho, é só chamar. Estamos aqui pra ajudar.": "Si tienes alguna duda, contacta con nosotros. Estamos aquí para ayudarte.",
  "Quando ativo, o espectador não consegue pausar o vídeo (clique, botão de pause). Funciona com ou sem controles e com autoplay.": "Al activarlo, el espectador no puede pausar el video mediante clic o botón de pausa. Funciona con o sin controles y con reproducción automática.",
  "Quando o vídeo termina, um card com contagem regressiva conduz o espectador direto pra sua oferta.": "Cuando termina el video, una tarjeta con cuenta atrás lleva al espectador directamente a tu oferta.",
  "Quantidade de cliques nos botões de chamada para ação. Métrica final de conversão do vídeo.": "Número de clics en los botones de llamada a la acción. Métrica final de conversión del video.",
  "Quantidade de vezes que o play foi clicado. A relação Plays/Visualizações gera a Taxa de Reprodução.": "Número de veces que se ha pulsado reproducir. La relación reproducciones/visualizaciones genera la tasa de reproducción.",
  "Quantidade de vezes que o vídeo foi carregado na página.": "Número de veces que se ha cargado el video en la página.",
  "Quarta 18-20h caiu 15% vs semana passada": "El miércoles de 18:00 a 20:00 bajó un 15 % frente a la semana pasada",
  "Quatro animações disponíveis: Nenhuma, Fade, Pop e Palavra por palavra": "Cuatro animaciones disponibles: ninguna, fundido, aparición y palabra por palabra",
  "Quem assiste te diz o que mudar na próxima versão.": "Quienes lo ven te dicen qué cambiar en la próxima versión.",
  "Rankings ao vivo: top vídeos, top lugares (com alternância país/estado) e top fontes de tráfego": "Clasificaciones en directo: mejores videos, ubicaciones (alternando país y estado) y fuentes de tráfico",
  "Receba um insight automático com leitura rápida do comportamento": "Recibe un análisis automático para comprender rápidamente el comportamiento",
  "Receba um insight automático com leitura rápida do comportamento do público": "Recibe un análisis automático para comprender rápidamente el comportamiento del público",
  "Receita das compras aprovadas": "Ingresos de las compras aprobadas",
  "Recurso Horários — Premium 10/10": "Función de horarios — Prémium 10/10",
  "Recursos do player": "Funciones del reproductor",
  "Redesign completo da página Parceiros seguindo PRD premium. Cards com altura fixa 212px, hover scale + blur, skeleton loading, fade-in animation, ícone chevron animado, acessibilidade completa.": "Rediseño completo de la página Socios siguiendo el PRD prémium. Tarjetas de 212 px de altura fija, escala y desenfoque al pasar el cursor, esqueletos de carga, animación de aparición, icono de flecha animado y accesibilidad completa.",
  "Redimensione e reposicione a caixa de autoplay diretamente no player com arraste visual.": "Cambia el tamaño y la posición del cuadro de reproducción automática directamente en el reproductor arrastrándolo.",
  "Redimensione usando os handles nos cantos e laterais": "Cambia el tamaño con los tiradores de las esquinas y los laterales",
  "Reduza o tempo até o CTA principal": "Reduce el tiempo hasta el CTA principal",
  "Reforce provas sociais antes da oferta": "Refuerza la prueba social antes de la oferta",
  "Refresh Token": "Token de renovación",
  "Regex inválido": "Expresión regular no válida",
  "Regras de cloaking": "Reglas de cloaking",
  "Regras por país e região: libere só onde você vende ou bloqueie onde não quer aparecer": "Reglas por país y región: permite solo donde vendes o bloquea donde no quieres aparecer",
  "Removido SectionCard wrapper do preview da barra de progresso para visual mais limpo.": "Se ha eliminado el contenedor SectionCard de la vista previa de la barra de progreso para un diseño más limpio.",
  "Removido chip X vídeos selecionados do título na etapa de seleção de vídeos. Layout mais limpo e minimalista.": "Se ha eliminado del título el indicador de videos seleccionados en la etapa de selección. Diseño más limpio y minimalista.",
  "Reordenação por drag-and-drop dos blocos de legenda": "Reordena los bloques de subtítulos arrastrando y soltando",
  "Repaginamos a Proteção Anti-Plágio de VSL: ficou mais simples de configurar e de esconder sua oferta de concorrentes e espiões.": "Hemos renovado la protección antiplagio de VSL: ahora es más sencillo configurarla y ocultar tu oferta a competidores y espías.",
  "Repete o trecho automaticamente": "Repite el fragmento automáticamente",
  "Replique o padrão de benefício + detalhe do VSL principal": "Repite el patrón de beneficio y detalle de la VSL principal",
  "Requer que os controles do player estejam habilitados": "Requiere que los controles del reproductor estén habilitados",
  "Respeita pausas manuais: só retoma se foi pausado pela função": "Respeta las pausas manuales: solo reanuda si la función causó la pausa",
  "Resultados segmentados que aumentam a conversão final": "Resultados segmentados que aumentan la conversión final",
  "Retomada instantânea ao voltar, sem precisar clicar em nada": "Reanudación instantánea al volver, sin hacer clic",
  "Retorno automático ao segundo 0:00 ao término do vídeo": "Vuelve automáticamente a 0:00 al terminar el video",
  "Retém usuários que saíram do vídeo": "Retiene a los usuarios que salieron del video",
  "Routing": "Enrutamiento",
  "SIM, ADICIONAR AO MEU PEDIDO": "SÍ, AÑADIR A MI PEDIDO",
  "SIM, EU QUERO": "SÍ, LO QUIERO",
  "SIM, QUERO ADICIONAR": "SÍ, QUIERO AÑADIRLO",
  "SIM, QUERO APROVEITAR": "SÍ, QUIERO APROVECHARLO",
  "Salvar e copiar código": "Guardar y copiar código",
  "Salvar nome": "Guardar nombre",
  "Salve suas alterações e depois copie o código para colar na sua página de vendas.": "Guarda los cambios y después copia el código para pegarlo en tu página de ventas.",
  "Scripts não são permitidos por segurança.": "No se permiten scripts por seguridad.",
  "Segunda opção": "Segunda opción",
  "Segundo melhor momento": "Segundo mejor momento",
  "Selecionar período": "Seleccionar período",
  "Selecione a plataforma e informe o token, ou desative o rastreamento": "Selecciona la plataforma e indica el token, o desactiva el seguimiento",
  "Selecione o comportamento": "Selecciona el comportamiento",
  "Selecione os Vídeos": "Selecciona los videos",
  "Selecione pelo menos um vídeo": "Selecciona al menos un video",
  "Selecione pelo menos uma intro para continuar": "Selecciona al menos una introducción para continuar",
  "Selecione pelo menos uma playlist": "Selecciona al menos una lista de reproducción",
  "Selecione um vídeo alternativo ou URL": "Selecciona un video alternativo o una URL",
  "Selecione um vídeo base para continuar": "Selecciona un video base para continuar",
  "Selecione uma avaliação": "Selecciona una valoración",
  "Seletor de período": "Selector de período",
  "Seletor de templates": "Selector de plantillas",
  "Seletor de vídeo premium": "Selector de video prémium",
  "Seleção de vídeos com badge ordem": "Selección de videos con insignia de orden",
  "Seleção intros com badge ordem": "Selección de introducciones con insignia de orden",
  "Sem Eventos": "Sin eventos",
  "Sem conexão com o servidor.": "Sin conexión con el servidor.",
  "Sem plugins complexos": "Sin complementos complejos",
  "Sem replay automático se o Autoplay estiver desativado": "Sin repetición automática si la reproducción automática está desactivada",
  "Senha Alterada": "Contraseña cambiada",
  "Sessões com saída de checkout": "Sesiones con salida a la página de pago",
  "Seu cartão está vencido.": "Tu tarjeta está caducada.",
  "Seu cartão foi recusado, tente novamente.": "Tu tarjeta ha sido rechazada. Inténtalo de nuevo.",
  "Seu cartão não possui saldo suficiente.": "Tu tarjeta no tiene saldo suficiente.",
  "Seu conteúdo está performando razoavelmente bem, mas há espaço para melhorias. Um bom equilíbrio entre taxa de reprodução e engajamento é essencial - lembre-se que não adianta ter muitos cliques se as pessoas não assistem o vídeo até o final.": "Tu contenido rinde razonablemente bien, pero puede mejorar. Un buen equilibrio entre la tasa de reproducción y la interacción es esencial: de poco sirven muchos clics si las personas no ven el video hasta el final.",
  "Seu preço hoje: R$ 99": "Tu precio de hoy: R$ 99",
  "Seu time trabalhando junto, cada um no seu lugar.": "Tu equipo trabajando junto, cada persona en su lugar.",
  "Sexta 14-16h subiu 22% vs semana passada": "El viernes de 14:00 a 16:00 subió un 22 % frente a la semana pasada",
  "Seção de Picos de Horários integrada": "Sección de horas punta integrada",
  "Sidebar desktop com position fixed para estabilidade, main content com margin-left compensatório. Layout Apple-like.": "Barra lateral de escritorio con posición fija para mayor estabilidad y contenido principal con margen izquierdo compensatorio. Diseño inspirado en Apple.",
  "Sidebar — Nova Aba Parceiros": "Barra lateral — Nueva pestaña Socios",
  "Sidebar — Posicionamento Fixo": "Barra lateral — Posición fija",
  "Sim ou Não": "Sí o no",
  "Sim! Como parceiro, você pode oferecer vantagens exclusivas aos seus indicados, como bônus especiais e materiais complementares.": "¡Sí! Como socio, puedes ofrecer ventajas exclusivas a tus referidos, como bonificaciones especiales y materiales complementarios.",
  "Sim! O programa aceita tanto pessoas físicas quanto jurídicas. Basta ter uma conta bancária ou chave PIX para receber os pagamentos.": "¡Sí! El programa acepta tanto a personas físicas como jurídicas. Solo necesitas una cuenta bancaria o una clave PIX para recibir los pagos.",
  "Sistema de Documentação Dinâmica": "Sistema de documentación dinámica",
  "Sistema de webinars": "Sistema de seminarios web",
  "Skeleton loading de parceiro": "Esqueleto de carga de socio",
  "Sobrenome Completo": "Apellidos completos",
  "Sombra de dropdowns": "Sombra de los desplegables",
  "Sombra de tooltips": "Sombra de los tooltips",
  "Sombra durante drag": "Sombra al arrastrar",
  "Sombra padrão de cards": "Sombra predeterminada de las tarjetas",
  "State Management": "Gestión del estado",
  "Stepper visual etapas": "Indicador visual de etapas",
  "Styling": "Estilos",
  "Sua VSL agora pode seguir o caminho de quem está assistindo. Com a VSL Dinâmica 2.0, você monta um funil visual de vídeos, perguntas e opções: o visitante escolhe uma resposta dentro do player e continua no vídeo que faz sentido para ele. Em vez de mostrar a mesma sequência para todo mundo, você pode apresentar argumentos diferentes para cada necessidade e conduzir a pessoa até o checkout, o WhatsApp ou outra página. Tudo é configurado no construtor, com pré-visualização e métricas para acompanhar cada caminho.": "Tu VSL puede seguir ahora el camino de quien la ve. Con VSL dinámica 2.0, creas un embudo visual de videos, preguntas y opciones: el visitante elige una respuesta dentro del reproductor y continúa con el video que le corresponde. Puedes presentar argumentos distintos según sus necesidades y dirigirlo a la página de pago, WhatsApp u otra página. Todo se configura en el constructor, con vista previa y métricas para seguir cada camino.",
  "Sua audiência passa o mouse na timeline e já vê uma miniatura do frame daquele momento.": "Tu audiencia pasa el cursor por la línea de tiempo y ve una miniatura del fotograma de ese momento.",
  "Sua audiência pode transmitir o vídeo pra Chromecast ou AirPlay com um clique direto do player.": "Tu audiencia puede transmitir el video a Chromecast o AirPlay con un clic desde el reproductor.",
  "Sua taxa de reprodução está abaixo da média. Experimente utilizar thumbnails mais atraentes, cores que chamem atenção e títulos mais impactantes. A primeira impressão é crucial para aumentar os cliques no play.": "Tu tasa de reproducción está por debajo de la media. Prueba miniaturas más atractivas, colores llamativos y títulos más impactantes. La primera impresión es crucial para aumentar los clics en reproducir.",
  "Superior central": "Superior central",
  "Superior direito": "Superior derecha",
  "Superior esquerdo": "Superior izquierda",
  "Suporte e Atendimento": "Soporte y atención al cliente",
  "Suporte premium HostVSL": "Soporte prémium de HostVSL",
  "Sydney (GMT+10)": "Sídney (GMT+10)",
  "Sábado": "Sábado",
  "Só o botão. É o comportamento clássico.": "Solo el botón. Es el comportamiento clásico.",
  "Sócio gerente": "Socio gestor",
  "Tamanho máximo de 2GB por vídeo (mesmo limite do upload normal)": "Tamaño máximo de 2 GB por video (el mismo límite de la subida normal)",
  "Taxa de Play (%)": "Tasa de reproducción (%)",
  "Taxa de Retenção (%)": "Tasa de retención (%)",
  "Taxas calculadas automaticamente: Play Rate, Click Rate e Conversion Rate": "Tasas calculadas automáticamente: reproducción, clics y conversión",
  "Template horizontal estilo Wistia/Vimeo com player centralizado, grid responsivo 4/2/1 colunas, autoplay sequencial com countdown.": "Plantilla horizontal al estilo Wistia/Vimeo con reproductor centrado, cuadrícula adaptable de 4/2/1 columnas y reproducción automática secuencial con cuenta atrás.",
  "Tempo médio assistido": "Tiempo medio visto",
  "Terceiro melhor momento": "Tercer mejor momento",
  "Termine suas VSLs levando o espectador direto para a decisão.": "Termina tus VSL llevando al espectador directamente a la decisión.",
  "Termo (Term)": "Término (Term)",
  "Terça 22-00h: Crescimento de 18% nas últimas 3 semanas": "Martes 22:00-00:00: crecimiento del 18 % en las últimas 3 semanas",
  "Terça-feira": "Martes",
  "Teste A/B - Remoção Badge Contagem": "Prueba A/B - Eliminación del indicador de conteo",
  "Teste A/B - Wizard Premium com Drag-and-Drop": "Prueba A/B - Asistente prémium con arrastrar y soltar",
  "Teste de Hook - Navegação Corrigida": "Prueba de ganchos - Navegación corregida",
  "Teste de Hook - Padronização com Teste A/B": "Prueba de ganchos - Unificación con la prueba A/B",
  "Teste grátis com um clique, sem cartão de crédito": "Prueba gratis con un clic, sin tarjeta de crédito",
  "Texto principal": "Texto principal",
  "Texto próprio no botão e escolha de abrir na mesma aba ou em uma nova": "Texto propio en el botón y opción de abrir en la misma pestaña o en una nueva",
  "Texto secundário": "Texto secundario",
  "Tipografia Premium — Font-weight 500": "Tipografía prémium — Peso de fuente 500",
  "Todas as alterações refletem no embed final automaticamente": "Todos los cambios se reflejan automáticamente en el código de inserción final",
  "Todos os recursos da HostVSL": "Todas las funciones de HostVSL",
  "Todos os recursos premium": "Todas las funciones prémium",
  "Token Revogado": "Token revocado",
  "Token de acesso vive apenas durante a sessão — segurança em primeiro lugar": "El token de acceso solo dura durante la sesión: la seguridad es lo primero",
  "Token de suporte para debug": "Token de soporte para depuración",
  "Total de conversões registradas hoje": "Total de conversiones registradas hoy",
  "Total de visualizações únicas do dia": "Total de visualizaciones únicas del día",
  "Total do dia": "Total del día",
  "Transforme curiosidade em conversão.": "Convierte la curiosidad en conversión.",
  "Transforme sua VSL em um funil interativo: cada resposta leva ao próximo vídeo ou à oferta certa.": "Convierte tu VSL en un embudo interactivo: cada respuesta lleva al siguiente video o a la oferta adecuada.",
  "Trilha organizada por módulos: Primeiros passos, Personalização, Conversão, Análises e Plano": "Recorrido organizado por módulos: Primeros pasos, Personalización, Conversión, Análisis y Plan",
  "Três formatos de avaliação: emojis, estrelas ou nota de 1 a 5": "Tres formatos de valoración: emojis, estrellas o puntuación del 1 al 5",
  "Type Safety": "Seguridad de tipos",
  "Títulos de tooltips": "Títulos de los tooltips",
  "Tóquio (GMT+9)": "Tokio (GMT+9)",
  "UI Library": "Biblioteca de interfaz",
  "URL contains suspicious patterns": "La URL contiene patrones sospechosos",
  "URL must be a non-empty string": "La URL debe ser una cadena de texto no vacía",
  "URL too long": "URL demasiado larga",
  "Um exemplo de caminho": "Un ejemplo de camino",
  "Upload Modal — Correção Borda Seleção": "Diálogo de subida — Corrección del borde de selección",
  "Upload de arquivos .VTT e .SRT com detecção automática de formato": "Subida de archivos .VTT y .SRT con detección automática del formato",
  "Upload de vídeo": "Subida de video",
  "Upload file": "Subir archivo",
  "Upsell + Downsell": "Oferta superior + oferta alternativa",
  "Use Picos de Horário para alinhar postagem, disparos e tráfego pago com os momentos de maior atenção. Menos achismo, mais performance.": "Usa las horas punta para ajustar publicaciones, envíos y tráfico de pago a los momentos de mayor atención. Menos suposiciones, más rendimiento.",
  "Use esse dado para agendar seus conteúdos": "Usa este dato para programar tus contenidos",
  "Use o cupom 50%OFF e comece hoje mesmo.": "Usa el cupón 50%OFF y empieza hoy mismo.",
  "Use pastas para organizar suas VSLs por produto ou campanha.": "Usa carpetas para organizar tus VSL por producto o campaña.",
  "Use só letras, números, \"_\", \"-\" e \".\" no nome do parâmetro.": "Usa solo letras, números, \"_\", \"-\" y \".\" en el nombre del parámetro.",
  "Use tempos com passo de 0,1 s": "Usa tiempos en incrementos de 0,1 s",
  "Use um testemunho mais relativo ao público-alvo": "Usa un testimonio más cercano al público objetivo",
  "VSL Dinâmica 2.0": "VSL dinámica 2.0",
  "Valor inválido": "Valor no válido",
  "Valor obrigatório": "El valor es obligatorio",
  "Valor total: R$ 999": "Valor total: R$ 999",
  "Valor é obrigatório": "El valor es obligatorio",
  "Valores em tooltips": "Valores de los tooltips",
  "Veja num mapa-múndi quem está assistindo às suas VSLs agora, em qualquer lugar do mundo.": "Consulta en un mapamundi quién está viendo tus VSL ahora, en cualquier lugar del mundo.",
  "Veja os horários ideais por tipo de acesso (desktop, mobile, tablet)": "Consulta los horarios ideales por tipo de acceso (escritorio, móvil y tableta)",
  "Veja os horários ideais por tipo de acesso e entenda diferenças entre desktop, mobile e tablet": "Consulta los horarios ideales por tipo de acceso y comprende las diferencias entre escritorio, móvil y tableta",
  "Veja quantos visitantes passam por cada etapa, qual opção escolhem, quantos chegam ao checkout e a retenção de cada vídeo. Só o primeiro clique de cada visitante conta como play no seu plano.": "Consulta cuántos visitantes pasan por cada etapa, qué opción eligen, cuántos llegan a la página de pago y la retención de cada video. Solo el primer clic de cada visitante cuenta como reproducción en tu plan.",
  "Vendas aprovadas ÷ plays do fluxo": "Ventas aprobadas ÷ reproducciones del flujo",
  "Verde ativo": "Verde activo",
  "Vermelho erro/excluir": "Rojo de error/eliminación",
  "VideoControlsTab - Simplificação de Labels": "VideoControlsTab - Simplificación de etiquetas",
  "VideoSelector — Dropdown Alinhado Premium": "VideoSelector — Desplegable prémium alineado",
  "Vincule cada pixel a um vídeo e ao site onde a sua VSL está publicada": "Vincula cada píxel a un video y al sitio donde está publicada tu VSL",
  "Visual premium e consistente em toda a plataforma": "Diseño prémium y coherente en toda la plataforma",
  "Visual premium, navegação mais rápida e consistência total.": "Diseño prémium, navegación más rápida y coherencia total.",
  "Visualização detalhada": "Vista detallada",
  "Visualização em barras verticais proporcionais com gradiente azul progressivo": "Visualización en barras verticales proporcionales con degradado azul progresivo",
  "Visualize toda a jornada do seu público em um funil de barras verticais com taxas de conversão entre etapas.": "Visualiza todo el recorrido de tu público en un embudo de barras verticales con tasas de conversión entre etapas.",
  "Você deve aceitar os termos": "Debes aceptar los términos",
  "Você precisa aceitar os termos": "Debes aceptar los términos",
  "Você recebe 20% de comissão recorrente sobre o valor do plano ativo. Por exemplo: se seu indicado possui o plano de R$ 147/mês, você recebe R$ 29,40 todo mês.": "Recibes un 20 % de comisión recurrente sobre el valor del plan activo. Por ejemplo: si tu referido tiene el plan de R$ 147/mes, recibes R$ 29,40 cada mes.",
  "Você terá acesso a um painel exclusivo onde poderá acompanhar suas indicações, conversões, comissões e pagamentos em tempo real.": "Tendrás acceso a un panel exclusivo para seguir tus recomendaciones, conversiones, comisiones y pagos en tiempo real.",
  "Vou abrir o menu do vídeo para você ver as opções disponíveis.": "Voy a abrir el menú del video para mostrarte las opciones disponibles.",
  "Voxuy é uma plataforma de envio de SMS em massa.": "Voxuy es una plataforma de envío masivo de SMS.",
  "Vídeo alternativo ou URL de redirecionamento é obrigatório": "El video alternativo o la URL de redirección son obligatorios",
  "Vídeo de entrada (antes da VSL) e vídeo de saída (depois) — use um ou os dois": "Video de entrada (antes de la VSL) y de salida (después): usa uno o ambos",
  "Vídeo de entrada exibido": "Video de entrada mostrado",
  "Vídeo de fundo começa mutado (recomendado)": "El video de fondo empieza sin sonido (recomendado)",
  "Vídeo final exibido": "Video final mostrado",
  "Vídeos & Pastas": "Videos y carpetas",
  "Vídeos copiados ficam protegidos e não podem ser compartilhados novamente": "Los videos copiados quedan protegidos y no pueden volver a compartirse",
  "Vídeos ilimitados sem restrição": "Videos ilimitados sin restricciones",
  "Webinars": "Seminarios web",
  "Wildcard inválido. Use *.seudominio.com.": "Comodín no válido. Usa *.tudominio.com.",
  "Wizard Teste A/B": "Asistente de prueba A/B",
  "Wizard Teste Hook": "Asistente de prueba de ganchos",
  "Wizard completo de criação de Teste A/B com 3 etapas: seleção de vídeos, distribuição de tráfego com drag-and-drop usando DnD-Kit, e cards sortáveis com badge de ordem e slider Radix.": "Asistente completo de creación de pruebas A/B con 3 etapas: selección de videos, distribución del tráfico mediante arrastrar y soltar con DnD-Kit y tarjetas ordenables con insignia de orden y control deslizante Radix.",
  "Wizard criação Teste A/B": "Asistente de creación de pruebas A/B",
  "Wizard criação Teste Hook": "Asistente de creación de pruebas de ganchos",
  "de taxa de conversão": "de tasa de conversión",
  "duração": "duración",
  "há 1 dia": "hace 1 día",
  "há 1 mês": "hace 1 mes",
  "indisponível": "no disponible",
  "maior audiência": "mayor audiencia",
  "média hoje": "media de hoy",
  "no primeiro mês": "en el primer mes",
  "oferta visível": "oferta visible",
  "ou R$ 154,68 à vista": "o R$ 154,68 en un solo pago",
  "retenção": "retención",
  "sem edição": "sin edición",
  "Área segura visual para garantir visibilidade em todos os dispositivos": "Zona segura visual para garantizar la visibilidad en todos los dispositivos",
  "É um programa onde você indica a Host VSL e recebe 20% de comissão recorrente sobre os planos ativados pelos clientes que você indicar.": "Es un programa en el que recomiendas Host VSL y recibes un 20 % de comisión recurrente sobre los planes activados por los clientes que hayas referido.",
  "Ícone de som": "Icono de sonido",
  "Últimas 24h": "Últimas 24 h",
  "⚠️ ÚLTIMA CHANCE!": "⚠️ ¡ÚLTIMA OPORTUNIDAD!",
  "📊 Métricas do Vídeo": "📊 Métricas del video",
  "🔥 Excelente desempenho! Alta taxa de play e engajamento sustentado. \n        💡 Sugestão: aumente gradualmente o tráfego para esta variação.": "🔥 ¡Excelente rendimiento! Alta tasa de reproducción e interacción sostenida.\n        💡 Sugerencia: aumenta gradualmente el tráfico de esta variación.",
  "🔴 Perda rápida nos primeiros segundos": "🔴 Abandono rápido en los primeros segundos",
  "🟡 Retenção cai significativamente aos 15-20s → promessa confusa?": "🟡 La retención cae considerablemente a los 15-20 s: ¿promesa poco clara?",
  "🟢 Boa estabilidade de retenção ao longo do vídeo": "🟢 Buena estabilidad de retención a lo largo del video"
};
export default messages;
